import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, EventEmitter, Output, ContentChildren, forwardRef, NgModule, Directive, ContentChild, HostListener, HostBinding, Pipe, Optional } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import moment from 'moment';
import * as i3 from 'angular2-draggable';
import { AngularDraggableModule } from 'angular2-draggable';
import * as i1$1 from '@angular/common/http';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import * as i1$2 from '@angular/platform-browser';
import * as i1$3 from '@angular/router';
import { RouterModule, NavigationStart } from '@angular/router';

class SlickInitParams {
    constructor() {
        this.errorLog = "minimal";
    }
}
class SlickInitService {
    constructor() { }
    static init(initParams) {
        console.info(`Slick Components Version ${SlickInitService.version}`);
        initParams.version = SlickInitService.version;
        window.slickComponentsParams = initParams;
        return window.slickComponentsParams;
    }
    static getParams() {
        if (!window.slickComponentsParams) {
            const defaultParams = new SlickInitParams();
            defaultParams.attachTo = "body";
            window.slickComponentsParams = defaultParams;
        }
        return window.slickComponentsParams;
    }
    static getAttachTo() {
        return SlickInitService.getParams().attachTo;
    }
    static setAttachTo(attachToElement) {
        SlickInitService.getParams().attachTo = attachToElement;
    }
    static getPlatform() {
        return SlickInitService.getParams().platform;
    }
    static setPlatform(platform) {
        SlickInitService.getParams().platform = platform;
    }
    static getErrorLog() {
        return SlickInitService.getParams().errorLog;
    }
    static setErrorLog(errorLog) {
        SlickInitService.getParams().errorLog = errorLog;
    }
}
SlickInitService.version = "4.4.29";
/** @nocollapse */ SlickInitService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickInitService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickInitService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickInitService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickInitService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

// @dynamic
class SlickSleepService {
    static async sleep(timeout = 0) {
        return new Promise((resolve) => setTimeout(() => resolve(), timeout));
    }
}
/** @nocollapse */ SlickSleepService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSleepService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickSleepService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSleepService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSleepService, decorators: [{
            type: Injectable
        }] });

// @dynamic
class SlickUtilsService {
    static newGuid() {
        let d = new Date().getTime();
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    }
    static waitForElement(elementSelector, iterationTimeout = 50) {
        let infiniteLoopCheck = 10;
        let iterationId;
        const p = new Promise((resolve, reject) => {
            iterationId = setInterval(() => {
                const el = document.querySelector(elementSelector);
                if (el) {
                    clearInterval(iterationId);
                    resolve(el);
                }
                if (--infiniteLoopCheck <= 0) {
                    clearInterval(iterationId);
                    alert("Loop Check failed trying to find " + elementSelector);
                    reject();
                }
            }, 100);
        });
        return p;
    }
    static waitForElementRef(elementRef, iterationTimeout = 50) {
        let infiniteLoopCheck = 10;
        let iterationId;
        const p = new Promise((resolve, reject) => {
            iterationId = setInterval(() => {
                const el = elementRef.nativeElement;
                if (el && el.clientHeight && el.clientWidth) {
                    clearInterval(iterationId);
                    resolve(elementRef);
                }
                if (--infiniteLoopCheck <= 0) {
                    clearInterval(iterationId);
                    console.error("Loop Check failed trying to find element");
                    reject();
                }
            }, iterationTimeout);
        });
        return p;
    }
    static getDeepObject(obj, objName) {
        const dotSplit = objName.split(".");
        let currentObj = obj;
        dotSplit.forEach((o) => {
            if (currentObj === null || currentObj === undefined)
                return null;
            currentObj = currentObj[o];
        });
        return currentObj;
    }
    static setDeepObject(obj, objName, val) {
        const dotSplit = objName.split(".");
        let prevObj = obj;
        let currentObj = obj;
        dotSplit.forEach((o) => {
            if (currentObj === null || currentObj === undefined)
                return null;
            prevObj = currentObj;
            currentObj = currentObj[o];
        });
        prevObj[dotSplit[dotSplit.length - 1]] = val;
        return currentObj;
    }
    static clone(obj) {
        if (obj === null || obj === undefined)
            return obj;
        let returnObj = JSON.parse(JSON.stringify(obj));
        //returnObj = this.dateSanitize(returnObj);
        return returnObj;
    }
    static dateSanitize(obj, infiniteLoopCheck = 0) {
        infiniteLoopCheck++;
        if (infiniteLoopCheck > 20) {
            console.error("infinte loop");
            return obj;
        }
        if (obj === null || obj === undefined)
            return obj;
        // If the obj IS a date, return the processed date
        if (typeof obj === "string" && /^([0-9]{4}-(0[1-9]|10|11|12)-([012][0-9]|30|31)T([01][0-9]|[2][0123]):([0-5][0-9]):([0-5][0-9])(.[0-9]{0,})?(z|Z))$/.test(obj))
            return new Date(obj);
        // If this is an atomic type (string, bool, number), just return the atomic object
        if (typeof obj !== "object")
            return obj;
        let returnObj;
        if (Array.isArray(obj)) {
            returnObj = [];
            obj.forEach(o => returnObj.push(this.dateSanitize(o, infiniteLoopCheck)));
        }
        else {
            returnObj = {};
            for (const key in obj) {
                if (obj[key] === null)
                    returnObj[key] = null;
                else if (Array.isArray(obj[key])) {
                    returnObj[key] = [];
                    obj[key].forEach(o => returnObj[key].push(this.dateSanitize(o, infiniteLoopCheck)));
                }
                else if (typeof obj[key] === "object")
                    returnObj[key] = this.dateSanitize(obj[key], ++infiniteLoopCheck);
                else if (/^([0-9]{4}-(0[1-9]|10|11|12)-([012][0-9]|30|31)T([01][0-9]|[2][0123]):([0-5][0-9]):([0-5][0-9])(.[0-9]{0,})?(z|Z))$/.test(obj[key]))
                    returnObj[key] = new Date(obj[key]);
                else
                    returnObj[key] = obj[key];
            }
        }
        return returnObj;
    }
    static round(num, decimals) {
        return Number(Math.round(parseFloat(num + 'e' + decimals)) + 'e-' + decimals);
    }
    static checkParentClassExists(el, className) {
        let currentEl = el;
        let hasSelector = false;
        while (currentEl && currentEl !== document.body) {
            if (currentEl.classList.contains(className)) {
                hasSelector = true;
                break;
            }
            currentEl = currentEl.parentElement;
        }
        return hasSelector;
    }
    static checkParentIdExists(el, idName) {
        let currentEl = el;
        let hasSelector = false;
        while (currentEl && currentEl !== document.body) {
            if (currentEl.getAttribute("id") === idName) {
                hasSelector = true;
                break;
            }
            currentEl = currentEl.parentElement;
        }
        return hasSelector;
    }
    static findParentByAttr(el, attrName, attrValue) {
        let currentEl = el;
        while (currentEl && currentEl !== document.body) {
            if (currentEl.hasAttribute(attrName) && currentEl.getAttribute(attrName) === attrValue) {
                return currentEl;
            }
            currentEl = currentEl.parentElement;
        }
        return null;
    }
    static findParent(el, className) {
        let currentEl = el;
        while (currentEl && currentEl !== document.body) {
            if (currentEl.classList && currentEl.classList.contains(className)) {
                return currentEl;
            }
            currentEl = currentEl.parentElement;
        }
        return null;
    }
    static getClosestSibling(el, className) {
        let currentEl = el;
        while (currentEl && currentEl !== document.body) {
            if (currentEl.classList && currentEl.classList.contains(className)) {
                return currentEl;
            }
            currentEl = currentEl.previousSibling;
        }
        return null;
    }
    static waitForTinyMCE(tinyMCEId) {
        return new Promise((resolve, reject) => {
            let waitForTinyMCE;
            if (tinymce.get(tinyMCEId) && tinymce.get(tinyMCEId).initialized) {
                resolve();
            }
            else {
                clearInterval(waitForTinyMCE);
                let infiniteLoopCheck = 100;
                waitForTinyMCE = setInterval(() => {
                    if ((tinymce.get(tinyMCEId) && tinymce.get(tinyMCEId).initialized) || infiniteLoopCheck === 0) {
                        clearInterval(waitForTinyMCE);
                        if (infiniteLoopCheck === 0) {
                            console.error("Timed out waiting for tinyMCE Id: " + tinyMCEId);
                            return reject();
                        }
                        else {
                            return resolve();
                        }
                    }
                    infiniteLoopCheck--;
                }, 100);
            }
        });
    }
    static attachElement(el, attachTo) {
        if (attachTo === 'body')
            document.body.appendChild(el);
        else {
            const parent = document.body.querySelector(attachTo);
            if (!parent) {
                console.error("Could not find element " + attachTo + " to attach to");
                return;
            }
            else {
                parent.appendChild(el);
            }
        }
    }
    static removeElement(el) {
        // it's okay if this fails.  It was already removed
        try {
            // the default destroy won't get rid of this
            document.body.removeChild(el);
        }
        catch { }
    }
    static arrayInsert(elementToInsert, arr, index) {
        const pre = arr.slice(0, index);
        const post = arr.slice(index, arr.length);
        return [...pre, elementToInsert, ...post];
    }
}
SlickUtilsService.getHashCode = function (str) {
    let hash = 0;
    let chr;
    if (str.length === 0)
        return hash;
    for (let i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
};
/** @nocollapse */ SlickUtilsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickUtilsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickUtilsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickUtilsService, decorators: [{
            type: Injectable
        }] });

class SlickAccordionItemComponent {
    constructor() {
        this.noExpand = false;
        this.PIXELS_PER_TICK = 15;
        this.isExpanded = false;
    }
    ngOnChanges() {
        this.noExpand = (this.noExpand.toString().toLowerCase() === 'true') ? true : false;
    }
    async onHeaderClicked() {
        if (this.noExpand) {
            if (this.onChangeCallback)
                this.onChangeCallback(this.index);
        }
        else {
            if (this.isExpanded === false)
                this.expand();
            else
                this.collapse();
        }
    }
    async expand() {
        if (this.noExpand)
            return;
        if (this.isExpanded === true)
            return;
        if (this.onChangeCallback)
            this.onChangeCallback(this.index);
        this.isExpanded = true;
        await SlickUtilsService.waitForElementRef(this.slickAccordionItemRef);
        // Give the collapses a chance to collapse down before we expand
        await SlickSleepService.sleep(100);
        const maxHeight = this.slickAccordionBodyRef.nativeElement.offsetHeight;
        this.slickAccordionBouncePaddingRef.nativeElement.style.display = "block";
        this.slickAccordionBodyWrapperRef.nativeElement.style.maxHeight = (maxHeight + 30) + "px";
        await SlickSleepService.sleep(125);
        this.slickAccordionBodyWrapperRef.nativeElement.style.maxHeight = maxHeight + "px";
        await SlickSleepService.sleep(100);
        this.slickAccordionBouncePaddingRef.nativeElement.style.display = "none";
        this.slickAccordionBodyWrapperRef.nativeElement.style.maxHeight = "none";
    }
    async collapse(ignoreOnChangeCallback = false) {
        if (this.isExpanded === false)
            return;
        this.isExpanded = false;
        // The animations requires a number for maxHeight.  Just set it to the current height, then to 0
        const maxHeight = this.slickAccordionBodyRef.nativeElement.offsetHeight;
        this.slickAccordionBodyWrapperRef.nativeElement.style.maxHeight = maxHeight + "px";
        await SlickSleepService.sleep();
        this.slickAccordionBodyWrapperRef.nativeElement.style.maxHeight = "0";
        if (this.onChangeCallback && ignoreOnChangeCallback === false)
            this.onChangeCallback(this.index);
    }
    getKey() {
        return this.key || null;
    }
}
/** @nocollapse */ SlickAccordionItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickAccordionItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickAccordionItemComponent, selector: "slick-accordion-item", inputs: { header: "header", headerIcon: "headerIcon", key: "key", noExpand: "noExpand" }, viewQueries: [{ propertyName: "slickAccordionItemRef", first: true, predicate: ["slickAccordionItemRef"], descendants: true }, { propertyName: "slickAccordionBodyWrapperRef", first: true, predicate: ["slickAccordionBodyWrapperRef"], descendants: true }, { propertyName: "slickAccordionBodyRef", first: true, predicate: ["slickAccordionBodyRef"], descendants: true }, { propertyName: "slickAccordionBouncePaddingRef", first: true, predicate: ["slickAccordionBouncePaddingRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #slickAccordionItemRef class=\"slick-accordion-item\">\r\n\t<div *ngIf=\"header\" class=\"slick-accordion-header card-header\" [ngClass]=\"{'badge-primary' : isExpanded }\" (click)=\"onHeaderClicked()\"><i *ngIf=\"headerIcon\" class=\"far\" [ngClass]=\"headerIcon\"></i> {{header}}</div>\r\n\t<div *ngIf=\"!header\" class=\"slick-accordion-header card-header\" [ngClass]=\"{'badge-primary' : isExpanded }\" (click)=\"onHeaderClicked()\"><ng-content select=\"slick-accordion-item-header\"></ng-content></div>\r\n\t<div #slickAccordionBodyWrapperRef class=\"slick-accordion-body-wrapper\">\r\n\t\t<div #slickAccordionBodyRef class=\"card-body slick-accordion-body\"><ng-content></ng-content></div>\r\n\t\t<div #slickAccordionBouncePaddingRef style=\"display: none; min-height: 30px;\"></div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionItemComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-accordion-item", template: "<div #slickAccordionItemRef class=\"slick-accordion-item\">\r\n\t<div *ngIf=\"header\" class=\"slick-accordion-header card-header\" [ngClass]=\"{'badge-primary' : isExpanded }\" (click)=\"onHeaderClicked()\"><i *ngIf=\"headerIcon\" class=\"far\" [ngClass]=\"headerIcon\"></i> {{header}}</div>\r\n\t<div *ngIf=\"!header\" class=\"slick-accordion-header card-header\" [ngClass]=\"{'badge-primary' : isExpanded }\" (click)=\"onHeaderClicked()\"><ng-content select=\"slick-accordion-item-header\"></ng-content></div>\r\n\t<div #slickAccordionBodyWrapperRef class=\"slick-accordion-body-wrapper\">\r\n\t\t<div #slickAccordionBodyRef class=\"card-body slick-accordion-body\"><ng-content></ng-content></div>\r\n\t\t<div #slickAccordionBouncePaddingRef style=\"display: none; min-height: 30px;\"></div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { header: [{
                type: Input,
                args: ["header"]
            }], headerIcon: [{
                type: Input,
                args: ["headerIcon"]
            }], key: [{
                type: Input,
                args: ["key"]
            }], noExpand: [{
                type: Input
            }], slickAccordionItemRef: [{
                type: ViewChild,
                args: ["slickAccordionItemRef"]
            }], slickAccordionBodyWrapperRef: [{
                type: ViewChild,
                args: ["slickAccordionBodyWrapperRef"]
            }], slickAccordionBodyRef: [{
                type: ViewChild,
                args: ["slickAccordionBodyRef"]
            }], slickAccordionBouncePaddingRef: [{
                type: ViewChild,
                args: ["slickAccordionBouncePaddingRef"]
            }] } });

class SlickAccordionComponent {
    constructor() {
        this.accordionIndexChange = new EventEmitter();
        this.keepExpanded = false;
        this.onChange = new EventEmitter();
    }
    async ngAfterContentInit() {
        this.slickAccordionItems$ = this.slickAccordionItems.changes.subscribe(async (slickAccordionItems) => {
            // Go through each of the accordion items and set the callback to collapse
            slickAccordionItems.forEach((x, idx) => {
                x.index = idx;
                x.onChangeCallback = (index) => {
                    if (this.keepExpanded === false && x.noExpand === false)
                        this.collapseAll();
                    if (this.accordionIndexChange)
                        this.accordionIndexChange.emit(index);
                    if (this.onChange)
                        this.onChange.emit(index);
                };
            });
            await SlickSleepService.sleep();
            if (this.accordionIndex !== undefined && this.accordionIndex !== null)
                this.expand(this.accordionIndex);
        });
        await SlickSleepService.sleep();
        this.slickAccordionItems.notifyOnChanges();
    }
    ngOnDestroy() {
        if (this.slickAccordionItems$)
            this.slickAccordionItems$.unsubscribe();
    }
    async ngOnChanges(changes) {
        this.keepExpanded = (this.keepExpanded.toString().toLowerCase() === 'true') ? true : false;
        if (this.keepExpanded === false && changes.accordionIndex)
            this.expand(this.accordionIndex);
    }
    expand(index) {
        if (!this.slickAccordionItems || (this.slickAccordionItems.length - 1) < index)
            return;
        this.slickAccordionItems.toArray()[index].expand();
    }
    collapse(index) {
        if (!this.slickAccordionItems || (this.slickAccordionItems.length - 1) < index)
            return;
        this.slickAccordionItems.toArray()[index].collapse();
    }
    getKey(index) {
        return this.slickAccordionItems.toArray()[index].getKey();
    }
    collapseAll() {
        this.slickAccordionItems.forEach(x => x.collapse(true));
    }
}
/** @nocollapse */ SlickAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickAccordionComponent, selector: "slick-accordion", inputs: { accordionIndex: "accordionIndex", keepExpanded: "keepExpanded" }, outputs: { accordionIndexChange: "accordionIndexChange", onChange: "onChange" }, queries: [{ propertyName: "slickAccordionItems", predicate: i0.forwardRef(function () { return SlickAccordionItemComponent; }) }], usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-accordion card\">\r\n\t<ng-content select=\"slick-accordion-item\"></ng-content>\r\n</div>\r\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-accordion", template: "<div class=\"slick-accordion card\">\r\n\t<ng-content select=\"slick-accordion-item\"></ng-content>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { accordionIndex: [{
                type: Input
            }], accordionIndexChange: [{
                type: Output
            }], keepExpanded: [{
                type: Input
            }], onChange: [{
                type: Output
            }], slickAccordionItems: [{
                type: ContentChildren,
                args: [forwardRef(() => SlickAccordionItemComponent)]
            }] } });

class SlickAccordionItemHeaderComponent {
}
/** @nocollapse */ SlickAccordionItemHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionItemHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickAccordionItemHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickAccordionItemHeaderComponent, selector: "slick-accordion-item-header", ngImport: i0, template: "<ng-content></ng-content>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionItemHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "slick-accordion-item-header",
                    template: "<ng-content></ng-content>"
                }]
        }] });

class SlickAccordionModule {
}
/** @nocollapse */ SlickAccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickAccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionModule, declarations: [SlickAccordionComponent, SlickAccordionItemComponent, SlickAccordionItemHeaderComponent], imports: [CommonModule], exports: [CommonModule, SlickAccordionComponent, SlickAccordionItemComponent, SlickAccordionItemHeaderComponent] });
/** @nocollapse */ SlickAccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [CommonModule, SlickAccordionComponent, SlickAccordionItemComponent, SlickAccordionItemHeaderComponent],
                    declarations: [SlickAccordionComponent, SlickAccordionItemComponent, SlickAccordionItemHeaderComponent]
                }]
        }] });

class SlickAutoCompleteListItemTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
/** @nocollapse */ SlickAutoCompleteListItemTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteListItemTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickAutoCompleteListItemTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickAutoCompleteListItemTemplateDirective, selector: "[slickAutoCompleteListItemTemplate]", inputs: { type: "type", name: ["slickAutoCompleteListItemTemplate", "name"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteListItemTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slickAutoCompleteListItemTemplate]',
                    host: {}
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { type: [{
                type: Input
            }], name: [{
                type: Input,
                args: ['slickAutoCompleteListItemTemplate']
            }] } });

class SlickFunctionLockModel {
    constructor() {
        this.infiniteLoopCheck = 100;
    }
}
class SlickFunctionLockService {
    constructor() {
        this.functionLocks = {};
    }
    lock(functionKey, iterationTimeout = 200) {
        if (!this.functionLocks[functionKey])
            this.functionLocks[functionKey] = [];
        const functionLock = new SlickFunctionLockModel();
        functionLock.functionKey = functionKey;
        let d = new Date().getTime();
        const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        functionLock.uuid = uuid;
        functionLock.lockCount = this.functionLocks[functionKey].length + 1;
        functionLock.promise = new Promise((resolve, reject) => {
            functionLock.intervalId = setInterval(() => {
                if (functionLock.lockCount === 1 || functionLock.infiniteLoopCheck-- === 0) {
                    clearInterval(functionLock.intervalId);
                    if (functionLock.infiniteLoopCheck === 0) {
                        alert("Inifite loop detected for " + functionLock.functionKey);
                    }
                    resolve(null);
                }
            }, iterationTimeout);
        });
        this.functionLocks[functionKey].push(functionLock);
        return functionLock.promise;
    }
    release(functionKey) {
        if (this.functionLocks && this.functionLocks[functionKey]) {
            this.functionLocks[functionKey].splice(0, 1);
            this.functionLocks[functionKey].forEach((fl) => fl.lockCount--);
            return this.functionLocks[functionKey].length;
        }
        else {
            return -1;
        }
    }
}
/** @nocollapse */ SlickFunctionLockService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFunctionLockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickFunctionLockService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFunctionLockService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFunctionLockService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class SlickAutoCompleteComponent {
    constructor(slickFunctionLockService) {
        this.slickFunctionLockService = slickFunctionLockService;
        this.delay = 300;
        this.selectFirst = true;
        this.listHeight = "300px";
        this.listWidth = '100%';
        this.allowFreeformText = true;
        this.showNoItemsFoundDisplay = true;
        this.onRefresh = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onFreeformTextSelect = new EventEmitter();
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.fnKeyDown = (e) => this.keyDown(e);
        this.lastInputValue = "";
        this.forcedCollapse = false;
        // This is necessary so that the scroll and resize events can add and remove the event properly,
        // as well as getting the correct ES6 function
        this.fnReposition = () => this.reposition();
        this.selectedIndex = -1;
        this.showAutoComplete = false;
        this.autoCompleteVisiblity = false;
        this.expanded = true;
        this.loading = false;
        this.propagateChange = (_) => { };
        this.uuid = SlickUtilsService.newGuid();
    }
    async ngOnInit() {
        await SlickSleepService.sleep();
        // Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
        // of a div when it expands beyond the bottom.
        this.autoCompleteRef.nativeElement.remove(this.autoCompleteRef);
        document.body.appendChild(this.autoCompleteRef.nativeElement);
        this.inputRef.addEventListener("keydown", this.fnKeyDown);
    }
    ngOnDestroy() {
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.removeEventListener("click", this.fnDocumentClick, true);
        this.inputRef.removeEventListener("keydown", this.fnKeyDown);
        clearTimeout(this.delayTimeout);
        this.delayTimeout = null;
        this.collapse();
        // Is okay if this fails.  It just means it was already removed.
        try {
            document.body.removeChild(this.autoCompleteRef.nativeElement);
        }
        catch { }
    }
    ngOnChanges(changes) {
        if (changes.allowFreeformText)
            this.allowFreeformText = (this.allowFreeformText.toString().toLowerCase() === 'false') ? false : true;
        if (changes.showNoItemsFoundDisplay)
            this.showNoItemsFoundDisplay = (this.showNoItemsFoundDisplay.toString().toLowerCase() === 'false') ? false : true;
        if (changes.items) {
            if (this.items && this.items.length === 0 && this.showNoItemsFoundDisplay === false)
                this.collapse();
        }
    }
    documentClick(e) {
        if (!this.expanded || !e.target)
            return;
        if (e.target === this.inputRef)
            return;
        if (SlickUtilsService.checkParentIdExists(e.target, "slick-auto-complete_" + this.uuid) === false) {
            clearInterval(this.waitForItemsInterval);
            this.slickFunctionLockService.release("AUTO_COMPLETE_WAIT_FOR_ITEMS");
            this.collapse();
            if (this.allowFreeformText && this.onFreeformTextSelect)
                this.onFreeformTextSelect.emit(this.inputRef.value);
        }
    }
    onItemClick(index) {
        this.selectItem(index);
        this.collapse();
    }
    async keyDown(event) {
        // alt
        if (event.keyCode === 18)
            return;
        clearInterval(this.waitForItemsInterval);
        this.slickFunctionLockService.release("AUTO_COMPLETE_WAIT_FOR_ITEMS");
        // If we're just tabbing through, don't even do anything
        if (!this.lastInputValue && (event.keyCode === 9 || event.keyCode === 13))
            return;
        await SlickSleepService.sleep();
        if (this.lastInputValue !== this.inputRef.value) {
            this.lastInputValue = this.inputRef.value;
            this.forcedCollapse = false;
            if (!this.lastInputValue) {
                this.propagateChange(null);
                this.collapse();
            }
            clearTimeout(this.delayTimeout);
            this.delayTimeout = null;
            if (this.inputRef.value === '') {
                this.items = null;
                this.collapse();
                return true;
            }
            else {
                this.delayTimeout = setTimeout(async () => {
                    (this.selectFirst === true) ? this.selectedIndex = 0 : this.selectedIndex = -1;
                    this.delayTimeout = null;
                    this.items = null;
                    this.expand();
                    await this.refreshItems(true);
                }, this.delay);
            }
        }
        if (event.keyCode === 9 || event.keyCode === 13) {
            if (this.delayTimeout && this.selectFirst) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = null;
                this.items = null;
                this.collapse();
                if (this.selectFirst === true && !this.forcedCollapse) {
                    await this.refreshItems(false);
                    this.selectedIndex = -1;
                    if (!this.items && !this.inputRef.value && this.onSelect) {
                        this.onSelect.emit(null);
                    }
                    else if (this.items && this.items.length > 0) {
                        this.selectedIndex = 0;
                        this.selectItem(this.selectedIndex);
                    }
                    else {
                        if (this.allowFreeformText && this.onFreeformTextSelect)
                            this.onFreeformTextSelect.emit(this.inputRef.value);
                    }
                }
                else {
                    if (this.allowFreeformText && this.onFreeformTextSelect)
                        this.onFreeformTextSelect.emit(this.inputRef.value);
                }
            }
            else {
                clearTimeout(this.delayTimeout);
                if (!this.items && !this.inputRef.value && this.onSelect) {
                    this.onSelect.emit(null);
                }
                else if (this.items && this.items.length > 0 && this.expanded && !this.forcedCollapse) {
                    this.selectItem(this.selectedIndex);
                }
                else {
                    if (this.allowFreeformText && this.onFreeformTextSelect) {
                        this.onFreeformTextSelect.emit(this.inputRef.value);
                    }
                }
                this.collapse();
            }
        }
        // Esc
        if (event.which === 27) {
            this.forcedCollapse = true;
            this.collapse();
            return false;
        }
        // Arrowup
        if (event.which === 38) {
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                this.selectedIndex = 0;
            if (this.selectedIndex > 0)
                this.selectedIndex--;
            return false;
        }
        // Arrowdown
        if (event.which === 40) {
            event.stopPropagation();
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                this.selectedIndex = -1;
            if (!this.expanded) {
                this.expand();
                return false;
            }
            if (this.selectedIndex < this.items.length - 1)
                this.selectedIndex++;
            return false;
        }
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj) {
        }
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    async selectItem(index) {
        if (index < 0 || !this.items || this.items.length === 0) {
            this.selectedItem = null;
        }
        else {
            this.selectedItem = this.items[index];
            if (this.displayTextFieldName) {
                const text = SlickUtilsService.getDeepObject(this.selectedItem, this.displayTextFieldName);
                if (text) {
                    this.inputRef.value = text;
                    this.lastInputValue = this.inputRef.value;
                }
            }
        }
        this.propagateChange(this.selectedItem);
        if (this.onSelect)
            this.onSelect.emit(this.selectedItem);
        // Call to update the model for the textbox
        await SlickSleepService.sleep();
        let evt = document.createEvent('Event');
        evt.initEvent('input', true, false);
        this.inputRef.dispatchEvent(evt);
    }
    async expand() {
        this.reposition();
        // If the flag to show items is false, don't display "Loading..."
        if (this.showNoItemsFoundDisplay === false && (!this.items || this.items.length === 0)) {
            this.showAutoComplete = false;
            this.autoCompleteVisiblity = false;
            this.expanded = false;
            return;
        }
        this.showAutoComplete = true;
        this.autoCompleteRef.nativeElement.style.display = "inline-block";
        await SlickSleepService.sleep();
        this.autoCompleteVisiblity = true;
        this.expanded = true;
        this.inputRef.classList.add("slick-auto-complete_remove-bottom-left-border-radius");
        this.inputRef.classList.add("slick-auto-complete_remove-bottom-right-border-radius");
        // This is necessary, otherwise `this` in the reposition function will be window
        // and not the component.
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.addEventListener("click", this.fnDocumentClick, true);
    }
    collapse() {
        let inputGroupPrepend = SlickUtilsService.getClosestSibling(this.inputRef, "input-group-prepend");
        if (inputGroupPrepend)
            inputGroupPrepend.classList.remove("slick-auto-complete_remove-bottom-left-border-radius");
        this.inputRef.classList.remove("slick-auto-complete_remove-bottom-left-border-radius");
        this.inputRef.classList.remove("slick-auto-complete_remove-bottom-right-border-radius");
        this.autoCompleteVisiblity = false;
        this.expanded = false;
        this.autoCompleteRef.nativeElement.style.display = "none";
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.removeEventListener("click", this.fnDocumentClick, true);
    }
    reposition() {
        let rect = this.inputRef.getBoundingClientRect();
        let inputLeft = rect.left;
        let inputTop = rect.top;
        let inputHeight = this.inputRef.offsetHeight;
        let inputWidth = this.inputRef.offsetWidth;
        let inputGroupPrepend = SlickUtilsService.getClosestSibling(this.inputRef, "input-group-prepend");
        if (inputGroupPrepend) {
            inputLeft = inputGroupPrepend.getBoundingClientRect().left;
            inputWidth = inputWidth += inputGroupPrepend.offsetWidth;
            inputGroupPrepend.classList.add("slick-auto-complete_remove-bottom-left-border-radius");
        }
        this.left = inputLeft + "px";
        this.top = (inputTop + inputHeight + 1) + "px";
        if (this.listWidth === '100%')
            this.width = inputWidth + "px";
        else if (this.listWidth === 'auto')
            this.width = "auto";
        else
            this.width = this.listWidth;
    }
    async refreshItems(expand) {
        return new Promise(async (resolve) => {
            await this.slickFunctionLockService.lock("AUTO_COMPLETE_WAIT_FOR_ITEMS");
            clearInterval(this.waitForItemsInterval);
            this.items = null;
            if (!this.onRefresh || !this.inputRef.value) {
                this.items = [];
                this.slickFunctionLockService.release("AUTO_COMPLETE_WAIT_FOR_ITEMS");
                resolve();
            }
            else {
                this.loading = true;
                if (this.showNoItemsFoundDisplay === false)
                    this.collapse();
                // Call the users refresh method to get a fresh list of items
                this.onRefresh.emit(this.inputRef.value);
                // Wait for the list to refresh
                let timeoutCheck = 1000;
                this.waitForItemsInterval = setInterval(() => {
                    // If we've timedout, got a response or they started typing something else, stop the interval
                    if (timeoutCheck <= 0 || this.items) {
                        clearInterval(this.waitForItemsInterval);
                        if (timeoutCheck <= 0) {
                            console.error("Timed out waiting for list in auto complete");
                            this.items = [];
                            if (this.showNoItemsFoundDisplay === false)
                                this.collapse();
                        }
                        this.loading = false;
                        if (expand)
                            this.expand();
                        this.slickFunctionLockService.release("AUTO_COMPLETE_WAIT_FOR_ITEMS");
                        resolve();
                    }
                    timeoutCheck--;
                }, 100);
            }
        });
    }
}
/** @nocollapse */ SlickAutoCompleteComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteComponent, deps: [{ token: SlickFunctionLockService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickAutoCompleteComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickAutoCompleteComponent, selector: "slick-auto-complete", inputs: { inputRef: "inputRef", items: "items", delay: "delay", selectFirst: "selectFirst", displayTextFieldName: "displayTextFieldName", listHeight: "listHeight", listWidth: "listWidth", allowFreeformText: "allowFreeformText", showNoItemsFoundDisplay: "showNoItemsFoundDisplay" }, outputs: { onRefresh: "onRefresh", onSelect: "onSelect", onFreeformTextSelect: "onFreeformTextSelect" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickAutoCompleteComponent)),
            multi: true
        }
    ], queries: [{ propertyName: "listItemTemplateRef", first: true, predicate: SlickAutoCompleteListItemTemplateDirective, descendants: true, static: true }], viewQueries: [{ propertyName: "autoCompleteRef", first: true, predicate: ["autoCompleteRef"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div #autoCompleteRef id=\"slick-auto-complete_{{uuid}}\" class='slick-auto-complete dropdown-menu' [style.width]=\"width\" [style.minWidth]=\"width\" [style.visibility]=\"(expanded === true) ? 'visible' : 'hidden'\" [style.opacity]=\"(expanded === true) ? '1' : '0'\" [style.max-height]=\"listHeight\" [style.left]=\"left\" [style.top]=\"top\">\r\n\t<div *ngIf=\"loading\" style=\"font-size: .8rem\" class=\"ml-3\">Loading...</div>\r\n\t<div *ngIf=\"!loading && items?.length === 0\" style=\"font-size: .8rem\" class=\"ml-3\">\r\n\t\tNo items found\r\n\t</div>\r\n\t<div *ngIf=\"!loading && items?.length > 0\">\r\n\t\t<div *ngFor=\"let item of items; let index = index;\" (click)=\"onItemClick(index)\" [class.card-header]=\"selectedIndex === index\" class=\"dropdown-item\">\r\n\t\t\t<ng-container *ngTemplateOutlet=\"listItemTemplateRef.template, context: { $implicit: item, index: index }\">\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-auto-complete', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickAutoCompleteComponent)),
                            multi: true
                        }
                    ], template: "<div #autoCompleteRef id=\"slick-auto-complete_{{uuid}}\" class='slick-auto-complete dropdown-menu' [style.width]=\"width\" [style.minWidth]=\"width\" [style.visibility]=\"(expanded === true) ? 'visible' : 'hidden'\" [style.opacity]=\"(expanded === true) ? '1' : '0'\" [style.max-height]=\"listHeight\" [style.left]=\"left\" [style.top]=\"top\">\r\n\t<div *ngIf=\"loading\" style=\"font-size: .8rem\" class=\"ml-3\">Loading...</div>\r\n\t<div *ngIf=\"!loading && items?.length === 0\" style=\"font-size: .8rem\" class=\"ml-3\">\r\n\t\tNo items found\r\n\t</div>\r\n\t<div *ngIf=\"!loading && items?.length > 0\">\r\n\t\t<div *ngFor=\"let item of items; let index = index;\" (click)=\"onItemClick(index)\" [class.card-header]=\"selectedIndex === index\" class=\"dropdown-item\">\r\n\t\t\t<ng-container *ngTemplateOutlet=\"listItemTemplateRef.template, context: { $implicit: item, index: index }\">\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: SlickFunctionLockService }]; }, propDecorators: { inputRef: [{
                type: Input,
                args: ["inputRef"]
            }], items: [{
                type: Input,
                args: ["items"]
            }], delay: [{
                type: Input,
                args: ["delay"]
            }], selectFirst: [{
                type: Input,
                args: ["selectFirst"]
            }], displayTextFieldName: [{
                type: Input,
                args: ["displayTextFieldName"]
            }], listHeight: [{
                type: Input,
                args: ["listHeight"]
            }], listWidth: [{
                type: Input,
                args: ["listWidth"]
            }], allowFreeformText: [{
                type: Input,
                args: ["allowFreeformText"]
            }], showNoItemsFoundDisplay: [{
                type: Input,
                args: ["showNoItemsFoundDisplay"]
            }], onRefresh: [{
                type: Output,
                args: ["onRefresh"]
            }], onSelect: [{
                type: Output,
                args: ["onSelect"]
            }], onFreeformTextSelect: [{
                type: Output,
                args: ["onFreeformTextSelect"]
            }], autoCompleteRef: [{
                type: ViewChild,
                args: ["autoCompleteRef", { static: true }]
            }], listItemTemplateRef: [{
                type: ContentChild,
                args: [SlickAutoCompleteListItemTemplateDirective, { static: true }]
            }] } });

class SlickAutoCompleteModule {
}
/** @nocollapse */ SlickAutoCompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickAutoCompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteModule, declarations: [SlickAutoCompleteComponent, SlickAutoCompleteListItemTemplateDirective], imports: [CommonModule, FormsModule], exports: [SlickAutoCompleteComponent, SlickAutoCompleteListItemTemplateDirective] });
/** @nocollapse */ SlickAutoCompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteModule, providers: [SlickFunctionLockService], imports: [CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickAutoCompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [SlickAutoCompleteComponent, SlickAutoCompleteListItemTemplateDirective],
                    exports: [SlickAutoCompleteComponent, SlickAutoCompleteListItemTemplateDirective],
                    providers: [SlickFunctionLockService]
                }]
        }] });

class SlickButtonSpinnerComponent {
    constructor(el) {
        this.el = el;
        this.spinnerVisible = false;
        this.checkVisible = false;
        this.errorVisible = false;
        this.currentStatus = "hidden";
        this.inProcess = false;
        this.expanded = false;
        el.nativeElement.classList.add("slick-button-spinner");
    }
    ngOnInit() {
    }
    async ngAfterViewInit() {
        this.originalPadding = this.el.nativeElement.style.paddingRight;
    }
    async ngOnChanges(changes) {
        if (!changes.spinnerStatus || !changes.spinnerStatus.currentValue)
            return;
        switch (changes.spinnerStatus.currentValue.toLowerCase()) {
            case 'spin':
                if (this.inProcess === true) {
                    // If it's expanding, wait for it to finish, then collapse it
                    let waitInterval = setInterval(async () => {
                        if (this.inProcess === false) {
                            clearTimeout(waitInterval);
                            await this.expand();
                            this.hideError();
                            this.hideCheck();
                            this.showSpinner();
                        }
                    }, 50);
                }
                else {
                    await this.expand();
                    this.hideError();
                    this.hideCheck();
                    this.showSpinner();
                }
                break;
            case 'ok':
                if (this.inProcess === true) {
                    // If it's expanding, wait for it to finish, then collapse it
                    let waitInterval = setInterval(() => {
                        if (this.inProcess === false) {
                            clearTimeout(waitInterval);
                            this.hideSpinner();
                            this.hideError();
                            this.showCheck();
                        }
                    }, 50);
                }
                else {
                    this.hideSpinner();
                    this.hideError();
                    this.showCheck();
                }
                break;
            case 'error':
                if (this.inProcess === true) {
                    // If it's expanding, wait for it to finish, then collapse it
                    let waitInterval = setInterval(() => {
                        if (this.inProcess === false) {
                            clearTimeout(waitInterval);
                            this.hideSpinner();
                            this.hideCheck();
                            this.showError();
                        }
                    }, 50);
                }
                else {
                    this.hideSpinner();
                    this.hideCheck();
                    this.showError();
                }
                break;
            case 'hide':
                if (this.inProcess === true) {
                    // If it's expanding, wait for it to finish, then collapse it
                    let waitInterval = setInterval(() => {
                        if (this.inProcess === false) {
                            clearTimeout(waitInterval);
                            this.hideCheck();
                            this.hideError();
                            this.hideSpinner();
                            this.collapse();
                        }
                    }, 50);
                }
                else {
                    this.hideCheck();
                    this.hideError();
                    this.hideSpinner();
                    this.collapse();
                }
            case 'reset':
                this.expanded = false;
                this.hideCheck();
                this.hideError();
                this.hideSpinner();
                this.el.nativeElement.disabled = false;
                this.el.nativeElement.style.paddingRight = this.originalPadding;
                this.el.nativeElement.classList.remove("expand-button-spinner");
                break;
        }
    }
    showSpinner() {
        this.spinnerVisible = true;
        this.el.nativeElement.disabled = true;
    }
    hideSpinner() {
        this.spinnerVisible = false;
        this.el.nativeElement.disabled = false;
    }
    showCheck() {
        this.checkVisible = true;
        this.showCheckInterval = setTimeout(() => {
            this.hideCheck();
            this.hideError();
            this.collapse();
        }, 2500);
    }
    hideCheck() {
        clearTimeout(this.showCheckInterval);
        this.checkVisible = false;
    }
    showError() {
        this.el.nativeElement.disabled = false;
        this.errorVisible = true;
    }
    hideError() {
        this.errorVisible = false;
    }
    async expand() {
        if (this.inProcess === true || this.expanded === true) {
            return Promise.resolve();
        }
        this.expanded = true;
        this.inProcess = true;
        this.el.nativeElement.classList.remove("collapse-button-spinner");
        this.el.nativeElement.classList.add("expand-button-spinner");
        await SlickSleepService.sleep(350);
        this.originalPadding = this.el.nativeElement.style.paddingRight;
        this.el.nativeElement.style.paddingRight = "35px";
        this.inProcess = false;
        return Promise.resolve();
    }
    async collapse() {
        if (this.inProcess === true || this.expanded === false) {
            return Promise.resolve();
        }
        this.expanded = false;
        this.inProcess = true;
        this.el.nativeElement.classList.remove("expand-button-spinner");
        this.el.nativeElement.classList.add("collapse-button-spinner");
        await SlickSleepService.sleep(500);
        this.el.nativeElement.style.paddingRight = this.originalPadding;
        this.inProcess = false;
        Promise.resolve();
    }
}
/** @nocollapse */ SlickButtonSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickButtonSpinnerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickButtonSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickButtonSpinnerComponent, selector: "[slick-button-spinner]", inputs: { spinnerStatus: ["slick-button-spinner", "spinnerStatus"] }, usesOnChanges: true, ngImport: i0, template: "<ng-content></ng-content><div *ngIf=\"spinnerVisible\" class=\"slick-button-spinner_spin-icon\"></div><div *ngIf=\"checkVisible\" class=\"slick-button-spinner_check\"><i class=\"far fa-check-circle\"></i></div><div *ngIf=\"errorVisible\" class=\"slick-button-spinner_error\"><i class=\"far fa-times-circle\"></i></div>\r\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickButtonSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: '[slick-button-spinner]', template: "<ng-content></ng-content><div *ngIf=\"spinnerVisible\" class=\"slick-button-spinner_spin-icon\"></div><div *ngIf=\"checkVisible\" class=\"slick-button-spinner_check\"><i class=\"far fa-check-circle\"></i></div><div *ngIf=\"errorVisible\" class=\"slick-button-spinner_error\"><i class=\"far fa-times-circle\"></i></div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { spinnerStatus: [{
                type: Input,
                args: ['slick-button-spinner']
            }] } });

class SlickButtonSpinnerModule {
}
/** @nocollapse */ SlickButtonSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickButtonSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickButtonSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickButtonSpinnerModule, declarations: [SlickButtonSpinnerComponent], imports: [CommonModule], exports: [SlickButtonSpinnerComponent] });
/** @nocollapse */ SlickButtonSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickButtonSpinnerModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickButtonSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickButtonSpinnerComponent],
                    exports: [SlickButtonSpinnerComponent]
                }]
        }] });

class DayModel {
}
class WeekModel {
}
class MonthModel {
}
class SlickCalendarComponent {
    constructor() {
        this.condensed = false;
        this.monthsToShow = 1;
        this.monthsToIncrement = 1;
        this.inactiveDates = [];
        this.inactiveWeekends = false;
        this.showDaysNotInMonth = false;
        this.multiSelect = false;
        this.multiSelectDatesChange = new EventEmitter();
        this.onDateSelect = new EventEmitter();
        this.onDateChange = new EventEmitter();
        this.onMonthChange = new EventEmitter();
        this.onMultiDateChange = new EventEmitter();
        this.selectedDate = new Date();
        this.visibleDate = new Date();
        this.propagateChange = (_) => { };
        this.uuid = SlickUtilsService.newGuid();
    }
    onClick(event, targetElement) {
        if (!targetElement || SlickUtilsService.checkParentClassExists(targetElement, "slickCalendar_month"))
            return;
    }
    ngOnInit() {
        this.recalc();
    }
    async ngOnChanges(changes) {
        if (changes.condensed)
            this.condensed = (this.condensed || 'false').toString().toLowerCase() === 'true' ? true : false;
        if (changes.inactiveWeekends)
            this.inactiveWeekends = (this.inactiveWeekends || 'true').toString().toLowerCase() === 'false' ? false : true;
        if (changes.showDaysNotInMonth)
            this.showDaysNotInMonth = (this.showDaysNotInMonth || 'false').toString().toLowerCase() === 'true' ? true : false;
        if (changes.multiSelect)
            this.multiSelect = (this.multiSelect || 'false').toString().toLowerCase() === 'true' ? true : false;
        const widthPerCalendar = (this.condensed) ? 180 : 250;
        this.minWidth = this.monthsToShow * widthPerCalendar;
        this.recalc();
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj) {
            if (moment(obj).isValid()) {
                this.selectedDate = obj;
                this.visibleDate = obj;
                if (this.months) {
                    // Say we have 3 months showing and they select a date on the 3rd month
                    // Recalc will re-draw the 3rd month as the first month instead of just 
                    // higlighting the date on the 3rd month.  Highlight instead.
                    let dateFound = false;
                    for (let month of this.months) {
                        for (let week of month.weeks) {
                            for (let day of week.days) {
                                day.isSelected = false;
                                if (day.isInCurrentMonth === true && moment(day.date).isSame(this.selectedDate, "date")) {
                                    day.isSelected = true;
                                    dateFound = true;
                                }
                            }
                        }
                    }
                    // But if they've 
                    if (dateFound === false)
                        this.recalc();
                }
                else {
                    this.recalc();
                }
            }
            else {
                this.selectedDate = null;
            }
        }
        else {
            if (!this.selectedDate && this.onDateChange)
                this.onDateChange.emit(null);
            this.selectedDate = null;
        }
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    prevMonth() {
        this.visibleDate = moment(this.visibleDate).subtract(this.monthsToIncrement, "months").toDate();
        this.recalc();
        if (this.onMonthChange) {
            let monthStart = moment(this.visibleDate).startOf("month");
            if (this.showDaysNotInMonth === true)
                monthStart = monthStart.startOf("week");
            this.onMonthChange.emit(monthStart.toDate());
        }
    }
    nextMonth() {
        this.visibleDate = moment(this.visibleDate).add(this.monthsToIncrement, "months").toDate();
        this.recalc();
        if (this.onMonthChange) {
            let monthStart = moment(this.visibleDate).startOf("month");
            if (this.showDaysNotInMonth === true)
                monthStart = monthStart.startOf("week");
            this.onMonthChange.emit(monthStart.toDate());
        }
    }
    selectMonth(monthIdx) {
        const month = this.months[monthIdx];
        let visibleDate = moment(this.visibleDate);
        let dateString = month + visibleDate.format(" 1, YYYY");
        this.visibleDate = moment(dateString, "MMMM DD, YYYY").toDate();
        this.recalc();
    }
    setDate(dayModel) {
        if (this.showDaysNotInMonth === false && dayModel.isInCurrentMonth === false)
            return;
        if (dayModel.isActive === false)
            return;
        if (this.multiSelect === false) {
            this.selectedDate = dayModel.date;
            this.visibleDate = dayModel.date;
            this.propagateChange(this.selectedDate);
            if (this.onDateChange)
                this.onDateChange.emit(this.selectedDate);
            if (this.onDateSelect)
                this.onDateSelect.emit(this.selectedDate);
            // Say we have 3 months showing and they select a date on the 3rd month
            // Recalc will re-draw the 3rd month as the first month instead of just 
            // higlighting the date on the 3rd month.  Highlight instead.
            let dateFound = false;
            for (let month of this.months) {
                for (let week of month.weeks) {
                    for (let day of week.days) {
                        day.isSelected = false;
                        if (day.isInCurrentMonth === true && moment(day.date).isSame(this.selectedDate, "date")) {
                            day.isSelected = true;
                            dateFound = true;
                        }
                    }
                }
            }
            // But if they've 
            if (dateFound === false)
                this.recalc();
        }
        else {
            // This will be reversed since we haven't re-calced the dates yet.
            if (!dayModel.isSelected)
                this.multiSelectDates.push(dayModel.date);
            else {
                let dateIdx = this.multiSelectDates.findIndex(d => moment(d).startOf("date").isSame(moment(dayModel.date).startOf("date")));
                this.multiSelectDates.splice(dateIdx, 1);
            }
            if (this.onMultiDateChange)
                this.onMultiDateChange.emit(this.multiSelectDates);
            for (let month of this.months) {
                for (let week of month.weeks) {
                    for (let day of week.days) {
                        day.isSelected = false;
                        if (day.isInCurrentMonth === true && (this.multiSelectDates.findIndex(x => moment(x).isSame(moment(day.date), "date")) >= 0)) {
                            day.isSelected = true;
                        }
                    }
                }
            }
        }
    }
    recalc() {
        this.months = [];
        for (let monthCount = 0; monthCount < this.monthsToShow; monthCount++) {
            let currentDate = moment(this.visibleDate).startOf("month");
            currentDate = moment(currentDate).add(monthCount, "months");
            currentDate = moment(currentDate).startOf("week").startOf("date");
            const month = new MonthModel();
            month.weeks = [];
            // CurrentDate is most likely going to be the month before, so add 15 days to get to the middle of the current month
            const monthToDisplay = moment(currentDate).add(15, "days");
            month.monthDisplay = (this.condensed === true) ? monthToDisplay.format("MMM YYYY") : monthToDisplay.format("MMM YYYY");
            for (let weekCount = 0; weekCount < 6; weekCount++) {
                const week = new WeekModel();
                week.days = [];
                for (let dayCount = 0; dayCount < 7; dayCount++) {
                    const day = new DayModel();
                    day.date = currentDate.toDate();
                    day.isToday = moment().isSame(currentDate, "date");
                    if (this.multiSelect && this.multiSelectDates)
                        day.isSelected = (this.multiSelectDates.findIndex(x => moment(x).isSame(moment(day.date), "date")) >= 0);
                    else
                        day.isSelected = moment(this.selectedDate).isSame(currentDate, "date");
                    day.isInCurrentMonth = (currentDate.month() === monthToDisplay.month());
                    day.isActive = true;
                    if (this.inactiveWeekends && currentDate.day() === 6 || currentDate.day() === 7)
                        day.isActive = false;
                    if (this.inactiveDates && this.inactiveDates.findIndex(x => moment(x).isSame(currentDate, "date")) >= 0)
                        day.isActive = false;
                    if (this.showDaysNotInMonth === false && day.isInCurrentMonth === false)
                        day.isActive = false;
                    // It's possible for the day to be in the month display, but hidden, but active
                    if (day.isActive === false)
                        day.isSelected = false;
                    if (day.isInCurrentMonth === false)
                        day.isSelected = false;
                    week.days.push(day);
                    currentDate = moment(currentDate).add(1, "days");
                }
                month.weeks.push(week);
            }
            this.months.push(month);
        }
    }
}
/** @nocollapse */ SlickCalendarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCalendarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickCalendarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickCalendarComponent, selector: "slick-calendar", inputs: { condensed: "condensed", monthsToShow: "monthsToShow", monthsToIncrement: "monthsToIncrement", inactiveDates: "inactiveDates", inactiveWeekends: "inactiveWeekends", showDaysNotInMonth: "showDaysNotInMonth", multiSelect: "multiSelect", multiSelectDates: "multiSelectDates" }, outputs: { multiSelectDatesChange: "multiSelectDatesChange", onDateSelect: "onDateSelect", onDateChange: "onDateChange", onMonthChange: "onMonthChange", onMultiDateChange: "onMultiDateChange" }, host: { listeners: { "click": "onClick($event,$event.target)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickCalendarComponent)),
            multi: true,
        }
    ], usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-calendar default-width card\" id=\"slick-calendar_{{uuid}}\" [style.minWidth.px]=\"minWidth\" [ngClass]=\"{'slick-calendar_condensed': condensed === true, 'slick-calendar_single': monthsToShow === 1 }\">\r\n\t<div class=\"slick-calendar_prev-month\" (click)=\"prevMonth()\"><i class=\"far fa-chevron-left\"></i></div>\r\n\t<div class=\"slick-calendar_next-month\" (click)=\"nextMonth()\"><i class=\"far fa-chevron-right\"></i></div>\r\n\r\n\t<div class=\"d-flex justify-content-around pt-2\" [ngClass]=\"{ 'mx-3': monthsToShow > 1, 'mx-1': monthsToShow === 1 }\">\r\n\t\t<div *ngFor=\"let month of months\" class=\"flex-fill mx-2\" style=\"text-align: center;max-width: 220px;\">\r\n\r\n\t\t\t<table class=\"table table-sm table-borderless\" style=\"table-layout: fixed; \">\r\n\t\t\t\t<thead>\r\n\t\t\t\t\t<tr class=\"slick-calendar_month-display\">\r\n\t\t\t\t\t\t<td colspan=\"7\"><b>{{month.monthDisplay}}</b></td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr class=\"slick-calendar_days-of-week\">\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Sun</span><span *ngIf='condensed === true'>S</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Mon</span><span *ngIf='condensed === true'>M</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Tue</span><span *ngIf='condensed === true'>T</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Wed</span><span *ngIf='condensed === true'>W</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Thu</span><span *ngIf='condensed === true'>Th</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Fri</span><span *ngIf='condensed === true'>F</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Sat</span><span *ngIf='condensed === true'>S</span></td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</thead>\r\n\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr *ngFor=\"let week of month.weeks\">\r\n\t\t\t\t\t\t<td *ngFor=\"let day of week.days\" (click)=\"setDate(day)\" class=\"slick-calendar_date\" [ngClass]=\"{ 'slick-calendar_is-today': day.isToday, 'bg-success text-white': day.isSelected, 'slick-calendar_not_in_month': day.isInCurrentMonth === false, 'slick-calendar_inactive': day.isActive === false }\">\r\n\t\t\t\t\t\t\t<span *ngIf=\"showDaysNotInMonth === true || (showDaysNotInMonth === false && day.isInCurrentMonth === true)\">{{day.date | date:'d'}}</span>\r\n\t\t\t\t\t\t\t<span *ngIf=\"monthsToShow > 1 && (showDaysNotInMonth === false && day.isInCurrentMonth === false)\">&nbsp;</span>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</tbody>\r\n\t\t\t</table>\r\n\r\n\r\n\t\t</div>\r\n\r\n\t</div>\r\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCalendarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-calendar', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickCalendarComponent)),
                            multi: true,
                        }
                    ], template: "<div class=\"slick-calendar default-width card\" id=\"slick-calendar_{{uuid}}\" [style.minWidth.px]=\"minWidth\" [ngClass]=\"{'slick-calendar_condensed': condensed === true, 'slick-calendar_single': monthsToShow === 1 }\">\r\n\t<div class=\"slick-calendar_prev-month\" (click)=\"prevMonth()\"><i class=\"far fa-chevron-left\"></i></div>\r\n\t<div class=\"slick-calendar_next-month\" (click)=\"nextMonth()\"><i class=\"far fa-chevron-right\"></i></div>\r\n\r\n\t<div class=\"d-flex justify-content-around pt-2\" [ngClass]=\"{ 'mx-3': monthsToShow > 1, 'mx-1': monthsToShow === 1 }\">\r\n\t\t<div *ngFor=\"let month of months\" class=\"flex-fill mx-2\" style=\"text-align: center;max-width: 220px;\">\r\n\r\n\t\t\t<table class=\"table table-sm table-borderless\" style=\"table-layout: fixed; \">\r\n\t\t\t\t<thead>\r\n\t\t\t\t\t<tr class=\"slick-calendar_month-display\">\r\n\t\t\t\t\t\t<td colspan=\"7\"><b>{{month.monthDisplay}}</b></td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr class=\"slick-calendar_days-of-week\">\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Sun</span><span *ngIf='condensed === true'>S</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Mon</span><span *ngIf='condensed === true'>M</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Tue</span><span *ngIf='condensed === true'>T</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Wed</span><span *ngIf='condensed === true'>W</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Thu</span><span *ngIf='condensed === true'>Th</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Fri</span><span *ngIf='condensed === true'>F</span></td>\r\n\t\t\t\t\t\t<td><span *ngIf='condensed === false'>Sat</span><span *ngIf='condensed === true'>S</span></td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</thead>\r\n\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr *ngFor=\"let week of month.weeks\">\r\n\t\t\t\t\t\t<td *ngFor=\"let day of week.days\" (click)=\"setDate(day)\" class=\"slick-calendar_date\" [ngClass]=\"{ 'slick-calendar_is-today': day.isToday, 'bg-success text-white': day.isSelected, 'slick-calendar_not_in_month': day.isInCurrentMonth === false, 'slick-calendar_inactive': day.isActive === false }\">\r\n\t\t\t\t\t\t\t<span *ngIf=\"showDaysNotInMonth === true || (showDaysNotInMonth === false && day.isInCurrentMonth === true)\">{{day.date | date:'d'}}</span>\r\n\t\t\t\t\t\t\t<span *ngIf=\"monthsToShow > 1 && (showDaysNotInMonth === false && day.isInCurrentMonth === false)\">&nbsp;</span>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</tbody>\r\n\t\t\t</table>\r\n\r\n\r\n\t\t</div>\r\n\r\n\t</div>\r\n</div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { condensed: [{
                type: Input
            }], monthsToShow: [{
                type: Input
            }], monthsToIncrement: [{
                type: Input
            }], inactiveDates: [{
                type: Input
            }], inactiveWeekends: [{
                type: Input
            }], showDaysNotInMonth: [{
                type: Input
            }], multiSelect: [{
                type: Input
            }], multiSelectDates: [{
                type: Input
            }], multiSelectDatesChange: [{
                type: Output
            }], onDateSelect: [{
                type: Output
            }], onDateChange: [{
                type: Output
            }], onMonthChange: [{
                type: Output
            }], onMultiDateChange: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event', '$event.target']]
            }] } });

class SlickCalendarModule {
}
/** @nocollapse */ SlickCalendarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCalendarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickCalendarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickCalendarModule, declarations: [SlickCalendarComponent], imports: [CommonModule], exports: [SlickCalendarComponent] });
/** @nocollapse */ SlickCalendarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCalendarModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCalendarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickCalendarComponent],
                    exports: [SlickCalendarComponent]
                }]
        }] });

class SlickCardHeaderComponent {
}
/** @nocollapse */ SlickCardHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickCardHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickCardHeaderComponent, selector: "slick-card-header", ngImport: i0, template: "<div class='card-header'><ng-content></ng-content></div>", isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "slick-card-header",
                    template: "<div class='card-header'><ng-content></ng-content></div>"
                }]
        }] });

class SlickCardComponent {
    constructor() {
        this.clickable = true;
        this.selected = false;
        this.cardKey = '';
        this.onSelect = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.clickable)
            this.clickable = (this.clickable === null || this.clickable === undefined) ? true : this.clickable.toString().toLowerCase() === "true";
        if (changes.selected) {
            if (this.clickable === true)
                this.selected = (this.selected === null || this.selected === undefined) ? false : this.selected.toString().toLowerCase() === "true";
            else
                this.selected = false;
        }
    }
    onClick() {
        if (this.clickable === true && this.onSelect)
            this.onSelect.emit(this.cardKey);
    }
}
/** @nocollapse */ SlickCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickCardComponent, selector: "slick-card", inputs: { header: "header", clickable: "clickable", selected: "selected", cardKey: "cardKey" }, outputs: { onSelect: "onSelect" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-card card\" [ngClass]=\"{'slick-card_clickable': clickable === true, 'bg-primary text-white': selected === true }\" (click)=\"onClick()\">\r\n\t<div *ngIf=\"header\" class=\"card-header\">{{header}}</div>\r\n\t<ng-content select=\"slick-card-header\"></ng-content>\r\n\t<div class=\"card-body\"><ng-content></ng-content></div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-card", template: "<div class=\"slick-card card\" [ngClass]=\"{'slick-card_clickable': clickable === true, 'bg-primary text-white': selected === true }\" (click)=\"onClick()\">\r\n\t<div *ngIf=\"header\" class=\"card-header\">{{header}}</div>\r\n\t<ng-content select=\"slick-card-header\"></ng-content>\r\n\t<div class=\"card-body\"><ng-content></ng-content></div>\r\n</div>\r\n" }]
        }], propDecorators: { header: [{
                type: Input
            }], clickable: [{
                type: Input
            }], selected: [{
                type: Input
            }], cardKey: [{
                type: Input
            }], onSelect: [{
                type: Output
            }] } });

class SlickCardModule {
}
/** @nocollapse */ SlickCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickCardModule, declarations: [SlickCardComponent, SlickCardHeaderComponent], imports: [CommonModule], exports: [SlickCardComponent, SlickCardHeaderComponent, CommonModule] });
/** @nocollapse */ SlickCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCardModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [SlickCardComponent, SlickCardHeaderComponent, CommonModule],
                    declarations: [SlickCardComponent, SlickCardHeaderComponent]
                }]
        }] });

class SlickDialogService {
    constructor() { }
    createOverlay() {
        let overlayEl = document.createElement("div");
        overlayEl.classList.add("slick-dialog-overlay");
        document.body.appendChild(overlayEl);
        return overlayEl;
    }
    showOverlay(overlayEl) {
        overlayEl.classList.add("visible");
        overlayEl.style.zIndex = (SlickDialogService.overlayCount * 100).toString();
        SlickDialogService.overlayCount++;
    }
    hideOverlay(overlayEl) {
        overlayEl.classList.remove("visible");
        //SlickDialogService.overlayCount--;
    }
    minimize(el) {
        SlickDialogService.minimizedDialogs.push(el);
        for (let i = 0; i < SlickDialogService.minimizedDialogs.length; i++)
            this.positionInBottomBar(i + 1);
    }
    maximize(el, top, width, height, xOffset, yOffset) {
        this.positionAtCenter(el, top, width, height, xOffset, yOffset);
        this.removeDialogFromMinimized(el);
    }
    removeDialogFromMinimized(el) {
        SlickDialogService.minimizedDialogs = SlickDialogService.minimizedDialogs.filter((x) => {
            return x.nativeElement !== el.nativeElement;
        });
        for (let i = 0; i < SlickDialogService.minimizedDialogs.length; i++)
            this.positionInBottomBar(i + 1);
    }
    positionAtCenter(el, top, width, height, xOffset, yOffset) {
        el.nativeElement.style.top = top + "px";
        el.nativeElement.style.width = width + "px";
        el.nativeElement.style.height = height === 0 ? "initial" : height + "px";
        el.nativeElement.style.bottom = "initial";
        el.nativeElement.style.right = "calc(50% - " + (width / 2) + "px)";
        el.nativeElement.style.transform = "translate(" + xOffset + "px, " + yOffset + "px)";
    }
    positionInBottomBar(position) {
        const index = position - 1;
        const slotSize = 280;
        const slotHeight = 44;
        const padding = 10;
        const width = window.innerWidth;
        const availableSlots = parseInt((width / (slotSize + padding)).toString());
        const column = position % availableSlots;
        const row = parseInt((position / availableSlots).toString()) + 1;
        const el = SlickDialogService.minimizedDialogs[index];
        el.nativeElement.style.left = "initial";
        el.nativeElement.style.top = `calc(100% - ${row * (slotHeight + padding)}px)`;
        el.nativeElement.style.bottom = (row * (slotHeight + padding)) + "px";
        el.nativeElement.style.right = "0";
        el.nativeElement.style.transform = `translateX(-${((column - 1) * slotSize) + padding}px)`;
    }
}
SlickDialogService.overlayCount = 1;
SlickDialogService.minimizedDialogs = new Array();
/** @nocollapse */ SlickDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class SlickDialogComponent {
    constructor(dialogService) {
        this.dialogService = dialogService;
        this.draggable = true;
        this.resizable = true;
        this.minimizable = true;
        this.showHeader = true;
        this.noPadding = false;
        this.top = 80;
        this.width = 600;
        this.height = 0;
        this.maxHeight = 0;
        this.showOverlay = true;
        this.disableScrollbar = false;
        this.onClose = new EventEmitter();
        this.fnResize = () => this.resize();
        this.showDialog_internal = false;
        this.isDialogVisible = false;
        this.isBodyVisible = false;
        this.hasFooter = false;
        this.zIndex = 0;
        this.inBounds = true;
        this.isMaximized = false;
        this.isMinimized = false;
        this.positionXOffset = 0;
        this.positionYOffset = 0;
    }
    ngOnInit() {
        this.loadPositionAndSize();
    }
    ngOnChanges(changes) {
        if (changes.draggable)
            this.draggable = (this.draggable.toString().toLowerCase() === 'false') ? false : true;
        if (changes.resizable)
            this.resizable = (this.resizable.toString().toLowerCase() === 'false') ? false : true;
        if (changes.minimizable)
            this.minimizable = (this.minimizable.toString().toLowerCase() === 'false') ? false : true;
        if (changes.showHeader)
            this.showHeader = (this.showHeader.toString().toLowerCase() === 'false') ? false : true;
        if (changes.noPadding)
            this.noPadding = (this.noPadding.toString().toLowerCase() === 'true') ? true : false;
        if (changes.top)
            this.top = parseInt(this.top.toString());
        if (changes.width)
            this.width = parseInt(this.width.toString());
        if (changes.height)
            this.height = parseInt(this.height.toString());
        if (changes.maxHeight)
            this.maxHeight = parseInt(this.maxHeight.toString());
        if (changes.showOverlay)
            this.showOverlay = (this.showOverlay.toString().toLowerCase() === 'false') ? false : true;
        if (changes.disableScrollbar)
            this.disableScrollbar = (this.disableScrollbar.toString().toLowerCase() === 'true') ? true : false;
    }
    ngOnDestroy() {
        window.removeEventListener("resize", this.fnResize, true);
        // It's fine if this fails.  It just means they were already removed
        try {
            document.body.removeChild(this.containerRef.nativeElement);
            document.body.removeChild(this.overlayEl);
        }
        catch { }
        this.overlayEl = null;
    }
    onMoveEnd(event) {
        this.positionXOffset = event.x;
        this.positionYOffset = event.y;
        this.updatePositionAndSize();
    }
    onResizeStop(event) {
        this.width = event.size.width;
        this.height = event.size.height;
        this.updatePositionAndSize();
    }
    updatePositionAndSize() {
        const state = {
            positionXOffset: this.positionXOffset,
            positionYOffset: this.positionYOffset,
            width: this.width,
            height: this.height
        };
        this.position = {
            x: this.positionXOffset,
            y: this.positionYOffset
        };
        if (this.key) {
            localStorage.setItem(`DIALOG_STATE_${this.key}`, JSON.stringify(state));
        }
    }
    loadPositionAndSize() {
        if (!this.key && SlickInitService.getParams().errorLog === "verbose") {
            console.error("Storage Key ([key] parameter) is not provided for Slick Dialog. Persisting state is disabled.");
            return;
        }
        const state = JSON.parse(localStorage.getItem(`DIALOG_STATE_${this.key}`));
        if (state) {
            this.positionXOffset = state.positionXOffset;
            this.positionYOffset = state.positionYOffset;
            this.width = state.width;
            this.height = state.height;
            // Sometimes this goes above the top of the screen.  If it does, reset it
            if (this.positionYOffset < 0 && this.positionYOffset < (this.top * -1)) {
                this.positionYOffset = this.top * -1;
                this.updatePositionAndSize();
            }
            this.position = {
                x: this.positionXOffset,
                y: this.positionYOffset
            };
        }
    }
    async showDialog() {
        this.showDialog_internal = true;
        await SlickSleepService.sleep();
        document.body.appendChild(this.containerRef.nativeElement);
        this.overlayEl = this.dialogService.createOverlay();
        this.isMinimized = false;
        this.isMaximized = false;
        this.dialogService.removeDialogFromMinimized(this.dialogWrapper);
        this.dialogService.positionAtCenter(this.dialogWrapper, this.top, this.width, this.height, this.positionXOffset, this.positionYOffset);
        this.dialogRef.nativeElement.style.width = this.width + "px";
        this.zIndex = ((SlickDialogService.overlayCount * 100) + 1);
        if (this.showOverlay) {
            this.dialogService.showOverlay(this.overlayEl);
        }
        this.isDialogVisible = true;
        this.resize();
        this.dialogRef.nativeElement.classList.remove("collapse-dialog");
        this.dialogRef.nativeElement.classList.add("expand-dialog");
        window.addEventListener("resize", this.fnResize, true);
    }
    async onDialogClose(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        await this.hideDialog();
        if (this.onClose)
            this.onClose.emit();
    }
    async hideDialog() {
        if (this.isDialogVisible === false)
            return;
        this.isMaximized = false;
        if (this.showOverlay) {
            this.dialogService.hideOverlay(this.overlayEl);
        }
        this.dialogRef.nativeElement.classList.remove("expand-dialog");
        this.dialogRef.nativeElement.classList.add("collapse-dialog");
        await SlickSleepService.sleep(350);
        this.isBodyVisible = false;
        this.isDialogVisible = false;
        if (this.isMinimized) {
            this.dialogService.removeDialogFromMinimized(this.dialogWrapper);
            this.isMinimized = false;
        }
        window.removeEventListener("resize", this.fnResize, true);
        // It's fine if this fails.  It just means they were already removed
        try {
            document.body.removeChild(this.containerRef.nativeElement);
            document.body.removeChild(this.overlayEl);
        }
        catch { }
        this.overlayEl = null;
        this.showDialog_internal = false;
    }
    onDialogMinimize(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.isMaximized = false;
        this.isMinimized = true;
        this.dialogRef.nativeElement.style.height = "initial";
        if (this.showOverlay) {
            this.dialogService.hideOverlay(this.overlayEl);
        }
        this.dialogService.minimize(this.dialogWrapper);
    }
    onDialogMaximize(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.dialogService.maximize(this.dialogWrapper, this.top, this.width, this.height, this.positionXOffset, this.positionYOffset);
        if (this.showOverlay) {
            this.dialogService.showOverlay(this.overlayEl);
        }
        this.zIndex = parseInt(this.overlayEl.style.zIndex) + 1;
        setTimeout(() => {
            this.isMinimized = false;
            this.dialogRef.nativeElement.style.height = "100%";
            this.dialogRef.nativeElement.style.width = this.width + "px";
            this.resize();
        }, 300);
    }
    toggleFullSize(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (!this.isMaximized) {
            this.dialogWrapper.nativeElement.style.top = "0px";
            this.dialogWrapper.nativeElement.style.right = "0px";
            this.dialogWrapper.nativeElement.style.left = "0px";
            this.dialogRef.nativeElement.style.height = window.innerHeight + "px";
            this.dialogRef.nativeElement.style.width = window.innerWidth + "px";
            this.dialogWrapper.nativeElement.style.width = window.innerWidth + "px";
            this.dialogRef.nativeElement.style.maxHeight = "initial";
            this.dialogWrapper.nativeElement.style.transform = "translate(0%)";
            this.isMaximized = true;
            this.resize(true);
        }
        else {
            this.dialogWrapper.nativeElement.style.top = this.top + "px";
            this.dialogWrapper.nativeElement.style.right = "calc(50% - " + (this.width / 2) + "px)";
            this.dialogWrapper.nativeElement.style.left = "calc(50% - " + (this.width / 2) + "px)";
            this.dialogWrapper.nativeElement.style.transform = "translate(" + this.positionXOffset + "px, " + this.positionYOffset + "px)";
            this.dialogRef.nativeElement.style.height = this.height === 0 ? "initial" : this.height + "px";
            this.dialogRef.nativeElement.style.width = this.width + "px";
            this.dialogWrapper.nativeElement.style.width = this.width + "px";
            this.dialogRef.nativeElement.style.maxHeight = this.maxHeight + "";
            this.isMaximized = false;
            this.resize(false);
        }
    }
    async resize(forFullSize = false) {
        if (this.isMaximized)
            forFullSize = true;
        await SlickSleepService.sleep(50);
        let headerHeight = (this.headerRef) ? this.headerRef.nativeElement.clientHeight : 0;
        let footerHeight = (this.footerRef) ? this.footerRef.nativeElement.clientHeight : 0;
        this.hasFooter = footerHeight > 0;
        let documentBodyHeight = !forFullSize ? (document.body.clientHeight || window.innerHeight) : window.innerHeight;
        this.maxHeight = !forFullSize ? documentBodyHeight - (this.top * 2) : documentBodyHeight;
        this.isBodyVisible = true;
    }
}
/** @nocollapse */ SlickDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogComponent, deps: [{ token: SlickDialogService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickDialogComponent, selector: "slick-dialog", inputs: { draggable: "draggable", resizable: "resizable", minimizable: "minimizable", header: "header", showHeader: "showHeader", noPadding: "noPadding", top: "top", width: "width", height: "height", maxHeight: "maxHeight", cssClass: "cssClass", key: "key", showOverlay: "showOverlay", disableScrollbar: "disableScrollbar" }, outputs: { onClose: "onClose" }, providers: [SlickDialogService], viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }, { propertyName: "dialogRef", first: true, predicate: ["dialogRef"], descendants: true }, { propertyName: "headerRef", first: true, predicate: ["headerRef"], descendants: true }, { propertyName: "footerRef", first: true, predicate: ["footerRef"], descendants: true }, { propertyName: "dialogWrapper", first: true, predicate: ["dialogWrapper"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerRef class=\"slick-dialog-container\" *ngIf=\"showDialog_internal === true\" [hidden]=\"!isDialogVisible\" [style.zIndex]=\"zIndex\" #bounds>\r\n    <div #dialogWrapper class=\"position-absolute slick-dialog-z-index d-inline-block\" [ngClass]=\"{'isMinimized' : isMinimized }\" (endOffset)=\"onMoveEnd($event)\" [position]=\"position\" [ngDraggable]=\"draggable && !isMinimized\" [bounds]=\"bounds\" [handle]=\"draggingHandle\" [inBounds]=\"inBounds\" [style.top.px]=\"top\">\r\n        <div #dialogRef (rzStop)=\"onResizeStop($event)\" [ngResizable]=\"resizable && !isMinimized\" class=\"slick-dialog modal-content d-flex flex-column drag-block-handle {{cssClass}}\" [style.height]=\"height === 0 ? '100%' : height + 'px'\" [style.width.px]=\"width\" [style.max-height.px]=\"maxHeight\">\r\n            <div [class.slick-dialog-draggingHangle]=\"draggable && !isMinimized\" #draggingHandle>\r\n                <div #headerRef class=\"slick-dialog_header modal-header py-0\" *ngIf=\"showHeader === true\">\r\n                    <div class=\"header-left\">{{header}}</div>\r\n                    <div class=\"header-right\" *ngIf=\"minimizable && !isMinimized\" (mousedown)=\"onDialogMinimize($event)\" style=\"width: 28px;\"><i class=\"far fa-window-minimize\"></i></div>\r\n                    <div class=\"header-right\" *ngIf=\"minimizable && !isMinimized\" (mousedown)=\"toggleFullSize($event)\" style=\"width: 28px;\"><i *ngIf=\"!isMaximized\" class=\"far fa-window-maximize\"></i><i *ngIf=\"isMaximized\" class=\"far fa-window-restore\"></i></div>\r\n                    <div class=\"header-right\" *ngIf=\"minimizable && isMinimized\" (mousedown)=\"onDialogMaximize($event)\" style=\"width: 28px;\"><i class=\"far fa-window-restore\"></i></div>\r\n                    <div class=\"header-right\" *ngIf=\"!isMinimized\" (mousedown)=\"onDialogClose($event)\" style=\"width: 28px;\"><i class=\"far fa-times\"></i></div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"!isMinimized\" [style.visibility]=\"(isBodyVisible === true) ? 'visible' : 'hidden'\" style=\"overflow-y: auto\" class=\"slick-dialog_body modal-body flex-fill\" [ngClass]=\"{'disable_scrollbar' : disableScrollbar === true, 'p-0': noPadding === true }\"><ng-content></ng-content></div>\r\n            <div #footerRef [ngClass]=\"{'slick-dialog_footer modal-footer': hasFooter === true }\" *ngIf=\"!isMinimized\"><ng-content select=\"slick-dialog-footer\"></ng-content></div>\r\n        </div>\r\n    </div>\r\n\r\n</div>", styles: [".ng-resizable{position:relative}.ng-resizable-handle{position:absolute;font-size:.1px;display:block;touch-action:none}.ng-resizable-handle.ng-resizable-e{cursor:e-resize;width:7px;right:-5px;height:100%;top:0}.ng-resizable-handle.ng-resizable-w{cursor:w-resize;width:7px;left:-5px;height:100%;top:0}.ng-resizable-handle.ng-resizable-s{cursor:s-resize;height:7px;bottom:-5px;width:100%;left:0}.ng-resizable-handle.ng-resizable-n{cursor:n-resize;height:7px;top:-5px;width:100%;left:0}.ng-resizable-handle.ng-resizable-se{cursor:se-resize;width:8px;height:8px;right:4px;bottom:4px}.ng-resizable-handle.ng-resizable-sw{cursor:sw-resize;width:12px;height:12px;left:1px;bottom:1px}.ng-resizable-handle.ng-resizable-ne{cursor:ne-resize;width:12px;height:12px;right:1px;top:1px}.ng-resizable-handle.ng-resizable-nw{cursor:nw-resize;width:12px;height:12px;left:1px;top:1px}.ng-resizable-diagonal{box-sizing:border-box;width:0;height:0;border-bottom:8px solid #aaa;border-left:8px solid transparent}.slick-dialog-z-index.isMinimized{-webkit-transition-property:all;-webkit-transition-duration:.3s;-webkit-transition-timing-function:linear;transition-property:all;transition-duration:.3s;transition-timing-function:linear}.isMinimized .header-left{display:inline-block;width:calc(100% - 40px);padding-left:15px;vertical-align:top;font-weight:700;text-overflow:ellipsis;overflow:hidden;width:200px;white-space:nowrap}.disable_scrollbar{overflow:hidden!important;overflow-x:hidden;overflow-y:hidden;padding:10px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.AngularDraggableDirective, selector: "[ngDraggable]", inputs: ["outOfBounds", "gridSize", "inBounds", "trackPosition", "scale", "preventDefaultEvent", "position", "lockAxis", "zIndex", "ngDraggable", "bounds", "handle", "zIndexMoving"], outputs: ["started", "stopped", "edge", "movingOffset", "endOffset"], exportAs: ["ngDraggable"] }, { kind: "directive", type: i3.AngularResizableDirective, selector: "[ngResizable]", inputs: ["rzHandles", "rzAspectRatio", "rzContainment", "rzGrid", "rzMinWidth", "rzMinHeight", "rzMaxWidth", "rzMaxHeight", "preventDefaultEvent", "ngResizable"], outputs: ["rzStart", "rzResizing", "rzStop"], exportAs: ["ngResizable"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-dialog', providers: [SlickDialogService], template: "<div #containerRef class=\"slick-dialog-container\" *ngIf=\"showDialog_internal === true\" [hidden]=\"!isDialogVisible\" [style.zIndex]=\"zIndex\" #bounds>\r\n    <div #dialogWrapper class=\"position-absolute slick-dialog-z-index d-inline-block\" [ngClass]=\"{'isMinimized' : isMinimized }\" (endOffset)=\"onMoveEnd($event)\" [position]=\"position\" [ngDraggable]=\"draggable && !isMinimized\" [bounds]=\"bounds\" [handle]=\"draggingHandle\" [inBounds]=\"inBounds\" [style.top.px]=\"top\">\r\n        <div #dialogRef (rzStop)=\"onResizeStop($event)\" [ngResizable]=\"resizable && !isMinimized\" class=\"slick-dialog modal-content d-flex flex-column drag-block-handle {{cssClass}}\" [style.height]=\"height === 0 ? '100%' : height + 'px'\" [style.width.px]=\"width\" [style.max-height.px]=\"maxHeight\">\r\n            <div [class.slick-dialog-draggingHangle]=\"draggable && !isMinimized\" #draggingHandle>\r\n                <div #headerRef class=\"slick-dialog_header modal-header py-0\" *ngIf=\"showHeader === true\">\r\n                    <div class=\"header-left\">{{header}}</div>\r\n                    <div class=\"header-right\" *ngIf=\"minimizable && !isMinimized\" (mousedown)=\"onDialogMinimize($event)\" style=\"width: 28px;\"><i class=\"far fa-window-minimize\"></i></div>\r\n                    <div class=\"header-right\" *ngIf=\"minimizable && !isMinimized\" (mousedown)=\"toggleFullSize($event)\" style=\"width: 28px;\"><i *ngIf=\"!isMaximized\" class=\"far fa-window-maximize\"></i><i *ngIf=\"isMaximized\" class=\"far fa-window-restore\"></i></div>\r\n                    <div class=\"header-right\" *ngIf=\"minimizable && isMinimized\" (mousedown)=\"onDialogMaximize($event)\" style=\"width: 28px;\"><i class=\"far fa-window-restore\"></i></div>\r\n                    <div class=\"header-right\" *ngIf=\"!isMinimized\" (mousedown)=\"onDialogClose($event)\" style=\"width: 28px;\"><i class=\"far fa-times\"></i></div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"!isMinimized\" [style.visibility]=\"(isBodyVisible === true) ? 'visible' : 'hidden'\" style=\"overflow-y: auto\" class=\"slick-dialog_body modal-body flex-fill\" [ngClass]=\"{'disable_scrollbar' : disableScrollbar === true, 'p-0': noPadding === true }\"><ng-content></ng-content></div>\r\n            <div #footerRef [ngClass]=\"{'slick-dialog_footer modal-footer': hasFooter === true }\" *ngIf=\"!isMinimized\"><ng-content select=\"slick-dialog-footer\"></ng-content></div>\r\n        </div>\r\n    </div>\r\n\r\n</div>", styles: [".ng-resizable{position:relative}.ng-resizable-handle{position:absolute;font-size:.1px;display:block;touch-action:none}.ng-resizable-handle.ng-resizable-e{cursor:e-resize;width:7px;right:-5px;height:100%;top:0}.ng-resizable-handle.ng-resizable-w{cursor:w-resize;width:7px;left:-5px;height:100%;top:0}.ng-resizable-handle.ng-resizable-s{cursor:s-resize;height:7px;bottom:-5px;width:100%;left:0}.ng-resizable-handle.ng-resizable-n{cursor:n-resize;height:7px;top:-5px;width:100%;left:0}.ng-resizable-handle.ng-resizable-se{cursor:se-resize;width:8px;height:8px;right:4px;bottom:4px}.ng-resizable-handle.ng-resizable-sw{cursor:sw-resize;width:12px;height:12px;left:1px;bottom:1px}.ng-resizable-handle.ng-resizable-ne{cursor:ne-resize;width:12px;height:12px;right:1px;top:1px}.ng-resizable-handle.ng-resizable-nw{cursor:nw-resize;width:12px;height:12px;left:1px;top:1px}.ng-resizable-diagonal{box-sizing:border-box;width:0;height:0;border-bottom:8px solid #aaa;border-left:8px solid transparent}.slick-dialog-z-index.isMinimized{-webkit-transition-property:all;-webkit-transition-duration:.3s;-webkit-transition-timing-function:linear;transition-property:all;transition-duration:.3s;transition-timing-function:linear}.isMinimized .header-left{display:inline-block;width:calc(100% - 40px);padding-left:15px;vertical-align:top;font-weight:700;text-overflow:ellipsis;overflow:hidden;width:200px;white-space:nowrap}.disable_scrollbar{overflow:hidden!important;overflow-x:hidden;overflow-y:hidden;padding:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: SlickDialogService }]; }, propDecorators: { draggable: [{
                type: Input
            }], resizable: [{
                type: Input
            }], minimizable: [{
                type: Input
            }], header: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], noPadding: [{
                type: Input
            }], top: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], key: [{
                type: Input
            }], showOverlay: [{
                type: Input
            }], disableScrollbar: [{
                type: Input
            }], onClose: [{
                type: Output
            }], containerRef: [{
                type: ViewChild,
                args: ["containerRef"]
            }], dialogRef: [{
                type: ViewChild,
                args: ["dialogRef"]
            }], headerRef: [{
                type: ViewChild,
                args: ["headerRef"]
            }], footerRef: [{
                type: ViewChild,
                args: ["footerRef"]
            }], dialogWrapper: [{
                type: ViewChild,
                args: ["dialogWrapper"]
            }] } });

var SlickConfirmDialogResults;
(function (SlickConfirmDialogResults) {
    SlickConfirmDialogResults[SlickConfirmDialogResults["Ok"] = 0] = "Ok";
    SlickConfirmDialogResults[SlickConfirmDialogResults["Cancel"] = 1] = "Cancel";
})(SlickConfirmDialogResults || (SlickConfirmDialogResults = {}));
class SlickConfirmDialogComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.width = 300;
        this.okButtonText = "Ok";
        this.cancelButtonText = "Cancel";
        this.showOkButton = true;
        this.showCancelButton = true;
        this.isVisible = false;
    }
    ngOnChanges(changes) {
        if (changes.showOkButton)
            this.showOkButton = (this.showOkButton.toString().toLowerCase() === 'false') ? false : true;
        if (changes.showCancelButton)
            this.showCancelButton = (this.showCancelButton.toString().toLowerCase() === 'false') ? false : true;
    }
    confirm() {
        this.isVisible = true;
        this.changeDetector.detectChanges();
        return new Promise((resolve, reject) => {
            this.dialogRef.showDialog();
            this.dialogResolve = resolve;
        });
    }
    onOk() {
        this.dialogRef.hideDialog();
        this.dialogResolve(SlickConfirmDialogResults.Ok);
    }
    onCancel() {
        this.dialogRef.hideDialog();
        this.dialogResolve(SlickConfirmDialogResults.Cancel);
    }
    onClose() {
        this.dialogResolve(SlickConfirmDialogResults.Cancel);
    }
}
/** @nocollapse */ SlickConfirmDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickConfirmDialogComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickConfirmDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickConfirmDialogComponent, selector: "slick-confirm-dialog", inputs: { width: "width", okButtonText: "okButtonText", cancelButtonText: "cancelButtonText", showOkButton: "showOkButton", showCancelButton: "showCancelButton" }, viewQueries: [{ propertyName: "dialogRef", first: true, predicate: ["dialogRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<slick-dialog *ngIf=\"isVisible === true\" #dialogRef [top]='200' [width]='width' [showHeader]='false' [resizable]=\"false\" [draggable]=\"false\" [minimizable]=\"false\" onClose='onClose()'>\r\n\t<div class=\"form-group text-center\">\r\n\t\t<h4 style='margin-top: 10px; margin-bottom: 20px'><ng-content></ng-content></h4>\r\n\t</div>\r\n\r\n\t<div class=\"text-center\" style='margin-top: 10px;'>\r\n\t\t<button *ngIf=\"showOkButton === true\" type=\"button\" style='width: 80px' class=\"btn btn-outline-primary\" (click)=\"onOk()\">{{okButtonText}}</button>&nbsp;&nbsp;\r\n\t\t<button *ngIf=\"showCancelButton === true\" type=\"button\" style='width: 80px' class=\"btn btn-outline-danger\" (click)=\"onCancel()\">Cancel</button>\r\n\t</div>\r\n</slick-dialog>\r\n", dependencies: [{ kind: "component", type: SlickDialogComponent, selector: "slick-dialog", inputs: ["draggable", "resizable", "minimizable", "header", "showHeader", "noPadding", "top", "width", "height", "maxHeight", "cssClass", "key", "showOverlay", "disableScrollbar"], outputs: ["onClose"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-confirm-dialog', template: "<slick-dialog *ngIf=\"isVisible === true\" #dialogRef [top]='200' [width]='width' [showHeader]='false' [resizable]=\"false\" [draggable]=\"false\" [minimizable]=\"false\" onClose='onClose()'>\r\n\t<div class=\"form-group text-center\">\r\n\t\t<h4 style='margin-top: 10px; margin-bottom: 20px'><ng-content></ng-content></h4>\r\n\t</div>\r\n\r\n\t<div class=\"text-center\" style='margin-top: 10px;'>\r\n\t\t<button *ngIf=\"showOkButton === true\" type=\"button\" style='width: 80px' class=\"btn btn-outline-primary\" (click)=\"onOk()\">{{okButtonText}}</button>&nbsp;&nbsp;\r\n\t\t<button *ngIf=\"showCancelButton === true\" type=\"button\" style='width: 80px' class=\"btn btn-outline-danger\" (click)=\"onCancel()\">Cancel</button>\r\n\t</div>\r\n</slick-dialog>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { width: [{
                type: Input
            }], okButtonText: [{
                type: Input
            }], cancelButtonText: [{
                type: Input
            }], showOkButton: [{
                type: Input
            }], showCancelButton: [{
                type: Input
            }], dialogRef: [{
                type: ViewChild,
                args: ["dialogRef"]
            }] } });

class SlickDialogFooterComponent {
    constructor() {
        this.flex = '1 1';
        this.textAlign = 'center';
    }
}
/** @nocollapse */ SlickDialogFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickDialogFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickDialogFooterComponent, selector: "slick-dialog-footer", host: { properties: { "style.flex": "this.flex", "style.textAlign": "this.textAlign" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-dialog-footer',
                    template: `<ng-content></ng-content>`
                }]
        }], propDecorators: { flex: [{
                type: HostBinding,
                args: ['style.flex']
            }], textAlign: [{
                type: HostBinding,
                args: ['style.textAlign']
            }] } });

class SlickDialogModule {
}
/** @nocollapse */ SlickDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogModule, declarations: [SlickDialogComponent, SlickDialogFooterComponent], imports: [CommonModule, AngularDraggableModule], exports: [SlickDialogComponent, SlickDialogFooterComponent] });
/** @nocollapse */ SlickDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogModule, providers: [SlickDialogService], imports: [CommonModule, AngularDraggableModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, AngularDraggableModule],
                    declarations: [SlickDialogComponent, SlickDialogFooterComponent],
                    exports: [SlickDialogComponent, SlickDialogFooterComponent],
                    providers: [SlickDialogService]
                }]
        }] });

class SlickConfirmDialogModule {
}
/** @nocollapse */ SlickConfirmDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickConfirmDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickConfirmDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickConfirmDialogModule, declarations: [SlickConfirmDialogComponent], imports: [SlickDialogModule, CommonModule], exports: [SlickConfirmDialogComponent] });
/** @nocollapse */ SlickConfirmDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickConfirmDialogModule, imports: [SlickDialogModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickConfirmDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [SlickDialogModule, CommonModule],
                    declarations: [SlickConfirmDialogComponent],
                    exports: [SlickConfirmDialogComponent]
                }]
        }] });

class SlickContainerComponent {
    constructor() {
        this.padding = true;
        this.uuid = SlickUtilsService.newGuid();
    }
}
/** @nocollapse */ SlickContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickContainerComponent, selector: "slick-container", inputs: { maxHeight: "maxHeight", padding: "padding" }, ngImport: i0, template: "<div #slickContainerDivRef id=\"slick-container_{{uuid}}\" class=\"slick-container\" [ngClass]=\"{ 'slick-container-padding': padding === true }\" [style.minHeight]=\"maxHeight\" [style.maxHeight]=\"maxHeight\">\r\n\t<ng-content select=\"slick-container-header\"></ng-content>\r\n\t<ng-content select=\"slick-container-body\"></ng-content>\r\n\t<ng-content select=\"slick-container-footer\"></ng-content>\r\n</div>\r\n\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-container', template: "<div #slickContainerDivRef id=\"slick-container_{{uuid}}\" class=\"slick-container\" [ngClass]=\"{ 'slick-container-padding': padding === true }\" [style.minHeight]=\"maxHeight\" [style.maxHeight]=\"maxHeight\">\r\n\t<ng-content select=\"slick-container-header\"></ng-content>\r\n\t<ng-content select=\"slick-container-body\"></ng-content>\r\n\t<ng-content select=\"slick-container-footer\"></ng-content>\r\n</div>\r\n\r\n" }]
        }], propDecorators: { maxHeight: [{
                type: Input
            }], padding: [{
                type: Input
            }] } });

class SlickContainerHeaderComponent {
    constructor() {
        this.slickContainerHeader = 'slick-container-header';
    }
}
/** @nocollapse */ SlickContainerHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickContainerHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickContainerHeaderComponent, selector: "slick-container-header", host: { properties: { "class": "this.slickContainerHeader" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-container-header',
                    template: `<ng-content></ng-content>`
                }]
        }], propDecorators: { slickContainerHeader: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class SlickContainerBodyComponent {
    constructor() {
        this.flex = 'slick-container-body flex-fill';
        this.overflowY = 'auto';
    }
}
/** @nocollapse */ SlickContainerBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerBodyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickContainerBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickContainerBodyComponent, selector: "slick-container-body", host: { properties: { "class": "this.flex", "style.overflowY": "this.overflowY" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerBodyComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-container-body',
                    template: `<ng-content></ng-content>`
                }]
        }], propDecorators: { flex: [{
                type: HostBinding,
                args: ['class']
            }], overflowY: [{
                type: HostBinding,
                args: ['style.overflowY']
            }] } });

class SlickContainerFooterComponent {
    constructor() {
        this.slickContainerFooter = 'slick-container-footer';
    }
}
/** @nocollapse */ SlickContainerFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickContainerFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickContainerFooterComponent, selector: "slick-container-footer", host: { properties: { "class": "this.slickContainerFooter" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-container-footer',
                    template: `<ng-content></ng-content>`
                }]
        }], propDecorators: { slickContainerFooter: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class SlickContainerModule {
}
/** @nocollapse */ SlickContainerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickContainerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerModule, declarations: [SlickContainerComponent, SlickContainerHeaderComponent, SlickContainerBodyComponent, SlickContainerFooterComponent], imports: [CommonModule], exports: [CommonModule, SlickContainerComponent, SlickContainerHeaderComponent, SlickContainerBodyComponent, SlickContainerFooterComponent] });
/** @nocollapse */ SlickContainerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickContainerComponent, SlickContainerHeaderComponent, SlickContainerBodyComponent, SlickContainerFooterComponent],
                    exports: [CommonModule, SlickContainerComponent, SlickContainerHeaderComponent, SlickContainerBodyComponent, SlickContainerFooterComponent]
                }]
        }] });

class SlickContextMenuItemComponent {
}
/** @nocollapse */ SlickContextMenuItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickContextMenuItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickContextMenuItemComponent, selector: "slick-context-menu-item", ngImport: i0, template: `<div class="dropdown-item"><ng-content></ng-content></div>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "slick-context-menu-item",
                    template: `<div class="dropdown-item"><ng-content></ng-content></div>`
                }]
        }] });

class SlickContextMenuComponent {
    constructor() {
    }
    onClick(targetElement) {
        this.slickContextMenuRef.nativeElement.style.display = "none";
        this.slickContextMenuDropdownMenuRef.nativeElement.style.opacity = "0";
    }
    onRightClick(event) {
        if (event.button === 2) {
            this.onClick(event.target);
        }
    }
    ngAfterViewInit() {
        // Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
        // of a div when it expands beyond the bottom.
        this.slickContextMenuRef.nativeElement.remove(this.slickContextMenuRef);
        document.body.appendChild(this.slickContextMenuRef.nativeElement);
    }
    showContextMenu(e) {
        this.slickContextMenuRef.nativeElement.style.left = (e.pageX) + "px";
        this.slickContextMenuRef.nativeElement.style.top = (e.pageY) + "px";
        this.slickContextMenuRef.nativeElement.style.display = "block";
        setTimeout(() => {
            this.slickContextMenuDropdownMenuRef.nativeElement.style.opacity = "1";
        });
    }
}
/** @nocollapse */ SlickContextMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickContextMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickContextMenuComponent, selector: "slick-context-menu", host: { listeners: { "document:click": "onClick($event.target)", "document:mousedown": "onRightClick($event)" } }, viewQueries: [{ propertyName: "slickContextMenuRef", first: true, predicate: ["slickContextMenuRef"], descendants: true }, { propertyName: "slickContextMenuDropdownMenuRef", first: true, predicate: ["slickContextMenuDropdownMenuRef"], descendants: true }], ngImport: i0, template: "<div #slickContextMenuRef class=\"slick-context-menu\">\r\n\t<div #slickContextMenuDropdownMenuRef class=\"dropdown-menu show\">\r\n\t\t<ng-content select=\"slick-context-menu-item\"></ng-content>\r\n\t</div>\r\n</div>\r\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-context-menu", template: "<div #slickContextMenuRef class=\"slick-context-menu\">\r\n\t<div #slickContextMenuDropdownMenuRef class=\"dropdown-menu show\">\r\n\t\t<ng-content select=\"slick-context-menu-item\"></ng-content>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { slickContextMenuRef: [{
                type: ViewChild,
                args: ["slickContextMenuRef"]
            }], slickContextMenuDropdownMenuRef: [{
                type: ViewChild,
                args: ["slickContextMenuDropdownMenuRef"]
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }], onRightClick: [{
                type: HostListener,
                args: ['document:mousedown', ['$event']]
            }] } });

class SlickContextMenuModule {
}
/** @nocollapse */ SlickContextMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickContextMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuModule, declarations: [SlickContextMenuComponent, SlickContextMenuItemComponent], imports: [CommonModule], exports: [SlickContextMenuComponent, SlickContextMenuItemComponent, CommonModule] });
/** @nocollapse */ SlickContextMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickContextMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [SlickContextMenuComponent, SlickContextMenuItemComponent, CommonModule],
                    declarations: [SlickContextMenuComponent, SlickContextMenuItemComponent]
                }]
        }] });

class SlickCurrencyMaskOptions {
    constructor() {
        this.prefix = "$";
        this.decimal = ".";
        this.thousands = ",";
        this.precision = 2;
        this.allowNegative = true;
        this.updateOnBlurOnly = true;
        this.defaultToZero = true;
    }
}

class SlickCurrencyMaskDirective {
    constructor(el) {
        this.el = el;
        this.hasFocus = false;
        this.uuid = SlickUtilsService.newGuid();
        this.options = new SlickCurrencyMaskOptions();
        this.fnKeyDown = (e) => this.keyDown(e);
        this.fnFocus = () => this.focus();
        this.fnBlur = () => this.blur();
        this.propagateChange = (_) => { };
        this.el.nativeElement.style.textAlign = "right";
        this.hasFocus = false;
        this.el.nativeElement.addEventListener('keydown', this.fnKeyDown);
        this.el.nativeElement.addEventListener('focus', this.fnFocus);
        this.el.nativeElement.addEventListener('blur', this.fnBlur);
    }
    ngOnInit() {
        // If the currency mask doesn't have any options, set default options
        if (!this.slickCurrencyMask)
            this.slickCurrencyMask = new SlickCurrencyMaskOptions();
        this.options = new SlickCurrencyMaskOptions();
        this.options.prefix = this.slickCurrencyMask.prefix || "$";
        this.options.decimal = this.slickCurrencyMask.decimal || ".";
        this.options.thousands = this.slickCurrencyMask.thousands || ",";
        this.options.precision = (this.slickCurrencyMask.precision === null || this.slickCurrencyMask.precision === undefined) ? 2 : parseInt(this.slickCurrencyMask.precision.toString());
        this.options.allowNegative = (this.slickCurrencyMask.allowNegative === null || this.slickCurrencyMask.allowNegative === undefined) ? true : (this.slickCurrencyMask.allowNegative.toString() === 'true');
        this.options.updateOnBlurOnly = (this.slickCurrencyMask.updateOnBlurOnly === null || this.slickCurrencyMask.updateOnBlurOnly === undefined) ? true : (this.slickCurrencyMask.updateOnBlurOnly.toString() === 'true');
        this.options.defaultToZero = (this.slickCurrencyMask.defaultToZero === null || this.slickCurrencyMask.defaultToZero === undefined) ? true : (this.slickCurrencyMask.defaultToZero.toString() === 'true');
    }
    ngOnDestroy() {
        this.el.nativeElement.removeEventListener('keydown', this.fnKeyDown);
        this.el.nativeElement.removeEventListener('focus', this.fnFocus);
        this.el.nativeElement.removeEventListener('blur', this.fnBlur);
    }
    async keyDown(e) {
        if (e.altKey || e.ctrlKey)
            return;
        let isValid = false;
        if (e.key === this.options.decimal)
            isValid = true;
        if (e.code === 'ArrowLeft' || e.code === 'ArrowRight')
            isValid = true;
        // Backspace
        if (e.keyCode === 8)
            isValid = true;
        // Tab
        if (e.keyCode === 9)
            isValid = true;
        // Del
        if (e.keyCode === 46)
            isValid = true;
        // F1-F12
        if (e.keyCode >= 112 && e.keyCode <= 123)
            isValid = true;
        if (e.key >= '0' && e.key <= '9')
            isValid = true;
        if (e.key === '-' && this.options.allowNegative === true)
            isValid = true;
        if (e.keyCode === 46)
            isValid = true;
        if (!isValid) {
            e.preventDefault();
            return;
        }
        await SlickSleepService.sleep();
        const usLocaleText = this.convertToUSLocale(this.el.nativeElement.value);
        const dollarValue = this.parseDollarValue(usLocaleText);
        if (this.options.updateOnBlurOnly === false)
            this.propagateChange(dollarValue);
    }
    async focus() {
        this.el.nativeElement.addEventListener('keydown', this.fnKeyDown);
        this.el.nativeElement.addEventListener('blur', this.fnBlur);
        this.hasFocus = true;
        const usLocaleText = this.convertToUSLocale(this.el.nativeElement.value);
        this.updateTextbox(usLocaleText);
        this.el.nativeElement.select();
    }
    async blur() {
        this.el.nativeElement.removeEventListener('keydown', this.fnKeyDown);
        this.el.nativeElement.removeEventListener('blur', this.fnBlur);
        this.hasFocus = false;
        const usLocaleText = this.convertToUSLocale(this.el.nativeElement.value);
        this.updateTextbox(usLocaleText);
        const dollarValue = this.parseDollarValue(usLocaleText);
        this.propagateChange(dollarValue);
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj === null || obj === undefined) {
            if (this.options.defaultToZero === true) {
                obj = 0;
                this.propagateChange(0);
            }
            else {
                this.el.nativeElement.value = null;
                this.propagateChange(null);
                return;
            }
        }
        // If this is a locale where , is the decimal separator, convert it back to . for our purposes
        const objStr = obj.toString().replace(",", ".");
        const objNum = parseFloat(objStr);
        // toLocaleString will add in the ,'s so make sure to remove them
        const objStrLocale = objNum.toLocaleString("en-US").replace(",", "");
        this.updateTextbox(objStrLocale);
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    convertToUSLocale(text) {
        while (text.indexOf(" ") >= 0)
            text = text.replace(" ", "");
        if (!text) {
            if (this.options.defaultToZero === true)
                text = "0.0";
            else
                return null;
        }
        if (text.indexOf(this.options.decimal) === 0)
            text = `0${text}`;
        const textParts = text.split(this.options.decimal).filter(x => x !== "");
        if (textParts.length === 0)
            textParts.push('0');
        if (textParts.length === 1)
            textParts.push('0');
        // Only take the first 2.  The rest are errors
        if (textParts.length > 2)
            textParts.slice(0, 1);
        textParts[0] = textParts[0]
            .replace(this.options.thousands, "")
            .replace(this.options.prefix, "")
            .replace(this.options.decimal, "");
        return `${textParts[0]}.${textParts[1]}`;
    }
    parseDollarValue(text) {
        if (!text)
            return null;
        while (text.indexOf(" ") >= 0)
            text = text.replace(" ", "");
        // Split the text into the dollar's part and the cents part
        const textParts = text.split(".").filter(x => x !== "");
        // Make sure we have a dollars and cents
        if (textParts.length === 0)
            textParts.push('0');
        if (textParts.length === 1)
            textParts.push('0');
        // Only take the first 2.  The rest are not allowed
        if (textParts.length > 2)
            textParts.slice(0, 1);
        textParts[0] = textParts[0]
            .replace(this.options.prefix, "")
            .replace(",", "");
        try {
            return parseFloat(`${textParts[0]}.${textParts[1]}`);
        }
        catch {
            return 0;
        }
    }
    updateTextbox(strVal) {
        if (!strVal) {
            this.el.nativeElement.value = null;
            return;
        }
        if (this.options.allowNegative === false)
            strVal = strVal.replace("-", "");
        // If there is a - sign, remove it temporarily
        const negativePart = (strVal.indexOf("-") === 0) ? "-" : "";
        strVal = strVal.replace("-", "");
        const currencyParts = strVal.split(".").filter(x => x !== "");
        // make sure there is a dollar amount
        if (currencyParts.length === 0)
            currencyParts.push("0");
        // make sure there is a cents amount
        if (currencyParts.length === 1)
            currencyParts.push("0");
        // Only take the first 2.  The rest are errors
        if (currencyParts.length > 2)
            currencyParts.slice(0, 1);
        let dollarPart = currencyParts[0];
        dollarPart = dollarPart.replace(',', '').replace('.', '');
        let centsPart = currencyParts[1];
        if (centsPart.length > this.options.precision)
            centsPart = centsPart.substr(0, this.options.precision);
        while (centsPart.length < this.options.precision)
            centsPart = centsPart + "0";
        // reverse the dollar part so we can put commas every 3 chars
        if (!this.hasFocus && dollarPart.length > 3) {
            for (let i = dollarPart.length - 3; i > 0; i -= 3)
                dollarPart = [dollarPart.slice(0, i), this.options.thousands, dollarPart.slice(i)].join('');
        }
        let textboxVal = `${negativePart}${dollarPart}${this.options.decimal}${centsPart}`;
        if (!this.hasFocus)
            textboxVal = `${this.options.prefix}${textboxVal}`;
        this.el.nativeElement.value = textboxVal;
    }
}
/** @nocollapse */ SlickCurrencyMaskDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCurrencyMaskDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickCurrencyMaskDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickCurrencyMaskDirective, selector: "[slick-currency-mask]", inputs: { slickCurrencyMask: ["slick-currency-mask", "slickCurrencyMask"] }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickCurrencyMaskDirective)),
            multi: true,
        }
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCurrencyMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-currency-mask]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickCurrencyMaskDirective)),
                            multi: true,
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { slickCurrencyMask: [{
                type: Input,
                args: ["slick-currency-mask"]
            }] } });

class SlickCurrencyMaskModule {
}
/** @nocollapse */ SlickCurrencyMaskModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCurrencyMaskModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickCurrencyMaskModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickCurrencyMaskModule, declarations: [SlickCurrencyMaskDirective], exports: [SlickCurrencyMaskDirective] });
/** @nocollapse */ SlickCurrencyMaskModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCurrencyMaskModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickCurrencyMaskModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [SlickCurrencyMaskDirective],
                    exports: [SlickCurrencyMaskDirective]
                }]
        }] });

class SlickDatePickerComponent {
    constructor(el) {
        this.el = el;
        this.format = "M/D/YYYY";
        this.condensed = false;
        this.mobile = false;
        this.onDateChange = new EventEmitter();
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.fnDocumentMouseDown = (e) => this.documentMouseDown(e);
        this.uuid = SlickUtilsService.newGuid();
        this.ignoreBlur = false;
        this.showDatePicker = false;
        this.datePickerVisiblity = "hidden";
        this.datePickerOpacity = '0';
        this.selectedDate = null;
        this.isInitial = true;
        this.propagateChange = (_) => { };
    }
    // Make sure they only press valid keys
    async onKeydown(event) {
        if (event.altKey || event.ctrlKey || event.metaKey === true)
            return;
        this.hideCalendar();
        // Allow: backspace, delete, tab, escape, enter
        if ((event.keyCode === 46 || event.keyCode === 8) ||
            (event.keyCode === 9 || event.keyCode === 27 || event.keyCode === 13) ||
            // Allow F1-F12 keys
            ((event.keyCode >= 112 && event.keyCode <= 123)) ||
            // Allow: home, end, left, right, down, up
            (event.keyCode >= 35 && event.keyCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((event.shiftKey || event.altKey || event.key < '0' || event.key > '9') &&
            event.key !== '/' && // Allow /
            event.key !== '-') { // Allow -		
            event.preventDefault();
            return;
        }
    }
    // When we first focus, show the date picker
    onFocus(event) {
        this.showCalendar();
    }
    // When we blur, update the model
    async onBlur(event, targetElement) {
        // If the user clicked on the calendar, it will trigger a mouse down event before the blur event.  Don't blur
        // if they clicked on the calendar.
        if (this.ignoreBlur === true) {
            this.ignoreBlur = false;
            return;
        }
        const textVal = this.el.nativeElement.value;
        if (!textVal) {
            this.doPropagate(null);
            return;
        }
        if (moment(textVal, this.format).isValid()) {
            var newDate = moment(textVal, this.format);
            this.doPropagate(newDate.toDate());
            this.el.nativeElement.value = newDate.format(this.format);
        }
    }
    async ngOnInit() {
        this.mobile = (this.mobile || 'false').toString().toLowerCase() === 'true' ? true : false;
        this.condensed = (this.condensed || 'false').toString().toLowerCase() === 'true' ? true : false;
        // Since this.mobile isn't necessarily defined yet, we need to sleep to allow the ngIf's to do their thing
        await SlickSleepService.sleep();
        // Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
        // of a div when it expands beyond the bottom.
        this.containerRef.nativeElement.remove(this.containerRef);
        document.body.appendChild(this.containerRef.nativeElement);
        await SlickSleepService.sleep();
        this.inputGroupPrepend = SlickUtilsService.getClosestSibling(this.el.nativeElement, "input-group-prepend");
    }
    ngOnDestroy() {
        document.removeEventListener("mousedown", this.fnDocumentMouseDown, true);
        document.removeEventListener("click", this.fnDocumentClick, true);
        // Is okay if this fails.  It just means it was already removed.
        try {
            document.body.removeChild(this.containerRef.nativeElement);
        }
        catch { }
    }
    doPropagate(date) {
        // We don't always go through the emit on the first call, so make sure this isn't the first change
        this.isInitial = false;
        if (!date) {
            if (this.selectedDate) {
                this.propagateChange(null);
                this.emitDateChange(null);
            }
            this.selectedDate = null;
            return;
        }
        else {
            const newDate = moment(date);
            // If the date is not valid, return
            if (newDate.isValid() === false)
                return;
            // Don't propogate if the dates are the same
            if (moment(this.selectedDate).isSame(newDate))
                return;
            // Setting this selectedDate will trigger the ngModelChange of the calendar.  Ignore this.
            this.selectedDate = moment(date).startOf("date").toDate();
            this.propagateChange(this.selectedDate);
            this.emitDateChange(this.selectedDate);
        }
    }
    emitDateChange(date) {
        if (this.onDateChange && !this.isInitial)
            this.onDateChange.emit(date);
        this.isInitial = false;
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj) {
            if (moment(obj).isValid() === false) {
                this.selectedDate = null;
                this.el.nativeElement.value = "Invalid Date";
                this.isInitial = false;
                return;
            }
            let updatedDate;
            if (obj instanceof Date || obj.indexOf("Z") >= 0)
                updatedDate = moment(obj).startOf("date");
            else
                updatedDate = moment(obj, this.format).startOf("date");
            if (moment(this.selectedDate || new Date()).isSame(updatedDate)) {
                this.isInitial = false;
                return;
            }
            this.selectedDate = updatedDate.toDate();
            this.el.nativeElement.value = moment(this.selectedDate).format(this.format);
        }
        else {
            if (!this.selectedDate && !obj) {
                this.isInitial = false;
                return;
            }
            this.el.nativeElement.value = '';
            this.selectedDate = null;
        }
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    documentMouseDown(e) {
        // This is the only way to capture that they clicked on the calendar before the blur event
        // fires.  
        if (SlickUtilsService.checkParentClassExists(e.target, "slick-calendar") === true)
            this.ignoreBlur = true;
    }
    documentClick(e) {
        if (!e.target)
            return;
        let targetElement = e.target;
        if (SlickUtilsService.checkParentClassExists(targetElement, "slick-calendar") === true)
            return;
        if (this.inputGroupPrepend && ((targetElement === this.inputGroupPrepend)
            || (targetElement.parentElement && targetElement.parentElement === this.inputGroupPrepend))
            || (targetElement.parentElement && targetElement.parentElement.parentElement && targetElement.parentElement.parentElement === this.inputGroupPrepend)) {
            this.toggleCalendar();
            return;
        }
        const clickedInside = this.el.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.hideCalendar();
        }
    }
    onDateSelect(date) {
        this.el.nativeElement.value = moment(date).format(this.format);
        this.hideCalendar();
        const newDate = moment(this.el.nativeElement.value, this.format).toDate();
        this.doPropagate(newDate);
    }
    async showCalendar() {
        document.removeEventListener("mousedown", this.fnDocumentMouseDown, true);
        document.removeEventListener("click", this.fnDocumentClick, true);
        this.showDatePicker = true;
        if (!this.mobile) {
            this.reposition();
        }
        this.datePickerOpacity = '1';
        this.datePickerVisiblity = 'visible';
        // Not sure why, but the click event is called immediately, which hides the calendar
        setTimeout(() => {
            document.addEventListener("mousedown", this.fnDocumentMouseDown, true);
            document.addEventListener("click", this.fnDocumentClick, true);
        }, 350);
    }
    hideCalendar() {
        document.removeEventListener("mousedown", this.fnDocumentMouseDown, true);
        document.removeEventListener("click", this.fnDocumentClick, true);
        this.datePickerVisiblity = 'hidden';
        this.datePickerOpacity = '0';
        this.showDatePicker = false;
    }
    reposition() {
        if (this.mobile === true)
            return;
        // Reposition the element to be where the textbox is, either below or above if there isn't enough room
        const inputEl = this.el.nativeElement;
        const rect = inputEl.getBoundingClientRect();
        const textboxLeft = rect.left;
        const textboxTop = rect.top;
        const textboxHeight = inputEl.offsetHeight;
        const containerHeight = this.containerRef.nativeElement.offsetHeight;
        this.left = textboxLeft + "px";
        this.top = (textboxTop + textboxHeight) + "px";
        if (textboxTop + textboxHeight + containerHeight > window.innerHeight) {
            this.top = (textboxTop - containerHeight - 2) + "px";
        }
    }
    toggleCalendar() {
        (this.showDatePicker === true) ? this.hideCalendar() : this.showCalendar();
    }
}
/** @nocollapse */ SlickDatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDatePickerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickDatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickDatePickerComponent, selector: "[slick-date-picker]", inputs: { slickDatePicker: ["slick-date-picker", "slickDatePicker"], format: ["slick-date-picker-format", "format"], condensed: ["slick-date-picker-condensed", "condensed"], mobile: ["slick-date-picker-mobile", "mobile"] }, outputs: { onDateChange: "onDateChange" }, host: { listeners: { "keydown": "onKeydown($event)", "focus": "onFocus($event)", "blur": "onBlur($event,$event.target)" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickDatePickerComponent)),
            multi: true
        }
    ], viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }], ngImport: i0, template: "<ng-content></ng-content>\r\n<div *ngIf=\"mobile === false\" #containerRef class=\"slick-date-picker-container\" [style.left]=\"left\" [style.top]=\"top\" [style.visibility]=\"datePickerVisiblity\" [style.opacity]=\"datePickerOpacity\">\r\n\t<slick-calendar [ngModel]=\"selectedDate\" [condensed]=\"condensed\" (onDateSelect)=\"onDateSelect($event)\"></slick-calendar>\r\n</div>\r\n<div *ngIf=\"mobile === true\" #containerRef class=\"slick-date-picker-mobile-container\" [style.visibility]=\"datePickerVisiblity\" [style.opacity]=\"datePickerOpacity\">\r\n\t<div class=\"slick-date-picker-mobile-calendar\">\r\n\t\t<slick-calendar [ngModel]=\"selectedDate\" [condensed]=\"condensed\" (onDateSelect)=\"onDateSelect($event)\"></slick-calendar>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickCalendarComponent, selector: "slick-calendar", inputs: ["condensed", "monthsToShow", "monthsToIncrement", "inactiveDates", "inactiveWeekends", "showDaysNotInMonth", "multiSelect", "multiSelectDates"], outputs: ["multiSelectDatesChange", "onDateSelect", "onDateChange", "onMonthChange", "onMultiDateChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: '[slick-date-picker]', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickDatePickerComponent)),
                            multi: true
                        }
                    ], template: "<ng-content></ng-content>\r\n<div *ngIf=\"mobile === false\" #containerRef class=\"slick-date-picker-container\" [style.left]=\"left\" [style.top]=\"top\" [style.visibility]=\"datePickerVisiblity\" [style.opacity]=\"datePickerOpacity\">\r\n\t<slick-calendar [ngModel]=\"selectedDate\" [condensed]=\"condensed\" (onDateSelect)=\"onDateSelect($event)\"></slick-calendar>\r\n</div>\r\n<div *ngIf=\"mobile === true\" #containerRef class=\"slick-date-picker-mobile-container\" [style.visibility]=\"datePickerVisiblity\" [style.opacity]=\"datePickerOpacity\">\r\n\t<div class=\"slick-date-picker-mobile-calendar\">\r\n\t\t<slick-calendar [ngModel]=\"selectedDate\" [condensed]=\"condensed\" (onDateSelect)=\"onDateSelect($event)\"></slick-calendar>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { slickDatePicker: [{
                type: Input,
                args: ["slick-date-picker"]
            }], format: [{
                type: Input,
                args: ["slick-date-picker-format"]
            }], condensed: [{
                type: Input,
                args: ["slick-date-picker-condensed"]
            }], mobile: [{
                type: Input,
                args: ["slick-date-picker-mobile"]
            }], onDateChange: [{
                type: Output,
                args: ["onDateChange"]
            }], containerRef: [{
                type: ViewChild,
                args: ["containerRef"]
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onFocus: [{
                type: HostListener,
                args: ['focus', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['blur', ['$event', '$event.target']]
            }] } });

class SlickDatePickerModule {
}
/** @nocollapse */ SlickDatePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickDatePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickDatePickerModule, declarations: [SlickDatePickerComponent], imports: [CommonModule, FormsModule, SlickCalendarModule], exports: [SlickDatePickerComponent, SlickCalendarModule] });
/** @nocollapse */ SlickDatePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDatePickerModule, imports: [CommonModule, FormsModule, SlickCalendarModule, SlickCalendarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SlickCalendarModule],
                    declarations: [SlickDatePickerComponent],
                    exports: [SlickDatePickerComponent, SlickCalendarModule]
                }]
        }] });

class SlickDragDropDirective {
}
/** @nocollapse */ SlickDragDropDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDragDropDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickDragDropDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickDragDropDirective, selector: "[slick-drag-drop]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDragDropDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-drag-drop]'
                }]
        }] });

class SlickDraggableDirective {
}
/** @nocollapse */ SlickDraggableDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDraggableDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickDraggableDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickDraggableDirective, selector: "[slick-draggable]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDraggableDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-draggable]'
                }]
        }] });

class SlickDragDropModule {
}
/** @nocollapse */ SlickDragDropModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDragDropModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickDragDropModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickDragDropModule, declarations: [SlickDragDropDirective, SlickDraggableDirective], imports: [CommonModule], exports: [SlickDragDropDirective, SlickDraggableDirective] });
/** @nocollapse */ SlickDragDropModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDragDropModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDragDropModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickDragDropDirective, SlickDraggableDirective],
                    exports: [SlickDragDropDirective, SlickDraggableDirective]
                }]
        }] });

var SlickValidationTypes;
(function (SlickValidationTypes) {
    SlickValidationTypes[SlickValidationTypes["None"] = 0] = "None";
    SlickValidationTypes[SlickValidationTypes["Error"] = 1] = "Error";
    SlickValidationTypes[SlickValidationTypes["Warning"] = 2] = "Warning";
})(SlickValidationTypes || (SlickValidationTypes = {}));
class SlickValidationIndicatorDirective {
    constructor(el) {
        this.el = el;
        this.validationType = SlickValidationTypes.Warning;
        this.bgWarningStyle = "#ffc207";
        this.bgDangerStyle = "#dc3545";
        this.bgSuccessStyle = "#28a745";
        this.originalBorderStyle = this.el.nativeElement.style.borderLeft;
    }
    ngOnInit() {
        if (this.validationType) {
            if (this.validationType.toString().toLowerCase() === 'warning')
                this.validationType = SlickValidationTypes.Warning;
            else if (this.validationType.toString().toLowerCase() === 'none')
                this.validationType = SlickValidationTypes.None;
            else
                this.validationType = SlickValidationTypes.Error;
        }
        this.setIndicator();
    }
    ngOnChanges(changes) {
        this.setIndicator();
    }
    setIndicator() {
        if (this.validationType === SlickValidationTypes.None) {
            this.el.nativeElement.style.borderLeft = this.originalBorderStyle;
        }
        else {
            if (this.isValid) {
                this.el.nativeElement.style.borderLeft = "6px solid " + this.bgSuccessStyle;
            }
            else {
                if (this.validationType === SlickValidationTypes.Warning)
                    this.el.nativeElement.style.borderLeft = "6px solid " + this.bgWarningStyle;
                else
                    this.el.nativeElement.style.borderLeft = "6px solid " + this.bgDangerStyle;
            }
        }
    }
}
/** @nocollapse */ SlickValidationIndicatorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickValidationIndicatorDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickValidationIndicatorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickValidationIndicatorDirective, selector: "[slick-validation-indicator]", inputs: { isValid: ["slick-validation-indicator", "isValid"], validationType: ["slickValidationType", "validationType"] }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickValidationIndicatorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-validation-indicator]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { isValid: [{
                type: Input,
                args: ["slick-validation-indicator"]
            }], validationType: [{
                type: Input,
                args: ["slickValidationType"]
            }] } });

class SlickValidationIndicatorModule {
}
/** @nocollapse */ SlickValidationIndicatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickValidationIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickValidationIndicatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickValidationIndicatorModule, declarations: [SlickValidationIndicatorDirective], imports: [CommonModule], exports: [CommonModule, SlickValidationIndicatorDirective] });
/** @nocollapse */ SlickValidationIndicatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickValidationIndicatorModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickValidationIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickValidationIndicatorDirective],
                    exports: [CommonModule, SlickValidationIndicatorDirective]
                }]
        }] });

class SlickDropDownService {
    constructor(http) {
        this.http = http;
    }
    getVisibleItems(items, idFieldName, textFieldName) {
        let foundSomeText = false;
        if (!items || items.length === 0)
            return null;
        let visibleItems = items.map((item) => {
            let id = SlickUtilsService.getDeepObject(item, idFieldName);
            if (id === null || id === undefined) {
                console.debug("%c slick-drop-down: Id not found for dropdown item.  The idFieldName is '" + idFieldName + "'.  Is this correct?", 'background: red; color: white');
                console.debug("First Item: ", items[0]);
            }
            let text = SlickUtilsService.getDeepObject(item, textFieldName);
            if (text !== null && text !== undefined)
                foundSomeText = true;
            return {
                id: id,
                text: text ? text.toString() : null,
                item: item
            };
        });
        if (foundSomeText === false) {
            console.error("%c slick-drop-down: Warning!  No text was found for dropdown item.  The textFieldName is '" + textFieldName + "'.  Is this correct?", 'background: red; color: white');
            console.error("First Item: ", items[0]);
        }
        return visibleItems;
    }
    getSelectedItem(items, selectedId) {
        if (!items || items.length === 0)
            return null;
        let selectedItem = items.find((item) => { return item.id === selectedId; });
        if (selectedItem)
            return selectedItem;
        else
            return null;
    }
    async getItemsFromServer(url) {
        return Promise.resolve((await this.http.get(url).toPromise()));
    }
    getItemIndex(items, selectedId) {
        return items.findIndex((item) => { return item.id === selectedId; });
    }
}
/** @nocollapse */ SlickDropDownService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickDropDownService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

// @dynamic
class SlickLogService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    async writeLog(text) {
        const params = {
            text: text,
            logDate: new Date()
        };
        await (this.httpClient.post("https://api.crflow.com/debuglogs/writelog", params).toPromise());
    }
    ;
}
/** @nocollapse */ SlickLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickLogService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickLogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

var SlickDropDownSearchTypes;
(function (SlickDropDownSearchTypes) {
    SlickDropDownSearchTypes[SlickDropDownSearchTypes["startsWith"] = 0] = "startsWith";
    SlickDropDownSearchTypes[SlickDropDownSearchTypes["eachWord"] = 1] = "eachWord";
    SlickDropDownSearchTypes[SlickDropDownSearchTypes["any"] = 2] = "any";
})(SlickDropDownSearchTypes || (SlickDropDownSearchTypes = {}));
class SlickDropDownComponent {
    constructor(slickDropDownService, changeDetector) {
        this.slickDropDownService = slickDropDownService;
        this.changeDetector = changeDetector;
        this.placeholder = '';
        this.idFieldName = "id";
        this.textFieldName = "text";
        this.compact = false;
        this.disabled = false;
        this.allowEmpty = true;
        this.width = '100%';
        this.listWidth = '100%';
        this.height = '300px';
        this.showLoadingMessage = false;
        this.searchType = SlickDropDownSearchTypes.startsWith;
        this.isMobile = false;
        this.onExpand = new EventEmitter();
        this.onSelect = new EventEmitter();
        this.onChange = new EventEmitter();
        // This is necessary so that the scroll and resize events can add and remove the event properly,
        // as well as getting the correct ES6 function
        this.fnReposition = () => this.reposition();
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.expanded = false;
        this.filterText = '';
        this.isVisible = false;
        this.isAndroid = ((SlickInitService.getPlatform() || '').toLowerCase() === 'android');
        this.skipOnFocusEvent = false;
        this.skipClickExpand = false;
        this.propagateChange = (_) => { };
        this.uuid = SlickUtilsService.newGuid();
    }
    async ngOnInit() {
        this.attachTo = this.attachTo || SlickInitService.getParams().attachTo || 'body';
    }
    ngAfterViewInit() {
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj !== null && obj !== undefined)
            this.selectedId = obj;
        else
            this.selectedId = null;
        this.selectItem(this.selectedId, false);
        this.collapse();
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    async ngOnChanges(changes) {
        await SlickSleepService.sleep();
        if (changes.items) {
            this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
            this.selectItem(this.selectedId, false);
            if (this.selectedTextInputRef && document.activeElement === this.selectedTextInputRef.nativeElement)
                this.expand();
        }
        if (changes.showLoadingMessage) {
            await SlickSleepService.sleep();
            if (this.showLoadingMessage === true)
                this.selectedText = "Loading...";
        }
        if (changes.getUrl) {
            if (this.showLoadingMessage === true) {
                this.selectedText = "Loading...";
            }
            let items = await this.slickDropDownService.getItemsFromServer(this.getUrl);
            this.selectedText = null;
            this.items = items;
            this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
            this.selectItem(this.selectedId, false);
            if (document.activeElement === this.selectedTextInputRef.nativeElement)
                this.expand();
        }
        if (changes.validationIndicator && changes.validationIndicator.firstChange) {
            if (!this.validationIndicatorType)
                this.validationIndicatorType = "error";
        }
        if (changes.allowEmpty)
            this.allowEmpty = (this.allowEmpty.toString().toLowerCase() === 'false') ? false : true;
        if (changes.isMobile)
            this.isMobile = (this.isMobile.toString().toLowerCase() === 'true') ? true : false;
        if (changes.disabled && changes.disabled.currentValue)
            this.disabled = (changes.disabled.currentValue.toString().toLowerCase() !== 'false');
        if (changes.compact && changes.compact.currentValue)
            this.compact = (changes.compact.currentValue.toString().toLowerCase() !== 'false');
        if (changes.searchType) {
            if (changes.searchType.currentValue.toString().toLowerCase() === 'eachword')
                this.searchType = SlickDropDownSearchTypes.eachWord;
            else if (changes.searchType.currentValue.toString().toLowerCase() === 'any')
                this.searchType = SlickDropDownSearchTypes.any;
            else
                this.searchType = SlickDropDownSearchTypes.startsWith;
        }
    }
    ngOnDestroy() {
        this.collapse();
        document.removeEventListener("click", this.fnDocumentClick, true);
        // it's okay if this fails.  It was already removed
        try {
            document.body.removeChild(this.dropdownList.nativeElement);
        }
        catch { }
    }
    async setFocus(showDropdownList = false) {
        this.filterText = '';
        this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
        this.skipOnFocusEvent = (showDropdownList === false);
        await SlickUtilsService.waitForElement("#slick-drop-down_" + this.uuid);
        this.selectedTextInputRef.nativeElement.focus();
    }
    async expand() {
        if (this.disabled)
            return;
        this.isVisible = true;
        this.changeDetector.detectChanges();
        SlickUtilsService.attachElement(this.dropdownList.nativeElement, this.attachTo);
        this.reposition();
        await SlickSleepService.sleep();
        this.dropdownList.nativeElement.style.display = "inline-block";
        const selectedItems = this.dropdownList.nativeElement.getElementsByClassName("active");
        if (selectedItems && selectedItems.length > 0)
            selectedItems[0].scrollIntoView({ block: 'nearest' });
        this.expanded = true;
        // This is necessary, otherwise `this` in the reposition function will be window
        // and not the component.
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.addEventListener("click", this.fnDocumentClick, true);
        if (this.onExpand)
            this.onExpand.emit();
    }
    collapse() {
        if (this.expanded === false)
            return;
        this.expanded = false;
        this.dropdownList.nativeElement.style.display = "none";
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.removeEventListener("click", this.fnDocumentClick, true);
        SlickUtilsService.removeElement(this.dropdownList.nativeElement);
        this.isVisible = false;
        this.skipOnFocusEvent = false;
    }
    reposition() {
        const dropDownRect = this.containerDiv.nativeElement.getBoundingClientRect();
        const parentRect = (this.attachTo === 'body') ? null : document.body.querySelector(this.attachTo).getBoundingClientRect();
        const containerLeft = (this.attachTo === 'body') ? dropDownRect.left : (dropDownRect.left - parentRect.left);
        const containerTop = (this.attachTo === 'body') ? dropDownRect.top : (dropDownRect.top - parentRect.top);
        const containerHeight = this.containerDiv.nativeElement.offsetHeight;
        const containerWidth = dropDownRect.width;
        this.width = containerWidth;
        if (this.listWidth === '100%')
            this.listGroupWidth = this.width;
        else if (this.listWidth === 'auto')
            this.listGroupWidth = "auto";
        else
            this.listGroupWidth = this.listWidth;
        this.top = (containerTop + containerHeight);
        this.left = containerLeft;
    }
    async documentClick(e) {
        // Not entirely sure why, but iPhones call onFocus when clicking out of the dropdown
        if (this.isMobile)
            this.skipOnFocusEvent = true;
        if (!this.expanded || !e.target)
            return;
        if (SlickUtilsService.checkParentIdExists(e.target, "slick-drop-down_" + this.uuid) === true)
            return;
        this.selectedTextInputRef.nativeElement.setSelectionRange(0, 0);
        if (this.selectedIndex !== null && this.visibleItems.length > 0) {
            let itemId = this.visibleItems[this.selectedIndex].id;
            this.selectItem(itemId, true);
        }
        this.collapse();
    }
    selectItem(id, emitOnSelect) {
        let item = this.slickDropDownService.getSelectedItem(this.visibleItems, id);
        if (item) {
            this.selectedItem = item;
            this.selectedId = item.id;
            this.selectedText = item.text;
            this.selectedIndex = this.slickDropDownService.getItemIndex(this.visibleItems, this.selectedId);
            if (this.onChange)
                this.onChange.emit(this.selectedItem.item);
            if (emitOnSelect === true && this.onSelect)
                this.onSelect.emit(this.selectedItem.item);
            this.propagateChange(this.selectedId);
        }
        else {
            this.selectedItem = null;
            this.selectedText = null;
            this.selectedIndex = null;
        }
    }
    async onFocus() {
        if (this.skipOnFocusEvent === true) {
            this.skipOnFocusEvent = false;
            return;
        }
        this.filterText = '';
        this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
        this.selectItem(this.selectedId, false);
        if (this.selectedIndex && this.selectedIndex >= 0) {
            this.selectedItem = this.visibleItems[this.selectedIndex];
            this.selectedTextInputRef.nativeElement.setSelectionRange(0, this.selectedItem.text.length);
        }
        // This is kind of hacky, but if onFocus is called by clicking the dropdown, the onDropdownClick event is called as well
        // That function will expand or collapse, depending on the state.  Since this expands, it thinks it needs to collapse.
        // So fake it out and tell it NOT to collapse.  BUT, if we came in from tabbing into the field, then it would mess up
        // the click event.  So only wait for 1/2 second.
        this.skipClickExpand = true;
        this.expand();
        await SlickSleepService.sleep(500);
        this.skipClickExpand = false;
    }
    async onKeyDown(e) {
        if (this.isAndroid)
            return;
        // Tab/enter
        if (e.which === 9 || e.which === 13) {
            this.collapse();
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                return;
            this.selectedTextInputRef.nativeElement.setSelectionRange(0, 0);
            let itemId = this.visibleItems[this.selectedIndex].id;
            this.selectItem(itemId, true);
            return true;
        }
        if (e.key && e.key.length > 1)
            return true;
        if (e.which === 46 || e.which === 8) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (e.which >= 32 && e.which <= 126) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    async onKeyUp(e) {
        e.preventDefault();
        e.stopPropagation();
        // If this is android, it won't pass us any key data so just read the entire input element
        if (this.isAndroid === true) {
            await SlickSleepService.sleep();
            this.filterText = this.selectedTextInputRef.nativeElement.value;
            this.filterSearch();
            return;
        }
        // Esc
        if (e.which === 27) {
            this.collapse();
            return false;
        }
        // del or backspace
        if (e.which === 46 || e.which === 8 && !this.filterText) {
            e.preventDefault();
            e.stopPropagation();
            if (this.allowEmpty === true) {
                this.selectItem(null, true);
                this.selectedId = null;
                this.propagateChange(null);
                if (this.onChange)
                    this.onChange.emit(null);
                if (this.onSelect)
                    this.onSelect.emit(null);
            }
            return false;
        }
        if (e.which === 8 && this.filterText) {
            this.filterText = this.filterText.substring(0, this.filterText.length - 1);
            if (this.filterText.length === 0) {
                this.selectedText = '';
                this.selectedIndex = null;
                this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
            }
            else
                this.filterSearch();
            return false;
        }
        // Arrowup
        if (e.which === 38) {
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                this.selectedIndex = 0;
            if (this.selectedIndex > 0)
                this.selectedIndex--;
            return false;
        }
        // Arrowdown
        if (e.which === 40) {
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                this.selectedIndex = -1;
            if (!this.expanded || !this.visibleItems) {
                this.expand();
                return false;
            }
            if (this.selectedIndex < this.visibleItems.length - 1)
                this.selectedIndex++;
            return false;
        }
        // If F1 is pressed, key length will be 2
        if (e.key.length > 1 || e.ctrlKey || e.altKey)
            return false;
        if (e.which >= 32 && e.which <= 126) {
            this.filterText += e.key;
            this.filterSearch();
        }
        return true;
    }
    //async onKeyPress(e: KeyboardEvent) {
    //	await SlickSleepService.sleep();
    //	if (((e.which >= 32 && e.which <= 126) || e.which === 8) && !e.ctrlKey && !e.altKey) {
    //		if (e.which === 8)
    //			this.filterText = this.filterText.substring(0, this.filterText.length - 1);
    //		else
    //			this.filterText += e.key;
    //		this.filterSearch();
    //	}
    //	return true;
    //}
    async filterSearch() {
        if (!this.expanded)
            this.expand();
        this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
        if (this.searchType === SlickDropDownSearchTypes.startsWith) {
            this.visibleItems = this.visibleItems.filter(x => x.text.toLowerCase().indexOf(this.filterText.toLowerCase()) === 0);
            if (this.visibleItems.length > 0) {
                this.selectedIndex = 0;
                if (this.isAndroid === false) {
                    this.selectedText = this.visibleItems[0].text;
                    await SlickSleepService.sleep();
                    this.selectedTextInputRef.nativeElement.setSelectionRange(this.filterText.length, this.selectedText.length);
                }
            }
            else {
                this.selectedText = this.filterText;
                this.selectedIndex = null;
            }
        }
        else if (this.searchType === SlickDropDownSearchTypes.eachWord) {
            this.visibleItems = this.visibleItems.filter(x => (" " + x.text.toLowerCase()).indexOf(" " + this.filterText.toLowerCase()) >= 0);
            if (this.visibleItems.length > 0) {
                this.selectedIndex = 0;
                if (this.isAndroid === false) {
                    this.selectedText = this.visibleItems[0].text;
                    const selectedTextStart = (" " + this.visibleItems[0].text).toLowerCase().indexOf(" " + this.filterText.toLowerCase());
                    await SlickSleepService.sleep();
                    this.selectedTextInputRef.nativeElement.setSelectionRange(selectedTextStart, selectedTextStart + this.filterText.length);
                }
            }
            else {
                this.selectedText = this.filterText;
                this.selectedIndex = null;
            }
        }
    }
    onDropdownClicked() {
        this.filterText = '';
        this.visibleItems = this.slickDropDownService.getVisibleItems(this.items, this.idFieldName, this.textFieldName);
        this.selectItem(this.selectedId, false);
        this.selectedTextInputRef.nativeElement.focus();
        if (this.skipClickExpand === true) {
            this.skipClickExpand = false;
            return;
        }
        if (this.expanded === false)
            this.expand();
        else
            this.collapse();
    }
    onItemClick(item) {
        this.selectItem(item.id, true);
        this.collapse();
    }
    handleCustomButtonClick(callback, event) {
        event.stopPropagation();
        event.preventDefault();
        if (callback) {
            callback(event);
        }
    }
}
/** @nocollapse */ SlickDropDownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownComponent, deps: [{ token: SlickDropDownService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickDropDownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickDropDownComponent, selector: "slick-drop-down", inputs: { placeholder: "placeholder", items: "items", idFieldName: "idFieldName", textFieldName: "textFieldName", compact: "compact", disabled: "disabled", allowEmpty: "allowEmpty", getUrl: "getUrl", width: "width", listWidth: "listWidth", height: "height", showLoadingMessage: "showLoadingMessage", showDebug: "showDebug", tabindex: "tabindex", validationIndicator: "validationIndicator", validationIndicatorType: "validationIndicatorType", attachTo: "attachTo", searchType: "searchType", appendButtons: "appendButtons", prependButtons: "prependButtons", isMobile: "isMobile", cssClass: "cssClass" }, outputs: { onExpand: "onExpand", onSelect: "onSelect", onChange: "onChange" }, providers: [SlickDropDownService, SlickLogService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickDropDownComponent)),
            multi: true,
        }], viewQueries: [{ propertyName: "containerDiv", first: true, predicate: ["containerDiv"], descendants: true }, { propertyName: "dropdownList", first: true, predicate: ["dropdownList"], descendants: true }, { propertyName: "selectedTextInputRef", first: true, predicate: ["selectedTextInputRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerDiv id=\"slick-drop-down_{{uuid}}\" attr.data-uuid=\"{{uuid}}\" [className]=\"'slick-drop-down ' + (cssClass || '')\" [class.open]=\"expanded\">\r\n\t<div *ngIf=\"compact === false\">\r\n        <div *ngIf=\"!disabled\" class='input-group' style=\"cursor: pointer !important\" (click)=\"onDropdownClicked()\">\r\n            <ng-container *ngIf=\"prependButtons && prependButtons.length > 0\">\r\n                <div class=\"input-group-prepend\">\r\n                    <ng-container *ngFor=\"let btn of prependButtons\">\r\n                        <button type=\"button\" class=\"input-group-text btn btn-primary badge-primary\" [disabled]=\"btn.disabled\" (click)=\"handleCustomButtonClick(btn.onClick, $event)\" style=\"margin-right: 2px; border-right: none;\">\r\n                            <i class=\"fas {{ btn.faClass }}\"></i>\r\n                        </button>\r\n                    </ng-container>\r\n                </div>\r\n            </ng-container>\r\n            <input *ngIf=\"validationIndicatorType\" [slick-validation-indicator]=\"validationIndicator\" [slickValidationType]=\"validationIndicatorType\" #selectedTextInputRef class='form-control' style='background: white; cursor: pointer' [(ngModel)]=\"selectedText\" [attr.tabindex]=\"tabindex\" (keyup)=\"onKeyUp($event)\" (keydown)=\"onKeyDown($event)\" (focus)=\"onFocus()\" [readonly]=\"!isMobile\" [placeholder]='placeholder' />\r\n            <input *ngIf=\"!validationIndicatorType\" #selectedTextInputRef class='form-control' style='background: white; cursor: pointer' [(ngModel)]=\"selectedText\" [attr.tabindex]=\"tabindex\" (keyup)=\"onKeyUp($event)\" (keydown)=\"onKeyDown($event)\" (focus)=\"onFocus()\" [readonly]=\"!isMobile\" [placeholder]='placeholder' />\r\n            <div tabindex=\"-1\" class=\"input-group-append\">\r\n                <span class=\"input-group-text btn-primary badge-primary\"><i class='fas fa-chevron-down'></i></span>\r\n            </div>\r\n            <ng-container *ngIf=\"appendButtons && appendButtons.length > 0\">\r\n                <div class=\"input-group-append\" style=\"margin-left: 0px;\">\r\n                    <ng-container *ngFor=\"let btn of appendButtons\">\r\n                        <button type=\"button\" class=\"input-group-text btn btn-primary badge-primary\" [disabled]=\"btn.disabled\" (click)=\"handleCustomButtonClick(btn.onClick, $event)\" style=\"margin-left: 1px; border-left: none;\">\r\n                            <i class=\"fas {{ btn.faClass }}\"></i>\r\n                        </button>\r\n                    </ng-container>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n\r\n\t\t<div *ngIf=\"disabled === true\" class='input-group'>\r\n\t\t\t<input #selectedTextInputRef style='cursor: default' [(ngModel)]=\"selectedText\" disabled=\"disabled\" readonly class='form-control' [placeholder]='placeholder' />\r\n\t\t\t<div tabindex=\"-1\" class=\"input-group-append disabled\">\r\n\t\t\t\t<span class=\"input-group-text text-muted\"><i class='fas fa-chevron-down'></i></span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div  [className]=\"'slick-drop-down-compact ' + (cssClass || '')\" *ngIf=\"compact === true\">\r\n\t\t<div *ngIf=\"disabled === false\" style=\"cursor: pointer !important\" (click)=\"onDropdownClicked()\">\r\n\t\t\t<input #selectedTextInputRef class=\"text-body\" [attr.tabindex]=\"tabindex\" [(ngModel)]=\"selectedText\" (keyup)=\"onKeyUp($event)\" (focus)=\"onFocus()\" ng-disabled='disabled' readonly [placeholder]='placeholder' />\r\n\t\t\t<div class=\"slick-drop-down-compact-arrow\" tabindex=\"-1\" style=\"position: relative; top: -1px;\"><i class='fas fa-chevron-down'></i></div>\r\n\t\t</div>\r\n\r\n\t\t<div *ngIf=\"disabled === true\" style=\"text-align: right;\">\r\n\t\t\t<div *ngIf='selectedText' style=\"text-align: right;\">{{selectedText}}</div>\r\n\t\t\t<div *ngIf=\"!selectedText\" style=\"text-align: right;\">{{placeholder}}</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<ul *ngIf=\"isVisible\" #dropdownList id=\"slick-drop-down_{{uuid}}\" class='slick-drop-down-list-group dropdown-menu' [style.width]=\"listGroupWidth\" [style.visibility]=\"(expanded === true) ? 'visible' : 'hidden'\" [style.opacity]=\"(expanded === true) ? '1' : '0'\" [style.max-height]=\"height\" [style.width.px]=\"listGroupWidth\" [style.left.px]=\"left\" [style.top.px]=\"top\">\r\n\t\t<li *ngFor=\"let item of visibleItems; let index = index;\" (click)=\"onItemClick(item)\" [class.active]=\"item.id === selectedItem?.id\" [class.card-header]=\"selectedIndex === index\" class=\"dropdown-item\">{{item.text}}</li>\r\n\t</ul>\r\n\r\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: SlickValidationIndicatorDirective, selector: "[slick-validation-indicator]", inputs: ["slick-validation-indicator", "slickValidationType"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-drop-down', providers: [SlickDropDownService, SlickLogService,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickDropDownComponent)),
                            multi: true,
                        }], template: "<div #containerDiv id=\"slick-drop-down_{{uuid}}\" attr.data-uuid=\"{{uuid}}\" [className]=\"'slick-drop-down ' + (cssClass || '')\" [class.open]=\"expanded\">\r\n\t<div *ngIf=\"compact === false\">\r\n        <div *ngIf=\"!disabled\" class='input-group' style=\"cursor: pointer !important\" (click)=\"onDropdownClicked()\">\r\n            <ng-container *ngIf=\"prependButtons && prependButtons.length > 0\">\r\n                <div class=\"input-group-prepend\">\r\n                    <ng-container *ngFor=\"let btn of prependButtons\">\r\n                        <button type=\"button\" class=\"input-group-text btn btn-primary badge-primary\" [disabled]=\"btn.disabled\" (click)=\"handleCustomButtonClick(btn.onClick, $event)\" style=\"margin-right: 2px; border-right: none;\">\r\n                            <i class=\"fas {{ btn.faClass }}\"></i>\r\n                        </button>\r\n                    </ng-container>\r\n                </div>\r\n            </ng-container>\r\n            <input *ngIf=\"validationIndicatorType\" [slick-validation-indicator]=\"validationIndicator\" [slickValidationType]=\"validationIndicatorType\" #selectedTextInputRef class='form-control' style='background: white; cursor: pointer' [(ngModel)]=\"selectedText\" [attr.tabindex]=\"tabindex\" (keyup)=\"onKeyUp($event)\" (keydown)=\"onKeyDown($event)\" (focus)=\"onFocus()\" [readonly]=\"!isMobile\" [placeholder]='placeholder' />\r\n            <input *ngIf=\"!validationIndicatorType\" #selectedTextInputRef class='form-control' style='background: white; cursor: pointer' [(ngModel)]=\"selectedText\" [attr.tabindex]=\"tabindex\" (keyup)=\"onKeyUp($event)\" (keydown)=\"onKeyDown($event)\" (focus)=\"onFocus()\" [readonly]=\"!isMobile\" [placeholder]='placeholder' />\r\n            <div tabindex=\"-1\" class=\"input-group-append\">\r\n                <span class=\"input-group-text btn-primary badge-primary\"><i class='fas fa-chevron-down'></i></span>\r\n            </div>\r\n            <ng-container *ngIf=\"appendButtons && appendButtons.length > 0\">\r\n                <div class=\"input-group-append\" style=\"margin-left: 0px;\">\r\n                    <ng-container *ngFor=\"let btn of appendButtons\">\r\n                        <button type=\"button\" class=\"input-group-text btn btn-primary badge-primary\" [disabled]=\"btn.disabled\" (click)=\"handleCustomButtonClick(btn.onClick, $event)\" style=\"margin-left: 1px; border-left: none;\">\r\n                            <i class=\"fas {{ btn.faClass }}\"></i>\r\n                        </button>\r\n                    </ng-container>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n\r\n\t\t<div *ngIf=\"disabled === true\" class='input-group'>\r\n\t\t\t<input #selectedTextInputRef style='cursor: default' [(ngModel)]=\"selectedText\" disabled=\"disabled\" readonly class='form-control' [placeholder]='placeholder' />\r\n\t\t\t<div tabindex=\"-1\" class=\"input-group-append disabled\">\r\n\t\t\t\t<span class=\"input-group-text text-muted\"><i class='fas fa-chevron-down'></i></span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div  [className]=\"'slick-drop-down-compact ' + (cssClass || '')\" *ngIf=\"compact === true\">\r\n\t\t<div *ngIf=\"disabled === false\" style=\"cursor: pointer !important\" (click)=\"onDropdownClicked()\">\r\n\t\t\t<input #selectedTextInputRef class=\"text-body\" [attr.tabindex]=\"tabindex\" [(ngModel)]=\"selectedText\" (keyup)=\"onKeyUp($event)\" (focus)=\"onFocus()\" ng-disabled='disabled' readonly [placeholder]='placeholder' />\r\n\t\t\t<div class=\"slick-drop-down-compact-arrow\" tabindex=\"-1\" style=\"position: relative; top: -1px;\"><i class='fas fa-chevron-down'></i></div>\r\n\t\t</div>\r\n\r\n\t\t<div *ngIf=\"disabled === true\" style=\"text-align: right;\">\r\n\t\t\t<div *ngIf='selectedText' style=\"text-align: right;\">{{selectedText}}</div>\r\n\t\t\t<div *ngIf=\"!selectedText\" style=\"text-align: right;\">{{placeholder}}</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<ul *ngIf=\"isVisible\" #dropdownList id=\"slick-drop-down_{{uuid}}\" class='slick-drop-down-list-group dropdown-menu' [style.width]=\"listGroupWidth\" [style.visibility]=\"(expanded === true) ? 'visible' : 'hidden'\" [style.opacity]=\"(expanded === true) ? '1' : '0'\" [style.max-height]=\"height\" [style.width.px]=\"listGroupWidth\" [style.left.px]=\"left\" [style.top.px]=\"top\">\r\n\t\t<li *ngFor=\"let item of visibleItems; let index = index;\" (click)=\"onItemClick(item)\" [class.active]=\"item.id === selectedItem?.id\" [class.card-header]=\"selectedIndex === index\" class=\"dropdown-item\">{{item.text}}</li>\r\n\t</ul>\r\n\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: SlickDropDownService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { placeholder: [{
                type: Input
            }], items: [{
                type: Input
            }], idFieldName: [{
                type: Input
            }], textFieldName: [{
                type: Input
            }], compact: [{
                type: Input
            }], disabled: [{
                type: Input
            }], allowEmpty: [{
                type: Input
            }], getUrl: [{
                type: Input
            }], width: [{
                type: Input
            }], listWidth: [{
                type: Input
            }], height: [{
                type: Input
            }], showLoadingMessage: [{
                type: Input
            }], showDebug: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], validationIndicator: [{
                type: Input
            }], validationIndicatorType: [{
                type: Input
            }], attachTo: [{
                type: Input
            }], searchType: [{
                type: Input
            }], appendButtons: [{
                type: Input
            }], prependButtons: [{
                type: Input
            }], isMobile: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], onExpand: [{
                type: Output
            }], onSelect: [{
                type: Output
            }], onChange: [{
                type: Output
            }], containerDiv: [{
                type: ViewChild,
                args: ["containerDiv"]
            }], dropdownList: [{
                type: ViewChild,
                args: ["dropdownList"]
            }], selectedTextInputRef: [{
                type: ViewChild,
                args: ["selectedTextInputRef"]
            }] } });

class SlickDropDownButtonModel {
    constructor(faClass = null, onClick = null) {
        this.onClick = onClick;
        this.faClass = faClass;
        this.tabIndex = -1;
    }
}

class SlickDropDownModule {
}
/** @nocollapse */ SlickDropDownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickDropDownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownModule, declarations: [SlickDropDownComponent], imports: [CommonModule, FormsModule, HttpClientModule, SlickValidationIndicatorModule], exports: [SlickDropDownComponent] });
/** @nocollapse */ SlickDropDownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownModule, providers: [HttpClientModule], imports: [CommonModule, FormsModule, HttpClientModule, SlickValidationIndicatorModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropDownModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, HttpClientModule, SlickValidationIndicatorModule],
                    declarations: [SlickDropDownComponent],
                    exports: [SlickDropDownComponent],
                    providers: [HttpClientModule]
                }]
        }] });

class SlickDropListDirective {
    constructor(el) {
        this.onSlickDropListReorder = new EventEmitter();
        this.onSlickDropListEnter = new EventEmitter();
        this.onSlickDropListLeave = new EventEmitter();
        this.uuid = SlickUtilsService.newGuid();
        this.fnMouseDown = (e) => this.mouseDown(e);
        this.fnMouseMove = (e) => this.mouseMove(e);
        this.fnMouseUp = () => this.mouseUp();
        this.el = el.nativeElement;
        this.el.setAttribute("drop-list-uuid", this.uuid);
    }
    ngOnInit() {
        this.el.style.position = "relative";
        document.addEventListener("mousedown", this.fnMouseDown, true);
    }
    ngOnDestroy() {
        document.removeEventListener("mousedown", this.fnMouseDown, true);
        document.removeEventListener("mousemove", this.fnMouseMove, true);
        document.removeEventListener("mouseup", this.fnMouseUp, true);
    }
    async mouseDown(e, target = null) {
        this.isAdding = false;
        this.isMoving = false;
        if (e.button !== 0 || !e || !e.target)
            return;
        document.removeEventListener("mouseup", this.fnMouseUp, true);
        document.removeEventListener("mousemove", this.fnMouseMove, true);
        document.addEventListener("mouseup", this.fnMouseUp, true);
        document.addEventListener("mousemove", this.fnMouseMove, true);
        if (!target)
            target = e.target;
        const parent = SlickUtilsService.findParentByAttr(target, 'drop-list-uuid', this.uuid);
        if (!parent)
            return;
        this.isMoving = true;
        const grabEls = this.el.querySelectorAll(".slick-drop-list-grab");
        if (grabEls.length > 0 && !SlickUtilsService.findParent(target, "slick-drop-list-grab"))
            return true;
        const dropListItem = SlickUtilsService.findParent(target, "slick-drop-list-item");
        if (!dropListItem) {
            console.error("Can't find item element");
            return;
        }
        // Find which element the mouse is over
        this.currentIdx = this.findElementIdx(e.y, false);
        this.originalIdx = this.currentIdx;
        this.startMove(dropListItem);
    }
    mouseMove(e) {
        if (this.isAdding)
            return;
        const parent = SlickUtilsService.findParentByAttr(e.target, 'drop-list-uuid', this.uuid);
        if (!parent) {
            // If this isn't the parent, but we we're moving, that means we just left this parent
            // Send a message which element was dragged out and reset everything else
            if (this.isMoving && this.onSlickDropListLeave.observers.length > 0) {
                this.isMoving = false;
                const allItems = this.el.querySelectorAll(".slick-drop-list-item");
                allItems.forEach(item => {
                    item.classList.remove("slick-drop-list-item-animation");
                    item.style.transform = "";
                });
                this.onSlickDropListLeave.emit(this.originalIdx);
            }
            return;
        }
        if (!this.isMoving && this.onSlickDropListEnter.observers.length === 0)
            return;
        // If the mouse was clicked outside of this droplist, but it has now moved inside this droplist, tell the parent where
        // in the droplist it has moved.
        // Since there is no way for a directive to have functions called via ViewChild, just assume that the page 
        // has added the appropriate element at the appropriate place
        if (!this.isMoving && this.onSlickDropListEnter) {
            this.isAdding = true;
            // Find which element the mouse is over
            const idx = this.findElementIdx(e.y, false);
            this.isAddingMouseEvent = e;
            // The caller needs to call the ready function after adding the new record to the array
            this.onSlickDropListEnter.emit({ idx: idx, ready: this.newItemReady.bind(this) });
            return;
        }
        // Find which element the mouse is over
        const dropListItems = this.el.querySelectorAll(".slick-drop-list-item");
        for (let i = 0; i < dropListItems.length; i++) {
            const dropListItem = dropListItems[i];
            const boundingRect = dropListItem.getBoundingClientRect();
            const topHalfTop = boundingRect.top;
            const topHalfBottom = topHalfTop + (boundingRect.height / 2);
            const bottomHalfTop = topHalfBottom + 1;
            const bottomHalfBottom = boundingRect.bottom;
            if (this.currentIdx !== i && e.y >= topHalfTop && e.y <= topHalfBottom) {
                this.currentIdx = i;
                this.redraw();
                break;
            }
            if (this.currentIdx !== i + 1 && e.y >= bottomHalfTop && e.y <= bottomHalfBottom) {
                this.currentIdx = i + 1;
                this.redraw();
                break;
            }
        }
    }
    mouseUp() {
        document.removeEventListener("mouseup", this.fnMouseUp, true);
        document.removeEventListener("mousemove", this.fnMouseMove, true);
        if (!this.isMoving)
            return;
        this.isMoving = false;
        // Remove the placeholder
        this.placeholderEl.classList.remove("slick-drop-list-placeholder");
        this.placeholderEl.classList.add("slick-drop-list-item");
        this.placeholderEl.style.boxShadow = "";
        this.placeholderEl.style.transform = "";
        this.el.removeChild(this.placeholderEl);
        // Add the placeholder back
        const allItems = this.el.querySelectorAll(".slick-drop-list-item");
        if (this.currentIdx === allItems.length)
            this.el.appendChild(this.placeholderEl);
        else
            this.el.insertBefore(this.placeholderEl, allItems[this.currentIdx]);
        this.placeholderEl = null;
        allItems.forEach(item => {
            item.classList.remove("slick-drop-list-item-animation");
            item.style.transform = "";
        });
        if (this.onSlickDropListReorder)
            this.onSlickDropListReorder.emit([this.originalIdx, this.currentIdx]);
        this.originalIdx = null;
        this.currentIdx = null;
    }
    redraw() {
        const allChildren = this.el.querySelectorAll(".slick-drop-list-item");
        let placeholderOffset = 0;
        for (let i = 0; i < allChildren.length; i++) {
            const item = allChildren[i];
            if (i < this.currentIdx) {
                item.style.transform = `translate3d(0px, 0px, 0px)`;
            }
            else {
                item.style.transform = `translate3d(0px, ${this.placeholderHeight}px, 0px)`;
                placeholderOffset += this.itemHeights[i];
            }
        }
        this.placeholderEl.style.transform = `translate3d(0px, -${placeholderOffset}px, 0px)`;
    }
    newItemReady(idx) {
        setTimeout(() => {
            this.currentIdx = idx;
            this.originalIdx = idx;
            const dropListItem = this.el.querySelectorAll(".slick-drop-list-item").item(idx);
            this.mouseDown(this.isAddingMouseEvent, dropListItem);
        });
    }
    findElementIdx(mouseY, useTopAndBottom) {
        const dropListItems = this.el.querySelectorAll(".slick-drop-list-item");
        for (let i = 0; i < dropListItems.length; i++) {
            const dropListItem = dropListItems[i];
            const boundingRect = dropListItem.getBoundingClientRect();
            if (useTopAndBottom) {
                const topHalfTop = boundingRect.top;
                const topHalfBottom = topHalfTop + (boundingRect.height / 2);
                const bottomHalfTop = topHalfBottom + 1;
                const bottomHalfBottom = boundingRect.bottom;
                if (mouseY >= topHalfTop && mouseY <= topHalfBottom)
                    return i;
                if (mouseY >= bottomHalfTop && mouseY <= bottomHalfBottom)
                    return i + 1;
            }
            else {
                if (mouseY >= boundingRect.top && mouseY <= boundingRect.bottom)
                    return i;
            }
        }
    }
    startMove(dropListItem) {
        this.el.style.userSelect = "none";
        this.placeholderEl = dropListItem;
        this.placeholderEl.classList.add("slick-drop-list-placeholder");
        this.placeholderEl.classList.remove("slick-drop-list-item");
        this.placeholderEl.style.boxShadow = "4px 12px 6px rgba(0,0,0,.24)";
        this.placeholderHeight = this.placeholderEl.getBoundingClientRect().height;
        this.el.removeChild(this.placeholderEl);
        this.el.appendChild(this.placeholderEl);
        this.itemHeights = [];
        this.el.querySelectorAll(".slick-drop-list-item").forEach(item => this.itemHeights.push(item.getBoundingClientRect().height));
        this.redraw();
        // Don't start the animation until after the first click because it looks weird
        setTimeout(() => {
            const allChildren = this.el.querySelectorAll(".slick-drop-list-item");
            allChildren.forEach(item => item.classList.add("slick-drop-list-item-animation"));
        });
    }
}
/** @nocollapse */ SlickDropListDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickDropListDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickDropListDirective, selector: "[slick-drop-list]", outputs: { onSlickDropListReorder: "onSlickDropListReorder", onSlickDropListEnter: "onSlickDropListEnter", onSlickDropListLeave: "onSlickDropListLeave" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-drop-list]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { onSlickDropListReorder: [{
                type: Output,
                args: ["onSlickDropListReorder"]
            }], onSlickDropListEnter: [{
                type: Output,
                args: ["onSlickDropListEnter"]
            }], onSlickDropListLeave: [{
                type: Output,
                args: ["onSlickDropListLeave"]
            }] } });

class SlickDropListItemDirective {
    constructor(el) {
        const dropListEl = el.nativeElement;
        if (dropListEl.classList.contains("slick-drop-list-item") === false)
            dropListEl.classList.add("slick-drop-list-item");
    }
}
/** @nocollapse */ SlickDropListItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListItemDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickDropListItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickDropListItemDirective, selector: "[slick-drop-list-item]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-drop-list-item]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class SlickDropListGrabDirective {
    constructor(el) {
        const dropListEl = el.nativeElement;
        if (dropListEl.classList.contains("slick-drop-list-grab") === false)
            dropListEl.classList.add("slick-drop-list-grab");
    }
}
/** @nocollapse */ SlickDropListGrabDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListGrabDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickDropListGrabDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickDropListGrabDirective, selector: "[slick-drop-list-grab]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListGrabDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-drop-list-grab]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class SlickDropListModule {
}
/** @nocollapse */ SlickDropListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickDropListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListModule, declarations: [SlickDropListDirective, SlickDropListItemDirective, SlickDropListGrabDirective], imports: [CommonModule], exports: [SlickDropListDirective, SlickDropListItemDirective, SlickDropListGrabDirective] });
/** @nocollapse */ SlickDropListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickDropListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickDropListDirective, SlickDropListItemDirective, SlickDropListGrabDirective],
                    exports: [SlickDropListDirective, SlickDropListItemDirective, SlickDropListGrabDirective]
                }]
        }] });

class SlickFileModel {
}

const imgExtensions$1 = ['bmp', 'gif', 'jpeg', 'jpg', 'png', 'tif', 'tiff'];
class SlickFileDropComponent {
    constructor() {
        this.displayText = "Drop Files Here...";
        this.filesChangedEmitter = new EventEmitter();
        this.fnOnFileInputChange = (e) => this.onFileInputChange(e);
        this.uuid = SlickUtilsService.newGuid();
    }
    onClick(e) {
        this.fileInput.nativeElement.click();
        this.fileInput.nativeElement.removeEventListener("change", this.fnOnFileInputChange, true);
        this.fileInput.nativeElement.addEventListener("change", this.fnOnFileInputChange, true);
    }
    ngOnDestroy() {
        this.fileInput.nativeElement.removeEventListener("change", this.fnOnFileInputChange, true);
    }
    onFileInputChange(e) {
        try {
            this.processFileTimeout = setTimeout(() => {
                alert("Processing files timed out");
            }, 10000);
            this.processFiles(this.fileInput.nativeElement.files);
            // A validation to make sure the files all got processed
            clearTimeout(this.processFileTimeout);
            this.fileInput.nativeElement.value = '';
        }
        catch (err) {
            alert("SlickFileDrop Error: " + err);
        }
    }
    onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.containerRef.nativeElement.classList.remove("slick-file-drop_drag-enter");
        this.processFiles(e.dataTransfer.files);
    }
    onDragEnter(e) {
        this.containerRef.nativeElement.classList.add("slick-file-drop_drag-enter");
    }
    onDragOver(e) {
        e.preventDefault();
    }
    onDragLeave(e) {
        this.containerRef.nativeElement.classList.remove("slick-file-drop_drag-enter");
    }
    async processFiles(files) {
        let slickFileModels = [];
        let imageLoadPromises = [];
        let imgPromises = [];
        for (let i = 0; i < files.length; i++) {
            imageLoadPromises.push(new Promise(async (resolve) => {
                let file = files.item(i);
                let slickFileModel = new SlickFileModel();
                slickFileModel.uuid = SlickUtilsService.newGuid();
                slickFileModel.file = file;
                slickFileModel.name = file.name;
                slickFileModel.title = file.name;
                let fileNameParts = slickFileModel.name.split('.');
                let ext = fileNameParts[fileNameParts.length - 1].toLowerCase();
                if (imgExtensions$1.indexOf(ext) >= 0) {
                    let img = new Image;
                    img.onload = () => {
                        slickFileModel.thumbnailBase64Image = this.resizeImageToBase64(img, 60, 60);
                        slickFileModel.base64Image = this.resizeImageToBase64(img, 1600, 1600);
                        slickFileModels.push(slickFileModel);
                        resolve(null);
                    };
                    img.src = await this.getBase64(file);
                }
                else {
                    slickFileModels.push(slickFileModel);
                    resolve(null);
                }
            }));
        }
        await Promise.all(imageLoadPromises);
        this.filesChangedEmitter.emit(slickFileModels);
    }
    resizeImageToBase64(img, width, height) {
        let scale = 1;
        if (img.width > img.height) {
            if (img.width > width)
                scale = width / img.width;
        }
        else {
            if (img.height > height)
                scale = height / img.height;
        }
        let newWidth = img.width * scale;
        let newHeight = img.height * scale;
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // We set the dimensions at the wanted size.
        canvas.width = newWidth;
        canvas.height = newHeight;
        // We resize the image with the canvas method drawImage();
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        return canvas.toDataURL("image/jpeg");
    }
    getBase64(file) {
        return new Promise((resolve, reject) => {
            // Capacitor fails on the FileReader, so we need to get _readReader
            // See: https://github.com/ionic-team/ionic-native/issues/505#issuecomment-503316333
            let fileReader = new FileReader();
            // Get the original real FileReader. The polyfill saves a reference to it.
            const realFileReader = fileReader._realReader;
            // Make sure we were able to get the original FileReader 
            if (realFileReader) {
                // Swap out the polyfill instance for the original instance.
                fileReader = realFileReader;
            }
            fileReader.readAsDataURL(file);
            fileReader.onload = () => resolve(fileReader.result);
            fileReader.onerror = (error) => reject('Error: ' + error);
        });
    }
}
/** @nocollapse */ SlickFileDropComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileDropComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickFileDropComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickFileDropComponent, selector: "slick-file-drop", inputs: { displayText: "displayText" }, outputs: { filesChangedEmitter: "filesChanged" }, host: { listeners: { "click": "onClick($event)", "drop": "onDrop($event)", "dragenter": "onDragEnter($event)", "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)" } }, viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }, { propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], ngImport: i0, template: "<p #containerRef id=\"slick-file-drop_{{uuid}}\" class=\"slick-file-drop card\">\r\n\t{{displayText}}\r\n</p>\r\n<input type=\"file\" #fileInput style=\"display: none\" multiple />\r\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileDropComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-file-drop', template: "<p #containerRef id=\"slick-file-drop_{{uuid}}\" class=\"slick-file-drop card\">\r\n\t{{displayText}}\r\n</p>\r\n<input type=\"file\" #fileInput style=\"display: none\" multiple />\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { displayText: [{
                type: Input,
                args: ["displayText"]
            }], filesChangedEmitter: [{
                type: Output,
                args: ["filesChanged"]
            }], containerRef: [{
                type: ViewChild,
                args: ["containerRef"]
            }], fileInput: [{
                type: ViewChild,
                args: ["fileInput"]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }], onDragEnter: [{
                type: HostListener,
                args: ['dragenter', ['$event']]
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }] } });

class SlickFileDropModule {
}
/** @nocollapse */ SlickFileDropModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileDropModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickFileDropModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickFileDropModule, declarations: [SlickFileDropComponent], imports: [CommonModule, FormsModule], exports: [CommonModule, FormsModule, SlickFileDropComponent] });
/** @nocollapse */ SlickFileDropModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileDropModule, imports: [CommonModule, FormsModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileDropModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [SlickFileDropComponent],
                    exports: [CommonModule, FormsModule, SlickFileDropComponent]
                }]
        }] });

class SlickPhotoGalleryModel {
}

class SlickPhotoGalleryComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.isVisible = false;
        this.isPhotoGalleryVisible = false;
        this.selectedPhoto = null;
        this.visibleIndex = 0;
    }
    async onResize(e) {
        if (e.which === 39)
            this.nextPhoto();
        else if (e.which === 37)
            this.previousPhoto();
        else if (e.which === 27)
            this.closeWindow();
    }
    ngOnDestroy() {
        // It's fine if this fails.  It just means it was removed elsewhere
        try {
            document.body.appendChild(this.containerRef.nativeElement);
        }
        catch { }
    }
    ngOnChanges(changes) {
        if (changes.files) {
            this.photos = [];
            if (changes.files.currentValue) {
                this.photos = changes.files.currentValue.map((f) => {
                    let photoModel = new SlickPhotoGalleryModel();
                    photoModel.photoUrl = f.base64Image || f.url;
                    photoModel.title = f.title;
                    return photoModel;
                });
            }
        }
    }
    async showPhotoGallery(visibleIndex = 0) {
        this.isVisible = true;
        this.changeDetector.detectChanges();
        document.body.appendChild(this.containerRef.nativeElement);
        await SlickSleepService.sleep();
        this.isPhotoGalleryVisible = true;
        this.visibleIndex = visibleIndex;
        if (this.photos && this.photos.length > 0)
            this.selectedPhoto = this.photos[this.visibleIndex];
    }
    hidePhotoGallery() {
        // It's fine if this fails.  It just means it was removed elsewhere
        try {
            document.body.removeChild(this.containerRef.nativeElement);
        }
        catch { }
        this.isVisible = false;
    }
    previousPhoto() {
        if (this.visibleIndex === 0)
            this.visibleIndex = this.photos.length - 1;
        else
            this.visibleIndex--;
        this.selectedPhoto = this.photos[this.visibleIndex];
    }
    nextPhoto() {
        if (this.visibleIndex === this.photos.length - 1)
            this.visibleIndex = 0;
        else
            this.visibleIndex++;
        this.selectedPhoto = this.photos[this.visibleIndex];
    }
    setPosition(idx) {
        this.visibleIndex = idx;
        this.selectedPhoto = this.photos[this.visibleIndex];
    }
    closeWindow() {
        this.hidePhotoGallery();
    }
}
/** @nocollapse */ SlickPhotoGalleryComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPhotoGalleryComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickPhotoGalleryComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickPhotoGalleryComponent, selector: "slick-photo-gallery", inputs: { photos: "photos", files: "files" }, host: { listeners: { "window:keydown": "onResize($event)" } }, viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerRef *ngIf=\"isVisible === true\" class='slick-photo-gallery'>\r\n\t<div class=\"slick-photo-gallery_overlay\" (click)=\"closeWindow()\" [ngClass]=\"{'visible': isPhotoGalleryVisible === true}\"></div>\r\n\t<div class=\"modal-content slick-photo-gallery_content\" style=\"width: 90%; margin-left: 5%;\" *ngIf=\"isPhotoGalleryVisible === true\">\r\n\t\t<div class=\"modal-header slick-photo-gallery_header\"><div class=\"header-right\" (click)='closeWindow()'><i class=\"far fa-times\"></i></div></div>\r\n\t\t<div class=\"modal-body\">\r\n\t\t\t<div *ngIf=\"selectedPhoto\" class='slick-photo-gallery_photo-container'>\r\n\t\t\t\t<img class='slick-photo-gallery_photo' [src]='selectedPhoto.photoUrl' />\r\n\t\t\t</div>\r\n\t\t\t<div (click)='previousPhoto()' class='slick-photo-gallery_previous-photo'><i class='far fa-chevron-left'></i></div>\r\n\t\t\t<div (click)='nextPhoto()' class='slick-photo-gallery_next-photo'><i class='far fa-chevron-right'></i></div>\r\n\t\t\t<!--<div *ngIf=\"photos\" class='slick-photo-gallery_position-indicators'>\r\n\t\t\t\t<i (click)='setPosition(index)' *ngFor='let photo of photos; let index = index' [ngClass]='(index === visibleIndex) ? \"fas fa-circle\" : \"far fa-circle\"'></i>\r\n\t\t\t</div>-->\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPhotoGalleryComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-photo-gallery", template: "<div #containerRef *ngIf=\"isVisible === true\" class='slick-photo-gallery'>\r\n\t<div class=\"slick-photo-gallery_overlay\" (click)=\"closeWindow()\" [ngClass]=\"{'visible': isPhotoGalleryVisible === true}\"></div>\r\n\t<div class=\"modal-content slick-photo-gallery_content\" style=\"width: 90%; margin-left: 5%;\" *ngIf=\"isPhotoGalleryVisible === true\">\r\n\t\t<div class=\"modal-header slick-photo-gallery_header\"><div class=\"header-right\" (click)='closeWindow()'><i class=\"far fa-times\"></i></div></div>\r\n\t\t<div class=\"modal-body\">\r\n\t\t\t<div *ngIf=\"selectedPhoto\" class='slick-photo-gallery_photo-container'>\r\n\t\t\t\t<img class='slick-photo-gallery_photo' [src]='selectedPhoto.photoUrl' />\r\n\t\t\t</div>\r\n\t\t\t<div (click)='previousPhoto()' class='slick-photo-gallery_previous-photo'><i class='far fa-chevron-left'></i></div>\r\n\t\t\t<div (click)='nextPhoto()' class='slick-photo-gallery_next-photo'><i class='far fa-chevron-right'></i></div>\r\n\t\t\t<!--<div *ngIf=\"photos\" class='slick-photo-gallery_position-indicators'>\r\n\t\t\t\t<i (click)='setPosition(index)' *ngFor='let photo of photos; let index = index' [ngClass]='(index === visibleIndex) ? \"fas fa-circle\" : \"far fa-circle\"'></i>\r\n\t\t\t</div>-->\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { photos: [{
                type: Input
            }], files: [{
                type: Input
            }], containerRef: [{
                type: ViewChild,
                args: ["containerRef"]
            }], onResize: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }] } });

const excelExtensions = ['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xla', 'xlam', 'xll', 'xlw'];
const wordExtensions = ['doc', 'dot', 'wbk', 'docx', 'docm', 'dotx', 'dotm', 'docb'];
const pdfExtensions = ['pdf'];
class SlickFileListItemComponent {
    constructor() {
        this.allowDelete = true;
        this.showPhotoGallery = false;
        this.showCheckbox = false;
        this.confirmDelete = true;
        this.fileChangeEmitter = new EventEmitter();
        this.fileDeleteEmitter = new EventEmitter();
        this.fileClicked = new EventEmitter();
        this.checkChanged = new EventEmitter();
        this.isEditing = false;
        this.tempTitle = '';
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.itemSize = 120;
        this.itemImgSize = 90;
        this.uuid = SlickUtilsService.newGuid();
    }
    ngOnChanges(changes) {
        if (changes.thumbnailSize) {
            this.itemImgSize = parseInt(this.thumbnailSize.toString());
            this.itemSize = this.itemImgSize + 20;
        }
        if (changes.allowDelete && changes.allowDelete.currentValue)
            this.allowDelete = (changes.allowDelete.currentValue.toString().toLowerCase() !== 'false');
        if (changes.showPhotoGallery && changes.showPhotoGallery.currentValue)
            this.showPhotoGallery = (changes.showPhotoGallery.currentValue.toString().toLowerCase() !== 'false');
        if (changes.showCheckbox && changes.showCheckbox.currentValue)
            this.showCheckbox = (changes.showCheckbox.currentValue.toString().toLowerCase() !== 'false');
        this.confirmDelete = (this.confirmDelete.toString() === 'true') ? true : false;
        if (this.file && this.file.name && !this.file.thumbnailBase64Image && !this.file.url) {
            if (this.file.isChecked === null)
                this.file.isChecked = false;
            let fileNameParts = this.file.name.split('.');
            if (fileNameParts.length > 1) {
                let ext = fileNameParts[fileNameParts.length - 1].toLowerCase();
                if (excelExtensions.indexOf(ext) >= 0) {
                    this.file.thumbnailBase64Image = "data:image/png;base64,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";
                }
                else if (wordExtensions.indexOf(ext) >= 0) {
                    this.file.thumbnailBase64Image = "data:image/png;base64,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";
                }
                else if (pdfExtensions.indexOf(ext) >= 0) {
                    this.file.thumbnailBase64Image = "data:image/png;base64,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";
                }
                else {
                    this.file.thumbnailBase64Image = "data:image/png;base64,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";
                }
            }
        }
        if (this.file && this.file.fileDate) {
            const fileDateFormat = (this.file.fileDateFormat ?? '') !== '' ? this.file.fileDateFormat : 'M/D/YYYY h:mm:ss a';
            this.fileDateFormatted = moment(this.file.fileDate).format(fileDateFormat);
        }
    }
    onClick() {
        if (this.fileClicked)
            this.fileClicked.emit(this.file);
    }
    async deleteFile(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.confirmDelete === false) {
            this.fileDeleteEmitter.emit(this.file);
        }
        else {
            const result = await this.deleteConfirmRef.confirm();
            if (result === SlickConfirmDialogResults.Ok)
                this.fileDeleteEmitter.emit(this.file);
        }
    }
    async editTitle() {
        this.isEditing = true;
        this.tempTitle = this.file.title;
        await SlickSleepService.sleep();
        this.editTitleInputRef.nativeElement.setSelectionRange(0, this.editTitleInputRef.nativeElement.value.length);
        this.editTitleInputRef.nativeElement.focus();
        document.addEventListener("click", this.fnDocumentClick, true);
    }
    onKeyDown(e) {
        if (e.which === 13) {
            this.file.title = this.tempTitle;
            this.fileChangeEmitter.emit(this.file);
            this.isEditing = false;
            document.removeEventListener("click", this.fnDocumentClick, true);
        }
        if (e.which === 27) {
            this.tempTitle = null;
            this.isEditing = false;
            document.removeEventListener("click", this.fnDocumentClick, true);
        }
    }
    async documentClick(e) {
        await SlickSleepService.sleep();
        const clickedInside = SlickUtilsService.checkParentClassExists(e.target, 'slick-file-list-item_title');
        if (clickedInside)
            return;
        if (this.isEditing === true) {
            this.file.title = this.tempTitle;
            this.fileChangeEmitter.emit(this.file);
            this.isEditing = false;
            document.removeEventListener("click", this.fnDocumentClick, true);
        }
    }
    async onCheckboxClicked(e) {
        this.file.isChecked = !this.file.isChecked;
        if (this.checkChanged)
            this.checkChanged.emit(e);
    }
    ngOnDestroy() {
        document.removeEventListener("click", this.fnDocumentClick, true);
    }
}
/** @nocollapse */ SlickFileListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickFileListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickFileListItemComponent, selector: "slick-file-list-item", inputs: { file: "file", allowDelete: "allowDelete", showPhotoGallery: "showPhotoGallery", showCheckbox: "showCheckbox", thumbnailSize: "thumbnailSize", confirmDelete: "confirmDelete" }, outputs: { fileChangeEmitter: "fileChange", fileDeleteEmitter: "fileDelete", fileClicked: "fileClicked", checkChanged: "checkChanged" }, viewQueries: [{ propertyName: "titleDivRef", first: true, predicate: ["titleDivRef"], descendants: true }, { propertyName: "editTitleDivRef", first: true, predicate: ["editTitleDivRef"], descendants: true }, { propertyName: "editTitleInputRef", first: true, predicate: ["editTitleInputRef"], descendants: true }, { propertyName: "deleteConfirmRef", first: true, predicate: ["deleteConfirmRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-file-list-item\" id=\"slick-file-list-item_{{uuid}}\">\r\n\t<div class=\"slick-file-list-item_img card\" (click)=\"onClick()\" [ngStyle]=\"{ 'cursor': (showPhotoGallery === true) ? 'pointer' : 'default' }\" [style.minHeight.px]=\"itemSize + 2\" [style.minWidth.px]=\"itemSize\">\r\n\t\t<img *ngIf=\"file.thumbnailBase64Image\" [src]=\"file.thumbnailBase64Image\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<img *ngIf=\"!file.thumbnailBase64Image && file.base64Image\" [src]=\"file.base64Image\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<img *ngIf=\"!file.thumbnailBase64Image && !file.base64Image && file.thumbnailUrl\" [src]=\"file.thumbnailUrl\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<img *ngIf=\"!file.thumbnailBase64Image && !file.base64Image && !file.thumbnailUrl && file.url\" [src]=\"file.url\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<i *ngIf=\"allowDelete\" class=\"fas fa-times-circle bg-white text-danger\" (click)=\"deleteFile($event)\"></i>\r\n\t</div>\r\n\t<div class=\"slick-file-list-item_title\" *ngIf=\"fileDateFormatted\" [style.minWidth.px]=\"itemSize\" [style.maxWidth.px]=\"itemSize\">\r\n\t\t<div class=\"slick-file-list-item_date\" *ngIf=\"fileDateFormatted\" [style.minWidth.px]=\"itemSize\">{{fileDateFormatted}}</div>\r\n\t</div>\r\n\t<div class=\"slick-file-list-item_title\" [style.minWidth.px]=\"itemSize\" [style.maxWidth.px]=\"itemSize\">\r\n\t\t<div class=\"slick-file-list-item_display-title\" #titleDivRef style=\"cursor: pointer\" *ngIf=\"!isEditing\" (click)=\"editTitle()\">{{file.title}}</div>\r\n\t\t<div #editTitleDivRef class=\"slick-file-list-item_edit-title\" *ngIf=\"isEditing\"><input #editTitleInputRef type=\"text\" class=\"form-control\" [(ngModel)]=\"tempTitle\" (keydown)=\"onKeyDown($event)\" [style.width.px]=\"itemSize\" /></div>\r\n\t</div>\r\n\r\n\t<!-- We want the user to be able to click just a little outside of the checkbox and still have it check -->\r\n\t<div *ngIf=\"showCheckbox === true\" class=\"slick-file-checkbox\" (click)=\"onCheckboxClicked($event)\">\r\n\t\t<input type=\"checkbox\" [ngModel]=\"file.isChecked\" />\r\n\t</div>\r\n</div>\r\n\r\n<slick-confirm-dialog #deleteConfirmRef>\r\n\t<h4 class=\"p-0 m-0 text-danger\">Are you sure you want to delete?</h4>\r\n</slick-confirm-dialog>", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickConfirmDialogComponent, selector: "slick-confirm-dialog", inputs: ["width", "okButtonText", "cancelButtonText", "showOkButton", "showCancelButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-file-list-item', template: "<div class=\"slick-file-list-item\" id=\"slick-file-list-item_{{uuid}}\">\r\n\t<div class=\"slick-file-list-item_img card\" (click)=\"onClick()\" [ngStyle]=\"{ 'cursor': (showPhotoGallery === true) ? 'pointer' : 'default' }\" [style.minHeight.px]=\"itemSize + 2\" [style.minWidth.px]=\"itemSize\">\r\n\t\t<img *ngIf=\"file.thumbnailBase64Image\" [src]=\"file.thumbnailBase64Image\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<img *ngIf=\"!file.thumbnailBase64Image && file.base64Image\" [src]=\"file.base64Image\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<img *ngIf=\"!file.thumbnailBase64Image && !file.base64Image && file.thumbnailUrl\" [src]=\"file.thumbnailUrl\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<img *ngIf=\"!file.thumbnailBase64Image && !file.base64Image && !file.thumbnailUrl && file.url\" [src]=\"file.url\" [style.maxWidth.px]=\"itemImgSize\" [style.maxHeight.px]=\"itemImgSize\" />\r\n\t\t<i *ngIf=\"allowDelete\" class=\"fas fa-times-circle bg-white text-danger\" (click)=\"deleteFile($event)\"></i>\r\n\t</div>\r\n\t<div class=\"slick-file-list-item_title\" *ngIf=\"fileDateFormatted\" [style.minWidth.px]=\"itemSize\" [style.maxWidth.px]=\"itemSize\">\r\n\t\t<div class=\"slick-file-list-item_date\" *ngIf=\"fileDateFormatted\" [style.minWidth.px]=\"itemSize\">{{fileDateFormatted}}</div>\r\n\t</div>\r\n\t<div class=\"slick-file-list-item_title\" [style.minWidth.px]=\"itemSize\" [style.maxWidth.px]=\"itemSize\">\r\n\t\t<div class=\"slick-file-list-item_display-title\" #titleDivRef style=\"cursor: pointer\" *ngIf=\"!isEditing\" (click)=\"editTitle()\">{{file.title}}</div>\r\n\t\t<div #editTitleDivRef class=\"slick-file-list-item_edit-title\" *ngIf=\"isEditing\"><input #editTitleInputRef type=\"text\" class=\"form-control\" [(ngModel)]=\"tempTitle\" (keydown)=\"onKeyDown($event)\" [style.width.px]=\"itemSize\" /></div>\r\n\t</div>\r\n\r\n\t<!-- We want the user to be able to click just a little outside of the checkbox and still have it check -->\r\n\t<div *ngIf=\"showCheckbox === true\" class=\"slick-file-checkbox\" (click)=\"onCheckboxClicked($event)\">\r\n\t\t<input type=\"checkbox\" [ngModel]=\"file.isChecked\" />\r\n\t</div>\r\n</div>\r\n\r\n<slick-confirm-dialog #deleteConfirmRef>\r\n\t<h4 class=\"p-0 m-0 text-danger\">Are you sure you want to delete?</h4>\r\n</slick-confirm-dialog>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { file: [{
                type: Input,
                args: ["file"]
            }], allowDelete: [{
                type: Input,
                args: ["allowDelete"]
            }], showPhotoGallery: [{
                type: Input,
                args: ["showPhotoGallery"]
            }], showCheckbox: [{
                type: Input,
                args: ["showCheckbox"]
            }], thumbnailSize: [{
                type: Input,
                args: ["thumbnailSize"]
            }], confirmDelete: [{
                type: Input,
                args: ["confirmDelete"]
            }], fileChangeEmitter: [{
                type: Output,
                args: ["fileChange"]
            }], fileDeleteEmitter: [{
                type: Output,
                args: ["fileDelete"]
            }], fileClicked: [{
                type: Output,
                args: ["fileClicked"]
            }], checkChanged: [{
                type: Output,
                args: ["checkChanged"]
            }], titleDivRef: [{
                type: ViewChild,
                args: ["titleDivRef"]
            }], editTitleDivRef: [{
                type: ViewChild,
                args: ["editTitleDivRef"]
            }], editTitleInputRef: [{
                type: ViewChild,
                args: ["editTitleInputRef"]
            }], deleteConfirmRef: [{
                type: ViewChild,
                args: ["deleteConfirmRef"]
            }] } });

class SlickFileListComponent {
    constructor() {
        this.allowDelete = true;
        this.showPhotoGallery = false;
        this.showCheckboxes = false;
        this.thumbnailSize = 90;
        this.confirmDelete = true;
        this.filesEmitter = new EventEmitter();
        this.onFileDeleteEmitter = new EventEmitter();
        this.onFileCheckChanged = new EventEmitter();
        this.onFileClicked = new EventEmitter();
        this.photos = [];
        this.lastCheckedIdx = null;
        this.uuid = SlickUtilsService.newGuid();
    }
    ngOnChanges(changes) {
        if (changes.thumbnailSize)
            this.thumbnailSize = parseInt(this.thumbnailSize.toString());
        if (changes.allowDelete && changes.allowDelete.currentValue)
            this.allowDelete = (changes.allowDelete.currentValue.toString().toLowerCase() !== 'false');
        if (changes.showPhotoGallery && changes.showPhotoGallery.currentValue)
            this.showPhotoGallery = (changes.showPhotoGallery.currentValue.toString().toLowerCase() !== 'false');
        if (changes.showCheckboxes && changes.showCheckboxes.currentValue)
            this.showCheckboxes = (changes.showCheckboxes.currentValue.toString().toLowerCase() !== 'false');
        if (changes.deleteConfirmation && changes.deleteConfirmation.currentValue)
            this.confirmDelete = (this.confirmDelete.toString() === 'true') ? true : false;
    }
    fileClicked(file, idx) {
        if (this.showPhotoGallery === true) {
            this.photoGalleryRef.showPhotoGallery(idx);
        }
        if (this.onFileClicked)
            this.onFileClicked.emit(file);
    }
    onFileChange(file, idx) {
        this.files[idx] = file;
        this.filesEmitter.emit(this.files);
    }
    async onFileDelete(file, idx) {
        this.files.splice(idx, 1);
        this.filesEmitter.emit(this.files);
        if (this.onFileDeleteEmitter)
            this.onFileDeleteEmitter.emit(file);
    }
    async onCheckChanged(e, fileIdx) {
        await SlickSleepService.sleep();
        if (e.shiftKey === true && this.lastCheckedIdx !== null) {
            let startIdx = (this.lastCheckedIdx < fileIdx) ? this.lastCheckedIdx : fileIdx;
            let endIdx = (this.lastCheckedIdx < fileIdx) ? fileIdx : this.lastCheckedIdx;
            for (let i = startIdx; i <= endIdx; i++) {
                this.files[i].isChecked = true;
                if (this.onFileCheckChanged)
                    this.onFileCheckChanged.emit(this.files[i]);
            }
        }
        else {
            this.lastCheckedIdx = fileIdx;
            if (this.onFileCheckChanged)
                this.onFileCheckChanged.emit(this.files[fileIdx]);
        }
    }
    checkAllFiles() {
        this.files.forEach(x => {
            if (x.isChecked === false && this.onFileCheckChanged) {
                x.isChecked = true;
                this.onFileCheckChanged.emit(x);
            }
            x.isChecked = true;
        });
    }
    uncheckAllFiles() {
        this.files.forEach(x => {
            if (x.isChecked === true && this.onFileCheckChanged) {
                x.isChecked = false;
                this.onFileCheckChanged.emit(x);
            }
            x.isChecked = false;
        });
    }
    getCheckedFiles() {
        return this.files.filter(x => x.isChecked === true);
    }
}
/** @nocollapse */ SlickFileListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickFileListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickFileListComponent, selector: "slick-file-list", inputs: { files: "files", allowDelete: "allowDelete", showPhotoGallery: "showPhotoGallery", showCheckboxes: "showCheckboxes", thumbnailSize: "thumbnailSize", confirmDelete: "confirmDelete" }, outputs: { filesEmitter: "filesEmitter", onFileDeleteEmitter: "onFileDelete", onFileCheckChanged: "onFileCheckChanged", onFileClicked: "onFileClicked" }, viewQueries: [{ propertyName: "photoGalleryRef", first: true, predicate: ["photoGalleryRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerRef id=\"slick-file-list_{{uuid}}\" class=\"slick-file-list\">\r\n\t<slick-file-list-item *ngFor=\"let file of files; let idx = index\" \r\n\t\t\t\t\t\t  [file]=\"file\" \r\n\t\t\t\t\t\t  [allowDelete]=\"allowDelete\" \r\n\t\t\t\t\t\t  [showPhotoGallery]=\"showPhotoGallery\" \r\n\t\t\t\t\t\t  [showCheckbox]=\"showCheckboxes\" \r\n\t\t\t\t\t\t  [thumbnailSize]=\"thumbnailSize\" \r\n\t\t\t\t\t\t  [confirmDelete]=\"confirmDelete\"\r\n\t\t\t\t\t\t  (checkChanged)=\"onCheckChanged($event, idx)\" \r\n\t\t\t\t\t\t  (fileClicked)=\"fileClicked($event, idx)\" \r\n\t\t\t\t\t\t  (fileChanged)=\"onFileChange($event, idx)\" \r\n\t\t\t\t\t\t  (fileDelete)=\"onFileDelete($event, idx)\"></slick-file-list-item>\r\n</div>\r\n\r\n<slick-photo-gallery #photoGalleryRef *ngIf=\"showPhotoGallery === true\" [files]=\"files\"></slick-photo-gallery>\r\n\r\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlickPhotoGalleryComponent, selector: "slick-photo-gallery", inputs: ["photos", "files"] }, { kind: "component", type: SlickFileListItemComponent, selector: "slick-file-list-item", inputs: ["file", "allowDelete", "showPhotoGallery", "showCheckbox", "thumbnailSize", "confirmDelete"], outputs: ["fileChange", "fileDelete", "fileClicked", "checkChanged"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-file-list', template: "<div #containerRef id=\"slick-file-list_{{uuid}}\" class=\"slick-file-list\">\r\n\t<slick-file-list-item *ngFor=\"let file of files; let idx = index\" \r\n\t\t\t\t\t\t  [file]=\"file\" \r\n\t\t\t\t\t\t  [allowDelete]=\"allowDelete\" \r\n\t\t\t\t\t\t  [showPhotoGallery]=\"showPhotoGallery\" \r\n\t\t\t\t\t\t  [showCheckbox]=\"showCheckboxes\" \r\n\t\t\t\t\t\t  [thumbnailSize]=\"thumbnailSize\" \r\n\t\t\t\t\t\t  [confirmDelete]=\"confirmDelete\"\r\n\t\t\t\t\t\t  (checkChanged)=\"onCheckChanged($event, idx)\" \r\n\t\t\t\t\t\t  (fileClicked)=\"fileClicked($event, idx)\" \r\n\t\t\t\t\t\t  (fileChanged)=\"onFileChange($event, idx)\" \r\n\t\t\t\t\t\t  (fileDelete)=\"onFileDelete($event, idx)\"></slick-file-list-item>\r\n</div>\r\n\r\n<slick-photo-gallery #photoGalleryRef *ngIf=\"showPhotoGallery === true\" [files]=\"files\"></slick-photo-gallery>\r\n\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { files: [{
                type: Input,
                args: ["files"]
            }], allowDelete: [{
                type: Input,
                args: ["allowDelete"]
            }], showPhotoGallery: [{
                type: Input,
                args: ["showPhotoGallery"]
            }], showCheckboxes: [{
                type: Input,
                args: ["showCheckboxes"]
            }], thumbnailSize: [{
                type: Input,
                args: ["thumbnailSize"]
            }], confirmDelete: [{
                type: Input,
                args: ["confirmDelete"]
            }], filesEmitter: [{
                type: Output,
                args: ["filesEmitter"]
            }], onFileDeleteEmitter: [{
                type: Output,
                args: ["onFileDelete"]
            }], onFileCheckChanged: [{
                type: Output,
                args: ["onFileCheckChanged"]
            }], onFileClicked: [{
                type: Output,
                args: ["onFileClicked"]
            }], photoGalleryRef: [{
                type: ViewChild,
                args: ["photoGalleryRef"]
            }] } });

class SlickPhotoGalleryModule {
}
/** @nocollapse */ SlickPhotoGalleryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPhotoGalleryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickPhotoGalleryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickPhotoGalleryModule, declarations: [SlickPhotoGalleryComponent], imports: [CommonModule], exports: [SlickPhotoGalleryComponent] });
/** @nocollapse */ SlickPhotoGalleryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPhotoGalleryModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPhotoGalleryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [SlickPhotoGalleryComponent],
                    declarations: [SlickPhotoGalleryComponent]
                }]
        }] });

class SlickFileListModule {
}
/** @nocollapse */ SlickFileListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickFileListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListModule, declarations: [SlickFileListComponent, SlickFileListItemComponent], imports: [CommonModule, FormsModule, SlickConfirmDialogModule, SlickPhotoGalleryModule], exports: [CommonModule, FormsModule, SlickFileListComponent] });
/** @nocollapse */ SlickFileListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListModule, imports: [CommonModule, FormsModule, SlickConfirmDialogModule, SlickPhotoGalleryModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickFileListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SlickConfirmDialogModule, SlickPhotoGalleryModule],
                    declarations: [SlickFileListComponent, SlickFileListItemComponent],
                    exports: [CommonModule, FormsModule, SlickFileListComponent]
                }]
        }] });

class SlickEmailerAddressModel {
}

class SlickEmailerComponent {
    constructor(slickFunctionLockService, changeDetector) {
        this.slickFunctionLockService = slickFunctionLockService;
        this.changeDetector = changeDetector;
        this.showButtons = true;
        this.bodyHeight = "180px";
        this.toAddressSearchEmitter = new EventEmitter();
        this.sendEmailClickEmitter = new EventEmitter();
        this.cancelEmailClickEmitter = new EventEmitter();
        this.isSubmitted = false;
        this.tinyMCEInitialized = false;
        this.spinnerStatus = null;
        this.propagateChange = (_) => { };
        this.uuid = SlickUtilsService.newGuid();
    }
    async ngAfterViewInit() {
        await this.initTinyMCE();
        const body = (this.emailerModel) ? (this.emailerModel.body || '') : '';
        tinymce.get(`emailer_tinymce_${this.tinyMCEUuid}`).setContent(body);
    }
    ngOnDestroy() {
        this.removeTinyMCE();
    }
    // this is the initial value set to the component
    async writeValue(obj) {
        if (obj) {
            this.spinnerStatus = "reset";
            this.emailerModel = obj;
            if (!this.emailerModel.attachments)
                this.emailerModel.attachments = [];
            if (!this.emailerModel.toEmailAddresses)
                this.emailerModel.toEmailAddresses = [];
        }
        else {
            this.emailerModel = null;
        }
        await this.initTinyMCE();
        const body = (this.emailerModel) ? (this.emailerModel.body || '') : '';
        tinymce.get(`emailer_tinymce_${this.tinyMCEUuid}`).setContent(body);
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    toAddressSearch(searchText) {
        this.toAddressSearchEmitter.emit(searchText);
    }
    onSelectEmailAddress(emailerAddressModel) {
        this.emailerModel.toEmailAddresses.push(emailerAddressModel);
        this.toEmailAddress = null;
    }
    onFreeformTextSelect(text) {
        const freeformEmailAddress = new SlickEmailerAddressModel();
        freeformEmailAddress.displayName = text;
        freeformEmailAddress.emailAddress = text;
        this.emailerModel.toEmailAddresses.push(freeformEmailAddress);
        this.toEmailAddress = null;
    }
    deleteEmailAddress(idx) {
        this.emailerModel.toEmailAddresses.splice(idx, 1);
    }
    onAttachmentsChanged(attachments) {
        this.emailerModel.attachments = this.emailerModel.attachments.concat(attachments);
    }
    validate() {
        this.isSubmitted = true;
        if (this.emailerModel.toEmailAddresses.length === 0)
            return false;
        return true;
    }
    getEmailAddresses(emailerModel) {
        let slickEmailerAddresses = emailerModel.toEmailAddresses || [];
        if (this.toEmailAddress) {
            const scrubbedToEmailAddress = this.toEmailAddress.replace(",", ";").replace(/\s/g, ";");
            const emailAddressesToAddStrings = scrubbedToEmailAddress.split(";").filter(x => x !== '');
            const emailAddressesToAdd = emailAddressesToAddStrings.map(x => {
                const slickEmailerAddressModel = new SlickEmailerAddressModel();
                slickEmailerAddressModel.contactId = 0;
                slickEmailerAddressModel.displayName = x;
                slickEmailerAddressModel.emailAddress = x;
                return slickEmailerAddressModel;
            });
            slickEmailerAddresses = slickEmailerAddresses.concat(emailAddressesToAdd);
        }
        this.toEmailAddress = null;
        return slickEmailerAddresses;
    }
    async setBody(body) {
        try {
            await this.slickFunctionLockService.lock("SLICK_EMAILER_SET_BODY");
            await this.initTinyMCE();
            const tinyMCE = tinymce.get(`emailer_tinymce_${this.tinyMCEUuid}`);
            if (!tinyMCE)
                console.error("tinyMCE not initialized");
            tinyMCE.setContent(body);
        }
        finally {
            this.slickFunctionLockService.release("SLICK_EMAILER_SET_BODY");
        }
    }
    getBody() {
        return tinymce.get(`emailer_tinymce_${this.tinyMCEUuid}`).getContent();
    }
    onSendEmail() {
        this.emailerModel.toEmailAddresses = this.getEmailAddresses(this.emailerModel);
        if (this.validate() === false)
            return;
        this.emailerModel.body = this.getBody();
        this.spinnerStatus = "spin";
        if (this.sendEmailClickEmitter)
            this.sendEmailClickEmitter.emit(this.emailerModel);
    }
    emailSent() {
        this.spinnerStatus = "ok";
    }
    emailError() {
        this.spinnerStatus = "error";
    }
    onCancelEmail() {
        if (this.cancelEmailClickEmitter)
            this.cancelEmailClickEmitter.emit();
    }
    async dialogInit() {
        this.removeTinyMCE();
        await this.initTinyMCE();
        const body = (this.emailerModel) ? (this.emailerModel.body || '') : '';
        tinymce.get(`emailer_tinymce_${this.tinyMCEUuid}`).setContent(body);
    }
    async initTinyMCE() {
        return new Promise(async (resolve) => {
            await this.slickFunctionLockService.lock("SLICK_EMAILER_INIT_TINY_MCE");
            if (this.tinyMCEUuid) {
                this.slickFunctionLockService.release("SLICK_EMAILER_INIT_TINY_MCE");
                resolve();
            }
            else {
                this.tinyMCEUuid = SlickUtilsService.newGuid();
                const tinyMCEContainer = this.tinyMCEContainerRef.nativeElement;
                const tinyMCETextarea = document.createElement("textarea");
                tinyMCETextarea.id = `emailer_tinymce_${this.tinyMCEUuid}`;
                tinyMCETextarea.style.minHeight = "300px";
                tinyMCETextarea.style.maxHeight = "300px";
                tinyMCEContainer.appendChild(tinyMCETextarea);
                tinymce.init({
                    selector: `#emailer_tinymce_${this.tinyMCEUuid}`,
                    branding: false,
                    menubar: 'edit insert format tools',
                    plugins: 'link image imagetools code',
                    toolbar: 'fontselect | fontsizeselect | styleselect | bold italic underline | indent outdent | bullist | alignleft aligncenter alignright | code | image',
                    fontsize_formats: "8px 10px 12px 14px 18px 24px 36px",
                    height: this.bodyHeight,
                    convert_urls: false,
                    setup: (ed) => {
                        ed.on('init', (args) => {
                            ed.setContent((this.emailerModel) ? (this.emailerModel.body || '') : '');
                            this.tinyMCEInitialized = true;
                            this.slickFunctionLockService.release("SLICK_EMAILER_INIT_TINY_MCE");
                            resolve();
                        });
                    }
                });
            }
        });
    }
    async removeTinyMCE() {
        if (this.tinyMCEUuid) {
            const tinyMCE = tinymce.get(`emailer_tinymce_${this.tinyMCEUuid}`);
            if (tinyMCE)
                tinyMCE.remove();
            const tinyMCEContainer = this.tinyMCEContainerRef.nativeElement;
            tinyMCEContainer.innerHTML = "";
            this.tinyMCEInitialized = false;
            this.tinyMCEUuid = null;
        }
    }
}
/** @nocollapse */ SlickEmailerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerComponent, deps: [{ token: SlickFunctionLockService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickEmailerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickEmailerComponent, selector: "slick-emailer", inputs: { toEmailAddressList: "toEmailAddressList", showButtons: "showButtons", bodyHeight: "bodyHeight" }, outputs: { toAddressSearchEmitter: "toAddressSearch", sendEmailClickEmitter: "sendEmailClick", cancelEmailClickEmitter: "cancelEmailClick" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickEmailerComponent)),
            multi: true,
        },
        SlickFunctionLockService
    ], viewQueries: [{ propertyName: "tinyMCEContainerRef", first: true, predicate: ["tinyMCEContainerRef"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"emailerModel\" id=\"slick-emailer_{{uuid}}\" class=\"slick-emailer\">\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<div *ngIf=\"isSubmitted === true && emailerModel.toEmailAddresses.length === 0\" class=\"errorWrapper showIcons\"><div class=\"text-danger\">Email must have at least one email address</div></div>\r\n\t\t\t<div class=\"input-group\">\r\n\t\t\t\t<div class=\"input-group-prepend\">\r\n\t\t\t\t\t<span class=\"input-group-text\"><span class=\"fas fa-search\"></span></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<input class=\"form-control\" #emailAddressAutocomplete [(ngModel)]=\"toEmailAddress\" placeholder=\"Email Search...\" autofocus />\r\n\t\t\t</div>\r\n\t\t\t<slick-auto-complete [inputRef]=\"emailAddressAutocomplete\" textField=\"emailDisplay\" [items]=\"toEmailAddressList\" (onRefresh)=\"toAddressSearch($event)\" (onSelect)=\"onSelectEmailAddress($event)\" (onFreeformTextSelect)=\"onFreeformTextSelect($event)\">\r\n\t\t\t\t<ng-template let-emailDisplay [slickAutoCompleteListItemTemplate]>\r\n\t\t\t\t\t<div style='line-height: 1.1em; font-size: 12px;'>\r\n\t\t\t\t\t\t{{emailDisplay.displayName}} [{{emailDisplay.emailAddress}}]\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</ng-template>\r\n\t\t\t</slick-auto-complete>\r\n\r\n\t\t\t<label>To:&nbsp;</label>\r\n\t\t\t<div *ngFor=\"let emailAddress of emailerModel.toEmailAddresses; let idx = index;\" class=\"slick-emailer_email-address alert alert-secondary\">{{emailAddress.displayName}} [{{emailAddress.emailAddress}}]<i (click)=\"deleteEmailAddress(idx)\" class=\"fas fa-times-circle bg-white text-danger ml-1\"></i></div>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Subject:</label>\r\n\t\t\t<input type=\"text\" class=\"form-control\" [(ngModel)]=\"emailerModel.subject\" />\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Body:</label>\r\n\t\t\t<div #tinyMCEContainerRef></div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Attachments:</label>\r\n\t\t\t<slick-file-drop (filesChanged)=\"onAttachmentsChanged($event)\"></slick-file-drop>\r\n\t\t\t<slick-file-list [(files)]=\"emailerModel.attachments\"></slick-file-list>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div *ngIf=\"showButtons\" class=\"row form-group\">\r\n\t\t<div class=\"col-12 text-center\">\r\n\t\t\t<button type=\"button\" style=\"width: 120px; margin-right: 10px;\" [slick-button-spinner]=\"spinnerStatus\" class=\"btn btn-outline-primary\" (click)=\"onSendEmail()\"><i class=\"far fa-envelope\"></i>&nbsp;Send</button>\r\n\t\t\t<button type=\"button\" style=\"width: 120px;\" class=\"btn btn-outline-danger\" (click)=\"onCancelEmail()\"><i class=\"far fa-times\"></i>&nbsp;Cancel</button>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickAutoCompleteComponent, selector: "slick-auto-complete", inputs: ["inputRef", "items", "delay", "selectFirst", "displayTextFieldName", "listHeight", "listWidth", "allowFreeformText", "showNoItemsFoundDisplay"], outputs: ["onRefresh", "onSelect", "onFreeformTextSelect"] }, { kind: "directive", type: SlickAutoCompleteListItemTemplateDirective, selector: "[slickAutoCompleteListItemTemplate]", inputs: ["type", "slickAutoCompleteListItemTemplate"] }, { kind: "component", type: SlickButtonSpinnerComponent, selector: "[slick-button-spinner]", inputs: ["slick-button-spinner"] }, { kind: "component", type: SlickFileDropComponent, selector: "slick-file-drop", inputs: ["displayText"], outputs: ["filesChanged"] }, { kind: "component", type: SlickFileListComponent, selector: "slick-file-list", inputs: ["files", "allowDelete", "showPhotoGallery", "showCheckboxes", "thumbnailSize", "confirmDelete"], outputs: ["filesEmitter", "onFileDelete", "onFileCheckChanged", "onFileClicked"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-emailer', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickEmailerComponent)),
                            multi: true,
                        },
                        SlickFunctionLockService
                    ], template: "<div *ngIf=\"emailerModel\" id=\"slick-emailer_{{uuid}}\" class=\"slick-emailer\">\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<div *ngIf=\"isSubmitted === true && emailerModel.toEmailAddresses.length === 0\" class=\"errorWrapper showIcons\"><div class=\"text-danger\">Email must have at least one email address</div></div>\r\n\t\t\t<div class=\"input-group\">\r\n\t\t\t\t<div class=\"input-group-prepend\">\r\n\t\t\t\t\t<span class=\"input-group-text\"><span class=\"fas fa-search\"></span></span>\r\n\t\t\t\t</div>\r\n\t\t\t\t<input class=\"form-control\" #emailAddressAutocomplete [(ngModel)]=\"toEmailAddress\" placeholder=\"Email Search...\" autofocus />\r\n\t\t\t</div>\r\n\t\t\t<slick-auto-complete [inputRef]=\"emailAddressAutocomplete\" textField=\"emailDisplay\" [items]=\"toEmailAddressList\" (onRefresh)=\"toAddressSearch($event)\" (onSelect)=\"onSelectEmailAddress($event)\" (onFreeformTextSelect)=\"onFreeformTextSelect($event)\">\r\n\t\t\t\t<ng-template let-emailDisplay [slickAutoCompleteListItemTemplate]>\r\n\t\t\t\t\t<div style='line-height: 1.1em; font-size: 12px;'>\r\n\t\t\t\t\t\t{{emailDisplay.displayName}} [{{emailDisplay.emailAddress}}]\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</ng-template>\r\n\t\t\t</slick-auto-complete>\r\n\r\n\t\t\t<label>To:&nbsp;</label>\r\n\t\t\t<div *ngFor=\"let emailAddress of emailerModel.toEmailAddresses; let idx = index;\" class=\"slick-emailer_email-address alert alert-secondary\">{{emailAddress.displayName}} [{{emailAddress.emailAddress}}]<i (click)=\"deleteEmailAddress(idx)\" class=\"fas fa-times-circle bg-white text-danger ml-1\"></i></div>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Subject:</label>\r\n\t\t\t<input type=\"text\" class=\"form-control\" [(ngModel)]=\"emailerModel.subject\" />\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Body:</label>\r\n\t\t\t<div #tinyMCEContainerRef></div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Attachments:</label>\r\n\t\t\t<slick-file-drop (filesChanged)=\"onAttachmentsChanged($event)\"></slick-file-drop>\r\n\t\t\t<slick-file-list [(files)]=\"emailerModel.attachments\"></slick-file-list>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div *ngIf=\"showButtons\" class=\"row form-group\">\r\n\t\t<div class=\"col-12 text-center\">\r\n\t\t\t<button type=\"button\" style=\"width: 120px; margin-right: 10px;\" [slick-button-spinner]=\"spinnerStatus\" class=\"btn btn-outline-primary\" (click)=\"onSendEmail()\"><i class=\"far fa-envelope\"></i>&nbsp;Send</button>\r\n\t\t\t<button type=\"button\" style=\"width: 120px;\" class=\"btn btn-outline-danger\" (click)=\"onCancelEmail()\"><i class=\"far fa-times\"></i>&nbsp;Cancel</button>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: SlickFunctionLockService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { toEmailAddressList: [{
                type: Input,
                args: ["toEmailAddressList"]
            }], showButtons: [{
                type: Input,
                args: ["showButtons"]
            }], bodyHeight: [{
                type: Input,
                args: ["bodyHeight"]
            }], toAddressSearchEmitter: [{
                type: Output,
                args: ["toAddressSearch"]
            }], sendEmailClickEmitter: [{
                type: Output,
                args: ["sendEmailClick"]
            }], cancelEmailClickEmitter: [{
                type: Output,
                args: ["cancelEmailClick"]
            }], tinyMCEContainerRef: [{
                type: ViewChild,
                args: ["tinyMCEContainerRef"]
            }] } });

class SlickEmailerDialogComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.bodyHeight = "180px";
        this.toAddressSearchEmitter = new EventEmitter();
        this.sendEmailClickEmitter = new EventEmitter();
        this.cancelEmailClickEmitter = new EventEmitter();
        this.spinnerStatus = null;
        this.isVisible = false;
        this.propagateChange = (_) => { };
    }
    // this is the initial value set to the component
    writeValue(obj) {
        this.emailerModel = obj;
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    async showDialog() {
        this.isVisible = true;
        await SlickSleepService.sleep();
        this.dialogEmailerModel = this.emailerModel;
        this.emailerRef.isSubmitted = false;
        this.spinnerStatus = "reset";
        this.emailerRef.dialogInit();
        this.emailerDialogRef.showDialog();
    }
    toAddressSearch(searchText) {
        this.toAddressSearchEmitter.emit(searchText);
    }
    onSendEmail() {
        this.dialogEmailerModel.toEmailAddresses = this.emailerRef.getEmailAddresses(this.dialogEmailerModel);
        if (this.emailerRef.validate() === false)
            return;
        this.dialogEmailerModel.body = this.emailerRef.getBody();
        this.spinnerStatus = "spin";
        if (this.sendEmailClickEmitter)
            this.sendEmailClickEmitter.emit(this.dialogEmailerModel);
    }
    async emailSent() {
        try {
            this.spinnerStatus = "ok";
            this.emailerRef.emailSent();
            this.emailerDialogRef.hideDialog();
            await SlickSleepService.sleep(500);
            this.emailerRef.removeTinyMCE();
        }
        catch (error) {
            console.error(error);
            this.spinnerStatus = "error";
        }
    }
    emailError() {
        this.spinnerStatus = "error";
    }
    async onCancelEmail() {
        this.spinnerStatus = "reset";
        this.emailerRef.removeTinyMCE();
        this.emailerDialogRef.hideDialog();
        if (this.cancelEmailClickEmitter)
            this.cancelEmailClickEmitter.emit();
    }
}
/** @nocollapse */ SlickEmailerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerDialogComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickEmailerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickEmailerDialogComponent, selector: "slick-emailer-dialog", inputs: { toEmailAddressList: "toEmailAddressList", bodyHeight: "bodyHeight" }, outputs: { toAddressSearchEmitter: "toAddressSearch", sendEmailClickEmitter: "sendEmailClick", cancelEmailClickEmitter: "cancelEmailClick" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickEmailerDialogComponent)),
            multi: true,
        }
    ], viewQueries: [{ propertyName: "emailerDialogRef", first: true, predicate: ["emailerDialogRef"], descendants: true }, { propertyName: "emailerRef", first: true, predicate: ["emailerRef"], descendants: true }], ngImport: i0, template: `<slick-dialog *ngIf='isVisible' header='Send Email' [width]='800' (onClose)='onCancelEmail()' #emailerDialogRef>
		<slick-emailer #emailerRef [(ngModel)]='dialogEmailerModel'
					[bodyHeight]='bodyHeight'
					[showButtons]='false'
					[toEmailAddressList]='toEmailAddressList' 
			        (toAddressSearch)='toAddressSearch($event)'>
		</slick-emailer>

		<slick-dialog-footer>
			<div class="row">
				<div class="col-12 text-center mb-2 mt-1">
					<button type="button" style="width: 120px; margin-right: 10px;" [slick-button-spinner]="spinnerStatus" class="btn btn-outline-primary" (click)="onSendEmail()"><i class="far fa-envelope"></i>&nbsp;Send</button>
					<button type="button" style="width: 120px;" class="btn btn-outline-danger" (click)="onCancelEmail()"><i class="far fa-times"></i>&nbsp;Cancel</button>
				</div>
			</div>
		</slick-dialog-footer>
	</slick-dialog>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickDialogComponent, selector: "slick-dialog", inputs: ["draggable", "resizable", "minimizable", "header", "showHeader", "noPadding", "top", "width", "height", "maxHeight", "cssClass", "key", "showOverlay", "disableScrollbar"], outputs: ["onClose"] }, { kind: "component", type: SlickDialogFooterComponent, selector: "slick-dialog-footer" }, { kind: "component", type: SlickButtonSpinnerComponent, selector: "[slick-button-spinner]", inputs: ["slick-button-spinner"] }, { kind: "component", type: SlickEmailerComponent, selector: "slick-emailer", inputs: ["toEmailAddressList", "showButtons", "bodyHeight"], outputs: ["toAddressSearch", "sendEmailClick", "cancelEmailClick"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-emailer-dialog',
                    template: `<slick-dialog *ngIf='isVisible' header='Send Email' [width]='800' (onClose)='onCancelEmail()' #emailerDialogRef>
		<slick-emailer #emailerRef [(ngModel)]='dialogEmailerModel'
					[bodyHeight]='bodyHeight'
					[showButtons]='false'
					[toEmailAddressList]='toEmailAddressList' 
			        (toAddressSearch)='toAddressSearch($event)'>
		</slick-emailer>

		<slick-dialog-footer>
			<div class="row">
				<div class="col-12 text-center mb-2 mt-1">
					<button type="button" style="width: 120px; margin-right: 10px;" [slick-button-spinner]="spinnerStatus" class="btn btn-outline-primary" (click)="onSendEmail()"><i class="far fa-envelope"></i>&nbsp;Send</button>
					<button type="button" style="width: 120px;" class="btn btn-outline-danger" (click)="onCancelEmail()"><i class="far fa-times"></i>&nbsp;Cancel</button>
				</div>
			</div>
		</slick-dialog-footer>
	</slick-dialog>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickEmailerDialogComponent)),
                            multi: true,
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { toEmailAddressList: [{
                type: Input,
                args: ["toEmailAddressList"]
            }], bodyHeight: [{
                type: Input,
                args: ["bodyHeight"]
            }], toAddressSearchEmitter: [{
                type: Output,
                args: ["toAddressSearch"]
            }], sendEmailClickEmitter: [{
                type: Output,
                args: ["sendEmailClick"]
            }], cancelEmailClickEmitter: [{
                type: Output,
                args: ["cancelEmailClick"]
            }], emailerDialogRef: [{
                type: ViewChild,
                args: ["emailerDialogRef"]
            }], emailerRef: [{
                type: ViewChild,
                args: ["emailerRef"]
            }] } });

class SlickEmailerModel {
}

class SlickEmailerModule {
}
/** @nocollapse */ SlickEmailerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickEmailerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerModule, declarations: [SlickEmailerComponent, SlickEmailerDialogComponent], imports: [CommonModule, FormsModule, SlickDialogModule, SlickAutoCompleteModule, SlickButtonSpinnerModule, SlickFileDropModule, SlickFileListModule], exports: [CommonModule, FormsModule, SlickEmailerComponent, SlickEmailerDialogComponent] });
/** @nocollapse */ SlickEmailerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerModule, imports: [CommonModule, FormsModule, SlickDialogModule, SlickAutoCompleteModule, SlickButtonSpinnerModule, SlickFileDropModule, SlickFileListModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SlickDialogModule, SlickAutoCompleteModule, SlickButtonSpinnerModule, SlickFileDropModule, SlickFileListModule],
                    declarations: [SlickEmailerComponent, SlickEmailerDialogComponent],
                    exports: [CommonModule, FormsModule, SlickEmailerComponent, SlickEmailerDialogComponent]
                }]
        }] });

class SlickEmailViewerComponent {
    constructor() {
        this.propagateChange = (_) => { };
        this.uuid = SlickUtilsService.newGuid();
    }
    // this is the initial value set to the component
    async writeValue(obj) {
        this.emailerModel = obj;
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
}
/** @nocollapse */ SlickEmailViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickEmailViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickEmailViewerComponent, selector: "slick-email-viewer", providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickEmailViewerComponent)),
            multi: true,
        }
    ], ngImport: i0, template: "<div *ngIf=\"emailerModel\" id=\"slick-email-viewer_{{uuid}}\" class=\"slick-email-viewer\">\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>To:&nbsp;</label><br />\r\n\t\t\t<div *ngFor=\"let emailAddress of emailerModel.toEmailAddresses; let idx = index;\" class=\"slick-email-viewer_email-address card\">{{emailAddress.displayName}} [{{emailAddress.emailAddress}}]</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Subject:</label><br />\r\n\t\t\t<div class=\"slick-email-viewer_subject card\">{{emailerModel.subject}}</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Body:</label><br />\r\n\t\t\t<div class=\"slick-email-viewer_body card\" [innerHTML]=\"emailerModel.body\"></div>\r\n\t\t\t\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div *ngIf=\"emailerModel.attachments && emailerModel.attachments.length > 0\" class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Attachments:</label>\r\n\t\t\t<slick-file-list [(files)]=\"emailerModel.attachments\" [allowDelete]=\"false\"></slick-file-list>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlickFileListComponent, selector: "slick-file-list", inputs: ["files", "allowDelete", "showPhotoGallery", "showCheckboxes", "thumbnailSize", "confirmDelete"], outputs: ["filesEmitter", "onFileDelete", "onFileCheckChanged", "onFileClicked"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-email-viewer', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickEmailViewerComponent)),
                            multi: true,
                        }
                    ], template: "<div *ngIf=\"emailerModel\" id=\"slick-email-viewer_{{uuid}}\" class=\"slick-email-viewer\">\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>To:&nbsp;</label><br />\r\n\t\t\t<div *ngFor=\"let emailAddress of emailerModel.toEmailAddresses; let idx = index;\" class=\"slick-email-viewer_email-address card\">{{emailAddress.displayName}} [{{emailAddress.emailAddress}}]</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Subject:</label><br />\r\n\t\t\t<div class=\"slick-email-viewer_subject card\">{{emailerModel.subject}}</div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Body:</label><br />\r\n\t\t\t<div class=\"slick-email-viewer_body card\" [innerHTML]=\"emailerModel.body\"></div>\r\n\t\t\t\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div *ngIf=\"emailerModel.attachments && emailerModel.attachments.length > 0\" class=\"row form-group\">\r\n\t\t<div class=\"col-12\">\r\n\t\t\t<label>Attachments:</label>\r\n\t\t\t<slick-file-list [(files)]=\"emailerModel.attachments\" [allowDelete]=\"false\"></slick-file-list>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return []; } });

class SlickEmailViewerDialogComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this.isVisible = false;
        this.propagateChange = (_) => { };
    }
    // this is the initial value set to the component
    writeValue(obj) {
        this.emailerModel = obj;
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    showDialog() {
        this.isVisible = true;
        this.changeDetector.detectChanges();
        this.emailViewerDialogRef.showDialog();
    }
    onOk() {
        this.isVisible = false;
        this.emailViewerDialogRef.hideDialog();
    }
}
/** @nocollapse */ SlickEmailViewerDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerDialogComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickEmailViewerDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickEmailViewerDialogComponent, selector: "slick-email-viewer-dialog", providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickEmailViewerDialogComponent)),
            multi: true,
        }
    ], viewQueries: [{ propertyName: "emailViewerDialogRef", first: true, predicate: ["emailViewerDialogRef"], descendants: true }], ngImport: i0, template: `<slick-dialog *ngIf='isVisible' header='View Email' [width]='800' #emailViewerDialogRef>
		<slick-email-viewer [(ngModel)]='emailerModel'></slick-email-viewer>

		<slick-dialog-footer>
			<div class="row">
				<div class="col-12 text-center mb-2 mt-1">
					<button type="button" style="width: 120px;" class="btn btn-outline-primary" (click)="onOk()">Ok</button>
				</div>
			</div>
		</slick-dialog-footer>
	</slick-dialog>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickDialogComponent, selector: "slick-dialog", inputs: ["draggable", "resizable", "minimizable", "header", "showHeader", "noPadding", "top", "width", "height", "maxHeight", "cssClass", "key", "showOverlay", "disableScrollbar"], outputs: ["onClose"] }, { kind: "component", type: SlickDialogFooterComponent, selector: "slick-dialog-footer" }, { kind: "component", type: SlickEmailViewerComponent, selector: "slick-email-viewer" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-email-viewer-dialog',
                    template: `<slick-dialog *ngIf='isVisible' header='View Email' [width]='800' #emailViewerDialogRef>
		<slick-email-viewer [(ngModel)]='emailerModel'></slick-email-viewer>

		<slick-dialog-footer>
			<div class="row">
				<div class="col-12 text-center mb-2 mt-1">
					<button type="button" style="width: 120px;" class="btn btn-outline-primary" (click)="onOk()">Ok</button>
				</div>
			</div>
		</slick-dialog-footer>
	</slick-dialog>`,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickEmailViewerDialogComponent)),
                            multi: true,
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { emailViewerDialogRef: [{
                type: ViewChild,
                args: ["emailViewerDialogRef"]
            }] } });

class SlickEmailViewerModule {
}
/** @nocollapse */ SlickEmailViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickEmailViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerModule, declarations: [SlickEmailViewerComponent, SlickEmailViewerDialogComponent], imports: [CommonModule, FormsModule, SlickDialogModule, SlickFileListModule], exports: [CommonModule, FormsModule, SlickEmailViewerComponent, SlickEmailViewerDialogComponent] });
/** @nocollapse */ SlickEmailViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerModule, imports: [CommonModule, FormsModule, SlickDialogModule, SlickFileListModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickEmailViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SlickDialogModule, SlickFileListModule],
                    declarations: [SlickEmailViewerComponent, SlickEmailViewerDialogComponent],
                    exports: [CommonModule, FormsModule, SlickEmailViewerComponent, SlickEmailViewerDialogComponent]
                }]
        }] });

class SlickGoogleAddressSearchDirective {
    constructor(el, ngZone) {
        this.el = el;
        this.ngZone = ngZone;
        this.googleAddressSearchChange = new EventEmitter();
        this.onGoogleAddressSelect = new EventEmitter();
    }
    ngOnInit() {
        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
            console.error("%c Error: It appears you have not included the google maps scripts.  Please see www.slickcomponents.com for instructions on how to add this.", 'background: red; color: white');
            return;
        }
        new google.maps.places.Autocomplete(this.el.nativeElement);
        this.autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, {
            types: []
        });
        this.autocomplete.addListener("place_changed", () => {
            //get the place result
            let place = this.autocomplete.getPlace();
            // Google maps kind of sucks.  Often times it will strip the house number, but it's there
            // in the prediction.
            // So take the predictive text and use the house number from that instead
            const sessionToken = new google.maps.places.AutocompleteSessionToken();
            const autocompleteService = new google.maps.places.AutocompleteService();
            autocompleteService.getPlacePredictions({
                input: this.el.nativeElement.value,
                sessionToken: sessionToken
            }, (predictionAddr) => {
                // Give control back to angular
                this.ngZone.run(() => {
                    // See if we got a prediction back
                    if (predictionAddr && predictionAddr.length > 0) {
                        // See if the original place already has a street #
                        if (!(place.address_components.find(x => x.types.find(addrType => addrType === 'street_number')))) {
                            // Parse out the prediction addr, by spaces
                            const preditionAddrParts = predictionAddr[0].structured_formatting.main_text.split(" ");
                            // If we couldn't parse it, ignore the street
                            if (preditionAddrParts.length > 0) {
                                // Add a new "street_number" field to the components
                                const streetNumber = preditionAddrParts[0];
                                place.address_components.unshift({
                                    long_name: streetNumber,
                                    short_name: streetNumber,
                                    types: ['street_number']
                                });
                            }
                        }
                    }
                    if (this.googleAddressSearchChange)
                        this.googleAddressSearchChange.emit(place);
                    if (this.onGoogleAddressSelect)
                        this.onGoogleAddressSelect.emit(place);
                    this.el.nativeElement.value = "";
                });
            });
        });
    }
    ngOnDestroy() {
        this.autocomplete.unbindAll();
    }
}
/** @nocollapse */ SlickGoogleAddressSearchDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleAddressSearchDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickGoogleAddressSearchDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickGoogleAddressSearchDirective, selector: "[slick-google-address-search]", inputs: { googleAddressSearch: "googleAddressSearch" }, outputs: { googleAddressSearchChange: "googleAddressSearchChange", onGoogleAddressSelect: "onGoogleAddressSelect" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleAddressSearchDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-google-address-search]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { googleAddressSearch: [{
                type: Input
            }], googleAddressSearchChange: [{
                type: Output
            }], onGoogleAddressSelect: [{
                type: Output
            }] } });

class SlickGoogleAddressSearchModule {
}
/** @nocollapse */ SlickGoogleAddressSearchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleAddressSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickGoogleAddressSearchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleAddressSearchModule, declarations: [SlickGoogleAddressSearchDirective], imports: [CommonModule], exports: [SlickGoogleAddressSearchDirective] });
/** @nocollapse */ SlickGoogleAddressSearchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleAddressSearchModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleAddressSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickGoogleAddressSearchDirective],
                    exports: [SlickGoogleAddressSearchDirective]
                }]
        }] });

class SlickGoogleMapComponent {
    constructor() {
    }
    ngOnDestroy() {
        this.map = null;
    }
    async ngOnChanges() {
        if (!this.map)
            this.map = new google.maps.Map(this.googleMapRef.nativeElement, this.options);
        await SlickSleepService.sleep();
        this.map.setOptions(this.options);
        if (this.currentMarkers)
            this.currentMarkers.forEach(currentMarker => currentMarker.setMap(null));
        this.currentMarkers = [];
        if (this.overlays && this.overlays.length > 0) {
            this.overlays.forEach(o => {
                o.setMap(this.map);
                this.currentMarkers.push(o);
            });
        }
        await SlickSleepService.sleep();
        google.maps.event.trigger(this.map, 'resize');
    }
}
/** @nocollapse */ SlickGoogleMapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickGoogleMapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickGoogleMapComponent, selector: "slick-google-map", inputs: { options: "options", overlays: "overlays", width: "width", height: "height" }, viewQueries: [{ propertyName: "googleMapRef", first: true, predicate: ["googleMapRef"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: `<div #googleMapRef [style.width]='width' [style.height]='height'></div>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: "slick-google-map",
                    template: `<div #googleMapRef [style.width]='width' [style.height]='height'></div>`
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { options: [{
                type: Input
            }], overlays: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], googleMapRef: [{
                type: ViewChild,
                args: ["googleMapRef", { static: true }]
            }] } });

class SlickGoogleMapDialogComponent {
    constructor() {
        this.isVisible = false;
        this.showMap = false;
    }
    async showDialog(googleMapOptions = null, googleMapOverlays = null) {
        this.isVisible = true;
        this.showMap = true;
        await SlickSleepService.sleep();
        if (googleMapOptions) {
            this.options = {};
            this.options = googleMapOptions;
        }
        if (googleMapOverlays)
            this.overlays = googleMapOverlays;
        this.googleMapDialogRef.showDialog();
    }
    onOk() {
        this.options = null;
        this.overlays = null;
        this.googleMapDialogRef.hideDialog();
    }
}
/** @nocollapse */ SlickGoogleMapDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapDialogComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickGoogleMapDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickGoogleMapDialogComponent, selector: "slick-google-map-dialog", inputs: { options: "options", overlays: "overlays" }, viewQueries: [{ propertyName: "googleMapDialogRef", first: true, predicate: ["googleMapDialogRef"], descendants: true }], ngImport: i0, template: `<slick-dialog *ngIf='isVisible' header='Map' [width]='600' #googleMapDialogRef>
		<slick-google-map *ngIf='showMap' [options]="options" [overlays]="overlays" [width]="'580px'" [height]="'500px'"></slick-google-map>
	</slick-dialog>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlickDialogComponent, selector: "slick-dialog", inputs: ["draggable", "resizable", "minimizable", "header", "showHeader", "noPadding", "top", "width", "height", "maxHeight", "cssClass", "key", "showOverlay", "disableScrollbar"], outputs: ["onClose"] }, { kind: "component", type: SlickGoogleMapComponent, selector: "slick-google-map", inputs: ["options", "overlays", "width", "height"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapDialogComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-google-map-dialog',
                    template: `<slick-dialog *ngIf='isVisible' header='Map' [width]='600' #googleMapDialogRef>
		<slick-google-map *ngIf='showMap' [options]="options" [overlays]="overlays" [width]="'580px'" [height]="'500px'"></slick-google-map>
	</slick-dialog>`
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { options: [{
                type: Input
            }], overlays: [{
                type: Input
            }], googleMapDialogRef: [{
                type: ViewChild,
                args: ["googleMapDialogRef"]
            }] } });

class SlickGoogleMapModule {
}
/** @nocollapse */ SlickGoogleMapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickGoogleMapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapModule, declarations: [SlickGoogleMapComponent, SlickGoogleMapDialogComponent], imports: [CommonModule, SlickDialogModule], exports: [SlickGoogleMapComponent, SlickGoogleMapDialogComponent] });
/** @nocollapse */ SlickGoogleMapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapModule, imports: [CommonModule, SlickDialogModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGoogleMapModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SlickDialogModule],
                    declarations: [SlickGoogleMapComponent, SlickGoogleMapDialogComponent],
                    exports: [SlickGoogleMapComponent, SlickGoogleMapDialogComponent]
                }]
        }] });

var SlickGridColumnFilterTypes;
(function (SlickGridColumnFilterTypes) {
    SlickGridColumnFilterTypes[SlickGridColumnFilterTypes["none"] = 0] = "none";
    SlickGridColumnFilterTypes[SlickGridColumnFilterTypes["text"] = 1] = "text";
    SlickGridColumnFilterTypes[SlickGridColumnFilterTypes["dropdown"] = 2] = "dropdown";
})(SlickGridColumnFilterTypes || (SlickGridColumnFilterTypes = {}));
var SlickGridColumnSortDirection;
(function (SlickGridColumnSortDirection) {
    SlickGridColumnSortDirection[SlickGridColumnSortDirection["none"] = 0] = "none";
    SlickGridColumnSortDirection[SlickGridColumnSortDirection["asc"] = 1] = "asc";
    SlickGridColumnSortDirection[SlickGridColumnSortDirection["desc"] = 2] = "desc";
})(SlickGridColumnSortDirection || (SlickGridColumnSortDirection = {}));
var SlickGridColumnTitleOrientation;
(function (SlickGridColumnTitleOrientation) {
    SlickGridColumnTitleOrientation[SlickGridColumnTitleOrientation["Horizontal"] = 0] = "Horizontal";
    SlickGridColumnTitleOrientation[SlickGridColumnTitleOrientation["Vertical"] = 1] = "Vertical";
})(SlickGridColumnTitleOrientation || (SlickGridColumnTitleOrientation = {}));
class SlickGridColumnModel {
    constructor() {
        this.sortable = true;
        this.sortDirection = SlickGridColumnSortDirection.none;
        this.filterType = SlickGridColumnFilterTypes.none;
        this.default = true;
        this.visible = true;
        this.flexible = false;
        this.html = '';
    }
    static addGridColumn(params) {
        let gridColumn = new SlickGridColumnModel();
        if (params.columnKey)
            gridColumn.columnKey = params.columnKey;
        if (params.title)
            gridColumn.title = params.title;
        gridColumn.titleOrientation = params.titleOrientation || SlickGridColumnTitleOrientation.Horizontal;
        if (params.titleHeight)
            gridColumn.titleHeight = params.titleHeight;
        if (params.dataFieldName)
            gridColumn.dataFieldName = params.dataFieldName;
        if (params.displayOrder !== null && params.displayOrder !== undefined)
            gridColumn.displayOrder = params.displayOrder;
        if (params.sortable !== null && params.sortable !== undefined)
            gridColumn.sortable = params.sortable;
        if (params.sortDirection)
            gridColumn.sortDirection = params.sortDirection;
        if (params.filterType)
            gridColumn.filterType = params.filterType;
        if (params.filterDropdownValues)
            gridColumn.filterDropdownValues = params.filterDropdownValues;
        if (params.width !== null && params.width !== undefined)
            gridColumn.width = params.width;
        if (!!params.flexible)
            gridColumn.flexible = params.flexible;
        if (params.html)
            gridColumn.html = params.html;
        if (params.default === null || params.default === undefined)
            gridColumn.default = true;
        else
            gridColumn.default = params.default;
        gridColumn.visible = gridColumn.default;
        if (params.columnFormatCallback) {
            console.error("columnFormatCallback is no longer used.  Please use key and <slick-grid-column columnKey='key'> with <ng-template let-item [slickGridColumnTemplate]>");
        }
        return gridColumn;
    }
}

class SlickGridFavoriteModel {
}

class SlickGridRequestModel {
}

class SlickGridResponseModel {
}

class SlickGridService {
    constructor(http) {
        this.http = http;
    }
    async getDataFromServer(requestModel) {
        try {
            let params = {};
            if (requestModel.additionalParams)
                params.additionalParams = requestModel.additionalParams;
            // If the user has a custom search string, add it to the params here
            if (requestModel.searchString)
                params.searchString = requestModel.searchString;
            if (requestModel.recordsPerPage)
                params.recordsPerPage = requestModel.recordsPerPage;
            params.page = (requestModel.page === null || requestModel.page === undefined) ? 1 : requestModel.page;
            if (requestModel.sortColumn) {
                params.sortColumn = requestModel.sortColumn;
                params.sortDirection = requestModel.sortDirection;
            }
            delete params.columnSearchValues;
            if (requestModel.columnSearchValues)
                params.columnSearchValues = requestModel.columnSearchValues;
            let data = await this.http.post(requestModel.url, params, { headers: requestModel.httpHeaders }).toPromise();
            data = SlickUtilsService.dateSanitize(data);
            return Promise.resolve(data);
        }
        catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
    async getDataFromDataObj(requestModel, data) {
        try {
            let responseModel = new SlickGridResponseModel();
            if (!data || data.length === 0) {
                responseModel.totalRecords = 0;
                responseModel.data = [];
            }
            else {
                responseModel.totalRecords = data.length;
                let page = (requestModel.page === null || requestModel.page === undefined) ? 1 : requestModel.page;
                let startIndex = (page - 1) * requestModel.recordsPerPage;
                let endIndex = startIndex + requestModel.recordsPerPage;
                if (endIndex > data.length)
                    endIndex = data.length;
                responseModel.data = data.slice(startIndex, endIndex);
            }
            return Promise.resolve(responseModel);
        }
        catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
}
/** @nocollapse */ SlickGridService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickGridService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

class SlickGridColumnTemplateDirective {
    constructor(template) {
        this.template = template;
    }
}
/** @nocollapse */ SlickGridColumnTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridColumnTemplateDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickGridColumnTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickGridColumnTemplateDirective, selector: "[slickGridColumnTemplate]", inputs: { columnKey: ["slickGridColumnTemplate", "columnKey"] }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridColumnTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slickGridColumnTemplate]'
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { columnKey: [{
                type: Input,
                args: ['slickGridColumnTemplate']
            }] } });

class SlickPopoverComponent {
    constructor(el) {
        this.el = el;
        this.position = 'right';
        this.hoverDelay = 250;
        this.outDelay = 250;
        this.alignment = "left";
        this.topOffsetPx = 0;
        this.leftOffsetPx = 0;
        this.whiteBackground = false;
        this.showByClick = false;
        this.showArrow = true;
        this.fnReposition = () => this.reposition();
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.fnMouseEnter = () => this.mouseEnter();
        this.fnMouseLeave = () => this.mouseLeave();
        this.isVisible = false;
        this.uuid = SlickUtilsService.newGuid();
    }
    async ngOnChanges(changes) {
        if (changes.topOffsetPx)
            this.topOffsetPx = parseFloat(changes.topOffsetPx.currentValue);
        if (changes.leftOffsetPx)
            this.leftOffsetPx = parseFloat(changes.leftOffsetPx.currentValue);
        if (changes.position) {
            this.containerDivRef.nativeElement.classList.add("hidden");
            this.containerDivRef.nativeElement.classList.remove("visible");
        }
        if (changes.showByClick)
            this.showByClick = (this.showByClick.toString().toLowerCase() === 'true') ? true : false;
        if (changes.whiteBackground && changes.whiteBackground.currentValue)
            this.whiteBackground = (changes.whiteBackground.currentValue.toString().toLowerCase() !== 'false');
        if (changes.showArrow && changes.showArrow.currentValue)
            this.showArrow = (changes.showArrow.currentValue.toString().toLowerCase() !== 'false');
        await SlickSleepService.sleep();
        this.reposition();
    }
    ngAfterViewInit() {
        this.containerDivRef.nativeElement.classList.add("hidden");
        this.containerDivRef.nativeElement.classList.add("showArrow");
        // Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
        // of a div when it expands beyond the bottom.
        //this.el.nativeElement.remove(this.el);
        document.body.appendChild(this.el.nativeElement);
        // This is necessary, otherwise `this` in the reposition function will be window
        // and not the component.
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        if (this.showByClick === true) {
            document.addEventListener("click", this.fnDocumentClick, true);
            if (!this.element.getAttribute("id"))
                this.element.setAttribute('id', `slick-popover-element_${this.uuid}`);
            this.elementId = this.element.getAttribute("id");
        }
        else {
            this.el.nativeElement.addEventListener("mouseenter", this.fnMouseEnter);
            this.element.addEventListener("mouseenter", this.fnMouseEnter);
            this.el.nativeElement.addEventListener("mouseleave", this.fnMouseLeave);
            this.element.addEventListener("mouseleave", this.fnMouseLeave);
        }
    }
    ngOnDestroy() {
        document.removeEventListener("click", this.fnDocumentClick, true);
        this.el.nativeElement.removeEventListener("mouseenter", this.fnMouseEnter);
        this.element.removeEventListener("mouseenter", this.fnMouseEnter);
        this.el.nativeElement.removeEventListener("mouseleave", this.fnMouseLeave);
        try {
            this.element.removeEventListener("mouseleave", this.fnMouseLeave);
            document.body.removeChild(this.el.nativeElement);
        }
        catch { }
    }
    mouseEnter() {
        clearTimeout(this.displayTimeout);
        clearTimeout(this.leaveTimeout);
        this.displayTimeout = setTimeout(() => {
            this.reposition();
            this.containerDivRef.nativeElement.classList.remove("hidden");
            this.containerDivRef.nativeElement.classList.add("visible");
        }, this.hoverDelay);
    }
    mouseLeave() {
        clearTimeout(this.displayTimeout);
        clearTimeout(this.leaveTimeout);
        this.leaveTimeout = setTimeout(() => {
            this.containerDivRef.nativeElement.classList.add("hidden");
            this.containerDivRef.nativeElement.classList.remove("visible");
        }, this.outDelay);
    }
    async reposition() {
        if (!this.topOffsetPx)
            this.topOffsetPx = 0;
        if (!this.leftOffsetPx)
            this.leftOffsetPx = 0;
        if (this.showArrow === true)
            this.containerDivRef.nativeElement.classList.add("showArrow");
        else if (this.showArrow === false)
            this.containerDivRef.nativeElement.classList.remove("showArrow");
        if (this.whiteBackground === true)
            this.containerDivRef.nativeElement.classList.add("whiteBackground");
        else if (this.whiteBackground === false)
            this.containerDivRef.nativeElement.classList.remove("whiteBackground");
        let targetRect = this.element.getBoundingClientRect();
        let targetLeft = targetRect.left;
        let targetTop = targetRect.top;
        let targetHeight = this.element.offsetHeight;
        let targetWidth = targetRect.width;
        let popoverHeight = this.popoverContentRef.nativeElement.offsetHeight;
        let popoverWidth = this.popoverContentRef.nativeElement.getBoundingClientRect().width;
        if (this.showArrow) {
            popoverWidth += 5;
        }
        if (this.position === 'left') {
            this.top = (targetTop + this.topOffsetPx);
            this.left = (targetLeft - popoverWidth - 3 + this.leftOffsetPx);
            if (this.showArrow)
                this.left -= 2;
        }
        else if (this.position === 'right') {
            this.top = (targetTop + this.topOffsetPx);
            this.left = (targetLeft + targetWidth - 7 + this.leftOffsetPx);
            if (this.showArrow)
                this.left += 7;
        }
        else if (this.position === 'top') {
            this.top = (targetTop - popoverHeight - 3 + this.topOffsetPx);
            this.left = (targetLeft + this.leftOffsetPx);
            // default to left aligned
            this.left = (targetLeft + this.leftOffsetPx);
            if (this.alignment && this.alignment.toLowerCase() === 'right')
                this.left = targetLeft + targetWidth - popoverWidth - 4 + this.leftOffsetPx;
            if (this.showArrow)
                this.top -= 7;
        }
        else if (this.position === 'bottom') {
            this.top = (targetTop + targetHeight - 7 + this.topOffsetPx);
            // default to left aligned
            this.left = (targetLeft + this.leftOffsetPx);
            if (this.alignment && this.alignment.toLowerCase() === 'right')
                this.left = targetLeft + targetWidth - popoverWidth - 4 + this.leftOffsetPx;
            if (this.showArrow)
                this.top += 7;
        }
    }
    documentClick(e) {
        if (SlickUtilsService.checkParentIdExists(e.target, this.elementId) === true) {
            if (this.isVisible === true) {
                this.containerDivRef.nativeElement.classList.remove("visible");
                this.containerDivRef.nativeElement.classList.add("hidden");
                this.isVisible = false;
            }
            else {
                this.reposition();
                this.containerDivRef.nativeElement.classList.remove("hidden");
                this.containerDivRef.nativeElement.classList.add("visible");
                this.isVisible = true;
            }
        }
        else {
            if (this.isVisible === true) {
                this.containerDivRef.nativeElement.classList.remove("visible");
                this.containerDivRef.nativeElement.classList.add("hidden");
                this.isVisible = false;
            }
        }
    }
}
/** @nocollapse */ SlickPopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPopoverComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickPopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickPopoverComponent, selector: "slick-popover", inputs: { element: "element", position: "position", hoverDelay: "hoverDelay", outDelay: "outDelay", alignment: "alignment", topOffsetPx: "topOffsetPx", leftOffsetPx: "leftOffsetPx", whiteBackground: "whiteBackground", showByClick: "showByClick", showArrow: "showArrow" }, viewQueries: [{ propertyName: "containerDivRef", first: true, predicate: ["containerDivRef"], descendants: true, static: true }, { propertyName: "popoverContentRef", first: true, predicate: ["popoverContentRef"], descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerDivRef id=\"slick-popover_{{uuid}}\" class=\"slick-popover slick-popover_{{position}}\" [style.top.px]=\"top\" [style.left.px]=\"left\">\r\n\t<div #popoverContentRef class=\"popover fade bs-popover-{{position}} show\">\r\n\t\t<div *ngIf=\"showArrow === true\" class=\"arrow\"></div>\r\n\t\t<div class=\"popover-body\"><ng-content></ng-content></div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-popover', template: "<div #containerDivRef id=\"slick-popover_{{uuid}}\" class=\"slick-popover slick-popover_{{position}}\" [style.top.px]=\"top\" [style.left.px]=\"left\">\r\n\t<div #popoverContentRef class=\"popover fade bs-popover-{{position}} show\">\r\n\t\t<div *ngIf=\"showArrow === true\" class=\"arrow\"></div>\r\n\t\t<div class=\"popover-body\"><ng-content></ng-content></div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { element: [{
                type: Input
            }], position: [{
                type: Input
            }], hoverDelay: [{
                type: Input
            }], outDelay: [{
                type: Input
            }], alignment: [{
                type: Input
            }], topOffsetPx: [{
                type: Input
            }], leftOffsetPx: [{
                type: Input
            }], whiteBackground: [{
                type: Input
            }], showByClick: [{
                type: Input
            }], showArrow: [{
                type: Input
            }], containerDivRef: [{
                type: ViewChild,
                args: ["containerDivRef", { static: true }]
            }], popoverContentRef: [{
                type: ViewChild,
                args: ["popoverContentRef", { static: true }]
            }] } });

class SlickPagingComponent {
    constructor() {
        this.class = 'd-flex';
        this.pageNumber = 1;
        this.pageNumberChange = new EventEmitter();
        this.onPageChange = new EventEmitter();
        this.showEllipses = false;
        // This will be 10 20 30, etc
        this.preDisplayPageNumbers = [];
        this.preDisplayEllipses = false;
        // This will be 41, 42, 43, 44, etc
        this.displayPageNumbers = [];
        // This will be 50 60 70, etc
        this.postDisplayPageNumbers = [];
        this.postDisplayEllipses = false;
    }
    ngOnChanges(changes) {
        if (changes.pageNumber) {
            this.pageNumber = parseInt((changes.pageNumber.currentValue || '1').toString());
        }
        this.recalc();
    }
    selectPage(selectedPageNumber) {
        this.pageNumber = selectedPageNumber;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    first() {
        this.pageNumber = 1;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    previousPage() {
        this.pageNumber--;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    previousSet() {
        this.pageNumber -= 20;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    nextPage() {
        this.pageNumber++;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    nextSet() {
        this.pageNumber += 20;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    last() {
        this.pageNumber = this.totalPages;
        this.recalc();
        if (this.onPageChange)
            this.onPageChange.emit(this.pageNumber);
        if (this.pageNumberChange)
            this.pageNumberChange.emit(this.pageNumber);
    }
    recalc() {
        this.preDisplayEllipses = false;
        this.postDisplayEllipses = false;
        if (!this.recordsPerPage)
            return;
        this.totalRecords = this.totalRecords || 0;
        if (this.totalRecords < 0)
            this.totalRecords = 0;
        this.recordsPerPage = this.recordsPerPage || 1;
        if (this.recordsPerPage <= 0)
            this.recordsPerPage = 1;
        this.totalPages = Math.floor(this.totalRecords / this.recordsPerPage);
        if ((this.totalRecords % this.recordsPerPage) > 0)
            this.totalPages++;
        if (this.pageNumber < 1)
            this.pageNumber = 1;
        if (this.pageNumber > this.totalPages)
            this.pageNumber = this.totalPages;
        this.currentRecordNumber = ((this.recordsPerPage) * (this.pageNumber - 1)) + 1;
        this.endRecordNumber = this.currentRecordNumber + this.recordsPerPage - 1;
        if (this.endRecordNumber > this.totalRecords)
            this.endRecordNumber = this.totalRecords;
        this.preDisplayPageNumbers = [];
        this.displayPageNumbers = [];
        this.postDisplayPageNumbers = [];
        // 10 is a special case where we want to just show all 10
        if (this.totalPages === 10) {
            for (let i = 1; i <= 10; i++) {
                this.displayPageNumbers.push(i);
            }
        }
        else {
            const preDisplayPageTotal = Math.floor(this.pageNumber / 10);
            if (preDisplayPageTotal > 0) {
                for (let i = 0; i < preDisplayPageTotal; i++) {
                    if (i === 0)
                        this.preDisplayPageNumbers.push(1);
                    else
                        this.preDisplayPageNumbers.push(i * 10);
                }
            }
            let currentDisplayPageStart = preDisplayPageTotal * 10;
            let currentDisplayPageEnd = currentDisplayPageStart + 9;
            if (currentDisplayPageEnd > this.totalPages)
                currentDisplayPageEnd = this.totalPages;
            for (let i = currentDisplayPageStart; i <= currentDisplayPageEnd; i++) {
                if (i > 0)
                    this.displayPageNumbers.push(i);
            }
            const postDisplayPageTotal = Math.floor((this.totalPages - preDisplayPageTotal + 10) / 10);
            if (postDisplayPageTotal > 0) {
                for (let i = preDisplayPageTotal + 1; i < postDisplayPageTotal; i++)
                    this.postDisplayPageNumbers.push(i * 10);
            }
            if (this.preDisplayPageNumbers.length > 1) {
                this.preDisplayEllipses = true;
                this.preDisplayPageNumbers = this.preDisplayPageNumbers.slice(this.preDisplayPageNumbers.length - 1, this.preDisplayPageNumbers.length);
            }
            if (this.postDisplayPageNumbers.length > 1) {
                this.postDisplayEllipses = true;
                this.postDisplayPageNumbers = this.postDisplayPageNumbers.slice(0, 1);
            }
        }
        //// If we can show ALL the pages without the ..., then do it
        //if (this.totalPages <= (this.adjacent * 2)) {
        //	this.allDisplayPageNumbers = [];
        //	this.showEllipses = false;
        //	for (let i = 1; i <= this.totalPages; i++) {
        //		this.allDisplayPageNumbers.push(i);
        //	}
        //}
        //else {
        //	this.showEllipses = true;
        //	if (this.allDisplayPageNumbers.indexOf(this.pageNumber) < 0) {
        //		this.allDisplayPageNumbers = [];
        //		for (let i = this.pageNumber; i < this.pageNumber + this.adjacent; i++)
        //			this.allDisplayPageNumbers.push(i);
        //		this.allDisplayPageNumbers.push(-1)
        //		for (let i = this.totalPages - this.adjacent; i < this.totalPages; i++)
        //			this.allDisplayPageNumbers.push(i);
        //	}
        //}
    }
}
/** @nocollapse */ SlickPagingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPagingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickPagingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickPagingComponent, selector: "slick-paging", inputs: { pageNumber: "pageNumber", totalRecords: "totalRecords", recordsPerPage: "recordsPerPage" }, outputs: { pageNumberChange: "pageNumberChange", onPageChange: "onPageChange" }, host: { properties: { "class": "this.class" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-paging\">\r\n\t<div class=\"ml-2 d-flex flex-column\">\r\n\t\t<ul class=\"pagination m-0\">\r\n\t\t\t<li class=\"page-item\" [class.disabled]=\"!totalRecords || pageNumber === 1\"><button type=\"button\" class=\"page-link\" (click)=\"previousPage()\" style=\"margin-left: 1px;\"><i class=\"far fa-angle-left\"></i></button></li>\r\n\t\t\t<li *ngIf=\"pageNumber > 10\" class=\"page-item\"><button type=\"button\" class=\"page-link\" (click)=\"first()\" style=\"margin-left: 1px;\">1</button></li>\r\n\t\t\t<li *ngIf=\"preDisplayEllipses === true\" class=\"page-item\"><button type=\"button\" class=\"page-link\" (click)=\"previousSet()\" style=\"margin-left: 1px;\"><i style=\"line-height: .8rem; vertical-align: bottom;\" class=\"far fa-ellipsis-h\"></i></button></li>\r\n\r\n\t\t\t<li *ngIf=\"totalPages > 10\" class=\"page-item\" style=\"margin-left: 2px;\"></li>\r\n\r\n\t\t\t<li class=\"page-item\" *ngFor=\"let displayPageNumber of preDisplayPageNumbers\">\r\n\t\t\t\t<button type=\"button\" class=\"page-link\" style=\"margin-right: 2px;\" (click)=\"selectPage(displayPageNumber)\">{{displayPageNumber}}</button>\r\n\t\t\t</li>\r\n\r\n\t\t\t<li class=\"page-item\" [class.active]=\"pageNumber === displayPageNumber\" *ngFor=\"let displayPageNumber of displayPageNumbers\">\r\n\t\t\t\t<button *ngIf=\"displayPageNumber !== -1\" type=\"button\" class=\"page-link\" (click)=\"selectPage(displayPageNumber)\">{{displayPageNumber}}</button>\r\n\t\t\t\t<div *ngIf=\"displayPageNumber === -1\" class=\"page-link ellipses pl-1 pr-1 text-white bg-primary\"><i class=\"far fa-ellipsis-h\" style=\"position: relative;\ttop: 4px;\"></i></div>\r\n\t\t\t</li>\r\n\r\n\t\t\t<li *ngIf=\"postDisplayPageNumbers.length > 0\" class=\"page-item\" style=\"margin-left: 2px;\"></li>\r\n\r\n\t\t\t<li class=\"page-item\" *ngFor=\"let displayPageNumber of postDisplayPageNumbers\">\r\n\t\t\t\t<button type=\"button\" class=\"page-link\" style=\"margin-right: 2px;\" (click)=\"selectPage(displayPageNumber)\">{{displayPageNumber}}</button>\r\n\t\t\t</li>\r\n\r\n\t\t\t<li *ngIf=\"postDisplayEllipses === true\" class=\"page-item\"><button type=\"button\" class=\"page-link\" (click)=\"nextSet()\" style=\"margin-right: 2px;\"><i style=\"line-height: .8rem; vertical-align: bottom;\" class=\"far fa-ellipsis-h\"></i></button></li>\r\n\t\t\t<li *ngIf=\"totalPages > 10\" class=\"page-item\" [class.disabled]=\"pageNumber === totalPages\"><button type=\"button\" class=\"page-link\" (click)=\"last()\" style=\"margin-right: 2px;\">{{totalPages}}</button></li>\r\n\t\t\t<li class=\"page-item\" [class.disabled]=\"!totalRecords || pageNumber === totalPages\"><button type=\"button\" class=\"page-link\" (click)=\"nextPage()\"><i class=\"far fa-angle-right\"></i></button></li>\r\n\t\t</ul>\r\n\t\t<div *ngIf=\"totalRecords <= 0\" style=\"font-size: .8em; line-height: 1.4em;\">&nbsp;</div>\r\n\t\t<div *ngIf=\"totalRecords > 0\" style=\"font-size: .8em; line-height: 1.4em;\">\r\n\t\t\tShowing {{currentRecordNumber}}-{{endRecordNumber}} of {{totalRecords}}\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPagingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-paging', template: "<div class=\"slick-paging\">\r\n\t<div class=\"ml-2 d-flex flex-column\">\r\n\t\t<ul class=\"pagination m-0\">\r\n\t\t\t<li class=\"page-item\" [class.disabled]=\"!totalRecords || pageNumber === 1\"><button type=\"button\" class=\"page-link\" (click)=\"previousPage()\" style=\"margin-left: 1px;\"><i class=\"far fa-angle-left\"></i></button></li>\r\n\t\t\t<li *ngIf=\"pageNumber > 10\" class=\"page-item\"><button type=\"button\" class=\"page-link\" (click)=\"first()\" style=\"margin-left: 1px;\">1</button></li>\r\n\t\t\t<li *ngIf=\"preDisplayEllipses === true\" class=\"page-item\"><button type=\"button\" class=\"page-link\" (click)=\"previousSet()\" style=\"margin-left: 1px;\"><i style=\"line-height: .8rem; vertical-align: bottom;\" class=\"far fa-ellipsis-h\"></i></button></li>\r\n\r\n\t\t\t<li *ngIf=\"totalPages > 10\" class=\"page-item\" style=\"margin-left: 2px;\"></li>\r\n\r\n\t\t\t<li class=\"page-item\" *ngFor=\"let displayPageNumber of preDisplayPageNumbers\">\r\n\t\t\t\t<button type=\"button\" class=\"page-link\" style=\"margin-right: 2px;\" (click)=\"selectPage(displayPageNumber)\">{{displayPageNumber}}</button>\r\n\t\t\t</li>\r\n\r\n\t\t\t<li class=\"page-item\" [class.active]=\"pageNumber === displayPageNumber\" *ngFor=\"let displayPageNumber of displayPageNumbers\">\r\n\t\t\t\t<button *ngIf=\"displayPageNumber !== -1\" type=\"button\" class=\"page-link\" (click)=\"selectPage(displayPageNumber)\">{{displayPageNumber}}</button>\r\n\t\t\t\t<div *ngIf=\"displayPageNumber === -1\" class=\"page-link ellipses pl-1 pr-1 text-white bg-primary\"><i class=\"far fa-ellipsis-h\" style=\"position: relative;\ttop: 4px;\"></i></div>\r\n\t\t\t</li>\r\n\r\n\t\t\t<li *ngIf=\"postDisplayPageNumbers.length > 0\" class=\"page-item\" style=\"margin-left: 2px;\"></li>\r\n\r\n\t\t\t<li class=\"page-item\" *ngFor=\"let displayPageNumber of postDisplayPageNumbers\">\r\n\t\t\t\t<button type=\"button\" class=\"page-link\" style=\"margin-right: 2px;\" (click)=\"selectPage(displayPageNumber)\">{{displayPageNumber}}</button>\r\n\t\t\t</li>\r\n\r\n\t\t\t<li *ngIf=\"postDisplayEllipses === true\" class=\"page-item\"><button type=\"button\" class=\"page-link\" (click)=\"nextSet()\" style=\"margin-right: 2px;\"><i style=\"line-height: .8rem; vertical-align: bottom;\" class=\"far fa-ellipsis-h\"></i></button></li>\r\n\t\t\t<li *ngIf=\"totalPages > 10\" class=\"page-item\" [class.disabled]=\"pageNumber === totalPages\"><button type=\"button\" class=\"page-link\" (click)=\"last()\" style=\"margin-right: 2px;\">{{totalPages}}</button></li>\r\n\t\t\t<li class=\"page-item\" [class.disabled]=\"!totalRecords || pageNumber === totalPages\"><button type=\"button\" class=\"page-link\" (click)=\"nextPage()\"><i class=\"far fa-angle-right\"></i></button></li>\r\n\t\t</ul>\r\n\t\t<div *ngIf=\"totalRecords <= 0\" style=\"font-size: .8em; line-height: 1.4em;\">&nbsp;</div>\r\n\t\t<div *ngIf=\"totalRecords > 0\" style=\"font-size: .8em; line-height: 1.4em;\">\r\n\t\t\tShowing {{currentRecordNumber}}-{{endRecordNumber}} of {{totalRecords}}\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], pageNumber: [{
                type: Input
            }], pageNumberChange: [{
                type: Output
            }], onPageChange: [{
                type: Output
            }], totalRecords: [{
                type: Input
            }], recordsPerPage: [{
                type: Input
            }] } });

class SlickGridSanitizeHtmlPipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(v) {
        return this._sanitizer.bypassSecurityTrustHtml(v);
    }
}
/** @nocollapse */ SlickGridSanitizeHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridSanitizeHtmlPipe, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ SlickGridSanitizeHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickGridSanitizeHtmlPipe, name: "slickGridSanitizeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridSanitizeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'slickGridSanitizeHtml'
                }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; } });

class DropDownModel {
    constructor(text) {
        this.id = text;
        this.text = text;
    }
}
class SlickGridComponent {
    constructor(gridService, functionLockService, changeDetector) {
        this.gridService = gridService;
        this.functionLockService = functionLockService;
        this.changeDetector = changeDetector;
        this.flexColumn = 'slick-flex-column';
        this.bordered = true;
        this.striped = true;
        this.hover = true;
        this.showingAllRecords = false;
        this.onRowSelected = new EventEmitter();
        this.onRowDoubleClick = new EventEmitter();
        this.onRowContextMenu = new EventEmitter();
        this.onFavoritesModified = new EventEmitter();
        this.fnOnMouseUp = (e) => this.onMouseUp(e);
        this.selectedIndex = null;
        this.gridOpacity = 0;
        this.loaded = false;
        this.isDoubleClick = false;
        this.currentPage = 1;
        this.showTestRow = false;
        this.showSearchRow = false;
        this.isResizing = false;
        this.visibleData = [];
        this.recordsPerPageValue = "Auto";
        this.resizeTimeout = null;
        this.uuid = SlickUtilsService.newGuid();
        this.requestModel = new SlickGridRequestModel();
    }
    async onResize(event, targetElement) {
        // This is here because firefox shows/hides the menu if you press alt. Don't redraw the grid if we're
        // just showing the menu
        if (Math.abs(this.slickGridHeight - this.slickGridRef.nativeElement.offsetHeight) < 50)
            return;
        if (this.slickGridHeight !== this.slickGridRef.nativeElement.offsetHeight) {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(async () => {
                this.currentPage = 1;
                this.requestModel.page = 1;
                await this.resizeGrid();
                this.requestModel.recordsPerPage = this.recordsPerPage;
                this.reload(this.requestModel);
            }, 500);
        }
    }
    async ngOnInit() {
        this.setGridOptions(this.gridOptions);
    }
    async ngAfterViewInit() {
        // Copy the templates to a variable that the html can access.  It can't access a QueryList
        this.templateRefs = {};
        this.slickGridColumnTemplates.forEach(t => {
            this.templateRefs[t.columnKey] = t.template;
        });
        if (this.tableRef)
            this.tableRef.nativeElement.focus();
    }
    async tableKeydown(e) {
        // Key up
        if (e.which === 38 && !(this.selectedIndex === 0 && this.currentPage === 1)) {
            clearTimeout(this.keypressTimeout);
            this.selectedIndex--;
            if (this.selectedIndex < 0) {
                if (this.currentPage > 1) {
                    this.currentPage--;
                    this.selectedIndex = 0;
                    await this.onPageChange(this.currentPage, false);
                    this.selectedIndex = this.recordsPerPage - 1;
                }
            }
            this.keypressTimeout = setTimeout(() => {
                const rowData = this.visibleData[this.selectedIndex];
                this.onRowClicked(rowData, this.selectedIndex);
            }, 500);
        }
        // Key down
        if (e.which === 40) {
            if (((this.currentPage - 1) * this.recordsPerPage) + this.selectedIndex >= this.totalRecords)
                return;
            clearTimeout(this.keypressTimeout);
            this.selectedIndex++;
            if (this.selectedIndex >= this.recordsPerPage) {
                if (((this.currentPage - 1) * this.recordsPerPage) + this.selectedIndex < this.totalRecords) {
                    this.currentPage++;
                    this.selectedIndex = 0;
                    await this.onPageChange(this.currentPage, false);
                }
            }
            this.keypressTimeout = setTimeout(() => {
                const rowData = this.visibleData[this.selectedIndex];
                this.onRowClicked(rowData, this.selectedIndex);
            }, 500);
        }
    }
    async ngOnChanges(changes) {
        if (changes.bordered) {
            if (this.gridOptions.bordered === null)
                this.bordered = (this.bordered.toString().toLowerCase() !== 'false') ? true : false;
        }
        if (changes.striped) {
            // The grid options override the tag options
            if (this.gridOptions.striped === null)
                this.striped = (this.striped.toString().toLowerCase() !== 'false') ? true : false;
        }
        if (changes.hover) {
            // The grid options override the tag options
            if (this.gridOptions.hover === null)
                this.hover = (this.hover.toString().toLowerCase() !== 'false') ? true : false;
        }
        if (changes.gridOptions) {
            if (this.gridOptions.bordered !== null)
                this.bordered = this.gridOptions.bordered;
            if (this.gridOptions.striped !== null)
                this.striped = this.gridOptions.striped;
            if (this.gridOptions.hover !== null)
                this.hover = this.gridOptions.hover;
            this.setGridOptions(this.gridOptions);
        }
        if (changes.data) {
            // If we don't do this lock, the first change will have null data and crash.  The second request will have the actual data
            await this.functionLockService.lock("GRID_" + this.uuid + "_DATA_CHANGES");
            // Only resize the grid on the first change, otherwise we get a flicker
            if (changes.data.firstChange === true)
                await this.resizeGrid();
            // We need to wait for the resize in the OnInit to finish before we continue
            this.loaded = true;
            this.currentPage = 1;
            this.requestModel.page = 1;
            this.requestModel.recordsPerPage = this.recordsPerPage;
            await this.reload(this.requestModel);
            if (this.visibleData && this.visibleData.length > 0 && this.gridOptions.autoSelectFirstRow === true)
                this.selectRow(0);
            this.functionLockService.release("GRID_" + this.uuid + "_DATA_CHANGES");
        }
    }
    ngOnDestroy() {
        document.removeEventListener('mouseup', this.fnOnMouseUp);
    }
    async onRecordsPerPageSelected(recordsPerPage) {
        if (!recordsPerPage)
            return;
        this.recordsPerPageValue = recordsPerPage;
        localStorage.setItem("GRID_" + this.gridOptions.gridKey + "_RECORDS_PER_PAGE", recordsPerPage);
        this.visibleData = [];
        this.gridOpacity = 0;
        await SlickSleepService.sleep();
        await this.resizeGrid(true);
        this.requestModel.recordsPerPage = this.recordsPerPage;
        this.currentPage = 1;
        await this.onPageChange(this.currentPage, true);
    }
    onColResizeMousedown(e, columnIdx) {
        this.isResizing = true;
        this.resizeInitialPos = e.pageX;
        this.resizeColIdx = columnIdx;
        let col = this.tableHeaderRowRef.nativeElement.querySelectorAll("td").item(columnIdx);
        this.resizeInitialWidth = col.offsetWidth - 9;
        this.visibleColumns[columnIdx].flexible = false;
        document.addEventListener('mouseup', this.fnOnMouseUp);
    }
    onColResizeDoubleclick(e, columnIdx) {
        this.visibleColumns[columnIdx].flexible = true;
        this.visibleColumns[columnIdx].width = null;
        this.saveColumnsToLocalStorage();
    }
    onColResizeMousemove(e) {
        if (!this.isResizing)
            return;
        let newCursorPos = e.pageX;
        let diff = newCursorPos - this.resizeInitialPos;
        this.visibleColumns[this.resizeColIdx].width = (this.resizeInitialWidth + diff) + "px";
        if ((this.resizeInitialWidth + diff) < 10)
            this.visibleColumns[this.resizeColIdx].width = "10px";
        this.visibleColumns[this.resizeColIdx].flexible = false;
    }
    onMouseUp(e) {
        this.isResizing = false;
        document.removeEventListener('mouseup', this.fnOnMouseUp);
        this.saveColumnsToLocalStorage();
    }
    getVisibleRecords() {
        return this.visibleData;
    }
    addNewRecord(newRecord, selectNewRecord = false) {
        this.visibleData.unshift(newRecord);
        if (selectNewRecord === true) {
            this.selectedIndex = 0;
            this.selectRow(0);
        }
        else {
            if (this.selectedIndex)
                this.selectedIndex++;
        }
    }
    updateRecord(rowNum, record) {
        this.visibleData[rowNum] = record;
    }
    onRowClicked(rowData, idx) {
        this.selectedIndex = idx;
        clearTimeout(this.doubleClickWaitTimeout);
        this.doubleClickWaitTimeout = setTimeout(() => {
            this.onRowSelected.emit(rowData);
        }, 250);
    }
    onRowDoubleClicked(rowData, idx) {
        this.selectedIndex = idx;
        clearTimeout(this.doubleClickWaitTimeout);
        this.onRowDoubleClick.emit(rowData);
    }
    onRowContextMenuClicked(e, rowData, idx) {
        if (this.onRowContextMenu) {
            let rowContextMenuModel = {
                mouseEvent: e,
                data: rowData,
                rowIdx: idx
            };
            this.onRowContextMenu.emit(rowContextMenuModel);
        }
    }
    async onPageChange(pageNumber, selectRow = true) {
        this.currentPage = pageNumber;
        this.requestModel.page = pageNumber;
        await this.reload(this.requestModel);
        this.selectedIndex = (this.gridOptions.autoSelectFirstRow === true) ? 0 : null;
        if (selectRow === true && this.gridOptions.autoSelectFirstRow === true) {
            const rowData = this.visibleData[this.selectedIndex];
            this.onRowClicked(rowData, this.selectedIndex);
        }
        this.tableRef.nativeElement.focus();
    }
    async reloadGrid(additionalParams) {
        try {
            await this.resizeGrid();
            await this.functionLockService.lock("GRID_" + this.uuid + "_RELOADGRID");
            this.requestModel.url = this.gridOptions.getUrl;
            this.requestModel.httpHeaders = this.gridOptions.httpHeaders;
            this.requestModel.additionalParams = additionalParams;
            this.requestModel.page = this.currentPage;
            this.requestModel.recordsPerPage = this.recordsPerPage;
            let responseModel = await this.reload(this.requestModel);
            this.functionLockService.release("GRID_" + this.uuid + "_RELOADGRID");
            return Promise.resolve(responseModel);
        }
        catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
    async reloadGridWithRequestModel(requestModel) {
        try {
            await this.resizeGrid();
            await this.functionLockService.lock("GRID_" + this.uuid + "_RELOADGRIDWITHREQUESTMODEL");
            this.requestModel = requestModel;
            this.currentPage = 1;
            this.requestModel.page = 1;
            let responseModel = await this.reload(this.requestModel);
            this.functionLockService.release("GRID_" + this.uuid + "_RELOADGRIDWITHREQUESTMODEL");
            return Promise.resolve(responseModel);
        }
        catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
    async reload(requestModel) {
        try {
            await this.functionLockService.lock("GRID_" + this.uuid + "_RELOAD");
            requestModel = this.getRequestModel(this.requestModel);
            let responseModel = null;
            if (requestModel.url)
                responseModel = await this.gridService.getDataFromServer(requestModel);
            else
                responseModel = await this.gridService.getDataFromDataObj(requestModel, this.data);
            this.loaded = true;
            this.totalRecords = responseModel.totalRecords;
            this.visibleData = responseModel.data;
            this.functionLockService.release("GRID_" + this.uuid + "_RELOAD");
            Promise.resolve(responseModel);
        }
        catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
    unselectRow() {
        this.selectedIndex = null;
    }
    selectRow(rowNumber) {
        let rowData = this.visibleData[rowNumber];
        this.onRowClicked(rowData, rowNumber);
    }
    getColumnHTML(rowData, dataFieldName) {
        const columnHTML = SlickUtilsService.getDeepObject(rowData, dataFieldName);
        if (columnHTML === null || columnHTML === undefined)
            return '';
        return columnHTML.toString();
    }
    async sortBy(sortColumn) {
        this.gridOptions.columns.forEach(c => {
            if (sortColumn && c.columnKey !== sortColumn.columnKey) {
                c.sortDirection = SlickGridColumnSortDirection.none;
            }
        });
        if (sortColumn) {
            if (sortColumn.sortDirection === SlickGridColumnSortDirection.none) {
                this.visibleColumns.forEach(c => c.sortDirection = SlickGridColumnSortDirection.none);
                sortColumn.sortDirection = SlickGridColumnSortDirection.asc;
            }
            else if (sortColumn.sortDirection === SlickGridColumnSortDirection.asc)
                sortColumn.sortDirection = SlickGridColumnSortDirection.desc;
            else {
                sortColumn.sortDirection = SlickGridColumnSortDirection.none;
            }
        }
        this.saveColumnsToLocalStorage();
        this.currentPage = 1;
        this.requestModel.page = 1;
        await this.reload(this.requestModel);
        if (this.visibleData && this.visibleData.length > 0 && this.gridOptions.autoSelectFirstRow === true)
            this.selectRow(0);
    }
    async onSearchSelect(ddValue, column) {
        if (!this.requestModel.columnSearchValues)
            this.requestModel.columnSearchValues = [];
        let columnSearchValueIdx = this.requestModel.columnSearchValues.findIndex(x => x.columnName === column.dataFieldName);
        if (columnSearchValueIdx >= 0)
            this.requestModel.columnSearchValues.splice(columnSearchValueIdx, 1);
        column.isFiltering = false;
        if (ddValue) {
            this.requestModel.columnSearchValues.push({
                columnName: column.dataFieldName,
                searchValueId: ddValue.id,
                searchValueText: ddValue.text
            });
            column.isFiltering = true;
        }
        else {
            column.isLocked = false;
        }
        this.currentPage = 1;
        this.requestModel.page = 1;
        await this.reload(this.requestModel);
        if (this.visibleData && this.visibleData.length > 0 && this.gridOptions.autoSelectFirstRow === true)
            this.selectRow(0);
    }
    async onSearch(column) {
        await SlickSleepService.sleep();
        if (!this.requestModel.columnSearchValues)
            this.requestModel.columnSearchValues = [];
        if (column.filterText === column.lastSearchText)
            return;
        column.lastSearchText = column.filterText;
        column.isFiltering = !!column.filterText;
        if (!column.isFiltering)
            column.isLocked = false;
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(async () => {
            this.saveColumnsToLocalStorage();
            let columnSearchValueIdx = this.requestModel.columnSearchValues.findIndex(x => x.columnName === column.dataFieldName);
            if (columnSearchValueIdx >= 0)
                this.requestModel.columnSearchValues.splice(columnSearchValueIdx, 1);
            if (column.filterText) {
                this.requestModel.columnSearchValues.push({
                    columnName: column.dataFieldName,
                    searchValueText: column.filterText
                });
            }
            this.currentPage = 1;
            this.requestModel.page = 1;
            await this.reload(this.requestModel);
            if (this.visibleData && this.visibleData.length > 0 && this.gridOptions.autoSelectFirstRow === true)
                this.selectRow(0);
        }, 250);
    }
    toggleLock(column) {
        column.isLocked = !column.isLocked;
        this.saveColumnsToLocalStorage();
    }
    async resetFilter(column) {
        column.isFiltering = false;
        column.isLocked = false;
        column.filterText = null;
        column.lastSearchText = null;
        column.filterDropdownValue = null;
        this.requestModel.columnSearchValues = this.requestModel.columnSearchValues.filter(x => x.columnName !== column.dataFieldName);
        this.saveColumnsToLocalStorage();
        this.currentPage = 1;
        this.requestModel.page = 1;
        await this.reload(this.requestModel);
        if (this.visibleData && this.visibleData.length > 0 && this.gridOptions.autoSelectFirstRow === true)
            this.selectRow(0);
    }
    openColumnSelectDialog() {
        this.columnSelectDialogColumns = [...this.gridOptions.columns];
        this.columnSelectDialogColumns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
        this.columnSelectDialogRef.showDialog();
    }
    onColumnDrop(e) {
        console.info(e);
    }
    async onColumnReorder(e) {
        const oldOrder = e[0];
        const newOrder = e[1];
        if (oldOrder === newOrder)
            return;
        const selectedCol = this.columnSelectDialogColumns.splice(oldOrder, 1)[0];
        selectedCol.displayOrder = newOrder;
        let currentOrder = 0;
        // Everything up to the new order reordered from 0
        for (let i = 0; i < this.columnSelectDialogColumns.length; i++) {
            // If we're at newOrder, leave a spot
            if (i === newOrder)
                currentOrder++;
            this.columnSelectDialogColumns[i].displayOrder = currentOrder++;
        }
        this.columnSelectDialogColumns = [...this.columnSelectDialogColumns, selectedCol];
        this.columnSelectDialogColumns = this.columnSelectDialogColumns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
    }
    async addNewFavorite() {
        this.newFavoriteText = '';
        const confirmResult = await this.addNewFavoriteDialogRef.confirm();
        if (confirmResult === SlickConfirmDialogResults.Ok && this.newFavoriteText) {
            // Save the previous selection to localstorage
            this.saveDialogColumnsToLocalStorage();
            this.favorites.push(new DropDownModel(this.newFavoriteText));
            this.selectedFavorite = this.newFavoriteText;
            localStorage.setItem("GRID_" + this.gridOptions.gridKey + "_SELECTED_FAVORITE", this.selectedFavorite);
            const favoritesJson = JSON.stringify(this.favorites.map(x => x.text));
            localStorage.setItem("GRID_" + this.gridOptions.gridKey + "_FAVORITES", favoritesJson);
            // Save the new one to localstorage
            this.saveDialogColumnsToLocalStorage();
        }
    }
    loadFavorite(favorite) {
        this.saveDialogColumnsToLocalStorage();
        this.selectedFavorite = favorite.text;
        let gridColumnsJson = localStorage.getItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${this.selectedFavorite === 'Default' ? '' : '_' + this.selectedFavorite}`);
        if (gridColumnsJson) {
            this.columnSelectDialogColumns = JSON.parse(gridColumnsJson);
            this.columnSelectDialogColumns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
        }
    }
    async setFavorite(favorite) {
        this.selectedFavorite = favorite;
        localStorage.setItem("GRID_" + this.gridOptions.gridKey + "_SELECTED_FAVORITE", this.selectedFavorite);
        let gridColumnsJson = localStorage.getItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${this.selectedFavorite === 'Default' ? '' : '_' + this.selectedFavorite}`);
        this.gridOptions.columns = JSON.parse(gridColumnsJson);
        this.gridOptions.columns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
        this.visibleColumns = this.gridOptions.columns.filter(c => c.visible === true);
        this.visibleColumns = this.visibleColumns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
        this.showSearchRow = this.visibleColumns.filter(c => c.filterType !== SlickGridColumnFilterTypes.none).length > 0;
        this.currentPage = 1;
        this.requestModel.page = 1;
        this.requestModel.recordsPerPage = this.recordsPerPage;
        await this.reload(this.requestModel);
    }
    onSaveColumns() {
        this.saveDialogColumnsToLocalStorage();
        this.gridOptions.columns = [...this.columnSelectDialogColumns];
        // Make sure if they've hidden a column that we aren't trying to sort or filter by this column
        this.gridOptions.columns.forEach(x => {
            if (x.visible === false) {
                x.filterDropdownValue = null;
                x.filterText = null;
                x.isFiltering = false;
                x.isLocked = false;
                x.lastSearchText = null;
                x.sortDirection = null;
            }
        });
        this.visibleColumns = this.gridOptions.columns.filter(c => c.visible === true);
        this.visibleColumns = this.visibleColumns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
        this.showSearchRow = this.visibleColumns.filter(c => c.filterType !== SlickGridColumnFilterTypes.none).length > 0;
        this.columnSelectDialogRef.hideDialog();
        this.resizeGrid();
        if (this.onFavoritesModified) {
            const gridFavorites = this.favorites.map(favorite => {
                const gridFavorite = new SlickGridFavoriteModel();
                gridFavorite.favoriteName = favorite.text;
                const suffix = gridFavorite.favoriteName === 'Default' ? '' : ('_' + gridFavorite.favoriteName);
                const dialogColumnsJSON = localStorage.getItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`);
                gridFavorite.columns = JSON.parse(dialogColumnsJSON);
                return gridFavorite;
            });
            this.onFavoritesModified.emit(gridFavorites);
        }
    }
    onCancelColumns() {
        this.columnSelectDialogRef.hideDialog();
    }
    saveDialogColumnsToLocalStorage() {
        let dialogColumnsJSON = JSON.stringify(this.columnSelectDialogColumns);
        if (this.gridOptions.gridKey) {
            const suffix = this.selectedFavorite === 'Default' ? '' : ('_' + this.selectedFavorite);
            localStorage.setItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`, dialogColumnsJSON);
        }
    }
    saveColumnsToLocalStorage() {
        let gridColumnsJSON = JSON.stringify(this.gridOptions.columns);
        if (this.gridOptions.gridKey) {
            const suffix = this.selectedFavorite === 'Default' ? '' : ('_' + this.selectedFavorite);
            let gridColumnsJson = localStorage.getItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`);
            if (gridColumnsJson) {
                let columns = JSON.parse(gridColumnsJson);
                let displayOrder = 0;
                columns.forEach(c => {
                    let column = this.gridOptions.columns.find(gridColumn => gridColumn.dataFieldName === c.dataFieldName);
                    if (column) {
                        c.displayOrder = displayOrder;
                        c.titleOrientation = column.titleOrientation;
                        c.titleHeight = column.titleHeight;
                        c.width = column.width;
                        c.filterDropdownValue = column.filterDropdownValue;
                        c.filterText = column.filterText;
                        c.isLocked = column.isLocked;
                        c.isFiltering = column.isFiltering;
                        c.sortDirection = column.sortDirection;
                    }
                    displayOrder++;
                });
                columns = columns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
                gridColumnsJSON = JSON.stringify(columns);
            }
            localStorage.setItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`, gridColumnsJSON);
        }
        if (this.onFavoritesModified) {
            const gridFavorites = this.favorites.map(favorite => {
                const gridFavorite = new SlickGridFavoriteModel();
                gridFavorite.favoriteName = favorite.text;
                const suffix = gridFavorite.favoriteName === 'Default' ? '' : ('_' + gridFavorite.favoriteName);
                const dialogColumnsJSON = localStorage.getItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`);
                gridFavorite.columns = JSON.parse(dialogColumnsJSON);
                return gridFavorite;
            });
            this.onFavoritesModified.emit(gridFavorites);
        }
    }
    async resizeGrid(forceRefresh = false) {
        return new Promise(async (resolve) => {
            if (!forceRefresh && this.slickGridRef.nativeElement.offsetHeight === this.slickGridHeight) {
                resolve();
                return;
            }
            if (this.recordsPerPageValue === 'Auto') {
                await this.functionLockService.lock("GRID_" + this.uuid + "_RESIZEGRID");
                this.slickGridHeight = this.tableContainerRef.nativeElement.offsetHeight;
                const testRow = this.tableRef.nativeElement.insertRow(0);
                const testCell = testRow.insertCell(0);
                testCell.style.visibility = "hidden";
                testCell.innerHTML = "&NBSP";
                const rowHeight = testCell.offsetHeight;
                this.tableRef.nativeElement.deleteRow(0);
                let headerHeight = this.tableHeaderRowRef.nativeElement.offsetHeight + 2;
                if (this.tableHeaderSearchRowRef)
                    headerHeight += this.tableHeaderSearchRowRef.nativeElement.offsetHeight + 2;
                const clientHeight = this.tableContainerRef.nativeElement.offsetHeight - headerHeight;
                this.recordsPerPage = parseInt(((clientHeight / rowHeight) - 1).toFixed(0));
                let actualRowHeight = parseInt((clientHeight / this.recordsPerPage).toFixed(0)) - 1;
                if (actualRowHeight < rowHeight)
                    actualRowHeight = rowHeight;
                const allRows = this.slickGridRef.nativeElement.querySelectorAll(".table tbody tr");
                allRows.forEach(row => {
                    row.style.height = (actualRowHeight) + "px";
                });
                this.functionLockService.release("GRID_" + this.uuid + "_RESIZEGRID");
                this.gridOpacity = 1;
                this.showTestRow = false;
                resolve();
            }
            else {
                await SlickSleepService.sleep();
                this.recordsPerPage = parseInt(this.recordsPerPageValue);
                this.gridOpacity = 1;
                resolve();
            }
        });
    }
    addColumn(column, idx = null) {
        if (idx === null)
            this.gridOptions.columns.push(column);
        else
            this.gridOptions.columns.splice(idx, 0, column);
        this.setGridOptions(this.gridOptions);
    }
    getRequestModel(requestModel = null) {
        if (!requestModel)
            requestModel = this.requestModel;
        requestModel.columnSearchValues = [];
        this.gridOptions.columns.forEach(c => {
            if (c.visible) {
                if (c.filterType === SlickGridColumnFilterTypes.text && c.filterText) {
                    c.filterText = c.filterText;
                    requestModel.columnSearchValues.push({
                        columnName: c.dataFieldName,
                        searchValueId: null,
                        searchValueText: c.filterText
                    });
                }
                else if (c.filterType === SlickGridColumnFilterTypes.dropdown && c.filterDropdownValue) {
                    c.filterDropdownValue = c.filterDropdownValue;
                    requestModel.columnSearchValues.push({
                        columnName: c.dataFieldName,
                        searchValueId: c.filterDropdownValue,
                        searchValueText: null
                    });
                }
            }
        });
        requestModel.sortColumn = null;
        const sortColumn = this.gridOptions.columns.find(x => x.sortDirection === SlickGridColumnSortDirection.asc || x.sortDirection === SlickGridColumnSortDirection.desc);
        if (sortColumn) {
            requestModel.sortColumn = (sortColumn.sortDirection === 0) ? null : sortColumn.dataFieldName;
            requestModel.sortDirection = sortColumn.sortDirection;
        }
        if (requestModel.recordsPerPage <= 0)
            requestModel.recordsPerPage = 20;
        return this.requestModel;
    }
    setGridOptions(gridOptions) {
        this.gridOptions = gridOptions;
        if (this.gridOptions.gridKey) {
            if (this.gridOptions.favorites) {
                const favoriteNames = this.gridOptions.favorites.map(f => f.favoriteName);
                localStorage.setItem(`GRID_${this.gridOptions.gridKey}_FAVORITES`, JSON.stringify(favoriteNames));
                this.gridOptions.favorites.forEach(favorite => {
                    // Make sure we haven't added a new column that needs to be saved
                    this.gridOptions.columns.forEach(c => {
                        const columnExists = favorite.columns.findIndex(x => x.dataFieldName === c.dataFieldName);
                        if (columnExists < 0)
                            favorite.columns.push(c);
                    });
                    let gridColumnsJSON = JSON.stringify(favorite.columns);
                    if (this.gridOptions.gridKey) {
                        const suffix = favorite.favoriteName === 'Default' ? '' : ('_' + favorite.favoriteName);
                        localStorage.setItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`, gridColumnsJSON);
                    }
                });
                if (favoriteNames.indexOf(this.selectedFavorite) < 0)
                    this.selectedFavorite = "Default";
            }
            this.selectedFavorite = localStorage.getItem("GRID_" + this.gridOptions.gridKey + "_SELECTED_FAVORITE") || 'Default';
            // Check to make sure we don't have any duplicate column names
            this.gridOptions.columns.forEach(c1 => {
                const dataFieldCount = (this.gridOptions.columns.filter(x => x.dataFieldName === c1.dataFieldName) || []).length;
                if (dataFieldCount > 1)
                    console.error(`Grid ${this.gridOptions.gridKey} column ${c1.dataFieldName} is defined ${dataFieldCount} times`);
            });
            const suffix = this.selectedFavorite === 'Default' ? '' : ('_' + this.selectedFavorite);
            let gridColumnsJson = localStorage.getItem(`GRID_${this.gridOptions.gridKey}_COLUMNS${suffix}`);
            if (gridColumnsJson) {
                let columns = JSON.parse(gridColumnsJson);
                let displayOrder = 0;
                columns.forEach(c => {
                    let column = this.gridOptions.columns.find(gridColumn => gridColumn.dataFieldName === c.dataFieldName);
                    if (column) {
                        column.visible = c.visible;
                        column.displayOrder = displayOrder;
                        column.titleOrientation = c.titleOrientation;
                        column.titleHeight = c.titleHeight;
                        column.width = c.width;
                        column.flexible = c.flexible;
                        column.sortDirection = c.sortDirection;
                        column.isLocked = c.isLocked;
                        //column.filterType = c.filterType;
                        if (column.isLocked && column.filterType !== SlickGridColumnFilterTypes.none) {
                            column.isFiltering = true;
                            if (column.filterType === SlickGridColumnFilterTypes.text)
                                column.filterText = c.filterText;
                            else if (column.filterType === SlickGridColumnFilterTypes.dropdown)
                                column.filterDropdownValue = c.filterDropdownValue;
                            if (!column.filterText && !column.filterDropdownValue) {
                                column.isFiltering = false;
                                column.isLocked = false;
                                column.filterText = null;
                                column.filterDropdownValue = null;
                            }
                        }
                    }
                    displayOrder++;
                });
            }
            if (this.gridOptions.defaultRecordsPerPage && !localStorage.getItem("GRID_" + this.gridOptions.gridKey + "_RECORDS_PER_PAGE"))
                this.recordsPerPageValue = this.gridOptions.defaultRecordsPerPage.toString();
            else
                this.recordsPerPageValue = localStorage.getItem("GRID_" + this.gridOptions.gridKey + "_RECORDS_PER_PAGE") || "Auto";
            const favoritesJson = localStorage.getItem("GRID_" + this.gridOptions.gridKey + "_FAVORITES") || `["Default"]`;
            this.favorites = JSON.parse(favoritesJson).map(favorite => {
                return new DropDownModel(favorite);
            });
        }
        this.visibleColumns = this.gridOptions.columns.filter(c => c.visible === true);
        this.visibleColumns = this.visibleColumns.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : (a.displayOrder < b.displayOrder) ? -1 : 0);
        this.showSearchRow = this.visibleColumns.filter(c => c.filterType !== SlickGridColumnFilterTypes.none).length > 0;
        let sortColumn = this.visibleColumns.find(c => c.sortable === true && c.sortDirection > 0);
        if (this.visibleColumns.length > 0 && sortColumn) {
            this.requestModel.sortColumn = sortColumn.dataFieldName;
            this.requestModel.sortDirection = sortColumn.sortDirection;
        }
    }
}
/** @nocollapse */ SlickGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridComponent, deps: [{ token: SlickGridService }, { token: SlickFunctionLockService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickGridComponent, selector: "slick-grid", inputs: { gridOptions: "gridOptions", bordered: "bordered", striped: "striped", hover: "hover", showingAllRecords: "showingAllRecords", data: "data" }, outputs: { onRowSelected: "onRowSelected", onRowDoubleClick: "onRowDoubleClick", onRowContextMenu: "onRowContextMenu", onFavoritesModified: "onFavoritesModified" }, host: { listeners: { "window:resize": "onResize($event,$event.target)" }, properties: { "class": "this.flexColumn" } }, providers: [SlickGridService], queries: [{ propertyName: "slickGridColumnTemplates", predicate: SlickGridColumnTemplateDirective }], viewQueries: [{ propertyName: "slickGridRef", first: true, predicate: ["slickGrid"], descendants: true, static: true }, { propertyName: "tableContainerRef", first: true, predicate: ["tableContainer"], descendants: true }, { propertyName: "tableRef", first: true, predicate: ["tableRef"], descendants: true }, { propertyName: "tableHeaderRowRef", first: true, predicate: ["tableHeaderRow"], descendants: true }, { propertyName: "tableHeaderSearchRowRef", first: true, predicate: ["tableHeaderSearchRow"], descendants: true }, { propertyName: "testRowRef", first: true, predicate: ["testRow"], descendants: true }, { propertyName: "tableBodyRowsRef", first: true, predicate: ["tableBodyRows"], descendants: true }, { propertyName: "columnSelectDialogRef", first: true, predicate: ["columnSelectDialogRef"], descendants: true }, { propertyName: "addNewFavoriteDialogRef", first: true, predicate: ["addNewFavoriteDialogRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div id=\"slick-grid_{{uuid}}\" class=\"slick-grid d-flex flex-column flex-fill\" style=\"position: absolute; left: 0; top: 0; right: 0; bottom: 0;\" #slickGrid>\r\n\t<div #tableContainer class=\"d-flex flex-fill\" style=\"overflow: auto\">\r\n\r\n\t\t<div>\r\n\t\t\t<table #tableRef class=\"table table-sm\" [class.table-bordered]=\"bordered\" [class.table-borderless]=\"!bordered\" [class.table-striped]=\"striped\" [class.table-hover]=\"hover\" [style.opacity]=\"gridOpacity\" style=\"margin: 0; padding: 0;\" (keydown)=\"tableKeydown($event)\" tabindex=\"0\">\r\n\t\t\t\t<thead>\r\n\t\t\t\t\t<tr #tableHeaderRow (mousemove)=\"onColResizeMousemove($event)\" [ngClass]=\"{ 'resizing': isResizing === true }\">\r\n\t\t\t\t\t\t<td *ngFor=\"let column of visibleColumns; let idx = index\" [style.width]=\"column.width\" [style.maxWidth]=\"column.width\" [style.height]=\"column.titleHeight\">\r\n\t\t\t\t\t\t\t<div [ngClass]=\"{ 'slick-grid_title-vertical' : column.titleOrientation === 1 }\">\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"idx > 0 && idx < visibleColumns.length\" class=\"resize_column_left\" [class.table-bordered]=\"bordered\" (mousedown)=\"onColResizeMousedown($event, idx - 1)\" (dblclick)=\"onColResizeDoubleclick($event, idx - 1)\"></div>\r\n\t\t\t\t\t\t\t\t<span class=\"sortIcon\" *ngIf=\"column.sortable === true && column.sortDirection > 0\"><i class=\"far\" [ngClass]=\"{'fa-caret-up': column.sortDirection === 1, 'fa-caret-down': column.sortDirection === 2}\"></i>&nbsp;</span>\r\n\t\t\t\t\t\t\t\t<a href=\"javascript:void(0)\" *ngIf=\"column.sortable === true\" (click)=\"sortBy(column)\" draggable=\"false\" title=\"{{column.title}}\">{{column.title}}</a>\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"column.sortable === false\" title=\"{{column.title}}\">{{column.title}}</div>\r\n\t\t\t\t\t\t\t\t<div class=\"resize_column_right\" (mousedown)=\"onColResizeMousedown($event, idx)\" (dblclick)=\"onColResizeDoubleclick($event, idx)\"></div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr #tableHeaderSearchRow *ngIf=\"showSearchRow === true\">\r\n\t\t\t\t\t\t<td *ngFor=\"let column of visibleColumns\">\r\n\t\t\t\t\t\t\t<div class=\"slick-grid_search-column\">\r\n\t\t\t\t\t\t\t\t<i *ngIf=\"column.isFiltering\" class=\"fas fa-times-circle bg-white text-danger mr-1\" (click)=\"resetFilter(column)\"></i>\r\n\t\t\t\t\t\t\t\t<i *ngIf=\"column.isFiltering && column.isLocked\" class=\"far fa-lock mr-1\" (click)=\"toggleLock(column)\"></i>\r\n\t\t\t\t\t\t\t\t<i *ngIf=\"column.isFiltering && !column.isLocked\" class=\"far fa-lock-open mr-1\" (click)=\"toggleLock(column)\"></i>\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"column.filterType === 1\" class=\"slick-grid_text-search\">\r\n\t\t\t\t\t\t\t\t\t<input autocomplete=\"nope\" type=\"text\" class=\"form-control\" [(ngModel)]=\"column.filterText\" name=\"searchText\" placeholder=\"Search...\" (keydown)=\"onSearch(column)\" />\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"column.filterType === 2\" class=\"input-group slick-grid_drop-down-search\">\r\n\t\t\t\t\t\t\t\t\t<slick-drop-down [items]=\"column.filterDropdownValues\" [(ngModel)]=\"column.filterDropdownValue\" listWidth=\"auto\" placeholder=\"Search...\" (onSelect)=\"onSearchSelect($event, column)\"></slick-drop-down>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</thead>\r\n\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr *ngIf=\"loaded && visibleData.length === 0\"><td [colSpan]=\"visibleColumns.length\">No Data</td></tr>\r\n\t\t\t\t\t<tr *ngFor=\"let rowData of visibleData; let idx = index\" #tableBodyRows (click)=\"onRowClicked(rowData, idx)\" (dblclick)=\"onRowDoubleClicked(rowData, idx)\" (contextmenu)=\"onRowContextMenuClicked($event, rowData, idx)\" [class.table-success]=\"selectedIndex === idx\">\r\n\t\t\t\t\t\t<td *ngFor=\"let column of visibleColumns\">\r\n\t\t\t\t\t\t\t<div *ngIf=\"!column.columnKey\" class=\"slick-grid_column-content\" [style.width]=\"column.width\" [style.maxWidth]=\"column.width\" [innerHTML]=\"getColumnHTML(rowData, column.dataFieldName) | slickGridSanitizeHtml\"></div>\r\n\t\t\t\t\t\t\t<div *ngIf=\"column.columnKey\" class=\"slick-grid_column-content\" [style.width]=\"column.width\" [style.maxWidth]=\"column.width\">\r\n\t\t\t\t\t\t\t\t<ng-container *ngTemplateOutlet=\"templateRefs[column.columnKey], context: { $implicit: rowData }\">\r\n\t\t\t\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</tbody>\r\n\t\t\t</table>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\r\n\t<div class=\"slick-grid-footer mt-2 d-flex\">\r\n\t\t<div>\r\n\t\t\t<button type=\"button\" (click)=\"openColumnSelectDialog()\" class=\"btn btn-outline-primary\"><i class=\"far fa-columns\"></i></button>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"favorites?.length > 1\">\r\n\t\t\t<button #favoriteSelectRef type=\"button\" class=\"btn btn-outline-primary ml-1\"><i class=\"far fa-star\"></i> {{this.selectedFavorite}}</button>\r\n\t\t\t<slick-popover [element]=\"favoriteSelectRef\" position=\"top\" showArrow=\"false\" [topOffsetPx]=\"0\" [leftOffsetPx]=\"0\" [showByClick]=\"true\">\r\n\t\t\t\t<table class=\"table-borderless table-sm table-hover\" style=\"min-width: 250px; cursor: default\">\r\n\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t<tr *ngFor=\"let favorite of favorites\" (click)=\"setFavorite(favorite.text)\">\r\n\t\t\t\t\t\t\t<td><i *ngIf=\"favorite.text === selectedFavorite\" class=\"far fa-star mr-1\"></i>{{favorite.text}}</td>\r\n\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t</tbody>\r\n\t\t\t\t</table>\r\n\t\t\t</slick-popover>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"showingAllRecords == false\">\r\n\t\t\t<slick-paging [(pageNumber)]=\"currentPage\" [totalRecords]=\"totalRecords\" [recordsPerPage]=\"recordsPerPage\" (onPageChange)=\"onPageChange($event)\"></slick-paging>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"showingAllRecords == false\" class=\"ml-1\">\r\n\t\t\t<button #recordsPerPageRef type=\"button\" class=\"btn btn-outline-primary\">{{recordsPerPageValue}}&nbsp;&nbsp;<i style=\"font-size: 12px\" class=\"far fa-chevron-down\"></i></button>\r\n\r\n\t\t\t<slick-popover [element]=\"recordsPerPageRef\" position=\"top\" showArrow=\"false\" [topOffsetPx]=\"0\" [leftOffsetPx]=\"0\" [showByClick]=\"true\">\r\n\t\t\t\t<table class=\"table-borderless table-sm table-hover\" style=\"min-width: 150px;\">\r\n\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('Auto')\"><td>Auto</td></tr>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('25')\"><td>25</td></tr>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('50')\"><td>50</td></tr>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('100')\"><td>100</td></tr>\r\n\t\t\t\t\t</tbody>\r\n\t\t\t\t</table>\r\n\t\t\t</slick-popover>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n<slick-dialog #columnSelectDialogRef header=\"Select Columns\">\r\n\t<div style=\"text-align: center; width: 475px;\" class=\"mx-5\">\r\n\t\t<div class=\"d-flex\">\r\n\t\t\t<div class=\"flex-fill\">\r\n\t\t\t\t<slick-drop-down [items]=\"favorites\"\r\n\t\t\t\t\t\t\t\t [ngModel]=\"selectedFavorite\"\r\n\t\t\t\t\t\t\t\t (onSelect)=\"loadFavorite($event)\"></slick-drop-down>\r\n\t\t\t</div>\r\n\t\t\t<div><button class=\"btn btn-outline-primary ml-1\" (click)=\"addNewFavorite()\"><i class=\"far fa-plus\"></i></button></div>\r\n\t\t</div>\r\n\t\t<div class=\"d-flex flex-column mt-1\" slick-drop-list (onSlickDropListReorder)=\"onColumnReorder($event)\">\r\n\t\t\t<div *ngFor=\"let column of columnSelectDialogColumns\" class=\"d-flex\" slick-drop-list-item>\r\n\t\t\t\t<div style=\"width: 20px\"><input type=\"checkbox\" style=\"position: relative; top: 2px;\" [(ngModel)]=\"column.visible\" /></div>\r\n\t\t\t\t<div class=\"py-0 flex-fill\" style=\"text-align: left; cursor: ns-resize\" slick-drop-list-grab>{{column.title}}</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<slick-dialog-footer>\r\n\t\t<div style=\"margin-top: 10px;\" class=\"col-12 text-center mb-2 mt-1\">\r\n\t\t\t<button type=\"button\" (click)=\"onSaveColumns()\" class=\"btn btn-outline-primary mr-1\"><i class=\"far fa-save\"></i>&nbsp;Save</button>&nbsp;\r\n\t\t\t<button type=\"button\" class=\"btn btn-outline-danger\" (click)=\"onCancelColumns()\">Cancel</button>\r\n\t\t</div>\r\n\t</slick-dialog-footer>\r\n</slick-dialog>\r\n\r\n\r\n<slick-confirm-dialog #addNewFavoriteDialogRef width=\"300\">\r\n\t<label>Enter new favorite name</label>\r\n\t<input type=\"text\" class=\"form-control mx-3\" style=\"width: 250px\" [(ngModel)]=\"newFavoriteText\" />\r\n</slick-confirm-dialog>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: SlickConfirmDialogComponent, selector: "slick-confirm-dialog", inputs: ["width", "okButtonText", "cancelButtonText", "showOkButton", "showCancelButton"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickPopoverComponent, selector: "slick-popover", inputs: ["element", "position", "hoverDelay", "outDelay", "alignment", "topOffsetPx", "leftOffsetPx", "whiteBackground", "showByClick", "showArrow"] }, { kind: "component", type: SlickDialogComponent, selector: "slick-dialog", inputs: ["draggable", "resizable", "minimizable", "header", "showHeader", "noPadding", "top", "width", "height", "maxHeight", "cssClass", "key", "showOverlay", "disableScrollbar"], outputs: ["onClose"] }, { kind: "component", type: SlickDialogFooterComponent, selector: "slick-dialog-footer" }, { kind: "component", type: SlickDropDownComponent, selector: "slick-drop-down", inputs: ["placeholder", "items", "idFieldName", "textFieldName", "compact", "disabled", "allowEmpty", "getUrl", "width", "listWidth", "height", "showLoadingMessage", "showDebug", "tabindex", "validationIndicator", "validationIndicatorType", "attachTo", "searchType", "appendButtons", "prependButtons", "isMobile", "cssClass"], outputs: ["onExpand", "onSelect", "onChange"] }, { kind: "directive", type: SlickDropListDirective, selector: "[slick-drop-list]", outputs: ["onSlickDropListReorder", "onSlickDropListEnter", "onSlickDropListLeave"] }, { kind: "directive", type: SlickDropListItemDirective, selector: "[slick-drop-list-item]" }, { kind: "directive", type: SlickDropListGrabDirective, selector: "[slick-drop-list-grab]" }, { kind: "component", type: SlickPagingComponent, selector: "slick-paging", inputs: ["pageNumber", "totalRecords", "recordsPerPage"], outputs: ["pageNumberChange", "onPageChange"] }, { kind: "pipe", type: SlickGridSanitizeHtmlPipe, name: "slickGridSanitizeHtml" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-grid', providers: [SlickGridService], template: "<div id=\"slick-grid_{{uuid}}\" class=\"slick-grid d-flex flex-column flex-fill\" style=\"position: absolute; left: 0; top: 0; right: 0; bottom: 0;\" #slickGrid>\r\n\t<div #tableContainer class=\"d-flex flex-fill\" style=\"overflow: auto\">\r\n\r\n\t\t<div>\r\n\t\t\t<table #tableRef class=\"table table-sm\" [class.table-bordered]=\"bordered\" [class.table-borderless]=\"!bordered\" [class.table-striped]=\"striped\" [class.table-hover]=\"hover\" [style.opacity]=\"gridOpacity\" style=\"margin: 0; padding: 0;\" (keydown)=\"tableKeydown($event)\" tabindex=\"0\">\r\n\t\t\t\t<thead>\r\n\t\t\t\t\t<tr #tableHeaderRow (mousemove)=\"onColResizeMousemove($event)\" [ngClass]=\"{ 'resizing': isResizing === true }\">\r\n\t\t\t\t\t\t<td *ngFor=\"let column of visibleColumns; let idx = index\" [style.width]=\"column.width\" [style.maxWidth]=\"column.width\" [style.height]=\"column.titleHeight\">\r\n\t\t\t\t\t\t\t<div [ngClass]=\"{ 'slick-grid_title-vertical' : column.titleOrientation === 1 }\">\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"idx > 0 && idx < visibleColumns.length\" class=\"resize_column_left\" [class.table-bordered]=\"bordered\" (mousedown)=\"onColResizeMousedown($event, idx - 1)\" (dblclick)=\"onColResizeDoubleclick($event, idx - 1)\"></div>\r\n\t\t\t\t\t\t\t\t<span class=\"sortIcon\" *ngIf=\"column.sortable === true && column.sortDirection > 0\"><i class=\"far\" [ngClass]=\"{'fa-caret-up': column.sortDirection === 1, 'fa-caret-down': column.sortDirection === 2}\"></i>&nbsp;</span>\r\n\t\t\t\t\t\t\t\t<a href=\"javascript:void(0)\" *ngIf=\"column.sortable === true\" (click)=\"sortBy(column)\" draggable=\"false\" title=\"{{column.title}}\">{{column.title}}</a>\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"column.sortable === false\" title=\"{{column.title}}\">{{column.title}}</div>\r\n\t\t\t\t\t\t\t\t<div class=\"resize_column_right\" (mousedown)=\"onColResizeMousedown($event, idx)\" (dblclick)=\"onColResizeDoubleclick($event, idx)\"></div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t\t<tr #tableHeaderSearchRow *ngIf=\"showSearchRow === true\">\r\n\t\t\t\t\t\t<td *ngFor=\"let column of visibleColumns\">\r\n\t\t\t\t\t\t\t<div class=\"slick-grid_search-column\">\r\n\t\t\t\t\t\t\t\t<i *ngIf=\"column.isFiltering\" class=\"fas fa-times-circle bg-white text-danger mr-1\" (click)=\"resetFilter(column)\"></i>\r\n\t\t\t\t\t\t\t\t<i *ngIf=\"column.isFiltering && column.isLocked\" class=\"far fa-lock mr-1\" (click)=\"toggleLock(column)\"></i>\r\n\t\t\t\t\t\t\t\t<i *ngIf=\"column.isFiltering && !column.isLocked\" class=\"far fa-lock-open mr-1\" (click)=\"toggleLock(column)\"></i>\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"column.filterType === 1\" class=\"slick-grid_text-search\">\r\n\t\t\t\t\t\t\t\t\t<input autocomplete=\"nope\" type=\"text\" class=\"form-control\" [(ngModel)]=\"column.filterText\" name=\"searchText\" placeholder=\"Search...\" (keydown)=\"onSearch(column)\" />\r\n\t\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t\t<div *ngIf=\"column.filterType === 2\" class=\"input-group slick-grid_drop-down-search\">\r\n\t\t\t\t\t\t\t\t\t<slick-drop-down [items]=\"column.filterDropdownValues\" [(ngModel)]=\"column.filterDropdownValue\" listWidth=\"auto\" placeholder=\"Search...\" (onSelect)=\"onSearchSelect($event, column)\"></slick-drop-down>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</thead>\r\n\r\n\t\t\t\t<tbody>\r\n\t\t\t\t\t<tr *ngIf=\"loaded && visibleData.length === 0\"><td [colSpan]=\"visibleColumns.length\">No Data</td></tr>\r\n\t\t\t\t\t<tr *ngFor=\"let rowData of visibleData; let idx = index\" #tableBodyRows (click)=\"onRowClicked(rowData, idx)\" (dblclick)=\"onRowDoubleClicked(rowData, idx)\" (contextmenu)=\"onRowContextMenuClicked($event, rowData, idx)\" [class.table-success]=\"selectedIndex === idx\">\r\n\t\t\t\t\t\t<td *ngFor=\"let column of visibleColumns\">\r\n\t\t\t\t\t\t\t<div *ngIf=\"!column.columnKey\" class=\"slick-grid_column-content\" [style.width]=\"column.width\" [style.maxWidth]=\"column.width\" [innerHTML]=\"getColumnHTML(rowData, column.dataFieldName) | slickGridSanitizeHtml\"></div>\r\n\t\t\t\t\t\t\t<div *ngIf=\"column.columnKey\" class=\"slick-grid_column-content\" [style.width]=\"column.width\" [style.maxWidth]=\"column.width\">\r\n\t\t\t\t\t\t\t\t<ng-container *ngTemplateOutlet=\"templateRefs[column.columnKey], context: { $implicit: rowData }\">\r\n\t\t\t\t\t\t\t\t</ng-container>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</td>\r\n\t\t\t\t\t</tr>\r\n\t\t\t\t</tbody>\r\n\t\t\t</table>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\r\n\t<div class=\"slick-grid-footer mt-2 d-flex\">\r\n\t\t<div>\r\n\t\t\t<button type=\"button\" (click)=\"openColumnSelectDialog()\" class=\"btn btn-outline-primary\"><i class=\"far fa-columns\"></i></button>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"favorites?.length > 1\">\r\n\t\t\t<button #favoriteSelectRef type=\"button\" class=\"btn btn-outline-primary ml-1\"><i class=\"far fa-star\"></i> {{this.selectedFavorite}}</button>\r\n\t\t\t<slick-popover [element]=\"favoriteSelectRef\" position=\"top\" showArrow=\"false\" [topOffsetPx]=\"0\" [leftOffsetPx]=\"0\" [showByClick]=\"true\">\r\n\t\t\t\t<table class=\"table-borderless table-sm table-hover\" style=\"min-width: 250px; cursor: default\">\r\n\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t<tr *ngFor=\"let favorite of favorites\" (click)=\"setFavorite(favorite.text)\">\r\n\t\t\t\t\t\t\t<td><i *ngIf=\"favorite.text === selectedFavorite\" class=\"far fa-star mr-1\"></i>{{favorite.text}}</td>\r\n\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t</tbody>\r\n\t\t\t\t</table>\r\n\t\t\t</slick-popover>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"showingAllRecords == false\">\r\n\t\t\t<slick-paging [(pageNumber)]=\"currentPage\" [totalRecords]=\"totalRecords\" [recordsPerPage]=\"recordsPerPage\" (onPageChange)=\"onPageChange($event)\"></slick-paging>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"showingAllRecords == false\" class=\"ml-1\">\r\n\t\t\t<button #recordsPerPageRef type=\"button\" class=\"btn btn-outline-primary\">{{recordsPerPageValue}}&nbsp;&nbsp;<i style=\"font-size: 12px\" class=\"far fa-chevron-down\"></i></button>\r\n\r\n\t\t\t<slick-popover [element]=\"recordsPerPageRef\" position=\"top\" showArrow=\"false\" [topOffsetPx]=\"0\" [leftOffsetPx]=\"0\" [showByClick]=\"true\">\r\n\t\t\t\t<table class=\"table-borderless table-sm table-hover\" style=\"min-width: 150px;\">\r\n\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('Auto')\"><td>Auto</td></tr>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('25')\"><td>25</td></tr>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('50')\"><td>50</td></tr>\r\n\t\t\t\t\t\t<tr (click)=\"onRecordsPerPageSelected('100')\"><td>100</td></tr>\r\n\t\t\t\t\t</tbody>\r\n\t\t\t\t</table>\r\n\t\t\t</slick-popover>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n<slick-dialog #columnSelectDialogRef header=\"Select Columns\">\r\n\t<div style=\"text-align: center; width: 475px;\" class=\"mx-5\">\r\n\t\t<div class=\"d-flex\">\r\n\t\t\t<div class=\"flex-fill\">\r\n\t\t\t\t<slick-drop-down [items]=\"favorites\"\r\n\t\t\t\t\t\t\t\t [ngModel]=\"selectedFavorite\"\r\n\t\t\t\t\t\t\t\t (onSelect)=\"loadFavorite($event)\"></slick-drop-down>\r\n\t\t\t</div>\r\n\t\t\t<div><button class=\"btn btn-outline-primary ml-1\" (click)=\"addNewFavorite()\"><i class=\"far fa-plus\"></i></button></div>\r\n\t\t</div>\r\n\t\t<div class=\"d-flex flex-column mt-1\" slick-drop-list (onSlickDropListReorder)=\"onColumnReorder($event)\">\r\n\t\t\t<div *ngFor=\"let column of columnSelectDialogColumns\" class=\"d-flex\" slick-drop-list-item>\r\n\t\t\t\t<div style=\"width: 20px\"><input type=\"checkbox\" style=\"position: relative; top: 2px;\" [(ngModel)]=\"column.visible\" /></div>\r\n\t\t\t\t<div class=\"py-0 flex-fill\" style=\"text-align: left; cursor: ns-resize\" slick-drop-list-grab>{{column.title}}</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<slick-dialog-footer>\r\n\t\t<div style=\"margin-top: 10px;\" class=\"col-12 text-center mb-2 mt-1\">\r\n\t\t\t<button type=\"button\" (click)=\"onSaveColumns()\" class=\"btn btn-outline-primary mr-1\"><i class=\"far fa-save\"></i>&nbsp;Save</button>&nbsp;\r\n\t\t\t<button type=\"button\" class=\"btn btn-outline-danger\" (click)=\"onCancelColumns()\">Cancel</button>\r\n\t\t</div>\r\n\t</slick-dialog-footer>\r\n</slick-dialog>\r\n\r\n\r\n<slick-confirm-dialog #addNewFavoriteDialogRef width=\"300\">\r\n\t<label>Enter new favorite name</label>\r\n\t<input type=\"text\" class=\"form-control mx-3\" style=\"width: 250px\" [(ngModel)]=\"newFavoriteText\" />\r\n</slick-confirm-dialog>" }]
        }], ctorParameters: function () { return [{ type: SlickGridService }, { type: SlickFunctionLockService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { flexColumn: [{
                type: HostBinding,
                args: ['class']
            }], gridOptions: [{
                type: Input
            }], bordered: [{
                type: Input
            }], striped: [{
                type: Input
            }], hover: [{
                type: Input
            }], showingAllRecords: [{
                type: Input
            }], data: [{
                type: Input
            }], onRowSelected: [{
                type: Output
            }], onRowDoubleClick: [{
                type: Output
            }], onRowContextMenu: [{
                type: Output
            }], onFavoritesModified: [{
                type: Output
            }], slickGridRef: [{
                type: ViewChild,
                args: ["slickGrid", { static: true }]
            }], tableContainerRef: [{
                type: ViewChild,
                args: ["tableContainer"]
            }], tableRef: [{
                type: ViewChild,
                args: ["tableRef"]
            }], tableHeaderRowRef: [{
                type: ViewChild,
                args: ["tableHeaderRow"]
            }], tableHeaderSearchRowRef: [{
                type: ViewChild,
                args: ["tableHeaderSearchRow"]
            }], testRowRef: [{
                type: ViewChild,
                args: ["testRow"]
            }], tableBodyRowsRef: [{
                type: ViewChild,
                args: ["tableBodyRows"]
            }], columnSelectDialogRef: [{
                type: ViewChild,
                args: ["columnSelectDialogRef"]
            }], addNewFavoriteDialogRef: [{
                type: ViewChild,
                args: ["addNewFavoriteDialogRef"]
            }], slickGridColumnTemplates: [{
                type: ContentChildren,
                args: [SlickGridColumnTemplateDirective]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event', '$event.target']]
            }] } });

class SlickGridOptions {
    constructor() {
        this.bordered = null;
        this.striped = null;
        this.hover = null;
        this.autoSelectFirstRow = true;
        this.columns = [];
        this.httpHeaders = new HttpHeaders();
    }
}

class SlickPagingModule {
}
/** @nocollapse */ SlickPagingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPagingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickPagingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickPagingModule, declarations: [SlickPagingComponent], imports: [CommonModule], exports: [SlickPagingComponent] });
/** @nocollapse */ SlickPagingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPagingModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPagingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickPagingComponent],
                    exports: [SlickPagingComponent]
                }]
        }] });

class SlickOrderedListComponent {
    constructor() {
        this.itemsChange = new EventEmitter();
        this.selectedItemsChange = new EventEmitter();
        this.buttonAlignment = "left";
        this.internalItems = [];
        this.anySelected = false;
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.uuid = SlickUtilsService.newGuid();
    }
    ngOnInit() {
        document.addEventListener("click", this.fnDocumentClick, true);
    }
    ngOnDestroy() {
        document.removeEventListener("click", this.fnDocumentClick, true);
    }
    documentClick(e) {
        if (e.target && SlickUtilsService.checkParentIdExists(e.target, "slick-ordered-list_" + this.uuid))
            return;
        // If we're using this in the picklist, don't do anything
        if (e.target && SlickUtilsService.checkParentClassExists(e.target, "slick-pick-list_buttons"))
            return;
        this.internalItems.forEach(item => item.selected = false);
        this.anySelected = false;
        if (this.selectedItemsChange)
            this.selectedItemsChange.emit(null);
    }
    async ngOnChanges(changes) {
        if (!this.items || !this.sortOrderFieldName || !this.displayFieldName)
            return;
        if (changes.items) {
            this.internalItems = [];
            this.sortList();
            let sortOrder = 0;
            this.items.forEach(item => {
                if (!item.uuid)
                    item.uuid = SlickUtilsService.newGuid();
                if (item)
                    SlickUtilsService.setDeepObject(item, this.sortOrderFieldName, sortOrder);
                this.internalItems.push({
                    uuid: item.uuid,
                    sortOrder: sortOrder,
                    selected: false,
                    text: SlickUtilsService.getDeepObject(item, this.displayFieldName)
                });
                sortOrder++;
            });
            this.anySelected = false;
        }
    }
    selectItem(e, item) {
        if (e.ctrlKey) {
            item.selected = !item.selected;
        }
        else if (e.shiftKey) {
            let selectedItemIdx = this.internalItems.findIndex(internalItem => item.uuid === internalItem.uuid);
            this.internalItems[selectedItemIdx].selected = !this.internalItems[selectedItemIdx].selected;
            // Check to see if there is a selected item previously in the list.  This will be the default
            // For example, if the 2nd item has been selected, then they shift-select the 5th item, iterate backwards through
            // the list until we find the 2nd item, which is flagged as selected.  Then mark everything from the 2nd-5th as selected.
            let prevSelectedIndex = selectedItemIdx;
            do {
                prevSelectedIndex--;
            } while (prevSelectedIndex >= 0 && this.internalItems[prevSelectedIndex].selected === false);
            if (prevSelectedIndex >= 0) {
                for (let i = prevSelectedIndex; i <= selectedItemIdx; i++)
                    this.internalItems[i].selected = true;
            }
            else {
                // Check to see if we're going bottom->top select
                // For example, if the 5th item has been selected, then they shift-select the 2nd item, iterate forwards through
                // the list until we find the 5th item, which is flagged as selected.  Then mark everything from the 2nd-5th as selected.
                let nextSelectedIndex = selectedItemIdx;
                do {
                    nextSelectedIndex++;
                } while (nextSelectedIndex <= this.internalItems.length && this.internalItems[nextSelectedIndex].selected === false);
                if (nextSelectedIndex <= this.internalItems.length) {
                    for (let i = selectedItemIdx; i <= nextSelectedIndex; i++)
                        this.internalItems[i].selected = true;
                }
            }
        }
        else {
            this.internalItems.forEach(item => item.selected = false);
            item.selected = true;
        }
        this.anySelected = false;
        let selectedItems = [];
        this.internalItems.forEach(item => {
            if (item.selected === true)
                selectedItems.push(item);
            this.anySelected = (this.anySelected === true || item.selected === true);
        });
        if (this.selectedItemsChange)
            this.selectedItemsChange.emit((selectedItems.length > 0) ? selectedItems : null);
    }
    moveTop() {
        let uuidsToMove = this.internalItems.filter(item => item.selected === true).map(item => item.uuid);
        let topArray = [];
        uuidsToMove.forEach((uuid, idx) => {
            let itemIdx = this.internalItems.findIndex(item => item.uuid === uuid);
            let temp = this.internalItems.splice(itemIdx, 1);
            topArray.push(temp[0]);
        });
        this.internalItems = topArray.concat(this.internalItems);
        this.internalItems.forEach((internalItem, idx) => {
            internalItem.sortOrder = idx;
            let item = this.items.find(item => item.uuid === internalItem.uuid);
            SlickUtilsService.setDeepObject(item, this.sortOrderFieldName, idx);
        });
        this.sortList();
    }
    moveUp() {
        let newArray = [];
        this.internalItems.forEach(x => x.sortOrder *= 10);
        this.internalItems.forEach((internalItem, idx) => {
            if (internalItem.selected === true)
                internalItem.sortOrder -= 11;
        });
        this.internalItems = this.internalItems.sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : (a.sortOrder < b.sortOrder) ? -1 : 0);
        this.internalItems.forEach((internalItem, idx) => {
            internalItem.sortOrder = idx;
            let item = this.items.find(item => item.uuid === internalItem.uuid);
            SlickUtilsService.setDeepObject(item, this.sortOrderFieldName, idx);
        });
        this.sortList();
    }
    moveDown() {
        let newArray = [];
        this.internalItems.forEach(x => x.sortOrder *= 10);
        this.internalItems.forEach((internalItem, idx) => {
            if (internalItem.selected === true)
                internalItem.sortOrder += 11;
        });
        this.internalItems = this.internalItems.sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : (a.sortOrder < b.sortOrder) ? -1 : 0);
        this.internalItems.forEach((internalItem, idx) => {
            internalItem.sortOrder = idx;
            let item = this.items.find(item => item.uuid === internalItem.uuid);
            SlickUtilsService.setDeepObject(item, this.sortOrderFieldName, idx);
        });
        this.sortList();
    }
    moveBottom() {
        let uuidsToMove = this.internalItems.filter(item => item.selected === true).map(item => item.uuid);
        let bottomArray = [];
        uuidsToMove.forEach((uuid, idx) => {
            let itemIdx = this.internalItems.findIndex(item => item.uuid === uuid);
            let temp = this.internalItems.splice(itemIdx, 1);
            bottomArray.push(temp[0]);
        });
        this.internalItems = this.internalItems.concat(bottomArray);
        this.internalItems.forEach((internalItem, idx) => {
            internalItem.sortOrder = idx;
            let item = this.items.find(item => item.uuid === internalItem.uuid);
            SlickUtilsService.setDeepObject(item, this.sortOrderFieldName, idx);
        });
        this.sortList();
    }
    sortList() {
        if (this.items) {
            this.items = this.items.sort((a, b) => {
                let val1 = SlickUtilsService.getDeepObject(a, this.sortOrderFieldName);
                let val2 = SlickUtilsService.getDeepObject(b, this.sortOrderFieldName);
                if (val1 < val2)
                    return -1;
                else if (val1 > val2)
                    return 1;
                else
                    return 0;
            });
        }
        this.items.forEach((item, idx) => SlickUtilsService.setDeepObject(item, this.sortOrderFieldName, idx));
        this.itemsChange.emit(this.items);
    }
}
/** @nocollapse */ SlickOrderedListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickOrderedListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickOrderedListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickOrderedListComponent, selector: "slick-ordered-list", inputs: { items: "items", title: "title", sortOrderFieldName: "sortOrderFieldName", displayFieldName: "displayFieldName", buttonAlignment: "buttonAlignment" }, outputs: { itemsChange: "itemsChange", selectedItemsChange: "selectedItemsChange" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-ordered-list\" id=\"slick-ordered-list_{{uuid}}\">\r\n\t<div *ngIf=\"buttonAlignment === 'left'\" class=\"slick-ordered-list_buttons\">\r\n\t\t<span *ngIf=\"title\"><br /></span>\r\n\t\t<button type=\"button\" class=\"move-top btn btn-outline-primary\" (click)=\"moveTop()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveUp()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveDown()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-down\"></i></button>\r\n\t\t<button type=\"button\" class=\"move-bottom btn btn-outline-primary\" (click)=\"moveBottom()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-down\"></i></button>\r\n\t</div>\r\n\t<div class=\"slick-ordered-list_list-items\">\r\n\t\t{{title}}<br />\r\n\t\t<ul class=\"dropdown-menu\">\r\n\t\t\t<li *ngFor=\"let item of internalItems\" class=\"dropdown-item\" style=\"cursor: pointer;\" [ngClass]=\"{'active': item.selected}\" (click)=\"selectItem($event, item)\">{{item.text}}</li>\r\n\t\t\t<li *ngIf=\"!internalItems || internalItems.length === 0\" class=\"slick-ordered-list_no-items list-group-item\">No Items</li>\r\n\t\t</ul>\r\n\r\n\t</div>\r\n\t<div *ngIf=\"buttonAlignment === 'right'\" class=\"slick-ordered-list_buttons\">\r\n\t\t<span *ngIf=\"title\"><br /></span>\r\n\t\t<button type=\"button\" class=\"move-top btn btn-outline-primary\" (click)=\"moveTop()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveUp()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveDown()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-down\"></i></button>\r\n\t\t<button type=\"button\" class=\"move-bottom btn btn-outline-primary\" (click)=\"moveBottom()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-down\"></i></button>\r\n\t</div>\r\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickOrderedListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-ordered-list', template: "<div class=\"slick-ordered-list\" id=\"slick-ordered-list_{{uuid}}\">\r\n\t<div *ngIf=\"buttonAlignment === 'left'\" class=\"slick-ordered-list_buttons\">\r\n\t\t<span *ngIf=\"title\"><br /></span>\r\n\t\t<button type=\"button\" class=\"move-top btn btn-outline-primary\" (click)=\"moveTop()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveUp()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveDown()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-down\"></i></button>\r\n\t\t<button type=\"button\" class=\"move-bottom btn btn-outline-primary\" (click)=\"moveBottom()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-down\"></i></button>\r\n\t</div>\r\n\t<div class=\"slick-ordered-list_list-items\">\r\n\t\t{{title}}<br />\r\n\t\t<ul class=\"dropdown-menu\">\r\n\t\t\t<li *ngFor=\"let item of internalItems\" class=\"dropdown-item\" style=\"cursor: pointer;\" [ngClass]=\"{'active': item.selected}\" (click)=\"selectItem($event, item)\">{{item.text}}</li>\r\n\t\t\t<li *ngIf=\"!internalItems || internalItems.length === 0\" class=\"slick-ordered-list_no-items list-group-item\">No Items</li>\r\n\t\t</ul>\r\n\r\n\t</div>\r\n\t<div *ngIf=\"buttonAlignment === 'right'\" class=\"slick-ordered-list_buttons\">\r\n\t\t<span *ngIf=\"title\"><br /></span>\r\n\t\t<button type=\"button\" class=\"move-top btn btn-outline-primary\" (click)=\"moveTop()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveUp()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-up\"></i></button>\r\n\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"moveDown()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-down\"></i></button>\r\n\t\t<button type=\"button\" class=\"move-bottom btn btn-outline-primary\" (click)=\"moveBottom()\" [disabled]=\"anySelected === false\"><i class=\"far fa-chevron-double-down\"></i></button>\r\n\t</div>\r\n</div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { items: [{
                type: Input
            }], itemsChange: [{
                type: Output
            }], title: [{
                type: Input
            }], selectedItemsChange: [{
                type: Output
            }], sortOrderFieldName: [{
                type: Input
            }], displayFieldName: [{
                type: Input
            }], buttonAlignment: [{
                type: Input
            }] } });

class SlickPickListComponent {
    constructor() {
        this.leftItemsChange = new EventEmitter();
        this.rightItemsChange = new EventEmitter();
        this.leftAnySelected = false;
        this.rightAnySelected = false;
        this.leftSelectedItems = [];
        this.rightSelectedItems = [];
        this.uuid = SlickUtilsService.newGuid();
    }
    onLeftSelectedItemsChange(selectedItems) {
        this.leftSelectedItems = selectedItems || [];
        this.leftAnySelected = (this.leftSelectedItems.length > 0);
        this.rightAnySelected = (this.rightSelectedItems.length > 0);
    }
    onRightSelectedItemsChange(selectedItems) {
        this.rightSelectedItems = selectedItems || [];
        this.leftAnySelected = (this.leftSelectedItems.length > 0);
        this.rightAnySelected = (this.rightSelectedItems.length > 0);
    }
    moveLeft() {
        let rightSelectedUuids = this.rightSelectedItems.map(item => item.uuid);
        rightSelectedUuids.forEach(uuid => {
            let itemIndex = this.rightItems.findIndex(i => i.uuid === uuid);
            let item = this.rightItems.splice(itemIndex, 1)[0];
            this.leftItems.push(item);
        });
        // Angular ngOnChange only works on reference detection.  This will create a new array with a new ref
        this.leftItems = this.leftItems.slice();
        this.rightItems = this.rightItems.slice();
        this.rightSelectedItems = [];
        if (this.leftItemsChange)
            this.leftItemsChange.emit(this.leftItems);
        if (this.rightItemsChange)
            this.rightItemsChange.emit(this.rightItems);
        this.leftAnySelected = false;
        this.rightAnySelected = false;
    }
    moveRight() {
        let leftSelectedUuids = this.leftSelectedItems.map(item => item.uuid);
        leftSelectedUuids.forEach(uuid => {
            let itemIndex = this.leftItems.findIndex(i => i.uuid === uuid);
            let item = this.leftItems.splice(itemIndex, 1)[0];
            this.rightItems.push(item);
        });
        // Angular ngOnChange only works on reference detection.  This will create a new array with a new ref
        this.rightItems = this.rightItems.slice();
        this.leftItems = this.leftItems.slice();
        this.leftSelectedItems = [];
        if (this.leftItemsChange)
            this.leftItemsChange.emit(this.leftItems);
        if (this.rightItemsChange)
            this.rightItemsChange.emit(this.rightItems);
        this.leftAnySelected = false;
        this.rightAnySelected = false;
    }
}
/** @nocollapse */ SlickPickListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPickListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickPickListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickPickListComponent, selector: "slick-pick-list", inputs: { leftItems: "leftItems", leftTitle: "leftTitle", rightItems: "rightItems", rightTitle: "rightTitle", sortOrderFieldName: "sortOrderFieldName", displayFieldName: "displayFieldName" }, outputs: { leftItemsChange: "leftItemsChange", rightItemsChange: "rightItemsChange" }, ngImport: i0, template: "<div class=\"slick-pick-list\" id=\"slick-pick-list_{{uuid}}\">\r\n\t<div class=\"slick-pick-list_left\">\r\n\t\t<slick-ordered-list [(items)]=\"leftItems\" [title]=\"leftTitle\" (selectedItemsChange)=\"onLeftSelectedItemsChange($event)\" [sortOrderFieldName]=\"sortOrderFieldName\" [displayFieldName]=\"displayFieldName\"></slick-ordered-list>\r\n\t</div>\r\n\t<div class=\"slick-pick-list_buttons\">\r\n\t\t<button type=\"button\" class=\"moveLeft btn btn-outline-primary\" (click)=\"moveLeft()\" [disabled]=\"rightAnySelected === false\"><i class=\"far fa-chevron-double-left\"></i></button>\r\n\t\t<button type=\"button\" class=\"moveRight btn btn-outline-primary\" (click)=\"moveRight()\" [disabled]=\"leftAnySelected === false\"><i class=\"far fa-chevron-double-right\"></i></button>\r\n\t</div>\r\n\t<div class=\"slick-pick-list_right\">\r\n\t\t<slick-ordered-list [(items)]=\"rightItems\" [title]=\"rightTitle\" (selectedItemsChange)=\"onRightSelectedItemsChange($event)\" [sortOrderFieldName]=\"sortOrderFieldName\" [displayFieldName]=\"displayFieldName\" buttonAlignment=\"right\"></slick-ordered-list>\r\n\t</div>\r\n\t<br />\r\n</div>", dependencies: [{ kind: "component", type: SlickOrderedListComponent, selector: "slick-ordered-list", inputs: ["items", "title", "sortOrderFieldName", "displayFieldName", "buttonAlignment"], outputs: ["itemsChange", "selectedItemsChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPickListComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-pick-list", template: "<div class=\"slick-pick-list\" id=\"slick-pick-list_{{uuid}}\">\r\n\t<div class=\"slick-pick-list_left\">\r\n\t\t<slick-ordered-list [(items)]=\"leftItems\" [title]=\"leftTitle\" (selectedItemsChange)=\"onLeftSelectedItemsChange($event)\" [sortOrderFieldName]=\"sortOrderFieldName\" [displayFieldName]=\"displayFieldName\"></slick-ordered-list>\r\n\t</div>\r\n\t<div class=\"slick-pick-list_buttons\">\r\n\t\t<button type=\"button\" class=\"moveLeft btn btn-outline-primary\" (click)=\"moveLeft()\" [disabled]=\"rightAnySelected === false\"><i class=\"far fa-chevron-double-left\"></i></button>\r\n\t\t<button type=\"button\" class=\"moveRight btn btn-outline-primary\" (click)=\"moveRight()\" [disabled]=\"leftAnySelected === false\"><i class=\"far fa-chevron-double-right\"></i></button>\r\n\t</div>\r\n\t<div class=\"slick-pick-list_right\">\r\n\t\t<slick-ordered-list [(items)]=\"rightItems\" [title]=\"rightTitle\" (selectedItemsChange)=\"onRightSelectedItemsChange($event)\" [sortOrderFieldName]=\"sortOrderFieldName\" [displayFieldName]=\"displayFieldName\" buttonAlignment=\"right\"></slick-ordered-list>\r\n\t</div>\r\n\t<br />\r\n</div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { leftItems: [{
                type: Input
            }], leftItemsChange: [{
                type: Output
            }], leftTitle: [{
                type: Input
            }], rightItems: [{
                type: Input
            }], rightItemsChange: [{
                type: Output
            }], rightTitle: [{
                type: Input
            }], sortOrderFieldName: [{
                type: Input
            }], displayFieldName: [{
                type: Input
            }] } });

class SlickOrderedListModule {
}
/** @nocollapse */ SlickOrderedListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickOrderedListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickOrderedListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickOrderedListModule, declarations: [SlickOrderedListComponent], imports: [CommonModule, FormsModule], exports: [CommonModule, FormsModule, SlickOrderedListComponent] });
/** @nocollapse */ SlickOrderedListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickOrderedListModule, imports: [CommonModule, FormsModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickOrderedListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [SlickOrderedListComponent],
                    exports: [CommonModule, FormsModule, SlickOrderedListComponent]
                }]
        }] });

class SlickPickListModule {
}
/** @nocollapse */ SlickPickListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPickListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickPickListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickPickListModule, declarations: [SlickPickListComponent], imports: [CommonModule, SlickOrderedListModule], exports: [CommonModule, SlickOrderedListModule, SlickPickListComponent] });
/** @nocollapse */ SlickPickListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPickListModule, imports: [CommonModule, SlickOrderedListModule, CommonModule, SlickOrderedListModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPickListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SlickOrderedListModule],
                    declarations: [SlickPickListComponent],
                    exports: [CommonModule, SlickOrderedListModule, SlickPickListComponent]
                }]
        }] });

class SlickPopoverModule {
}
/** @nocollapse */ SlickPopoverModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPopoverModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickPopoverModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickPopoverModule, declarations: [SlickPopoverComponent], imports: [CommonModule], exports: [CommonModule, SlickPopoverComponent] });
/** @nocollapse */ SlickPopoverModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPopoverModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickPopoverModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickPopoverComponent],
                    exports: [CommonModule, SlickPopoverComponent]
                }]
        }] });

class SlickGridModule {
}
/** @nocollapse */ SlickGridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickGridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickGridModule, declarations: [SlickGridComponent, SlickGridColumnTemplateDirective, SlickGridSanitizeHtmlPipe], imports: [CommonModule, SlickConfirmDialogModule, SlickPickListModule, SlickPopoverModule, SlickDialogModule, SlickDropDownModule, SlickDropListModule, SlickPagingModule, HttpClientModule], exports: [SlickGridComponent, SlickGridColumnTemplateDirective, SlickPickListModule, SlickDialogModule, SlickDropDownModule] });
/** @nocollapse */ SlickGridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridModule, providers: [SlickGridService, SlickFunctionLockService, SlickGridSanitizeHtmlPipe], imports: [CommonModule, SlickConfirmDialogModule, SlickPickListModule, SlickPopoverModule, SlickDialogModule, SlickDropDownModule, SlickDropListModule, SlickPagingModule, HttpClientModule, SlickPickListModule, SlickDialogModule, SlickDropDownModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickGridModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SlickConfirmDialogModule, SlickPickListModule, SlickPopoverModule, SlickDialogModule, SlickDropDownModule, SlickDropListModule, SlickPagingModule, HttpClientModule],
                    declarations: [SlickGridComponent, SlickGridColumnTemplateDirective, SlickGridSanitizeHtmlPipe],
                    exports: [SlickGridComponent, SlickGridColumnTemplateDirective, SlickPickListModule, SlickDialogModule, SlickDropDownModule],
                    providers: [SlickGridService, SlickFunctionLockService, SlickGridSanitizeHtmlPipe]
                }]
        }] });

class SlickMultiSelectService {
    getVisibleItems(items, selectedIds, idFieldName, textFieldName) {
        let foundSomeText = false;
        if (!items || items.length === 0)
            return null;
        let visibleItems = items.map((item) => {
            let id = item[idFieldName];
            if (id === null || id === undefined) {
                console.error("%c Id not found for multiSelect item.  The idFieldName is '" + idFieldName + "'.  Is this correct?", 'background: red; color: white');
                console.error("First Item: ", items[0]);
            }
            if (!selectedIds || (selectedIds.indexOf(id) === -1 && selectedIds.indexOf(id.toString()) === -1)) {
                let text = item[textFieldName];
                if (text !== null && text !== undefined)
                    foundSomeText = true;
                return {
                    id: id,
                    text: text ? text.toString() : null,
                    item: item
                };
            }
        });
        visibleItems = visibleItems.filter(x => !!x);
        if (visibleItems.length === 0)
            return null;
        if (foundSomeText === false) {
            console.error("%c Warning!  No text was found for multiSelect item.  The textFieldName is '" + textFieldName + "'.  Is this correct?", 'background: red; color: white');
            console.error("First Item: ", items[0]);
        }
        return visibleItems;
    }
    getSelectedItems(items, selectedIds, idFieldName, textFieldName) {
        let foundSomeText = false;
        if (!items || items.length === 0 || !selectedIds || selectedIds.length === 0)
            return null;
        let selectedItems = selectedIds.map((id) => {
            let item = items.find(x => x[idFieldName] == id);
            if (item === null || item === undefined) {
                console.error("%c Id not found for multiSelect item.  The idFieldName is '" + idFieldName + "'.  Is this correct?", 'background: red; color: white');
                console.error("First Item: ", items[0]);
                return null;
            }
            let text = item[textFieldName];
            if (text !== null && text !== undefined)
                foundSomeText = true;
            return {
                id: id,
                text: text ? text.toString() : null
            };
        });
        if (foundSomeText === false) {
            console.error("%c Warning!  No text was found for multiSelect item.  The textFieldName is '" + textFieldName + "'.  Is this correct?", 'background: red; color: white');
            console.error("First Item: ", items[0]);
        }
        return selectedItems;
    }
    getSelectedItem(items, selectedId) {
        if (!items || items.length === 0)
            return null;
        let selectedItem = items.find((item) => { return item.id === selectedId; });
        if (selectedItem)
            return selectedItem;
        else
            return null;
    }
    getItemIndex(items, selectedId) {
        return items.findIndex((item) => { return item.id === selectedId; });
    }
}
/** @nocollapse */ SlickMultiSelectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickMultiSelectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectService, decorators: [{
            type: Injectable
        }] });

var SlickMultiSelectSearchTypes;
(function (SlickMultiSelectSearchTypes) {
    SlickMultiSelectSearchTypes[SlickMultiSelectSearchTypes["startsWith"] = 0] = "startsWith";
    SlickMultiSelectSearchTypes[SlickMultiSelectSearchTypes["eachWord"] = 1] = "eachWord";
    SlickMultiSelectSearchTypes[SlickMultiSelectSearchTypes["any"] = 2] = "any";
})(SlickMultiSelectSearchTypes || (SlickMultiSelectSearchTypes = {}));
class SlickMultiSelectComponent {
    constructor(ngZone, slickMultiSelectService, el) {
        this.ngZone = ngZone;
        this.slickMultiSelectService = slickMultiSelectService;
        this.el = el;
        this.placeholder = '';
        this.idFieldName = "id";
        this.textFieldName = "text";
        this.disabled = false;
        this.allowEmpty = 'true';
        this.singleSelect = false;
        this.width = '100%';
        this.listWidth = '100%';
        this.height = '300px';
        this.showLoadingMessage = false;
        this.searchType = SlickMultiSelectSearchTypes.eachWord;
        this.onExpand = new EventEmitter();
        this.onCollapse = new EventEmitter();
        this.onSelect = new EventEmitter();
        // This is necessary so that the scroll and resize events can add and remove the event properly,
        // as well as getting the correct ES6 function
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.keyboardActive = false;
        this.expanded = false;
        this.filterText = '';
        this.isAndroid = ((SlickInitService.getPlatform() || '').toLowerCase() === 'android');
        this.skipClickExpand = false;
        this.propagateChange = (_) => { };
        this.uuid = SlickUtilsService.newGuid();
    }
    async ngAfterViewInit() {
        // Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
        // of a div when it expands beyond the bottom.
        this.multiSelectList.nativeElement.remove(this.multiSelectList);
        document.body.appendChild(this.multiSelectList.nativeElement);
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj)
            this.selectedIds = obj;
        else
            this.selectedIds = null;
        this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
        this.selectedItems = this.slickMultiSelectService.getSelectedItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    ngOnChanges(changes) {
        if (changes.isMobile) {
            this.isMobile = (this.isMobile.toString().toLowerCase() === 'true') ? true : false;
        }
        if (changes.singleSelect) {
            this.singleSelect = (this.singleSelect.toString().toLowerCase() === 'true') ? true : false;
        }
        if (changes.searchType) {
            if (changes.searchType.currentValue.toString().toLowerCase() === 'startswith')
                this.searchType = SlickMultiSelectSearchTypes.startsWith;
            else if (changes.searchType.currentValue.toString().toLowerCase() === 'any')
                this.searchType = SlickMultiSelectSearchTypes.any;
            else
                this.searchType = SlickMultiSelectSearchTypes.eachWord;
        }
        if (changes.items) {
            this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
            this.selectedItems = this.slickMultiSelectService.getSelectedItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
            if (this.selectedTextInputRef && document.activeElement == this.selectedTextInputRef.nativeElement)
                this.expand();
        }
    }
    ngOnDestroy() {
        this.collapse();
        document.removeEventListener("click", this.fnDocumentClick, true);
        // it's okay if this fails.  It was already removed
        try {
            document.body.removeChild(this.multiSelectList.nativeElement);
        }
        catch { }
    }
    async onKeyboardIconClicked() {
        if (this.keyboardActive === true) {
            this.collapse();
            this.keyboardActive = false;
            this.selectedText = '';
            this.selectedTextInputRef.nativeElement.value = '';
        }
        else {
            this.keyboardActive = true;
            await SlickSleepService.sleep();
            this.selectedTextInputRef.nativeElement.focus();
        }
    }
    async expand() {
        if (this.disabled)
            return;
        this.reposition();
        await SlickSleepService.sleep();
        this.multiSelectList.nativeElement.style.display = "inline-block";
        let selectedItems = this.multiSelectList.nativeElement.getElementsByClassName("selected");
        if (selectedItems && selectedItems.length > 0)
            selectedItems[0].scrollIntoView({ block: 'nearest' });
        this.expanded = true;
        // This is necessary, otherwise `this` in the reposition function will be window
        // and not the component.
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.addEventListener("click", this.fnDocumentClick, true);
        if (this.onExpand)
            this.onExpand.emit();
    }
    collapse() {
        this.expanded = false;
        this.multiSelectList.nativeElement.style.display = "none";
        // Since angular has no way to use the third parameter, I'm doing this in raw js
        document.removeEventListener("click", this.fnDocumentClick, true);
        if (this.onCollapse)
            this.onCollapse.emit();
    }
    async reposition() {
        await SlickSleepService.sleep();
        let rect = this.containerDiv.nativeElement.getBoundingClientRect();
        let containerLeft = rect.left;
        let containerTop = rect.top;
        let containerHeight = this.containerDiv.nativeElement.offsetHeight;
        let containerWidth = rect.width;
        this.width = containerWidth;
        if (this.listWidth === '100%')
            this.listGroupWidth = this.width;
        else if (this.listWidth === 'auto')
            this.listGroupWidth = "auto";
        else
            this.listGroupWidth = this.listWidth;
        this.top = (containerTop + containerHeight);
        this.left = containerLeft;
    }
    documentClick(e) {
        if (!this.expanded || !e.target)
            return;
        // If they clicked on the keyboard icon, don't do anything
        if (SlickUtilsService.checkParentClassExists(e.target, "slick-multi-select_mobile-container") &&
            SlickUtilsService.checkParentIdExists(e.target, "slick-multi-select_" + this.uuid))
            return;
        const clickedInside = SlickUtilsService.checkParentClassExists(e.target, "slick-multi-select_list-item");
        if (!clickedInside) {
            this.keyboardActive = false;
            this.selectedText = '';
            this.selectedTextInputRef.nativeElement.value = '';
            this.collapse();
        }
    }
    selectItem(id) {
        let item = this.slickMultiSelectService.getSelectedItem(this.visibleItems, id);
        if (item) {
            if (this.onSelect)
                this.onSelect.emit(item);
            if (!this.selectedIds)
                this.selectedIds = [];
            this.selectedIds.push(id);
            this.propagateChange(this.selectedIds);
            this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
            this.selectedItems = this.slickMultiSelectService.getSelectedItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
            this.reposition();
            this.selectedText = '';
            this.selectedTextInputRef.nativeElement.value = '';
            if (this.singleSelect === true)
                this.collapse();
        }
    }
    setFocus(showMobileKeyboard = false) {
        this.selectedTextInputRef.nativeElement.focus();
        if (showMobileKeyboard === true)
            this.keyboardActive = true;
    }
    async onFocus() {
        this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
        this.selectedItems = this.slickMultiSelectService.getSelectedItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
        this.filterText = '';
        this.selectedTextInputRef.nativeElement.focus();
        // This is kind of hacky, but if onFocus is called by clicking the multiSelect, the onMultiSelectClick event is called as well
        // That function will expand or collapse, depending on the state.  Since this expands, it thinks it needs to collapse.
        // So fake it out and tell it NOT to collapse.  BUT, if we came in from tabbing into the field, then it would mess up
        // the click event.  So only wait for 1/2 second.
        this.skipClickExpand = true;
        this.expand();
        await SlickSleepService.sleep(500);
        this.skipClickExpand = false;
    }
    async onKeyUp(e) {
        e.stopPropagation();
        e.preventDefault();
        // If this is android, it won't pass us any key data so just read the entire input element
        if (this.isAndroid === true) {
            await SlickSleepService.sleep();
            this.filterText = this.selectedTextInputRef.nativeElement.value;
            this.filterSearch();
            return;
        }
        // Tab/enter
        if (e.which === 9 || e.which === 13) {
            if (this.filterText && this.selectedIndex !== null && this.selectedIndex !== undefined) {
                this.selectItem(this.visibleItems[this.selectedIndex].id);
                this.filterText = '';
                this.selectedIndex = null;
                return false;
            }
            this.collapse();
            this.filterText = '';
            this.selectedText = '';
            this.selectedTextInputRef.nativeElement.value = '';
            this.selectedIndex = null;
            return true;
        }
        // Esc
        if (e.which === 27) {
            this.filterText = '';
            this.selectedText = '';
            this.selectedTextInputRef.nativeElement.value = '';
            this.collapse();
            return false;
        }
        // Backspace
        if (e.which === 8 && this.filterText) {
            this.filterText = this.filterText.substring(0, this.filterText.length - 1);
            if (this.filterText.length === 0) {
                this.selectedText = '';
                this.selectedTextInputRef.nativeElement.value = '';
                this.selectedIndex = null;
                this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
                this.selectedItems = this.slickMultiSelectService.getSelectedItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
            }
            else
                this.filterSearch();
            return false;
        }
        // Arrowup
        if (e.which === 38) {
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                this.selectedIndex = 0;
            if (this.selectedIndex > 0)
                this.selectedIndex--;
            return false;
        }
        // Arrowdown
        if (e.which === 40) {
            if (this.selectedIndex === null || this.selectedIndex === undefined)
                this.selectedIndex = -1;
            if (!this.expanded || !this.visibleItems)
                this.expand();
            if (this.selectedIndex < this.visibleItems.length - 1)
                this.selectedIndex++;
            return false;
        }
        // If F1 is pressed, key length will be 2
        if (e.key.length > 1 || e.ctrlKey || e.altKey)
            return false;
        if (e.which >= 32 && e.which <= 126) {
            this.filterText += e.key;
            this.filterSearch();
        }
        return true;
    }
    async filterSearch() {
        if (!this.expanded)
            this.expand();
        this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
        if (this.searchType === SlickMultiSelectSearchTypes.startsWith) {
            this.visibleItems = this.visibleItems.filter(x => x.text.toLowerCase().indexOf(this.filterText.toLowerCase()) === 0);
            if (this.visibleItems.length > 0) {
                this.selectedIndex = 0;
                this.selectedText = this.visibleItems[0].text;
                if (this.isAndroid === false) {
                    await SlickSleepService.sleep();
                    this.selectedTextInputRef.nativeElement.value = this.selectedText;
                    this.selectedTextInputRef.nativeElement.setSelectionRange(this.filterText.length, this.selectedText.length);
                }
            }
            else {
                this.selectedIndex = null;
                if (this.isAndroid === false) {
                    this.selectedText = this.filterText;
                    this.selectedTextInputRef.nativeElement.value = this.selectedText;
                }
            }
        }
        else if (this.searchType === SlickMultiSelectSearchTypes.eachWord) {
            this.visibleItems = this.visibleItems.filter(x => (" " + x.text.toLowerCase()).indexOf(" " + this.filterText.toLowerCase()) >= 0);
            if (this.visibleItems.length > 0) {
                this.selectedIndex = 0;
                this.selectedText = this.visibleItems[0].text;
                if (this.isAndroid === false) {
                    await SlickSleepService.sleep();
                    this.selectedTextInputRef.nativeElement.value = this.selectedText;
                    this.selectedTextInputRef.nativeElement.setSelectionRange(this.filterText.length, this.selectedText.length);
                }
            }
            else {
                this.selectedText = this.filterText;
                this.selectedIndex = null;
            }
        }
        this.reposition();
    }
    onMultiSelectClicked() {
        if (this.skipClickExpand === true) {
            this.skipClickExpand = false;
            return;
        }
        this.selectedTextInputRef.nativeElement.focus();
        if (this.expanded === false)
            this.expand();
        else
            this.collapse();
    }
    onItemClick(item) {
        this.selectItem(item.id);
        if (this.keyboardActive === true)
            this.selectedTextInputRef.nativeElement.focus();
    }
    onRemoveItem(item) {
        this.selectedIds = this.selectedIds.filter(id => id !== item.id);
        this.visibleItems = this.slickMultiSelectService.getVisibleItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
        this.selectedItems = this.slickMultiSelectService.getSelectedItems(this.items, this.selectedIds, this.idFieldName, this.textFieldName);
        this.propagateChange(this.selectedIds);
    }
}
/** @nocollapse */ SlickMultiSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectComponent, deps: [{ token: i0.NgZone }, { token: SlickMultiSelectService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickMultiSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickMultiSelectComponent, selector: "slick-multi-select", inputs: { placeholder: "placeholder", items: "items", idFieldName: "idFieldName", textFieldName: "textFieldName", disabled: "disabled", allowEmpty: "allowEmpty", singleSelect: "singleSelect", width: "width", listWidth: "listWidth", height: "height", showLoadingMessage: "showLoadingMessage", showDebug: "showDebug", tabindex: "tabindex", isMobile: "isMobile", searchType: "searchType" }, outputs: { onExpand: "onExpand", onCollapse: "onCollapse", onSelect: "onSelect" }, providers: [SlickMultiSelectService,
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickMultiSelectComponent)),
            multi: true,
        }], viewQueries: [{ propertyName: "containerDiv", first: true, predicate: ["containerDiv"], descendants: true }, { propertyName: "multiSelectList", first: true, predicate: ["multiSelectList"], descendants: true }, { propertyName: "selectedTextInputRef", first: true, predicate: ["selectedTextInputRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerDiv id=\"slick-multi-select_{{uuid}}\" attr.data-uuid=\"{{uuid}}\" class=\"slick-multi-select\" [class.mobile]=\"isMobile === true\" [class.open]=\"expanded\">\r\n\t<div class=\"slick-multi-select_input-container\">\r\n\t\t<div *ngIf=\"disabled === false\" style=\"cursor: pointer !important; flex-grow: 1;\" [ngClass]=\"{ 'slick-multi-select_mobile': isMobile === true }\" (click)=\"onMultiSelectClicked()\">\r\n\t\t\t<div *ngFor=\"let selectedItem of selectedItems\" class=\"slick-multi-select_selected-item card\"><div class=\"slick-multi-select_remove\" (click)=\"onRemoveItem(selectedItem)\"><i class=\"fas fa-times-circle bg-white text-danger\"></i></div>{{selectedItem.text}}</div>\r\n\t\t\t<input #selectedTextInputRef *ngIf=\"!isMobile\" [attr.tabindex]=\"tabindex\" [ngClass]=\"{'slick-multi-select_show-selected-text': (keyboardActive || (selectedText && selectedText.length > 0)) }\" (keyup)=\"onKeyUp($event)\" (focus)=\"onFocus()\" ng-disabled='disabled' readonly [placeholder]='placeholder' />\r\n\t\t\t<input #selectedTextInputRef *ngIf=\"isMobile === true\" [ngClass]=\"{'slick-multi-select_show-selected-text': (keyboardActive || (selectedText && selectedText.length > 0)) }\" (keyup)=\"onKeyUp($event)\" (focus)=\"onFocus()\" />\r\n\t\t</div>\r\n\t\t<div *ngIf=\"disabled === false && isMobile === true\" class=\"slick-multi-select_mobile-container\">\r\n\t\t\t<i class=\"far fa-keyboard\" style=\"cursor: pointer\" (click)=\"onKeyboardIconClicked()\"></i>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div *ngIf=\"disabled === true\" class='input-group'>\r\n\t\t<div *ngFor=\"let selectedItem of selectedItems\" class=\"slick-multi-select_selected-item card\">{{selectedItem.text}}</div>\r\n\t</div>\r\n\r\n\t<ul #multiSelectList id=\"slick-multi-select-list_{{uuid}}\" class='slick-multi-select-list-group dropdown-menu' [style.width]=\"listGroupWidth\" [style.visibility]=\"(expanded === true) ? 'visible' : 'hidden'\" [style.opacity]=\"(expanded === true) ? '1' : '0'\" [style.max-height]=\"height\" [style.width.px]=\"listGroupWidth\" [style.left.px]=\"left\" [style.top.px]=\"top\">\r\n\t\t<li *ngFor=\"let item of visibleItems; let index = index;\" (mouseover)=\"selectedIndex = index\" (click)=\"onItemClick(item)\" [class.card-header]=\"selectedIndex === index\" class=\"dropdown-item slick-multi-select_list-item\">{{item.text}}</li>\r\n\t</ul>\r\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-multi-select', providers: [SlickMultiSelectService,
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickMultiSelectComponent)),
                            multi: true,
                        }], template: "<div #containerDiv id=\"slick-multi-select_{{uuid}}\" attr.data-uuid=\"{{uuid}}\" class=\"slick-multi-select\" [class.mobile]=\"isMobile === true\" [class.open]=\"expanded\">\r\n\t<div class=\"slick-multi-select_input-container\">\r\n\t\t<div *ngIf=\"disabled === false\" style=\"cursor: pointer !important; flex-grow: 1;\" [ngClass]=\"{ 'slick-multi-select_mobile': isMobile === true }\" (click)=\"onMultiSelectClicked()\">\r\n\t\t\t<div *ngFor=\"let selectedItem of selectedItems\" class=\"slick-multi-select_selected-item card\"><div class=\"slick-multi-select_remove\" (click)=\"onRemoveItem(selectedItem)\"><i class=\"fas fa-times-circle bg-white text-danger\"></i></div>{{selectedItem.text}}</div>\r\n\t\t\t<input #selectedTextInputRef *ngIf=\"!isMobile\" [attr.tabindex]=\"tabindex\" [ngClass]=\"{'slick-multi-select_show-selected-text': (keyboardActive || (selectedText && selectedText.length > 0)) }\" (keyup)=\"onKeyUp($event)\" (focus)=\"onFocus()\" ng-disabled='disabled' readonly [placeholder]='placeholder' />\r\n\t\t\t<input #selectedTextInputRef *ngIf=\"isMobile === true\" [ngClass]=\"{'slick-multi-select_show-selected-text': (keyboardActive || (selectedText && selectedText.length > 0)) }\" (keyup)=\"onKeyUp($event)\" (focus)=\"onFocus()\" />\r\n\t\t</div>\r\n\t\t<div *ngIf=\"disabled === false && isMobile === true\" class=\"slick-multi-select_mobile-container\">\r\n\t\t\t<i class=\"far fa-keyboard\" style=\"cursor: pointer\" (click)=\"onKeyboardIconClicked()\"></i>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div *ngIf=\"disabled === true\" class='input-group'>\r\n\t\t<div *ngFor=\"let selectedItem of selectedItems\" class=\"slick-multi-select_selected-item card\">{{selectedItem.text}}</div>\r\n\t</div>\r\n\r\n\t<ul #multiSelectList id=\"slick-multi-select-list_{{uuid}}\" class='slick-multi-select-list-group dropdown-menu' [style.width]=\"listGroupWidth\" [style.visibility]=\"(expanded === true) ? 'visible' : 'hidden'\" [style.opacity]=\"(expanded === true) ? '1' : '0'\" [style.max-height]=\"height\" [style.width.px]=\"listGroupWidth\" [style.left.px]=\"left\" [style.top.px]=\"top\">\r\n\t\t<li *ngFor=\"let item of visibleItems; let index = index;\" (mouseover)=\"selectedIndex = index\" (click)=\"onItemClick(item)\" [class.card-header]=\"selectedIndex === index\" class=\"dropdown-item slick-multi-select_list-item\">{{item.text}}</li>\r\n\t</ul>\r\n</div>" }]
        }], ctorParameters: function () { return [{ type: i0.NgZone }, { type: SlickMultiSelectService }, { type: i0.ElementRef }]; }, propDecorators: { placeholder: [{
                type: Input
            }], items: [{
                type: Input
            }], idFieldName: [{
                type: Input
            }], textFieldName: [{
                type: Input
            }], disabled: [{
                type: Input
            }], allowEmpty: [{
                type: Input
            }], singleSelect: [{
                type: Input
            }], width: [{
                type: Input
            }], listWidth: [{
                type: Input
            }], height: [{
                type: Input
            }], showLoadingMessage: [{
                type: Input
            }], showDebug: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], isMobile: [{
                type: Input
            }], searchType: [{
                type: Input
            }], onExpand: [{
                type: Output
            }], onCollapse: [{
                type: Output
            }], onSelect: [{
                type: Output
            }], containerDiv: [{
                type: ViewChild,
                args: ["containerDiv"]
            }], multiSelectList: [{
                type: ViewChild,
                args: ["multiSelectList"]
            }], selectedTextInputRef: [{
                type: ViewChild,
                args: ["selectedTextInputRef"]
            }] } });

class SlickMultiSelectModule {
}
/** @nocollapse */ SlickMultiSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickMultiSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectModule, declarations: [SlickMultiSelectComponent], imports: [CommonModule, FormsModule], exports: [SlickMultiSelectComponent] });
/** @nocollapse */ SlickMultiSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectModule, imports: [CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickMultiSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [SlickMultiSelectComponent],
                    exports: [SlickMultiSelectComponent]
                }]
        }] });

const imgExtensions = ['bmp', 'gif', 'jpeg', 'jpg', 'png', 'tif', 'tiff'];
class SlickProfilePictureComponent {
    constructor() {
        this.viewOnly = false;
        this.width = "80px";
        this.height = "80px";
        this.resizeWidth = 600;
        this.resizeHeight = 600;
        this.filesChangedEmitter = new EventEmitter();
        this.fnOnFileInputChange = (e) => this.onFileInputChange(e);
        this.uuid = SlickUtilsService.newGuid();
    }
    onClick(e) {
        if (this.viewOnly === true)
            return;
        this.fileInput.nativeElement.click();
        this.fileInput.nativeElement.addEventListener("change", this.fnOnFileInputChange);
    }
    onFileInputChange(e) {
        this.processFile(this.fileInput.nativeElement.files);
    }
    onDrop(e) {
        if (this.viewOnly === true)
            return;
        e.preventDefault();
        e.stopPropagation();
        this.containerRef.nativeElement.classList.remove("slick-file-drop_drag-enter");
        this.processFile(e.dataTransfer.files);
    }
    onDragEnter(e) {
        if (this.viewOnly === true)
            return;
        this.containerRef.nativeElement.classList.add("slick-file-drop_drag-enter");
    }
    onDragOver(e) {
        if (this.viewOnly === true)
            return;
        e.preventDefault();
    }
    onDragLeave(e) {
        if (this.viewOnly === true)
            return;
        this.containerRef.nativeElement.classList.remove("slick-file-drop_drag-enter");
    }
    ngOnChanges(changes) {
        if (changes.gravatarEmailAddress) {
            var MD5 = function (s) { function L(k, d) { return (k << d) | (k >>> (32 - d)); } function K(G, k) { var I, d, F, H, x; F = (G & 2147483648); H = (k & 2147483648); I = (G & 1073741824); d = (k & 1073741824); x = (G & 1073741823) + (k & 1073741823); if (I & d) {
                return (x ^ 2147483648 ^ F ^ H);
            } if (I | d) {
                if (x & 1073741824) {
                    return (x ^ 3221225472 ^ F ^ H);
                }
                else {
                    return (x ^ 1073741824 ^ F ^ H);
                }
            }
            else {
                return (x ^ F ^ H);
            } } function r(d, F, k) { return (d & F) | ((~d) & k); } function q(d, F, k) { return (d & k) | (F & (~k)); } function p(d, F, k) { return (d ^ F ^ k); } function n(d, F, k) { return (F ^ (d | (~k))); } function u(G, F, aa, Z, k, H, I) { G = K(G, K(K(r(F, aa, Z), k), I)); return K(L(G, H), F); } function f(G, F, aa, Z, k, H, I) { G = K(G, K(K(q(F, aa, Z), k), I)); return K(L(G, H), F); } function D(G, F, aa, Z, k, H, I) { G = K(G, K(K(p(F, aa, Z), k), I)); return K(L(G, H), F); } function t(G, F, aa, Z, k, H, I) { G = K(G, K(K(n(F, aa, Z), k), I)); return K(L(G, H), F); } function e(G) { var Z; var F = G.length; var x = F + 8; var k = (x - (x % 64)) / 64; var I = (k + 1) * 16; var aa = Array(I - 1); var d = 0; var H = 0; while (H < F) {
                Z = (H - (H % 4)) / 4;
                d = (H % 4) * 8;
                aa[Z] = (aa[Z] | (G.charCodeAt(H) << d));
                H++;
            } Z = (H - (H % 4)) / 4; d = (H % 4) * 8; aa[Z] = aa[Z] | (128 << d); aa[I - 2] = F << 3; aa[I - 1] = F >>> 29; return aa; } function B(x) { var k = "", F = "", G, d; for (d = 0; d <= 3; d++) {
                G = (x >>> (d * 8)) & 255;
                F = "0" + G.toString(16);
                k = k + F.substr(F.length - 2, 2);
            } return k; } function J(k) { k = k.replace(/rn/g, "n"); var d = ""; for (var F = 0; F < k.length; F++) {
                var x = k.charCodeAt(F);
                if (x < 128) {
                    d += String.fromCharCode(x);
                }
                else {
                    if ((x > 127) && (x < 2048)) {
                        d += String.fromCharCode((x >> 6) | 192);
                        d += String.fromCharCode((x & 63) | 128);
                    }
                    else {
                        d += String.fromCharCode((x >> 12) | 224);
                        d += String.fromCharCode(((x >> 6) & 63) | 128);
                        d += String.fromCharCode((x & 63) | 128);
                    }
                }
            } return d; } var C = Array(); var P, h, E, v, g, Y, X, W, V; var S = 7, Q = 12, N = 17, M = 22; var A = 5, z = 9, y = 14, w = 20; var o = 4, m = 11, l = 16, j = 23; var U = 6, T = 10, R = 15, O = 21; s = J(s); C = e(s); Y = 1732584193; X = 4023233417; W = 2562383102; V = 271733878; for (P = 0; P < C.length; P += 16) {
                h = Y;
                E = X;
                v = W;
                g = V;
                Y = u(Y, X, W, V, C[P + 0], S, 3614090360);
                V = u(V, Y, X, W, C[P + 1], Q, 3905402710);
                W = u(W, V, Y, X, C[P + 2], N, 606105819);
                X = u(X, W, V, Y, C[P + 3], M, 3250441966);
                Y = u(Y, X, W, V, C[P + 4], S, 4118548399);
                V = u(V, Y, X, W, C[P + 5], Q, 1200080426);
                W = u(W, V, Y, X, C[P + 6], N, 2821735955);
                X = u(X, W, V, Y, C[P + 7], M, 4249261313);
                Y = u(Y, X, W, V, C[P + 8], S, 1770035416);
                V = u(V, Y, X, W, C[P + 9], Q, 2336552879);
                W = u(W, V, Y, X, C[P + 10], N, 4294925233);
                X = u(X, W, V, Y, C[P + 11], M, 2304563134);
                Y = u(Y, X, W, V, C[P + 12], S, 1804603682);
                V = u(V, Y, X, W, C[P + 13], Q, 4254626195);
                W = u(W, V, Y, X, C[P + 14], N, 2792965006);
                X = u(X, W, V, Y, C[P + 15], M, 1236535329);
                Y = f(Y, X, W, V, C[P + 1], A, 4129170786);
                V = f(V, Y, X, W, C[P + 6], z, 3225465664);
                W = f(W, V, Y, X, C[P + 11], y, 643717713);
                X = f(X, W, V, Y, C[P + 0], w, 3921069994);
                Y = f(Y, X, W, V, C[P + 5], A, 3593408605);
                V = f(V, Y, X, W, C[P + 10], z, 38016083);
                W = f(W, V, Y, X, C[P + 15], y, 3634488961);
                X = f(X, W, V, Y, C[P + 4], w, 3889429448);
                Y = f(Y, X, W, V, C[P + 9], A, 568446438);
                V = f(V, Y, X, W, C[P + 14], z, 3275163606);
                W = f(W, V, Y, X, C[P + 3], y, 4107603335);
                X = f(X, W, V, Y, C[P + 8], w, 1163531501);
                Y = f(Y, X, W, V, C[P + 13], A, 2850285829);
                V = f(V, Y, X, W, C[P + 2], z, 4243563512);
                W = f(W, V, Y, X, C[P + 7], y, 1735328473);
                X = f(X, W, V, Y, C[P + 12], w, 2368359562);
                Y = D(Y, X, W, V, C[P + 5], o, 4294588738);
                V = D(V, Y, X, W, C[P + 8], m, 2272392833);
                W = D(W, V, Y, X, C[P + 11], l, 1839030562);
                X = D(X, W, V, Y, C[P + 14], j, 4259657740);
                Y = D(Y, X, W, V, C[P + 1], o, 2763975236);
                V = D(V, Y, X, W, C[P + 4], m, 1272893353);
                W = D(W, V, Y, X, C[P + 7], l, 4139469664);
                X = D(X, W, V, Y, C[P + 10], j, 3200236656);
                Y = D(Y, X, W, V, C[P + 13], o, 681279174);
                V = D(V, Y, X, W, C[P + 0], m, 3936430074);
                W = D(W, V, Y, X, C[P + 3], l, 3572445317);
                X = D(X, W, V, Y, C[P + 6], j, 76029189);
                Y = D(Y, X, W, V, C[P + 9], o, 3654602809);
                V = D(V, Y, X, W, C[P + 12], m, 3873151461);
                W = D(W, V, Y, X, C[P + 15], l, 530742520);
                X = D(X, W, V, Y, C[P + 2], j, 3299628645);
                Y = t(Y, X, W, V, C[P + 0], U, 4096336452);
                V = t(V, Y, X, W, C[P + 7], T, 1126891415);
                W = t(W, V, Y, X, C[P + 14], R, 2878612391);
                X = t(X, W, V, Y, C[P + 5], O, 4237533241);
                Y = t(Y, X, W, V, C[P + 12], U, 1700485571);
                V = t(V, Y, X, W, C[P + 3], T, 2399980690);
                W = t(W, V, Y, X, C[P + 10], R, 4293915773);
                X = t(X, W, V, Y, C[P + 1], O, 2240044497);
                Y = t(Y, X, W, V, C[P + 8], U, 1873313359);
                V = t(V, Y, X, W, C[P + 15], T, 4264355552);
                W = t(W, V, Y, X, C[P + 6], R, 2734768916);
                X = t(X, W, V, Y, C[P + 13], O, 1309151649);
                Y = t(Y, X, W, V, C[P + 4], U, 4149444226);
                V = t(V, Y, X, W, C[P + 11], T, 3174756917);
                W = t(W, V, Y, X, C[P + 2], R, 718787259);
                X = t(X, W, V, Y, C[P + 9], O, 3951481745);
                Y = K(Y, h);
                X = K(X, E);
                W = K(W, v);
                V = K(V, g);
            } var i = B(Y) + B(X) + B(W) + B(V); return i.toLowerCase(); };
            this.gravatarEmailAddress = this.gravatarEmailAddress.trim().toLowerCase();
            this.imageSrc = 'http://www.gravatar.com/avatar/' + MD5(this.gravatarEmailAddress) + '.jpg?s=' + 80;
        }
        if (changes.viewOnly && changes.viewOnly.currentValue)
            this.viewOnly = (changes.viewOnly.currentValue.toString().toLowerCase() !== 'false');
    }
    async processFile(files) {
        if (files && files.length > 0) {
            let file = files.item(0);
            let fileNameParts = file.name.split('.');
            let ext = fileNameParts[fileNameParts.length - 1].toLowerCase();
            let fileType = file.type;
            if (imgExtensions.indexOf(ext) >= 0) {
                let img = new Image;
                img.onload = () => {
                    this.imageSrc = this.resizeImageToBase64(img, fileType, this.resizeWidth, this.resizeHeight);
                    if (this.filesChangedEmitter)
                        this.filesChangedEmitter.emit(this.imageSrc);
                };
                img.src = await this.getBase64(file);
            }
        }
    }
    resizeImageToBase64(img, fileType, width, height) {
        let scale = 1;
        if (img.width > img.height) {
            if (img.width > width)
                scale = width / img.width;
        }
        else {
            if (img.height > height)
                scale = height / img.height;
        }
        let newWidth = img.width * scale;
        let newHeight = img.height * scale;
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        // We set the dimensions at the wanted size.
        canvas.width = newWidth;
        canvas.height = newHeight;
        // We resize the image with the canvas method drawImage();
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        return canvas.toDataURL(fileType);
    }
    getBase64(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject('Error: ' + error);
        });
    }
}
/** @nocollapse */ SlickProfilePictureComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProfilePictureComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickProfilePictureComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickProfilePictureComponent, selector: "slick-profile-picture", inputs: { imageSrc: "imageSrc", gravatarEmailAddress: "gravatarEmailAddress", viewOnly: "viewOnly", width: "width", height: "height", resizeWidth: "resizeWidth", resizeHeight: "resizeHeight" }, outputs: { filesChangedEmitter: "profilePictureChanged" }, host: { listeners: { "click": "onClick($event)", "drop": "onDrop($event)", "dragenter": "onDragEnter($event)", "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)" } }, viewQueries: [{ propertyName: "containerRef", first: true, predicate: ["containerRef"], descendants: true }, { propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #containerRef id=\"slick-profile-picture_{{uuid}}\" class=\"slick-profile-picture card\" [ngClass]=\"{ 'slick-profile-picture_view-only': viewOnly === true, 'slick-profile-picture_editable': viewOnly === false }\" [ngStyle]=\"{ 'width': width, 'min-width': width, 'height': height, 'min-height': height }\">\r\n\t<div class=\"slick-profile-picture_text\" *ngIf='viewOnly === false'>Click to change...</div>\r\n\t<img class=\"slick-profile-picture_img\" *ngIf=\"imageSrc\" [src]=\"imageSrc\" [ngStyle]=\"{ 'max-width': width, 'max-height': height }\" />\r\n</div>\r\n<input type=\"file\" #fileInput style=\"display: none\" multiple />\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProfilePictureComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-profile-picture', template: "<div #containerRef id=\"slick-profile-picture_{{uuid}}\" class=\"slick-profile-picture card\" [ngClass]=\"{ 'slick-profile-picture_view-only': viewOnly === true, 'slick-profile-picture_editable': viewOnly === false }\" [ngStyle]=\"{ 'width': width, 'min-width': width, 'height': height, 'min-height': height }\">\r\n\t<div class=\"slick-profile-picture_text\" *ngIf='viewOnly === false'>Click to change...</div>\r\n\t<img class=\"slick-profile-picture_img\" *ngIf=\"imageSrc\" [src]=\"imageSrc\" [ngStyle]=\"{ 'max-width': width, 'max-height': height }\" />\r\n</div>\r\n<input type=\"file\" #fileInput style=\"display: none\" multiple />\r\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { imageSrc: [{
                type: Input,
                args: ["imageSrc"]
            }], gravatarEmailAddress: [{
                type: Input,
                args: ["gravatarEmailAddress"]
            }], viewOnly: [{
                type: Input,
                args: ["viewOnly"]
            }], width: [{
                type: Input,
                args: ["width"]
            }], height: [{
                type: Input,
                args: ["height"]
            }], resizeWidth: [{
                type: Input,
                args: ["resizeWidth"]
            }], resizeHeight: [{
                type: Input,
                args: ["resizeHeight"]
            }], filesChangedEmitter: [{
                type: Output,
                args: ["profilePictureChanged"]
            }], containerRef: [{
                type: ViewChild,
                args: ["containerRef"]
            }], fileInput: [{
                type: ViewChild,
                args: ["fileInput"]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onDrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }], onDragEnter: [{
                type: HostListener,
                args: ['dragenter', ['$event']]
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }] } });

class SlickProfilePictureModule {
}
/** @nocollapse */ SlickProfilePictureModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProfilePictureModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickProfilePictureModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickProfilePictureModule, declarations: [SlickProfilePictureComponent], imports: [CommonModule, FormsModule], exports: [CommonModule, FormsModule, SlickProfilePictureComponent] });
/** @nocollapse */ SlickProfilePictureModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProfilePictureModule, imports: [CommonModule, FormsModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProfilePictureModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule],
                    declarations: [SlickProfilePictureComponent],
                    exports: [CommonModule, FormsModule, SlickProfilePictureComponent]
                }]
        }] });

class SlickProgressBarService {
    constructor() {
        this.isVisible = false;
        this.progressPercent = 0;
    }
    setProgress(progressPercent, message) {
        if (progressPercent < 1)
            progressPercent *= 100;
        this.progressPercent = progressPercent;
        this.progressBarDiv.style.width = (progressPercent + "%");
        this.progressBarTextDiv.innerHTML = message;
    }
    show(initialPercent = 0) {
        this.progressPercent = initialPercent;
        this.isVisible = false;
        let screenBlockerDiv = document.getElementById("slick-progress-bar-screen-blocker");
        if (!screenBlockerDiv) {
            screenBlockerDiv = document.createElement("div");
            screenBlockerDiv.id = "slick-progress-bar-screen-blocker";
            screenBlockerDiv.classList.add('slick-progress-bar-screen-blocker');
            document.body.appendChild(screenBlockerDiv);
        }
        const progressDiv = document.createElement("div");
        progressDiv.classList.add('progress');
        progressDiv.classList.add('slick-progress-bar');
        progressDiv.classList.add('bg-dark');
        this.progressBarDiv = document.createElement("div");
        this.progressBarDiv.classList.add('progress-bar');
        this.progressBarDiv.classList.add('bg-primary');
        this.progressBarDiv.style.width = "0";
        progressDiv.append(this.progressBarDiv);
        this.progressBarTextDiv = document.createElement("div");
        this.progressBarTextDiv.classList.add('progress-bar-text');
        this.progressBarTextDiv.classList.add('text-white');
        progressDiv.append(this.progressBarTextDiv);
        screenBlockerDiv.append(progressDiv);
        screenBlockerDiv.classList.add('visible');
    }
    hide() {
        this.isVisible = false;
        const screenBlockerDiv = document.getElementById("slick-progress-bar-screen-blocker");
        if (screenBlockerDiv)
            screenBlockerDiv.remove();
    }
}
/** @nocollapse */ SlickProgressBarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickProgressBarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarService, decorators: [{
            type: Injectable
        }] });

class SlickProgressBarModule {
}
/** @nocollapse */ SlickProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarModule, imports: [RouterModule] });
/** @nocollapse */ SlickProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarModule, providers: [SlickProgressBarService], imports: [RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule],
                    providers: [SlickProgressBarService]
                }]
        }] });

class SlickScreenBlockerService {
    constructor() {
        this.isVisible = false;
        this.forceBlockActive = false;
    }
    block(delay = 350) {
        if (this.forceBlockActive === true)
            return;
        SlickScreenBlockerService.blockCount++;
        if (!SlickScreenBlockerService.preShowTimeout) {
            SlickScreenBlockerService.preShowTimeout = setTimeout(() => {
                this.show();
                clearTimeout(SlickScreenBlockerService.blockTimeout);
                SlickScreenBlockerService.blockTimeout = setTimeout(() => {
                    SlickScreenBlockerService.blockCount = 0;
                    this.isVisible = false;
                    this.hide();
                }, 20000);
            }, delay);
        }
        else {
            clearTimeout(SlickScreenBlockerService.blockTimeout);
            SlickScreenBlockerService.blockTimeout = setTimeout(() => {
                SlickScreenBlockerService.blockCount = 0;
                this.isVisible = false;
                this.hide();
            }, 20000);
        }
    }
    unblock() {
        if (this.forceBlockActive === true)
            return;
        SlickScreenBlockerService.blockCount--;
        if (SlickScreenBlockerService.blockCount <= 0) {
            SlickScreenBlockerService.blockCount = 0;
            clearTimeout(SlickScreenBlockerService.preShowTimeout);
            SlickScreenBlockerService.preShowTimeout = null;
            clearTimeout(SlickScreenBlockerService.blockTimeout);
            this.isVisible = false;
            this.hide();
        }
    }
    forceBlock() {
        clearTimeout(SlickScreenBlockerService.blockTimeout);
        this.forceBlockActive = true;
        this.isVisible = true;
        this.show();
    }
    forceUnblock() {
        clearTimeout(SlickScreenBlockerService.blockTimeout);
        SlickScreenBlockerService.blockCount = 0;
        this.forceBlockActive = false;
        this.isVisible = false;
        this.hide();
    }
    show() {
        let screenBlockerDiv = document.getElementById("slick-screen-blocker");
        if (!screenBlockerDiv) {
            screenBlockerDiv = document.createElement("div");
            screenBlockerDiv.id = "slick-screen-blocker";
            screenBlockerDiv.classList.add('slick-screen-blocker');
            screenBlockerDiv.innerHTML = `<div class='slick-screen-blocker_spinner'></div>`;
            document.body.appendChild(screenBlockerDiv);
        }
        screenBlockerDiv.classList.add('visible');
    }
    hide() {
        let screenBlockerDiv = document.getElementById("slick-screen-blocker");
        if (screenBlockerDiv)
            screenBlockerDiv.classList.remove('visible');
    }
}
SlickScreenBlockerService.blockCount = 0;
SlickScreenBlockerService.preShowTimeout = null;
SlickScreenBlockerService.blockTimeout = null;
/** @nocollapse */ SlickScreenBlockerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickScreenBlockerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerService, decorators: [{
            type: Injectable
        }] });

class SlickScreenBlockerModule {
}
/** @nocollapse */ SlickScreenBlockerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickScreenBlockerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerModule, imports: [CommonModule] });
/** @nocollapse */ SlickScreenBlockerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerModule, providers: [SlickScreenBlockerService], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickScreenBlockerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [SlickScreenBlockerService]
                }]
        }] });

class SlickSliderComponent {
    constructor() {
        this.ticks = [];
        this.startTickChange = new EventEmitter();
        this.endTickChange = new EventEmitter();
        this.fnDocumentMouseUp = (e) => this.documentMouseUp(e);
        this.startMoving = false;
        this.endMoving = false;
    }
    async ngAfterViewInit() {
        this.recalc();
    }
    ngOnDestroy() {
        document.removeEventListener("mouseup", this.fnDocumentMouseUp, true);
    }
    ngOnChanges(changes) {
        if (changes.startTick)
            this.startTick = parseInt(this.startTick.toString());
        if (changes.endTick)
            this.endTick = parseInt(this.endTick.toString());
    }
    onStartMouseDown(e) {
        this.startMoving = true;
        this.endMoving = false;
        document.removeEventListener("mouseup", this.fnDocumentMouseUp, true);
        document.addEventListener("mouseup", this.fnDocumentMouseUp, true);
    }
    onEndMouseDown(e) {
        this.startMoving = false;
        this.endMoving = true;
        document.removeEventListener("mouseup", this.fnDocumentMouseUp, true);
        document.addEventListener("mouseup", this.fnDocumentMouseUp, true);
    }
    documentMouseUp(e) {
        document.removeEventListener("mouseup", this.fnDocumentMouseUp, true);
        if (this.startMoving && this.startTickChange)
            this.startTickChange.emit(this.startTick);
        if (this.endMoving && this.endTickChange)
            this.endTickChange.emit(this.endTick);
        this.startMoving = false;
        this.endMoving = false;
    }
    onTickMouseOver(idx) {
        if (this.startMoving === true && idx < this.endTick) {
            this.startTick = idx;
            this.recalc();
        }
        if (this.endMoving === true && idx > this.startTick) {
            this.endTick = idx;
            this.recalc();
        }
    }
    async recalc() {
        await SlickSleepService.sleep();
        const startLeft = this.findTickLeft(this.startTick) + 3;
        this.startLeftPx = startLeft + "px";
        const endLeft = this.findTickLeft(this.endTick) + 3;
        this.endLeftPx = endLeft + "px";
        this.selectionLeftPx = (startLeft + 7) + "px";
        this.selectionWidthPx = (endLeft - startLeft + 1) + "px";
    }
    findTickLeft(tickNumber) {
        const tickEl = this.sliderTicksRef.nativeElement.querySelector("tr td[data-tick='" + tickNumber + "']");
        return tickEl.offsetLeft;
    }
}
/** @nocollapse */ SlickSliderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickSliderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickSliderComponent, selector: "slick-slider", inputs: { ticks: "ticks", startTick: "startTick", endTick: "endTick" }, outputs: { startTickChange: "startTickChange", endTickChange: "endTickChange" }, viewQueries: [{ propertyName: "sliderTicksRef", first: true, predicate: ["sliderTicksRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"slick-slider\" [ngClass]=\"{'slick-slider-moving': startMoving === true || endMoving === true }\">\r\n\t<div class=\"slick-slider-selection bg-primary\" [style.left]=\"selectionLeftPx\" [style.width]=\"selectionWidthPx\"></div>\r\n\t<table #sliderTicksRef class='slick-slider-ticks'>\r\n\t\t<tr>\r\n\t\t\t<td *ngFor='let tick of ticks; let idx = index' [attr.data-tick]='idx' (mouseover)=\"onTickMouseOver(idx)\">\r\n\t\t\t\t<div class='slick-slider-tick border-bottom'>\r\n\t\t\t\t\t<div class=\"slick-slider-tick-text text-light\">{{tick.text}}</div>\r\n\t\t\t\t\t<div *ngIf=\"tick.majorTick === true\" class=\"slick-slider-major-tick border-left\"></div>\r\n\t\t\t\t\t<div *ngIf=\"tick.minorTick === true\" class=\"slick-slider-minor-tick border-left\"></div>\r\n\r\n\t\t\t\t</div>\r\n\t\t\t</td>\r\n\t\t\t<td [attr.data-tick]='ticks.length' (mouseover)=\"onTickMouseOver(ticks.length)\">\r\n\t\t\t\t<div class=\"slick-slider-tick border-0\">\r\n\t\t\t\t\t<div class=\"slick-slider-major-tick border-left\"></div>\r\n\t\t\t\t</div>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t</table>\r\n\t<div *ngIf=\"startLeftPx\" class='slick-slider-start' (mousedown)=\"onStartMouseDown($event)\" [style.left]=\"startLeftPx\">\r\n\t\t<div class='slick-slider-start-block bg-primary'></div>\r\n\t\t<div class='slick-slider-start-pointer bg-primary'></div>\r\n\t</div>\r\n\t<div *ngIf=\"endLeftPx\" class='slick-slider-end' (mousedown)=\"onEndMouseDown($event)\" [style.left]=\"endLeftPx\">\r\n\t\t<div class='slick-slider-end-block bg-primary'></div>\r\n\t\t<div class='slick-slider-end-pointer bg-primary'></div>\r\n\t</div>\r\n\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-slider", template: "<div class=\"slick-slider\" [ngClass]=\"{'slick-slider-moving': startMoving === true || endMoving === true }\">\r\n\t<div class=\"slick-slider-selection bg-primary\" [style.left]=\"selectionLeftPx\" [style.width]=\"selectionWidthPx\"></div>\r\n\t<table #sliderTicksRef class='slick-slider-ticks'>\r\n\t\t<tr>\r\n\t\t\t<td *ngFor='let tick of ticks; let idx = index' [attr.data-tick]='idx' (mouseover)=\"onTickMouseOver(idx)\">\r\n\t\t\t\t<div class='slick-slider-tick border-bottom'>\r\n\t\t\t\t\t<div class=\"slick-slider-tick-text text-light\">{{tick.text}}</div>\r\n\t\t\t\t\t<div *ngIf=\"tick.majorTick === true\" class=\"slick-slider-major-tick border-left\"></div>\r\n\t\t\t\t\t<div *ngIf=\"tick.minorTick === true\" class=\"slick-slider-minor-tick border-left\"></div>\r\n\r\n\t\t\t\t</div>\r\n\t\t\t</td>\r\n\t\t\t<td [attr.data-tick]='ticks.length' (mouseover)=\"onTickMouseOver(ticks.length)\">\r\n\t\t\t\t<div class=\"slick-slider-tick border-0\">\r\n\t\t\t\t\t<div class=\"slick-slider-major-tick border-left\"></div>\r\n\t\t\t\t</div>\r\n\t\t\t</td>\r\n\t\t</tr>\r\n\t</table>\r\n\t<div *ngIf=\"startLeftPx\" class='slick-slider-start' (mousedown)=\"onStartMouseDown($event)\" [style.left]=\"startLeftPx\">\r\n\t\t<div class='slick-slider-start-block bg-primary'></div>\r\n\t\t<div class='slick-slider-start-pointer bg-primary'></div>\r\n\t</div>\r\n\t<div *ngIf=\"endLeftPx\" class='slick-slider-end' (mousedown)=\"onEndMouseDown($event)\" [style.left]=\"endLeftPx\">\r\n\t\t<div class='slick-slider-end-block bg-primary'></div>\r\n\t\t<div class='slick-slider-end-pointer bg-primary'></div>\r\n\t</div>\r\n\r\n</div>\r\n" }]
        }], propDecorators: { ticks: [{
                type: Input
            }], startTick: [{
                type: Input
            }], endTick: [{
                type: Input
            }], startTickChange: [{
                type: Output
            }], endTickChange: [{
                type: Output
            }], sliderTicksRef: [{
                type: ViewChild,
                args: ["sliderTicksRef"]
            }] } });

class SlickSliderTickModel {
}

class SlickSliderModule {
}
/** @nocollapse */ SlickSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickSliderModule, declarations: [SlickSliderComponent], imports: [CommonModule], exports: [SlickSliderComponent, CommonModule] });
/** @nocollapse */ SlickSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSliderModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [SlickSliderComponent, CommonModule],
                    declarations: [SlickSliderComponent]
                }]
        }] });

class SlickSplitScreenComponent {
    constructor() {
        this.orientation = 'vertical';
        this.allowSwitch = true;
        this.verticalSplitPercent = 75;
        this.horizontalSplitPercent = 60;
        this.onResizeStart = new EventEmitter();
        this.onResizeEnd = new EventEmitter();
        this.currentOrientation = 'vertical';
        this.resizing = false;
        this.fnOnMouseMove = (e) => this.onMouseMove(e);
        this.fnOnMouseUp = (e) => this.onMouseUp(e);
        this.throttleTimeout = null;
    }
    ngOnChanges(changes) {
        if (changes.orientation) {
            if (changes.orientation.isFirstChange() === true && this.key)
                this.currentOrientation = localStorage.getItem("SLICK_SPLIT_SCREEN_ORIENTATION_" + this.key) || changes.orientation.currentValue;
            else
                this.currentOrientation = changes.orientation.currentValue;
        }
        if (changes.verticalSplitPercent) {
            if (changes.verticalSplitPercent.isFirstChange() === true && this.key)
                this.verticalSplitPercent = parseInt(localStorage.getItem("SLICK_SPLIT_SCREEN_VERTICAL_SPLIT_PERCENT_" + this.key) || this.verticalSplitPercent.toString());
            else
                this.verticalSplitPercent = changes.verticalSplitPercent.currentValue;
        }
        if (changes.horizontalSplitPercent) {
            if (changes.horizontalSplitPercent.isFirstChange() === true && this.key)
                this.horizontalSplitPercent = parseInt(localStorage.getItem("SLICK_SPLIT_SCREEN_HORIZONTAL_SPLIT_PERCENT_" + this.key) || this.horizontalSplitPercent.toString());
            else
                this.horizontalSplitPercent = changes.horizontalSplitPercent.currentValue;
        }
        this.resize();
    }
    ngOnDestroy() {
        document.removeEventListener('mousemove', this.fnOnMouseMove);
        document.removeEventListener('mouseup', this.fnOnMouseUp);
    }
    changeOrientation() {
        if (this.currentOrientation === 'vertical')
            this.currentOrientation = 'horizontal';
        else
            this.currentOrientation = 'vertical';
        this.resize();
    }
    onDragStart(e) {
        return false;
    }
    onMouseDown(e) {
        e.preventDefault();
        if (this.onResizeStart)
            this.onResizeStart.emit();
        if (this.currentOrientation === "vertical")
            document.body.style.cursor = "col-resize";
        else
            document.body.style.cursor = "row-resize";
        this.resizing = true;
        this.fullWidthPx = this.slickSplitScreenContainer.nativeElement.offsetWidth;
        this.fullHeightPx = this.slickSplitScreenContainer.nativeElement.offsetHeight;
        let rect = this.slickSplitScreenLeft.nativeElement.getBoundingClientRect();
        this.clientRectLeft = rect.left;
        this.clientRectTop = rect.top;
        this.resize();
        document.addEventListener('mousemove', this.fnOnMouseMove);
        document.addEventListener('mouseup', this.fnOnMouseUp);
    }
    onMouseUp(e) {
        this.resizing = false;
        document.body.style.cursor = "default";
        document.removeEventListener('mousemove', this.fnOnMouseMove);
        document.removeEventListener('mouseup', this.fnOnMouseUp);
        if (this.onResizeEnd)
            this.onResizeEnd.emit();
    }
    onMouseMove(e) {
        e.preventDefault();
        if (this.throttleTimeout)
            return;
        this.throttleTimeout = setTimeout(() => {
            if (this.currentOrientation === 'vertical') {
                let adjustedLeft = e.pageX - this.clientRectLeft;
                this.verticalSplitPercent = (adjustedLeft / this.fullWidthPx) * 100;
                if (this.verticalSplitPercent > 80)
                    this.verticalSplitPercent = 80;
                if (this.verticalSplitPercent < 20)
                    this.verticalSplitPercent = 20;
            }
            else {
                let adjustedTop = e.pageY - this.clientRectTop;
                this.horizontalSplitPercent = (adjustedTop / this.fullHeightPx) * 100;
                if (this.horizontalSplitPercent > 80)
                    this.horizontalSplitPercent = 80;
                if (this.horizontalSplitPercent < 20)
                    this.horizontalSplitPercent = 20;
            }
            this.resize();
            this.throttleTimeout = null;
        }, 25);
    }
    resize() {
        if (this.currentOrientation === "vertical") {
            this.leftWidth = "calc(" + this.verticalSplitPercent + "% - 1px)";
            this.leftHeight = "100%";
            this.rightWidth = (100 - this.verticalSplitPercent) + "%";
            this.rightHeight = "100%";
            this.splitBarMiddleTop = "0";
            this.splitBarMiddleLeft = "calc(" + this.verticalSplitPercent + "% - 4px)";
            if (this.key)
                localStorage.setItem("SLICK_SPLIT_SCREEN_VERTICAL_SPLIT_PERCENT_" + this.key, this.verticalSplitPercent.toString());
        }
        else {
            this.leftWidth = "100%";
            this.leftHeight = "calc(" + this.horizontalSplitPercent + "% - 1px)";
            this.rightWidth = "100%";
            this.rightHeight = (100 - this.horizontalSplitPercent) + "%";
            this.splitBarMiddleTop = "calc(" + this.horizontalSplitPercent + "% - 3px)";
            this.splitBarMiddleLeft = "0";
            if (this.key)
                localStorage.setItem("SLICK_SPLIT_SCREEN_HORIZONTAL_SPLIT_PERCENT_" + this.key, this.horizontalSplitPercent.toString());
        }
        if (this.key) {
            localStorage.setItem("SLICK_SPLIT_SCREEN_ORIENTATION_" + this.key, this.currentOrientation);
        }
    }
}
/** @nocollapse */ SlickSplitScreenComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickSplitScreenComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickSplitScreenComponent, selector: "slick-split-screen", inputs: { orientation: "orientation", allowSwitch: "allowSwitch", key: "key", verticalSplitPercent: "verticalSplitPercent", horizontalSplitPercent: "horizontalSplitPercent" }, outputs: { onResizeStart: "onResizeStart", onResizeEnd: "onResizeEnd" }, viewQueries: [{ propertyName: "slickSplitScreenContainer", first: true, predicate: ["slickSplitScreenContainer"], descendants: true }, { propertyName: "slickSplitScreenLeft", first: true, predicate: ["slickSplitScreenLeftContent"], descendants: true }, { propertyName: "slickSplitScreenRight", first: true, predicate: ["slickSplitScreenRightContent"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #slickSplitScreenContainer class=\"slick-split-screen\" [ngClass]=\"{'vertical': currentOrientation === 'vertical', 'horizontal': currentOrientation === 'horizontal'}\"><div #slickSplitScreenLeftContent [style.width]=\"leftWidth\" [style.maxWidth]=\"leftWidth\" [style.height]=\"leftHeight\" [style.maxHeight]=\"leftHeight\" class=\"slick-split-screen-left-content\" [ngClass]=\"{'resizing': resizing === true}\"><ng-content select=\"slick-split-screen-left-content\"></ng-content></div><div class=\"slick-split-screen-split-bar\"></div><div #splitSplitScreenRightContent [style.width]=\"rightWidth\" [style.maxWidth]=\"rightWidth\" [style.height]=\"rightHeight\" [style.maxHeight]=\"rightHeight\" class=\"slick-split-screen-right-content\" [ngClass]=\"{'resizing': resizing === true}\"><ng-content select=\"slick-split-screen-right-content\"></ng-content></div><div [style.left]=\"splitBarMiddleLeft\" [style.top]=\"splitBarMiddleTop\" class=\"slick-split-screen-split-bar-middle\" (mousedown)=\"onMouseDown($event)\" (dragstart)=\"onDragStart($event)\"></div><button type=\"button\" (click)=\"changeOrientation()\" class=\"btn btn-primary orientation-switch\" *ngIf=\"allowSwitch === true\"><div [ngClass]=\"{'slick-split-screen-horizontal-icon': currentOrientation === 'vertical', 'slick-split-screen-vertical-icon': currentOrientation === 'horizontal'}\"></div></button></div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenComponent, decorators: [{
            type: Component,
            args: [{ selector: "slick-split-screen", template: "<div #slickSplitScreenContainer class=\"slick-split-screen\" [ngClass]=\"{'vertical': currentOrientation === 'vertical', 'horizontal': currentOrientation === 'horizontal'}\"><div #slickSplitScreenLeftContent [style.width]=\"leftWidth\" [style.maxWidth]=\"leftWidth\" [style.height]=\"leftHeight\" [style.maxHeight]=\"leftHeight\" class=\"slick-split-screen-left-content\" [ngClass]=\"{'resizing': resizing === true}\"><ng-content select=\"slick-split-screen-left-content\"></ng-content></div><div class=\"slick-split-screen-split-bar\"></div><div #splitSplitScreenRightContent [style.width]=\"rightWidth\" [style.maxWidth]=\"rightWidth\" [style.height]=\"rightHeight\" [style.maxHeight]=\"rightHeight\" class=\"slick-split-screen-right-content\" [ngClass]=\"{'resizing': resizing === true}\"><ng-content select=\"slick-split-screen-right-content\"></ng-content></div><div [style.left]=\"splitBarMiddleLeft\" [style.top]=\"splitBarMiddleTop\" class=\"slick-split-screen-split-bar-middle\" (mousedown)=\"onMouseDown($event)\" (dragstart)=\"onDragStart($event)\"></div><button type=\"button\" (click)=\"changeOrientation()\" class=\"btn btn-primary orientation-switch\" *ngIf=\"allowSwitch === true\"><div [ngClass]=\"{'slick-split-screen-horizontal-icon': currentOrientation === 'vertical', 'slick-split-screen-vertical-icon': currentOrientation === 'horizontal'}\"></div></button></div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { orientation: [{
                type: Input
            }], allowSwitch: [{
                type: Input
            }], key: [{
                type: Input
            }], verticalSplitPercent: [{
                type: Input
            }], horizontalSplitPercent: [{
                type: Input
            }], onResizeStart: [{
                type: Output
            }], onResizeEnd: [{
                type: Output
            }], slickSplitScreenContainer: [{
                type: ViewChild,
                args: ["slickSplitScreenContainer"]
            }], slickSplitScreenLeft: [{
                type: ViewChild,
                args: ["slickSplitScreenLeftContent"]
            }], slickSplitScreenRight: [{
                type: ViewChild,
                args: ["slickSplitScreenRightContent"]
            }] } });

class SlickSplitScreenLeftContentComponent {
    constructor() { }
}
/** @nocollapse */ SlickSplitScreenLeftContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenLeftContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickSplitScreenLeftContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickSplitScreenLeftContentComponent, selector: "slick-split-screen-left-content", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenLeftContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-split-screen-left-content',
                    template: '<ng-content></ng-content>'
                }]
        }], ctorParameters: function () { return []; } });

class SlickSplitScreenRightContentComponent {
    constructor() { }
}
/** @nocollapse */ SlickSplitScreenRightContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenRightContentComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickSplitScreenRightContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickSplitScreenRightContentComponent, selector: "slick-split-screen-right-content", ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenRightContentComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-split-screen-right-content',
                    template: '<ng-content></ng-content>'
                }]
        }], ctorParameters: function () { return []; } });

class SlickSplitScreenModule {
}
/** @nocollapse */ SlickSplitScreenModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickSplitScreenModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenModule, declarations: [SlickSplitScreenComponent, SlickSplitScreenLeftContentComponent, SlickSplitScreenRightContentComponent], imports: [CommonModule], exports: [SlickSplitScreenComponent, SlickSplitScreenLeftContentComponent, SlickSplitScreenRightContentComponent] });
/** @nocollapse */ SlickSplitScreenModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickSplitScreenModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickSplitScreenComponent, SlickSplitScreenLeftContentComponent, SlickSplitScreenRightContentComponent],
                    exports: [SlickSplitScreenComponent, SlickSplitScreenLeftContentComponent, SlickSplitScreenRightContentComponent]
                }]
        }] });

class Star {
    constructor(selected) {
        this.selected = selected;
    }
}
class SlickStarRatingComponent {
    constructor() {
        this.stars = [];
        this.checkedColor = "gold";
        this.uncheckedColor = "gray";
        this.size = "24px";
        this.readonly = false;
        this.totalStars = 5;
        this.propagateChange = (_) => { };
    }
    ngOnChanges(changes) {
        this.readonly = ((this.readonly || 'false').toString() === 'true');
        if (changes.totalstars)
            this.generateStars();
    }
    // this is the initial value set to the component
    writeValue(obj) {
        if (obj)
            this.ratingValue = obj - 1;
        else
            this.ratingValue = -1;
        this.generateStars();
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
    reset() {
        this.stars.forEach((s, idx) => s.selected = (idx <= this.ratingValue));
    }
    onMouseEnter(starIdx) {
        if (this.readonly === true)
            return;
        this.stars.forEach((s, idx) => s.selected = (idx <= starIdx));
    }
    setRatingValue(starIdx) {
        if (this.readonly === true)
            return;
        this.ratingValue = starIdx;
        this.propagateChange(this.ratingValue + 1);
        this.stars.forEach((s, idx) => s.selected = (idx <= starIdx));
    }
    generateStars() {
        this.stars = [];
        for (let i = 0; i < this.totalStars; i++) {
            const selected = (i <= this.ratingValue);
            this.stars.push(new Star(selected));
        }
    }
}
/** @nocollapse */ SlickStarRatingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickStarRatingComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickStarRatingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickStarRatingComponent, selector: "slick-star-rating", inputs: { checkedColor: "checkedColor", uncheckedColor: "uncheckedColor", size: "size", readonly: "readonly", totalStars: "totalStars" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickStarRatingComponent)),
            multi: true,
        }
    ], usesOnChanges: true, ngImport: i0, template: "<div class=\"d-flex\" (mouseleave)=\"reset()\">\r\n\t<div *ngFor=\"let star of stars; let idx = index\" class=\"pl-1\" style=\"cursor: pointer\" (mouseenter)=\"onMouseEnter(idx)\" (click)=\"setRatingValue(idx)\">\r\n\t\t<div *ngIf=\"star.selected === true\" style=\"position: relative\">\r\n\t\t\t<div class=\"fas fa-star\" [style.color]=\"checkedColor\" [style.font-size]=\"size\"></div>\r\n\t\t\t<div class=\"fal fa-star\" [style.color]=\"uncheckedColor\" [style.font-size]=\"size\" style=\"position: absolute; left: 0;\"></div>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"star.selected === false\" class=\"fal fa-star\" [style.color]=\"uncheckedColor\" [style.font-size]=\"size\"></div>\r\n\t</div>\r\n</div>", dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickStarRatingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-star-rating', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickStarRatingComponent)),
                            multi: true,
                        }
                    ], template: "<div class=\"d-flex\" (mouseleave)=\"reset()\">\r\n\t<div *ngFor=\"let star of stars; let idx = index\" class=\"pl-1\" style=\"cursor: pointer\" (mouseenter)=\"onMouseEnter(idx)\" (click)=\"setRatingValue(idx)\">\r\n\t\t<div *ngIf=\"star.selected === true\" style=\"position: relative\">\r\n\t\t\t<div class=\"fas fa-star\" [style.color]=\"checkedColor\" [style.font-size]=\"size\"></div>\r\n\t\t\t<div class=\"fal fa-star\" [style.color]=\"uncheckedColor\" [style.font-size]=\"size\" style=\"position: absolute; left: 0;\"></div>\r\n\t\t</div>\r\n\t\t<div *ngIf=\"star.selected === false\" class=\"fal fa-star\" [style.color]=\"uncheckedColor\" [style.font-size]=\"size\"></div>\r\n\t</div>\r\n</div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { checkedColor: [{
                type: Input
            }], uncheckedColor: [{
                type: Input
            }], size: [{
                type: Input
            }], readonly: [{
                type: Input
            }], totalStars: [{
                type: Input
            }] } });

class SlickStarRatingModule {
}
/** @nocollapse */ SlickStarRatingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickStarRatingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickStarRatingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickStarRatingModule, declarations: [SlickStarRatingComponent], imports: [CommonModule, FormsModule, SlickCalendarModule], exports: [SlickStarRatingComponent, SlickCalendarModule] });
/** @nocollapse */ SlickStarRatingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickStarRatingModule, imports: [CommonModule, FormsModule, SlickCalendarModule, SlickCalendarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickStarRatingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SlickCalendarModule],
                    declarations: [SlickStarRatingComponent],
                    exports: [SlickStarRatingComponent, SlickCalendarModule]
                }]
        }] });

class SlickTabHeaderComponent {
    constructor() {
        this.uuid = SlickUtilsService.newGuid();
    }
    setHeader(header) {
        this.tabHeaderRef.nativeElement.innerHTML = header;
    }
    setIcon(icon) {
        this.icon = icon;
    }
}
/** @nocollapse */ SlickTabHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickTabHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickTabHeaderComponent, selector: "slick-tab-header", viewQueries: [{ propertyName: "tabHeaderRef", first: true, predicate: ["tabHeaderRef"], descendants: true }], ngImport: i0, template: `<i style='margin-right: 5px; font-size: .8em; position: relative; top: -.1em;' *ngIf='icon' class='far {{icon}}'></i><div class='slick-tab-header' #tabHeaderRef><ng-content></ng-content></div>`, isInline: true, dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabHeaderComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'slick-tab-header',
                    template: `<i style='margin-right: 5px; font-size: .8em; position: relative; top: -.1em;' *ngIf='icon' class='far {{icon}}'></i><div class='slick-tab-header' #tabHeaderRef><ng-content></ng-content></div>`
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { tabHeaderRef: [{
                type: ViewChild,
                args: ["tabHeaderRef"]
            }] } });

class SlickTabComponent {
    constructor(el) {
        this.el = el;
        this.showHeaderFromInput = false;
        this.selected = false;
        this.uuid = SlickUtilsService.newGuid();
    }
    async ngAfterViewInit() {
        // Sleep 1 cycle to give this.parentComponent a chance to populate
        await SlickSleepService.sleep();
        // Remove this from the inline version and put it on the body so that it doesn't hide behind the bottom
        // of a div when it expands beyond the bottom.
        let displayBody = document.getElementById("slick-tab-display-body_" + this.parentComponent.uuid);
        if (displayBody)
            displayBody.appendChild(this.tabBodyRef.nativeElement);
    }
    async ngOnChanges(changes) {
        if (changes.header) {
            this.showHeaderFromInput = true;
            await SlickSleepService.sleep();
            if (this.tabHeaderRef)
                this.tabHeaderRef.setHeader(changes.header.currentValue);
        }
        if (changes.icon) {
            await SlickSleepService.sleep();
            if (this.tabHeaderRef)
                this.tabHeaderRef.setIcon(changes.icon.currentValue);
        }
    }
    async onTabClicked() {
        // If this is already selected, don't run the onTabSelected again.
        // This is causing double calls to the event
        if (this.selected)
            return;
        this.parentComponent.onTabSelected(this.uuid);
        this.selected = true;
    }
}
/** @nocollapse */ SlickTabComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickTabComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickTabComponent, selector: "slick-tab", inputs: { header: "header", icon: "icon", key: "key" }, viewQueries: [{ propertyName: "tabHeaderRef", first: true, predicate: ["tabHeaderRef"], descendants: true }, { propertyName: "tabBodyRef", first: true, predicate: ["tabBodyRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class='slick-tab btn' [ngClass]=\"{'btn-primary': selected === true, 'btn-secondary': selected === false }\" (click)='onTabClicked()'>\r\n\t<slick-tab-header *ngIf='showHeaderFromInput' #tabHeaderRef></slick-tab-header>\r\n\t<ng-content *ngIf='!showHeaderFromInput' select='slick-tab-header'></ng-content>\r\n\t<div id='tabBody_{{uuid}}' class='slick-tab-body' style='display: none; width: 100%;' #tabBodyRef>\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</div>\r\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: SlickTabHeaderComponent, selector: "slick-tab-header" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-tab', template: "<div class='slick-tab btn' [ngClass]=\"{'btn-primary': selected === true, 'btn-secondary': selected === false }\" (click)='onTabClicked()'>\r\n\t<slick-tab-header *ngIf='showHeaderFromInput' #tabHeaderRef></slick-tab-header>\r\n\t<ng-content *ngIf='!showHeaderFromInput' select='slick-tab-header'></ng-content>\r\n\t<div id='tabBody_{{uuid}}' class='slick-tab-body' style='display: none; width: 100%;' #tabBodyRef>\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { header: [{
                type: Input
            }], icon: [{
                type: Input
            }], key: [{
                type: Input
            }], tabHeaderRef: [{
                type: ViewChild,
                args: ["tabHeaderRef"]
            }], tabBodyRef: [{
                type: ViewChild,
                args: ["tabBodyRef"]
            }] } });

class SlickTabsComponent {
    constructor() {
        this.hideBorder = false;
        this.tabIndex = 0;
        this.tabIndexChange = new EventEmitter();
        this.tabChange = new EventEmitter();
        this.savedTabChildren = [];
        this.uuid = SlickUtilsService.newGuid();
    }
    ngOnChanges(changes) {
        if (changes.hideBorder && changes.hideBorder.currentValue)
            this.hideBorder = (changes.hideBorder.currentValue.toString().toLowerCase() !== 'false');
        if (changes.tabIndex && changes.tabIndex.firstChange === false)
            this.slickTabs.toArray()[changes.tabIndex.currentValue].onTabClicked();
    }
    async ngAfterViewInit() {
        this.slickTabs.forEach(tab => this.processTab(tab));
        await SlickSleepService.sleep();
        if (this.slickTabs.length > 0 && this.tabIndex < this.slickTabs.length)
            this.slickTabs.toArray()[this.tabIndex].onTabClicked();
        await SlickSleepService.sleep();
        if (this.slickTabs && this.slickTabs.changes) {
            this.slickTabs$ = this.slickTabs.changes.subscribe(async (changes) => {
                let tabsAdded = changes.filter(changedTab => !this.savedTabChildren.find(savedTabChild => savedTabChild.uuid === changedTab.uuid));
                let tabsRemoved = this.savedTabChildren.filter(savedTabChild => !changes.find(changedTab => savedTabChild.uuid === changedTab.uuid));
                tabsRemoved.forEach(x => {
                    document.getElementById("tabBody_" + x.uuid).style.display = "none";
                    x.selected = false;
                });
                tabsAdded.forEach(t => this.processTab(t));
                await SlickSleepService.sleep();
                if (this.slickTabs.length > 0 && this.tabIndex < this.slickTabs.length)
                    this.slickTabs.toArray()[this.tabIndex].onTabClicked();
            });
        }
    }
    processTab(tab) {
        var existingTab = this.savedTabChildren.find(x => x.uuid === tab.uuid);
        if (!existingTab) {
            this.savedTabChildren.push(tab);
            tab.parentComponent = this;
        }
    }
    onTabSelected(uuid) {
        let tabIndex = 0;
        this.slickTabs.forEach(x => {
            let tabBody = document.getElementById("tabBody_" + x.uuid);
            if (tabBody) {
                if (x.uuid === uuid) {
                    this.tabIndex = tabIndex;
                    if (this.tabIndexChange)
                        this.tabIndexChange.emit(tabIndex);
                    if (this.tabChange) {
                        const tabKey = this.getTabKey(tabIndex);
                        this.tabChange.emit(tabKey);
                    }
                }
                tabIndex++;
                tabBody.style.display = (x.uuid === uuid) ? "inline-block" : "none";
                x.selected = false;
            }
        });
    }
    getTabHeader(index) {
        const tabs = this.slickTabs.toArray();
        if (index > tabs.length)
            return null;
        return tabs[index].header;
    }
    getTabKey(index) {
        const tabs = this.slickTabs.toArray();
        if (index > tabs.length)
            return null;
        return tabs[index].key || tabs[index].header || index.toString();
    }
    ngOnDestroy() {
        if (this.slickTabs$)
            this.slickTabs$.unsubscribe();
    }
}
/** @nocollapse */ SlickTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickTabsComponent, selector: "slick-tabs", inputs: { tabModels: ["tabs", "tabModels"], hideBorder: "hideBorder", tabIndex: "tabIndex" }, outputs: { tabIndexChange: "tabIndexChange", tabChange: "tabChange" }, queries: [{ propertyName: "slickTabs", predicate: i0.forwardRef(function () { return SlickTabComponent; }) }], usesOnChanges: true, ngImport: i0, template: "<div id=\"slick-tabs_{{uuid}}\" class=\"slick-tabs\">\r\n\t<div class=\"slick-tab-headers\" [ngClass]=\"{'no-border': hideBorder === true}\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n\t<div id='slick-tab-display-body_{{uuid}}' class=\"slick-tab-display-body\"></div>\r\n</div>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-tabs', template: "<div id=\"slick-tabs_{{uuid}}\" class=\"slick-tabs\">\r\n\t<div class=\"slick-tab-headers\" [ngClass]=\"{'no-border': hideBorder === true}\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n\t<div id='slick-tab-display-body_{{uuid}}' class=\"slick-tab-display-body\"></div>\r\n</div>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { tabModels: [{
                type: Input,
                args: ["tabs"]
            }], hideBorder: [{
                type: Input
            }], tabIndex: [{
                type: Input
            }], tabIndexChange: [{
                type: Output
            }], tabChange: [{
                type: Output
            }], slickTabs: [{
                type: ContentChildren,
                args: [forwardRef(() => SlickTabComponent)]
            }] } });

class SlickTabsModule {
}
/** @nocollapse */ SlickTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickTabsModule, declarations: [SlickTabsComponent, SlickTabComponent, SlickTabHeaderComponent], imports: [CommonModule], exports: [CommonModule, SlickTabsComponent, SlickTabComponent, SlickTabHeaderComponent] });
/** @nocollapse */ SlickTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabsModule, imports: [CommonModule, CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [SlickTabsComponent, SlickTabComponent, SlickTabHeaderComponent],
                    exports: [CommonModule, SlickTabsComponent, SlickTabComponent, SlickTabHeaderComponent]
                }]
        }] });

class SlickToastInfo {
}
class SlickToastService {
    constructor(router) {
        this.router = router;
        if (document.getElementById("slick-toasts") === null) {
            let container = document.createElement("div");
            container.id = "slick-toasts";
            document.body.appendChild(container);
        }
        if (this.router) {
            // Every time we change a page, reset the page auto-logout timeout
            this.router.events.subscribe((event) => {
                if (event instanceof NavigationStart) {
                    this.resetAll();
                }
            });
        }
    }
    showSuccess(message, delay = 6000) {
        this.showMessage("<i style='font-size: 1.2em' class='far fa-check'></i>&nbsp;&nbsp;" + message, delay, "bg-success");
    }
    showInfo(message, delay = 6000) {
        this.showMessage("<i style='font-size: 1.2em' class='far fa-info-circle'></i>&nbsp;&nbsp;" + message, delay, "bg-info");
    }
    showWarning(message, delay = 6000) {
        this.showMessage("<i style='font-size: 1.2em' class='far fa-exclamation-triangle'></i>&nbsp;&nbsp;" + message, delay, "bg-warning");
    }
    showDanger(message, delay = 6000) {
        this.showMessage("<i style='font-size: 1.2em' class='far fa-times-circle'></i>&nbsp;&nbsp;" + message, delay, "bg-danger");
    }
    resetAll() {
        for (let i = 0; i < SlickToastService.messageInfos.length; i++) {
            clearTimeout(SlickToastService.messageInfos[i].fadeTimeout);
            const container = document.getElementById("slick-toasts");
            if (container) {
                try {
                    container.removeChild(SlickToastService.messageInfos[i].messageDiv);
                }
                catch { }
            }
        }
    }
    async fadeOut(messageInfo) {
        messageInfo.messageDiv.style.opacity = "0";
        await SlickSleepService.sleep(600);
        let container = document.getElementById("slick-toasts");
        if (container) {
            try {
                container.removeChild(messageInfo.messageDiv);
            }
            catch { }
        }
        SlickToastService.messageInfos = SlickToastService.messageInfos.filter(x => x.uuid !== messageInfo.uuid);
    }
    async showMessage(message, delay, bgClass) {
        let container = document.getElementById("slick-toasts");
        let newMessage = new SlickToastInfo();
        newMessage.uuid = SlickUtilsService.newGuid();
        newMessage.message = message;
        newMessage.fadeTimeout = setTimeout(() => this.fadeOut(newMessage), delay);
        newMessage.messageDiv = document.createElement("div");
        newMessage.messageDiv.id = "slick-toast_" + newMessage.uuid;
        newMessage.messageDiv.classList.add('slick-toast');
        newMessage.messageDiv.classList.add('jumbotron');
        newMessage.messageDiv.classList.add(bgClass);
        newMessage.messageDiv.innerHTML = message;
        SlickToastService.messageInfos.push(newMessage);
        container.insertAdjacentElement('afterbegin', newMessage.messageDiv);
        await SlickSleepService.sleep();
        document.getElementById("slick-toast_" + newMessage.uuid).style.opacity = "1";
    }
}
SlickToastService.messageInfos = [];
/** @nocollapse */ SlickToastService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickToastService, deps: [{ token: i1$3.Router, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ SlickToastService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickToastService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickToastService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Router, decorators: [{
                    type: Optional
                }] }]; } });

class SlickToastModule {
}
/** @nocollapse */ SlickToastModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickToastModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickToastModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickToastModule, imports: [RouterModule] });
/** @nocollapse */ SlickToastModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickToastModule, providers: [SlickToastService], imports: [RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickToastModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule],
                    providers: [SlickToastService]
                }]
        }] });

class SlickTreeNodeModel {
    constructor(parentNode, text) {
        this.expanded = false;
        this.canEditText = true;
        this.canDelete = true;
        this.canAddChildren = true;
        this.uuid = SlickUtilsService.newGuid();
        this.text = text;
        this.hidden = false;
        if (parentNode)
            this.parentUuid = parentNode.uuid;
        else {
            this.parentUuid = null;
        }
    }
}

class SlickTreeViewDisplayModel {
    constructor(node, level) {
        this.uuid = node.uuid;
        this.parentUuid = node.parentUuid;
        this.node = node;
        this.text = node.text;
        this.level = level;
        this.expanded = node.expanded;
        this.editingText = false;
        this.indentArray = [];
        for (let i = 0; i < this.level; i++)
            this.indentArray.push(true);
    }
}
class SlickTreeViewComponent {
    constructor() {
        this.nodesChange = new EventEmitter();
        this.showRootNode = true;
        this.expandOnClick = true;
        this.onNodeSelected = new EventEmitter();
        this.onNodeChanged = new EventEmitter();
        this.onNodeAdded = new EventEmitter();
        this.onNodeDeleted = new EventEmitter();
        this.fnDocumentClick = (e) => this.documentClick(e);
        this.fnContextMenu = (e) => this.contextMenu(e);
        this.uuid = SlickUtilsService.newGuid();
        this.newUuid = null;
    }
    ngOnInit() {
        document.addEventListener("click", this.fnDocumentClick, true);
        this.slickTreeViewRef.nativeElement.addEventListener("contextmenu", this.fnContextMenu, true);
    }
    ngOnDestroy() {
        document.removeEventListener("click", this.fnDocumentClick, true);
        this.slickTreeViewRef.nativeElement.removeEventListener("contextmenu", this.fnContextMenu, true);
    }
    ngOnChanges(changes) {
        this.expandOnClick = (this.expandOnClick.toString().toLowerCase() === 'false') ? false : true;
        this.showRootNode = (this.showRootNode.toString().toLowerCase() === 'false') ? false : true;
        this.rootNodeUuid = this.rootNodeUuid || null;
        if (changes.nodes)
            this.refreshDisplay();
    }
    async documentClick(e) {
        if (e.target && SlickUtilsService.checkParentClassExists(e.target, "slick-tree-view_node-text-edit"))
            return;
        if (e.target && SlickUtilsService.checkParentClassExists(e.target, "slick-tree-view_context-menu"))
            return;
        const contextMenuElement = this.contextMenuRef.nativeElement;
        contextMenuElement.classList.remove("menu-visible");
        contextMenuElement.classList.add("menu-hidden");
        this.processNewNode();
        this.displayNodes = this.displayNodes.map(displayNode => {
            if (displayNode.editingText) {
                displayNode.editingText = false;
                if (this.onNodeChanged && displayNode.text !== displayNode.node.text) {
                    displayNode.node.text = displayNode.text;
                    this.onNodeChanged.emit(displayNode.node);
                }
            }
            return displayNode;
        });
    }
    onTextKeydown(e, displayNode) {
        // Esc
        if (e.keyCode === 27) {
            displayNode.editingText = false;
            displayNode.node.text = displayNode.text;
            this.processNewNode();
        }
        // Enter or tab
        if (e.keyCode === 13 || e.keyCode === 9) {
            displayNode.editingText = false;
            this.processNewNode();
            if (this.onNodeChanged && displayNode.text !== displayNode.node.text) {
                displayNode.node.text = displayNode.text;
                this.onNodeChanged.emit(displayNode.node);
            }
        }
    }
    contextMenu(e) {
        if (!e || !e.target)
            return;
        if (!SlickUtilsService.checkParentIdExists(e.target, `slick-tree-view_${this.uuid}`))
            return;
        const contextNodeElement = SlickUtilsService.findParent(e.target, "slick-tree-view-node");
        if (!contextNodeElement)
            return;
        e.preventDefault();
        this.contextNodeUuid = contextNodeElement.getAttribute("data-uuid");
        const node = this.nodes.find(x => x.uuid === this.contextNodeUuid);
        this.contextMenuShowAdd = node.canAddChildren;
        this.contextMenuShowDelete = node.canDelete;
        this.contextMenuShowEditText = node.canEditText;
        // If there's nothing to do, don't even show the context menu
        if (this.contextMenuShowAdd === false && this.contextMenuShowDelete === false && this.contextMenuShowEditText === false)
            return;
        const contextMenuElement = this.contextMenuRef.nativeElement;
        const top = (contextNodeElement.offsetTop + contextNodeElement.offsetHeight - 5);
        const indentationElement = contextNodeElement.querySelector(".slick-tree-view_indentation");
        const iconElement = contextNodeElement.querySelector(".slick-tree-view_icon");
        const indentationWidth = (indentationElement) ? indentationElement.offsetWidth : 0;
        const iconWidth = (iconElement) ? iconElement.offsetWidth : 0;
        const left = indentationWidth + iconWidth + 2;
        contextMenuElement.style.top = top + "px";
        contextMenuElement.style.left = left + "px";
        contextMenuElement.classList.add("menu-visible");
        contextMenuElement.classList.remove("menu-hidden");
    }
    async addNode() {
        // Hide the context menu
        const contextMenuElement = this.contextMenuRef.nativeElement;
        contextMenuElement.classList.remove("menu-visible");
        contextMenuElement.classList.add("menu-hidden");
        if (!this.contextNodeUuid)
            return;
        const parentNodeIdx = this.nodes.findIndex(x => x.uuid === this.contextNodeUuid);
        const parentNode = this.nodes[parentNodeIdx];
        // Since we want to add this one to the top, pass null as the parent
        var newNode = new SlickTreeNodeModel(null, "New Folder");
        newNode.parentUuid = parentNode.uuid;
        parentNode.expanded = true;
        this.nodes.splice(parentNodeIdx, 0, newNode);
        this.refreshDisplay();
        const displayNode = this.displayNodes.find(x => x.uuid === newNode.uuid);
        this.editText(displayNode);
        this.newUuid = newNode.uuid;
    }
    async deleteNode() {
        // Hide the context menu
        const contextMenuElement = this.contextMenuRef.nativeElement;
        contextMenuElement.classList.remove("menu-visible");
        contextMenuElement.classList.add("menu-hidden");
        if (!this.contextNodeUuid)
            return;
        const node = this.nodes.find(x => x.uuid === this.contextNodeUuid);
        this.deleteNodeName = node.text;
        const confirmResult = await this.deleteNodeConfirmRef.confirm();
        if (confirmResult === SlickConfirmDialogResults.Cancel)
            return;
        const removedNodes = this.deleteRecursive(node);
        this.refreshDisplay();
        if (this.onNodeDeleted)
            this.onNodeDeleted.emit(removedNodes);
        if (this.nodesChange)
            this.nodesChange.emit(this.nodes);
    }
    editNodeText() {
        // Hide the context menu
        const contextMenuElement = this.contextMenuRef.nativeElement;
        contextMenuElement.classList.remove("menu-visible");
        contextMenuElement.classList.add("menu-hidden");
        if (!this.contextNodeUuid)
            return;
        const displayNode = this.displayNodes.find(x => x.uuid === this.contextNodeUuid);
        this.editText(displayNode);
        if (this.nodesChange)
            this.nodesChange.emit(this.nodes);
    }
    selectNode(displayNode) {
        if (this.selectedUuid === displayNode.uuid)
            return;
        this.selectedUuid = displayNode.uuid;
        if (displayNode.node.expandOnClick === true)
            this.expandNode(displayNode);
        if (this.onNodeSelected)
            this.onNodeSelected.emit(displayNode.node);
    }
    expandNode(displayNode) {
        displayNode.node.expanded = true;
        this.refreshDisplay();
    }
    collapseNode(displayNode) {
        displayNode.node.expanded = false;
        this.refreshDisplay();
    }
    async editText(displayNode) {
        if (!displayNode.node.canEditText)
            return;
        displayNode.editingText = true;
        await SlickSleepService.sleep();
        const textbox = document.querySelector(`.slick-tree-view_node-text-edit_${displayNode.uuid}`);
        if (textbox) {
            textbox.focus();
            textbox.select();
        }
    }
    refreshDisplay() {
        this.displayNodes = [];
        if (!this.nodes || this.nodes.length === 0)
            return;
        let rootNode;
        if (this.rootNodeUuid)
            rootNode = this.nodes.find(x => x.uuid === this.rootNodeUuid);
        else
            rootNode = this.nodes.find(x => x.parentUuid === null);
        // Always expand the root node
        rootNode.expanded = true;
        // If we aren't showing the root node, start at -1 for the indent level
        this.populateDisplayNodes(rootNode, (this.showRootNode) ? 0 : -1);
        if (this.showRootNode === false)
            this.displayNodes = this.displayNodes.filter(x => x.parentUuid !== null);
    }
    populateDisplayNodes(node, level) {
        if (level >= 100) {
            console.error("Exceeeded max of 100 levels deep.  Possible infinite recursion.");
            return;
        }
        const displayNode = new SlickTreeViewDisplayModel(node, level);
        if (node.expandOnClick === null || node.expandOnClick === undefined)
            node.expandOnClick = this.expandOnClick;
        if (displayNode.parentUuid === null)
            displayNode.node.canDelete = false;
        if (displayNode.uuid === this.newUuid)
            displayNode.editingText = true;
        this.displayNodes.push(displayNode);
        const childNodes = this.nodes.filter(x => x.parentUuid === node.uuid) || [];
        displayNode.hasChildNodes = (childNodes.length > 0);
        if (node.expanded === true)
            childNodes.forEach(childNode => {
                if (!childNode.hidden)
                    this.populateDisplayNodes(childNode, level + 1);
            });
    }
    deleteRecursive(node) {
        let removedNodes = [];
        const childNodes = this.nodes.filter(x => x.parentUuid === node.uuid) || [];
        childNodes.forEach(childNode => {
            removedNodes = removedNodes.concat(this.deleteRecursive(childNode));
        });
        removedNodes.push(node);
        this.nodes = this.nodes.filter(x => x.uuid !== node.uuid);
        return removedNodes;
    }
    processNewNode() {
        if (!this.newUuid)
            return;
        const newNode = this.nodes.find(x => x.uuid === this.newUuid);
        const displayNode = this.displayNodes.find(x => x.uuid == this.newUuid);
        // Do this so that we don't trigger the node update
        newNode.text = displayNode.text;
        this.newUuid = null;
        if (!newNode)
            return;
        if (this.onNodeAdded)
            this.onNodeAdded.emit(newNode);
        if (this.nodesChange)
            this.nodesChange.emit(this.nodes);
    }
}
/** @nocollapse */ SlickTreeViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTreeViewComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SlickTreeViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.4", type: SlickTreeViewComponent, selector: "slick-tree-view", inputs: { nodes: "nodes", showRootNode: "showRootNode", rootNodeUuid: "rootNodeUuid", expandOnClick: "expandOnClick" }, outputs: { nodesChange: "nodesChange", onNodeSelected: "onNodeSelected", onNodeChanged: "onNodeChanged", onNodeAdded: "onNodeAdded", onNodeDeleted: "onNodeDeleted" }, viewQueries: [{ propertyName: "slickTreeViewRef", first: true, predicate: ["slickTreeViewRef"], descendants: true, static: true }, { propertyName: "contextMenuRef", first: true, predicate: ["contextMenuRef"], descendants: true }, { propertyName: "deleteNodeConfirmRef", first: true, predicate: ["deleteNodeConfirmRef"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #slickTreeViewRef id=\"slick-tree-view_{{uuid}}\" class=\"slick-tree-view position-relative pr-2\">\r\n\t<div class=\"d-flex slick-tree-view-node\" [attr.data-uuid]=\"displayNode.uuid\" *ngFor=\"let displayNode of displayNodes\">\r\n\t\t<div class=\"slick-tree-view_indentation\">\r\n\t\t\t<i *ngFor=\"let indent of displayNode.indentArray\" class=\"far fa-caret-right mr-1\" style=\"opacity: 0\"></i>\r\n\t\t\t<i *ngIf=\"!displayNode.hasChildNodes\" class=\"far fa-caret-right mr-1\" style=\"opacity: 0\"></i>\r\n\t\t\t<i *ngIf=\"displayNode.hasChildNodes && !displayNode.expanded\" class=\"far fa-caret-right mr-1\" style=\"cursor: pointer\" (click)=\"expandNode(displayNode)\"></i>\r\n\t\t\t<i *ngIf=\"displayNode.hasChildNodes && displayNode.expanded\" class=\"far fa-caret-down mr-1\" style=\"cursor: pointer\" (click)=\"collapseNode(displayNode)\"></i>\r\n\t\t</div>\r\n\t\t<div class=\"d-flex px-1\" [ngClass]=\"{'bg-success text-white' : displayNode.uuid === selectedUuid }\">\r\n\t\t\t<div *ngIf=\"displayNode.node.iconClass || displayNode.node.iconUrl\" class=\"mr-1 slick-tree-view_icon\">\r\n\t\t\t\t<i *ngIf=\"displayNode.node.iconClass\" [style.color]=\"displayNode.node.iconColor\" [ngClass]=\"displayNode.node.iconClass\"></i>\r\n\t\t\t</div>\r\n\t\t\t<div *ngIf=\"!displayNode.editingText\" style=\"cursor: pointer\" (click)=\"selectNode(displayNode)\" (dblclick)=\"editText(displayNode)\">{{displayNode.text}}</div>\r\n\t\t\t<div *ngIf=\"displayNode.editingText\" class=\"slick-tree-view_node-text-edit\"><input type=\"text\" class=\"form-control slick-tree-view_node-text-edit_{{displayNode.uuid}}\" [(ngModel)]=\"displayNode.text\" (keydown)=\"onTextKeydown($event, displayNode)\" /></div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div #contextMenuRef class='slick-tree-view_context-menu dropdown-menu p-0 show menu-hidden'>\r\n\t\t<div *ngIf=\"contextMenuShowAdd\" class=\"px-2 dropdown-item\" (click)=\"addNode()\">Add</div>\r\n\t\t<div *ngIf=\"contextMenuShowDelete\" class=\"px-2 dropdown-item\" (click)=\"deleteNode()\">Delete</div>\r\n\t\t<div *ngIf=\"contextMenuShowEditText\" class=\"px-2 dropdown-item\" (click)=\"editNodeText()\">Edit Name</div>\r\n\t</div>\r\n</div>\r\n\r\n<slick-confirm-dialog #deleteNodeConfirmRef>\r\n\tAre you sure you want to delete {{deleteNodeName}}?\r\n</slick-confirm-dialog>", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: SlickConfirmDialogComponent, selector: "slick-confirm-dialog", inputs: ["width", "okButtonText", "cancelButtonText", "showOkButton", "showCancelButton"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTreeViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'slick-tree-view', template: "<div #slickTreeViewRef id=\"slick-tree-view_{{uuid}}\" class=\"slick-tree-view position-relative pr-2\">\r\n\t<div class=\"d-flex slick-tree-view-node\" [attr.data-uuid]=\"displayNode.uuid\" *ngFor=\"let displayNode of displayNodes\">\r\n\t\t<div class=\"slick-tree-view_indentation\">\r\n\t\t\t<i *ngFor=\"let indent of displayNode.indentArray\" class=\"far fa-caret-right mr-1\" style=\"opacity: 0\"></i>\r\n\t\t\t<i *ngIf=\"!displayNode.hasChildNodes\" class=\"far fa-caret-right mr-1\" style=\"opacity: 0\"></i>\r\n\t\t\t<i *ngIf=\"displayNode.hasChildNodes && !displayNode.expanded\" class=\"far fa-caret-right mr-1\" style=\"cursor: pointer\" (click)=\"expandNode(displayNode)\"></i>\r\n\t\t\t<i *ngIf=\"displayNode.hasChildNodes && displayNode.expanded\" class=\"far fa-caret-down mr-1\" style=\"cursor: pointer\" (click)=\"collapseNode(displayNode)\"></i>\r\n\t\t</div>\r\n\t\t<div class=\"d-flex px-1\" [ngClass]=\"{'bg-success text-white' : displayNode.uuid === selectedUuid }\">\r\n\t\t\t<div *ngIf=\"displayNode.node.iconClass || displayNode.node.iconUrl\" class=\"mr-1 slick-tree-view_icon\">\r\n\t\t\t\t<i *ngIf=\"displayNode.node.iconClass\" [style.color]=\"displayNode.node.iconColor\" [ngClass]=\"displayNode.node.iconClass\"></i>\r\n\t\t\t</div>\r\n\t\t\t<div *ngIf=\"!displayNode.editingText\" style=\"cursor: pointer\" (click)=\"selectNode(displayNode)\" (dblclick)=\"editText(displayNode)\">{{displayNode.text}}</div>\r\n\t\t\t<div *ngIf=\"displayNode.editingText\" class=\"slick-tree-view_node-text-edit\"><input type=\"text\" class=\"form-control slick-tree-view_node-text-edit_{{displayNode.uuid}}\" [(ngModel)]=\"displayNode.text\" (keydown)=\"onTextKeydown($event, displayNode)\" /></div>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<div #contextMenuRef class='slick-tree-view_context-menu dropdown-menu p-0 show menu-hidden'>\r\n\t\t<div *ngIf=\"contextMenuShowAdd\" class=\"px-2 dropdown-item\" (click)=\"addNode()\">Add</div>\r\n\t\t<div *ngIf=\"contextMenuShowDelete\" class=\"px-2 dropdown-item\" (click)=\"deleteNode()\">Delete</div>\r\n\t\t<div *ngIf=\"contextMenuShowEditText\" class=\"px-2 dropdown-item\" (click)=\"editNodeText()\">Edit Name</div>\r\n\t</div>\r\n</div>\r\n\r\n<slick-confirm-dialog #deleteNodeConfirmRef>\r\n\tAre you sure you want to delete {{deleteNodeName}}?\r\n</slick-confirm-dialog>" }]
        }], ctorParameters: function () { return []; }, propDecorators: { nodes: [{
                type: Input
            }], nodesChange: [{
                type: Output
            }], showRootNode: [{
                type: Input
            }], rootNodeUuid: [{
                type: Input
            }], expandOnClick: [{
                type: Input
            }], onNodeSelected: [{
                type: Output
            }], onNodeChanged: [{
                type: Output
            }], onNodeAdded: [{
                type: Output
            }], onNodeDeleted: [{
                type: Output
            }], slickTreeViewRef: [{
                type: ViewChild,
                args: ["slickTreeViewRef", { static: true }]
            }], contextMenuRef: [{
                type: ViewChild,
                args: ["contextMenuRef"]
            }], deleteNodeConfirmRef: [{
                type: ViewChild,
                args: ["deleteNodeConfirmRef"]
            }] } });

class SlickTreeViewModule {
}
/** @nocollapse */ SlickTreeViewModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTreeViewModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickTreeViewModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickTreeViewModule, declarations: [SlickTreeViewComponent], imports: [CommonModule, FormsModule, SlickConfirmDialogModule], exports: [CommonModule, FormsModule, SlickTreeViewComponent] });
/** @nocollapse */ SlickTreeViewModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTreeViewModule, imports: [CommonModule, FormsModule, SlickConfirmDialogModule, CommonModule, FormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTreeViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, FormsModule, SlickConfirmDialogModule],
                    declarations: [SlickTreeViewComponent],
                    exports: [CommonModule, FormsModule, SlickTreeViewComponent]
                }]
        }] });

class SlickTypeAheadDirective {
    constructor(el) {
        this.el = el;
        this.slickTypeAheadChange = new EventEmitter();
        this.fnKeyDown = (e) => this.keyDown(e);
        this.propagateChange = (_) => { };
    }
    ngOnInit() {
        this.el.nativeElement.addEventListener('keydown', this.fnKeyDown);
    }
    ngOnChanges() {
    }
    ngOnDestroy() {
        this.el.nativeElement.removeEventListener('keydown', this.fnKeyDown);
    }
    async keyDown(e) {
        if (e.altKey || e.ctrlKey)
            return;
        var valid = (e.keyCode > 47 && e.keyCode < 58) || // number keys
            e.keyCode === 32 || e.keyCode === 13 ||
            e.keyCode === 8 || e.keyCode === 9 || // spacebar, return & tab key(s) (if you want to allow carriage returns)
            (e.keyCode > 64 && e.keyCode < 91) || // letter keys
            (e.keyCode > 95 && e.keyCode < 112) || // numpad keys
            (e.keyCode > 185 && e.keyCode < 193) || // ;=,-./` (in order)
            (e.keyCode > 218 && e.keyCode < 223); // [\]' (in order)
        if (!valid) {
            return;
        }
        e.stopPropagation();
        await SlickSleepService.sleep();
        // Tab/enter
        if (e.which === 9) {
            this.propagateChange(this.suggestedItem);
            this.createSelection(this.el.nativeElement, this.el.nativeElement.value, 0);
            if (this.slickTypeAheadChange) {
                if (this.filteredItems && this.filteredItems.length > 0)
                    this.slickTypeAheadChange.emit(this.filteredItems[0]);
                else
                    this.slickTypeAheadChange.emit(this.el.nativeElement.value);
            }
            return false;
        }
        if (e.which === 8) {
            if (this.el.nativeElement.value.length > 0) {
                var cursorLoc = this.el.nativeElement.selectionStart;
                if (cursorLoc > 0) {
                    var valSubstr = this.el.nativeElement.value.substring(0, cursorLoc - 1);
                    valSubstr += this.el.nativeElement.value.substring(cursorLoc);
                    this.el.nativeElement.value = valSubstr;
                }
            }
        }
        if (!this.el.nativeElement.value)
            return;
        // Esc
        if (e.which === 27) {
            this.filteredItems = null;
            this.suggestedItem = null;
            return false;
        }
        this.suggestedItem = null;
        let val = this.el.nativeElement.value.toLowerCase();
        if (!this.slickTypeAheadField && !this.slickTypeAheadFields) {
            this.filteredItems = this.slickTypeAhead.filter(x => x.toLowerCase().indexOf(val) === 0);
            if (this.filteredItems && this.filteredItems.length > 0)
                this.suggestedItem = this.filteredItems[0];
        }
        else {
            if (this.slickTypeAheadField) {
                this.filteredItems = this.slickTypeAhead.filter(x => ((SlickUtilsService.getDeepObject(x, this.slickTypeAheadField)) ? SlickUtilsService.getDeepObject(x, this.slickTypeAheadField).toLowerCase().indexOf(val) === 0 : false));
                if (this.filteredItems && this.filteredItems.length > 0)
                    this.suggestedItem = SlickUtilsService.getDeepObject(this.filteredItems[0], this.slickTypeAheadField);
            }
            else {
                let fields = this.slickTypeAheadFields.split("|");
                this.filteredItems = null;
                fields.forEach(field => {
                    if (!this.filteredItems || this.filteredItems.length === 0) {
                        this.filteredItems = this.slickTypeAhead.filter(x => ((SlickUtilsService.getDeepObject(x, field)) ? SlickUtilsService.getDeepObject(x, field).toLowerCase().indexOf(val) === 0 : false));
                        if (this.filteredItems && this.filteredItems.length > 0) {
                            this.suggestedItem = SlickUtilsService.getDeepObject(this.filteredItems[0], field);
                        }
                    }
                });
            }
        }
        if (this.suggestedItem) {
            var len = this.el.nativeElement.value.length;
            this.el.nativeElement.value = this.suggestedItem;
            this.createSelection(this.el.nativeElement, len, this.suggestedItem.length);
        }
        else {
            this.suggestedItem = this.el.nativeElement.value;
        }
    }
    createSelection(field, start, end) {
        if (field.createTextRange) {
            var selRange = field.createTextRange();
            selRange.collapse(true);
            selRange.moveStart('character', start);
            selRange.moveEnd('character', end);
            selRange.select();
            field.focus();
        }
        else if (field.setSelectionRange) {
            field.focus();
            field.setSelectionRange(start, end);
        }
        else if (typeof field.selectionStart != 'undefined') {
            field.selectionStart = start;
            field.selectionEnd = end;
            field.focus();
        }
    }
    // this is the initial value set to the component
    writeValue(obj) {
    }
    // registers 'fn' that will be fired when changes are made
    // this is how we emit the changes back to the form
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    // not used, used for touch input
    registerOnTouched() { }
}
/** @nocollapse */ SlickTypeAheadDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTypeAheadDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ SlickTypeAheadDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.4", type: SlickTypeAheadDirective, selector: "[slick-type-ahead]", inputs: { slickTypeAhead: ["slick-type-ahead", "slickTypeAhead"], slickTypeAheadField: ["slick-type-ahead-field-id", "slickTypeAheadField"], slickTypeAheadFields: ["slick-type-ahead-field-ids", "slickTypeAheadFields"] }, outputs: { slickTypeAheadChange: "slick-type-ahead-change" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => SlickTypeAheadDirective)),
            multi: true,
        }
    ], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTypeAheadDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[slick-type-ahead]',
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => SlickTypeAheadDirective)),
                            multi: true,
                        }
                    ]
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { slickTypeAhead: [{
                type: Input,
                args: ["slick-type-ahead"]
            }], slickTypeAheadField: [{
                type: Input,
                args: ["slick-type-ahead-field-id"]
            }], slickTypeAheadFields: [{
                type: Input,
                args: ["slick-type-ahead-field-ids"]
            }], slickTypeAheadChange: [{
                type: Output,
                args: ["slick-type-ahead-change"]
            }] } });

class SlickTypeAheadModule {
}
/** @nocollapse */ SlickTypeAheadModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTypeAheadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SlickTypeAheadModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.4", ngImport: i0, type: SlickTypeAheadModule, declarations: [SlickTypeAheadDirective], exports: [SlickTypeAheadDirective] });
/** @nocollapse */ SlickTypeAheadModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTypeAheadModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.4", ngImport: i0, type: SlickTypeAheadModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [SlickTypeAheadDirective],
                    exports: [SlickTypeAheadDirective]
                }]
        }] });

/*
 * Public API Surface of components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SlickAccordionComponent, SlickAccordionItemComponent, SlickAccordionItemHeaderComponent, SlickAccordionModule, SlickAutoCompleteComponent, SlickAutoCompleteListItemTemplateDirective, SlickAutoCompleteModule, SlickButtonSpinnerComponent, SlickButtonSpinnerModule, SlickCalendarComponent, SlickCalendarModule, SlickCardComponent, SlickCardHeaderComponent, SlickCardModule, SlickConfirmDialogComponent, SlickConfirmDialogModule, SlickConfirmDialogResults, SlickContainerBodyComponent, SlickContainerComponent, SlickContainerFooterComponent, SlickContainerHeaderComponent, SlickContainerModule, SlickContextMenuComponent, SlickContextMenuItemComponent, SlickContextMenuModule, SlickCurrencyMaskDirective, SlickCurrencyMaskModule, SlickCurrencyMaskOptions, SlickDatePickerComponent, SlickDatePickerModule, SlickDialogComponent, SlickDialogFooterComponent, SlickDialogModule, SlickDragDropDirective, SlickDragDropModule, SlickDraggableDirective, SlickDropDownButtonModel, SlickDropDownComponent, SlickDropDownModule, SlickDropListDirective, SlickDropListGrabDirective, SlickDropListItemDirective, SlickDropListModule, SlickEmailViewerComponent, SlickEmailViewerDialogComponent, SlickEmailViewerModule, SlickEmailerAddressModel, SlickEmailerComponent, SlickEmailerDialogComponent, SlickEmailerModel, SlickEmailerModule, SlickFileDropComponent, SlickFileDropModule, SlickFileListComponent, SlickFileListModule, SlickFileModel, SlickGoogleAddressSearchDirective, SlickGoogleAddressSearchModule, SlickGoogleMapComponent, SlickGoogleMapDialogComponent, SlickGoogleMapModule, SlickGridColumnFilterTypes, SlickGridColumnModel, SlickGridColumnSortDirection, SlickGridColumnTemplateDirective, SlickGridComponent, SlickGridFavoriteModel, SlickGridModule, SlickGridOptions, SlickGridRequestModel, SlickGridResponseModel, SlickInitParams, SlickInitService, SlickMultiSelectComponent, SlickMultiSelectModule, SlickOrderedListComponent, SlickOrderedListModule, SlickPagingComponent, SlickPagingModule, SlickPhotoGalleryComponent, SlickPhotoGalleryModel, SlickPhotoGalleryModule, SlickPickListComponent, SlickPickListModule, SlickPopoverComponent, SlickPopoverModule, SlickProfilePictureComponent, SlickProfilePictureModule, SlickProgressBarModule, SlickProgressBarService, SlickScreenBlockerModule, SlickScreenBlockerService, SlickSliderComponent, SlickSliderModule, SlickSliderTickModel, SlickSplitScreenComponent, SlickSplitScreenLeftContentComponent, SlickSplitScreenModule, SlickSplitScreenRightContentComponent, SlickStarRatingComponent, SlickStarRatingModule, SlickTabComponent, SlickTabHeaderComponent, SlickTabsComponent, SlickTabsModule, SlickToastModule, SlickToastService, SlickTreeNodeModel, SlickTreeViewComponent, SlickTreeViewModule, SlickTypeAheadDirective, SlickTypeAheadModule, SlickValidationIndicatorDirective, SlickValidationIndicatorModule, SlickValidationTypes };
